import * as React from 'react';
import React__default, { useCallback, useMemo, useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch, Provider } from 'react-redux';
import { notification, Input as Input$2, Table as Table$2, Icon, Checkbox as Checkbox$1, Popover, Descriptions, Button as Button$2, Form as Form$2, Select as Select$2, Card as Card$2, TimePicker as TimePicker$2, DatePicker as DatePicker$2, Alert, Collapse as Collapse$2, Radio as Radio$2, InputNumber as InputNumber$2, Row, Col, Spin, Tooltip, Divider, Tree, Dropdown as Dropdown$2, Menu, Tag, Tabs as Tabs$2, Badge } from 'antd';
import { getAccessToken } from '@timeedit/te-auth-components/lib/services/token.service';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import _, { isEmpty, keyBy, castArray, compact, pick, uniq, concat, groupBy, merge, mapValues, sortBy, defaultTo, isEqual, get, size, slice, includes, some, toLower, pickBy, cloneDeep, chain, pull, uniqBy, orderBy, isNaN as isNaN$1, omit, partition, clamp } from 'lodash';
import { createIntl, defineMessages } from 'react-intl';
import moment from 'moment';
import { createAsyncThunk, createSlice, configureStore } from '@reduxjs/toolkit';
import axios from 'axios';
import { schema, normalize } from 'normalizr';
import jwt from 'jsonwebtoken';
import { skipToken } from '@reduxjs/toolkit/query';
import { skipToken as skipToken$1 } from '@reduxjs/toolkit/dist/query';
import PropTypes from 'prop-types';
import { MdAdd, MdPriorityHigh, MdHighlightOff, MdEvent, MdAccessTime } from 'react-icons/md';
import styled, { css } from 'styled-components';
import { darken, rgba, lighten } from 'polished';
import { useFormContext, Controller, useForm, useFieldArray, FormProvider } from 'react-hook-form';
import { InfoCircleOutlined, LoadingOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import WarningTwoTone from '@ant-design/icons/lib/icons/WarningTwoTone';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var _envVarMap;

var apiVersion = 'v1';
var examApiVersion = 'v3';
var Env;

(function (Env) {
  Env["PRODUCTION"] = "production";
  Env["STAGING"] = "staging";
  Env["BETA"] = "beta";
  Env["LOCALHOST"] = "localhost";
})(Env || (Env = {}));

var env = undefined;
var setEnv = function setEnv(newEnv) {
  env = newEnv;
};
var envVarMap = (_envVarMap = {}, _defineProperty(_envVarMap, Env.PRODUCTION, {
  API_URL: "https://exam.timeedit.net/api/".concat(examApiVersion),
  AUTH_URL: "https://auth.timeedit.net/".concat(apiVersion),
  ADMIN_URL: "https://admin.timeedit.net/".concat(apiVersion),
  APP_ID: '5d08ac331dcbc63d30dd3e43',
  APP_NAME: 'tePIC',
  VIEWS_URL: "https://views.timeedit.com/".concat(apiVersion),
  AM_BE_URL: "https://activity-manager.timeedit.com/".concat(apiVersion)
}), _defineProperty(_envVarMap, Env.STAGING, {
  API_URL: "https://exam-v3.timeedit.io/api/".concat(examApiVersion),
  AUTH_URL: "https://auth.timeedit.io/".concat(apiVersion),
  ADMIN_URL: "https://admin.timeedit.io/".concat(apiVersion),
  APP_ID: '5ce2c9f647c807e3ebda352a',
  APP_NAME: 'tePIC',
  VIEWS_URL: "https://views.timeedit.io/".concat(apiVersion),
  AM_BE_URL: "https://activity-manager.timeedit.io/".concat(apiVersion)
}), _defineProperty(_envVarMap, Env.BETA, {
  API_URL: "https://exam.timeedit.dev/api/".concat(examApiVersion),
  AUTH_URL: "https://auth.timeedit.dev/".concat(apiVersion),
  ADMIN_URL: "https://admin.timeedit.dev/".concat(apiVersion),
  APP_ID: '5ce2c9f647c807e3ebda352a',
  APP_NAME: 'tePIC',
  VIEWS_URL: "https://views.timeedit.io/".concat(apiVersion),
  AM_BE_URL: "http://localhost:3001/".concat(apiVersion)
}), _defineProperty(_envVarMap, Env.LOCALHOST, {
  // API_URL: `https://exam-beta.timeedit.io/api/${apiVersion}`,
  API_URL: "http://localhost:7070/api/".concat(examApiVersion),
  AUTH_URL: "https://auth-beta.timeedit.io/".concat(apiVersion),
  ADMIN_URL: "https://admin-beta.timeedit.io/".concat(apiVersion),
  APP_ID: '5ce2c9f647c807e3ebda352a',
  APP_NAME: 'tePIC',
  VIEWS_URL: "https://views.timeedit.io/".concat(apiVersion),
  AM_BE_URL: "http://localhost:3001/".concat(apiVersion)
}), _envVarMap);
var availableEnvs = Object.values(Env);
var getEnvParams = function getEnvParams() {
  if (!env) {
    throw new Error('Environment not set');
  }

  if (!availableEnvs.includes(env)) {
    throw new Error("Unknown environment: ".concat(env));
  }

  return envVarMap[env];
};
var TOKEN_NAME = 'te_auth_token';

var dynamicBaseQuery = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args, WebApi, extraOptions) {
    var baseUrl, rawBaseQuery;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            baseUrl = "".concat(getEnvParams().API_URL);
            rawBaseQuery = fetchBaseQuery({
              baseUrl: baseUrl,
              prepareHeaders: function prepareHeaders(headers) {
                var token = getAccessToken();

                if (token) {
                  headers.set('authorization', "Bearer ".concat(token));
                }

                return headers;
              }
            });
            return _context.abrupt("return", rawBaseQuery(args, WebApi, extraOptions));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function dynamicBaseQuery(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var baseApi = createApi({
  baseQuery: dynamicBaseQuery,
  endpoints: function endpoints(build) {
    return {};
  }
});

var _TEX_LANGUAGES;

var LANG_CODE = {
  Danish: 'da',
  Dutch: 'nl',
  English: 'en',
  Finnish: 'fi',
  German: 'de',
  Norwegian: 'nb',
  Swedish: 'sv'
}; // Languages supported in TE Exam

(_TEX_LANGUAGES = {}, _defineProperty(_TEX_LANGUAGES, LANG_CODE.English, 'English'), _defineProperty(_TEX_LANGUAGES, LANG_CODE.Swedish, 'Svenska'), _defineProperty(_TEX_LANGUAGES, LANG_CODE.Norwegian, 'Norsk'), _TEX_LANGUAGES);
var DEFAULT_LANG = LANG_CODE.English;

var en = {
	"_i.error.request.endPointNotFound": "The requested endpoint does not exist.",
	"_i.error.request.invalidParams": "The request has invalid parameters.",
	"_i.error.server.internalError": "The server encountered an internal error.",
	"_i.error.server.unknown": "The server encountered an unknown error.",
	"_i.error.server.unsuccessfulRequest": "The request cannot be fulfilled.",
	"_i.error.validation.notPass": "Validation did not pass.",
	"_i.exam.createChild.error.exceedingRemainStudents": "Students Planned for sub exam must not exceeding remaining students. (Remains: {remainStudents}).",
	"_i.exam.createChild.error.parentNotFound": "Parent Exam id {parentExamId} not found.",
	"common.label.action": "Actions",
	"common.button.activateItem": "Activate {item}",
	"common.label.active": "Active",
	"common.valueLabel.isActive.active": "Active",
	"common.placeholder.commentToAdmin": "Add a comment",
	"common.button.addNewItem": "Add new {item}",
	"common.button.addItem": "Add {item}",
	"common.placeholder.addItem": "Add {item}...",
	"common.label.address": "Address",
	"common.valueLabel.commentScope.admin": "Admin",
	"common.valueLabel.role.admin": "Admin",
	"common.valueLabel.commentScope.administrator": "Administrator",
	"common.valueLabel.commentScope.all": "All",
	"common.title.allRooms": "All rooms",
	"common.label.allocated": "Allocated",
	"common.valueLabel.allocationStatus.allocated": "Allocated",
	"common.valueLabel.usePlannedStudents.allocated": "Allocated students",
	"common.label.allowItem": "Allow {param}",
	"common.error.unknownUpload": "An unknown error occured when processing the request. Please try again.",
	"common.label.studentAnonymizedCode": "Anonymized student code",
	"pages.examSlotDetail.deletePopover.title": "Are you sure you want to deactivate this exam slot?",
	"common.message.deleteItemConfirm": "Are you sure you want to delete this {item}?",
	"common.label.assignedSpecialNeeds": "Assigned special needs",
	"common.label.attributes": "Attributes",
	"common.title.availability": "Availability",
	"common.title.exams.batchImport": "Batch import",
	"common.button.viewSupervisorsOnBooking": "Book supervisors for room booking",
	"common.label.bookedObjects": "Booked objects",
	"common.title.bookings.detail": "Booking on {date} in {room}",
	"common.label.building": "Building",
	"common.label.campus": "Campus",
	"common.label.mainSupervisor_short": "Can be lead",
	"common.button.cancel": "Cancel",
	"common.label.capacity": "Capacity",
	"common.valueLabel.mainSupervisor.certified": "Certified",
	"common.label.mainSupervisor_long": "Certified to lead",
	"common.label.checklist": "Checklist",
	"common.label.postEndTime_long": "Clean-up end",
	"common.label.comment": "Comment",
	"common.label.commentToAdmin": "Comment for administrators",
	"common.button.configureNow": "Configure now",
	"common.title.common.confirm": "Confirm",
	"common.label.costCenters": "Cost centers",
	"common.model.costCenters": "Cost centers",
	"common.valueLabel.importStatus.couldNotBeImported": "Could not be imported",
	"common.label.courseEvents": "Course events",
	"common.label.courses": "Courses",
	"common.button.createItem": "Create {item}",
	"common.label.date": "Date",
	"common.label.dateFormat": "Date format",
	"common.button.deactivateItem": "Deactivate {item}",
	"common.valueLabel.isActive.deactivated": "Deactivated",
	"common.button.deleteItem": "Delete {item}",
	"common.label.department": "Department",
	"common.label.departments": "Departments",
	"common.label.description": "Description",
	"common.button.deselectAllItem": "Deselect all {item}",
	"common.button.disable": "Disable",
	"common.button.discard": "Discard",
	"common.label.duration": "Duration",
	"common.placeholder.durationHours": "Duration hours",
	"common.placeholder.durationMinutes": "Duration minutes",
	"common.button.editItem": "Edit {item}",
	"common.title.common.editItem": "Edit {item}",
	"pages.examSlotDetail.readonly.description": "This exam slot has rooms booked on it, and therefore the time cannot be changed",
	"common.label.email": "Email",
	"common.button.enable": "Enable",
	"common.label.endTime": "End time",
	"common.label.exam": "Exam",
	"common.label.examDuration": "Exam duration",
	"common.label.endTime_long": "Exam end time",
	"common.label.examLanguage": "Exam language",
	"common.button.examScheduling": "Exam scheduling",
	"common.title.settings.exams": "Exam settings",
	"common.label.examSlot": "Exam slot",
	"pages.examSlotDetail.readonly.message": "Exam Slot Time is Locked",
	"common.title.examSlots": "Exam slots",
	"common.label.startTime_long": "Exam start time",
	"common.label.examStatus": "Exam status",
	"common.label.examType": "Exam type",
	"common.title.settings.examTypes": "Exam types",
	"common.label.exams": "Exams",
	"common.title.exams": "Exams",
	"common.label.examsScheduled": "Exams scheduled",
	"common.title.exams.export": "Export Exams",
	"common.button.exportExams": "Export {item}",
	"common.label.externalExamName": "External exam name",
	"common.placeholder.filterItem": "Filter {item}",
	"common.label.firstName": "First name",
	"common.label.floor": "Floor",
	"common.title.home": "Home",
	"common.label.hours": "Hours",
	"common.label.id": "Id",
	"common.title.exams.update": "Id #{id}",
	"common.label.idAndName": "Id & name",
	"common.label.importStatus": "Import status",
	"common.button.importItem": "Import {item}",
	"common.valueLabel.importStatus.imported": "Imported",
	"common.label.importedSpecialNeeds": "Imported special needs",
	"common.label.importedToExam": "Imported to exam",
	"common.valueLabel.isActive.inactive": "Inactive",
	"common.label.info": "Info",
	"common.label.infoField1": "Info field 1",
	"common.label.infoField2": "Info field 2",
	"common.label.infoField3": "Info field 3",
	"common.label.infoField4": "Info field 4",
	"common.label.infoField5": "Info field 5",
	"common.valueLabel.allowIntervalOrSlotParam.interval": "Interval",
	"common.label.knowledgeAreas": "Knowledge areas",
	"common.title.settings.knowledgeAreas": "Knowledge areas",
	"common.title.settings.languages": "Languages",
	"common.label.lastName": "Last name",
	"common.label.isLead": "Lead",
	"common.label.linkedExam": "Linked exam",
	"common.label.mainSupervisor": "Main supervisor",
	"common.label.isReExam_short": "Make-up",
	"common.valueLabel.isReExam.makeUp": "Make-up exam",
	"common.label.mappedValue": "Mapped value",
	"common.label.maxRequestNumber": "Max number of requests",
	"common.label.minRequestNumber": "Min number of requests",
	"common.label.minutes": "Minutes",
	"common.label.modules": "Modules",
	"common.title.myAvailability": "My availability",
	"common.label.name": "Name",
	"common.title.exams.create": "New exam",
	"common.title.examSlots.create": "New exam slot",
	"common.title.common.newItem": "New {item}",
	"common.message.noExamScheduled": "No exams have been scheduled on this room booking",
	"common.message.noItemSelected": "No {item} has been selected",
	"common.valueLabel.allocationStatus.notAllocated": "Not allocated",
	"common.valueLabel.mainSupervisor.notCertified": "Not certified",
	"common.label.notes": "Notes",
	"common.title.common.overview": "Overview",
	"common.label.owner": "Owner",
	"common.label.permittedResources": "Permitted resources",
	"common.label.studentPersonalIdentificationNumber": "Personal identification number",
	"common.label.planned": "Planned",
	"common.label.studentsPlanned": "Planned number of students",
	"common.valueLabel.usePlannedStudents.planned": "Planned students",
	"common.label.postEndTime": "Post end time",
	"common.label.preStartTime": "Pre start time",
	"common.label.preStartTime_long": "Prep time starts",
	"common.label.pricePerSeatPerHour_short": "Price",
	"common.label.pricePerSeatPerHour_long": "Price / seat / hour",
	"common.label.pricePerSeatPerHour": "Price per seat per hour",
	"common.label.professors": "Professors",
	"common.label.registered": "Registered",
	"common.label.registeredStudents": "Registered students",
	"common.label.registrationDate": "Registration date",
	"common.valueLabel.isReExam.regular": "Regular exam",
	"common.label.isReExam_long": "Regular or make-up exam",
	"common.button.removeFromTEExam": "Remove from TE Exam",
	"common.button.removeItem": "Remove {item}",
	"common.title.scheduling.requested": "Requested scheduling for {exam}",
	"common.button.resetConfiguration": "Reset configuration",
	"common.label.role": "Role",
	"common.label.room": "Room",
	"common.button.roomBooking": "Room booking",
	"common.title.bookings": "Room bookings",
	"common.label.roomName": "Room name",
	"common.label.roomType": "Room type",
	"common.label.roomUtilization": "Room utilization",
	"common.title.rooms": "Rooms",
	"common.title.scheduling.rooms": "Rooms",
	"common.button.saveChanges": "Save changes",
	"common.button.saveItem": "Save {item}",
	"common.valueLabel.savingStatus.saved": "Saved",
	"common.menu.scheduling": "Scheduling",
	"common.valueLabel.isScheduled.completed": "Scheduling completed",
	"common.valueLabel.isScheduled.incomplete": "Scheduling incomplete",
	"common.label.schedulingStatus": "Scheduling status",
	"common.title.scheduling": "Scheduling {exam, select, NONE {} other {for {exam}}}",
	"common.label.seatingNo": "Seating no.",
	"common.label.seatingStatus": "Seating status",
	"common.placeholder.selectItem": "Select {item}",
	"common.button.selectAllItem": "Select all {item}",
	"common.label.selected": "Selected",
	"common.label.selectedStudents": "Selected students",
	"common.button.send": "Send",
	"common.title.settings": "Settings",
	"common.valueLabel.allowIntervalOrSlotParam.slot": "Slot",
	"common.title.settings.specialNeeds": "Special needs",
	"common.label.specialNeedsAssignment": "Special needs assignment",
	"common.label.startTime": "Start time",
	"common.label.status": "Status",
	"common.label.studentId": "Student Id",
	"common.label.studentName": "Student name",
	"common.menu.settings.students": "Student registration",
	"common.title.settings.students": "Student registration mapping",
	"common.label.students": "Students",
	"common.label.studentsRegistered": "Students registered",
	"common.label.supervisor": "Supervisor",
	"common.valueLabel.role.supervisor": "Supervisor",
	"common.button.supervisorScheduling": "Supervisor scheduling",
	"common.label.supervisors": "Supervisors",
	"common.title.scheduling.supervisors": "Supervisors",
	"common.title.settings.supervisors": "Supervisors",
	"common.label.teExtId": "TE ExtId",
	"common.menu.teIntegration": "TE Integration",
	"common.error.readFile": "The file could not be read. Please try again.",
	"common.error.findingDataSheet": "The file doesn't contain a sheet called ’data_sheet’, please edit your file and try again.",
	"common.error.email": "The input is not valid email.",
	"common.error.uploadFile": "The upload was terminated prematurely, please check your internet connect and try again.",
	"common.message.actionCannotUndoneWarning": "This action can not be undone",
	"common.label.time": "Time",
	"common.title.settings.time-intervals": "Time intervals",
	"common.title.settings.teIntegration": "TimeEdit integration",
	"common.label.totalStudentsAllocated": "Total students allocated",
	"common.label.totalStudentsPlanned": "Total students planned",
	"common.label.totalStudentsRegistered": "Total students registered",
	"common.label.type": "Type",
	"common.placeholder.comment": "Type your comment here...",
	"common.valueLabel.savingStatus.unsaved": "Unsaved changes",
	"common.button.update": "Update",
	"common.label.useIntervals": "Use intervals",
	"common.title.settings.users": "Users",
	"common.label.utilization": "Utilization",
	"common.label.value": "Value",
	"common.label.valueFormat": "Value format",
	"common.label.view": "View",
	"common.button.viewAndEdit": "View & edit",
	"common.button.viewInCalendar": "View in calendar",
	"common.button.viewInExamCalendar": "View in exam calendar",
	"common.button.viewInSupervisorCalendar": "View in supervisor calendar",
	"common.button.viewRoomBooking": "View room booking",
	"common.button.yes": "Yes",
	"common.model.campus": "campus",
	"common.model.childExam": "child exam",
	"common.model.column": "column",
	"common.model.comment": "comment",
	"common.model.courseEvents": "course events",
	"common.model.courses": "courses",
	"common.model.departments": "departments",
	"common.model.exam": "exam",
	"common.model.examLanguage": "exam language",
	"common.model.examRequest": "exam request",
	"common.model.examSlot": "exam slot",
	"common.model.examSlots": "exam slots",
	"common.model.examType": "exam type",
	"common.model.examTypes": "exam types",
	"common.model.exams": "exams",
	"common.model.filter": "filter",
	"common.model.item": "item",
	"common.model.knowledgeArea": "knowledge area",
	"common.model.knowledgeAreas": "knowledge areas",
	"common.model.language": "language",
	"common.model.languages": "languages",
	"common.model.linkedExam": "linked exam",
	"common.model.modules": "modules",
	"common.model.objects": "objects",
	"common.model.professors": "professors",
	"common.model.roomBooking": "room booking",
	"common.model.rooms": "rooms",
	"common.model.scheduling": "scheduling",
	"common.model.specialNeed": "special need",
	"common.model.specialNeeds": "special needs",
	"common.model.supervisor": "supervisor",
	"common.model.supervisors": "supervisors",
	"common.model.timeInterval": "time interval",
	"common.model.timeIntervals": "time intervals",
	"common.model.user": "user",
	"common.model.users": "users",
	"common.model.value": "value",
	"common.error.required": "{field} is required{item, select, NONE {} other { for the {item}}}.",
	"common.title.common.itemOverview": "{item} overview",
	"common.valueLabel.supervisorCount.accepted": "{number} accepted",
	"common.valueLabel.supervisorCount.required": "{number} required",
	"common.valueLabel.supervisorCount.scheduled": "{number} scheduled",
	"common.valueLabel.savingStatus.allocated": "{number} students allocated",
	"common.valueLabel.savingStatus.planned": "{number} students planned",
	"common.valueLabel.savingStatus.registered": "{number} students registered",
	"components.totalExamCostChart.label.seatsUsed": "Seats used",
	"components.totalExamCostChart.label.totalRoomCost": "Total room cost",
	"components.totalExamCostChart.label.costForExam}": "Cost for {examId}",
	"components.examCostChart.label.totalRoomCost": "Total room cost",
	"components.examCostChart.label.costForExam}": "Cost for {examId}",
	"components.examCostChart.label.costsForOtherExams": "Costs for other exams",
	"components.examCostChart.label.costOfUnderUtilization": "Cost of underutilization",
	"components.examCostChart.label.totalCostForRoom": "Total cost for room",
	"components.examCostChart.label.costBreakdown": "Cost breakdown",
	"components.totalExamCostChart.label.costsForOtherExams": "Costs for other exams",
	"components.totalExamCostChart.label.costOfUnderUtilization": "Cost of underutilization",
	"components.totalExamCostChart.label.totalCostForAllRooms": "Total cost for all rooms",
	"components.totalExamCostChart.label.costBreakdown": "Cost breakdown",
	"components.commentChannelSelectorPane.label": "Select channel",
	"components.commentChannelSelectorPane.group.roomBooking": "Room booking",
	"components.commentChannelSelectorPane.group.examGroup": "Exam group",
	"components.commentChannelSelectorPane.group.exams": "Exams",
	"components.bootstrapConfigError.message": "We're sorry, but it seems like TE Exam is not fully configured yet.",
	"components.bootstrapConfigError.link": "Config it",
	"components.examComment.text.timeAgo": "{time} ago",
	"components.examPropertySelection.selectTypeTable.column.type": "Type",
	"components.examPropertySelection.selectTypeTable.column.selectedObjects": "Selected objects",
	"components.examPropertySelection.selectPropertyTable.title": "Select {property}",
	"components.examPropertySelection.search.placeholder": "Filter properties...",
	"components.examSchedulingStatusPane.label.studentsScheduled": "Students scheduled",
	"components.examSchedulingStatusPane.label.numberOfChildExams": "Number of child exams",
	"components.filterBar.title": "FILTERS",
	"components.filterBar.title.dataset": "Show me all {title}",
	"components.filterBar.title.filterMode": "Matching",
	"components.filterBar.title.filter": "Filters:",
	"components.filterBar.message.noFiltersAdded": "You have not added any filters yet",
	"components.filterBarFilter.placeholder.category": "Select a category",
	"components.filterBarFilter.placeholder.property": "Select a property",
	"components.filterBarFilter.placeholder.filterRule": "Select a filter rule",
	"components.filterBarFilter.label.key": "KEY",
	"components.filterBarFilter.label.rule": "RULE",
	"components.filterBarFilter.label.value": "VALUE",
	"components.filterButton.header": "FILTERS",
	"components.filterButton.button.matchOne": "Match one",
	"components.filterButton.button.matchAll": "Match all",
	"components.filterButton.label.key": "KEY",
	"components.filterButton.label.rule": "RULE",
	"components.filterButton.label.value": "VALUE",
	"components.filterButton.message.noFilter": "You have not added any filters yet",
	"components.filterModeLinkDropdown.button.matchOne": "One of the filters",
	"components.filterModeLinkDropdown.button.matchAll": "All of the filters",
	"components.filterRow.placeholder.category": "Select a category",
	"components.filterRow.placeholder.property": "Select a property",
	"components.filterRow.placeholder.filterRule": "Select a filter rule",
	"components.saveFiltersButton.message.noFilter": "No filter",
	"components.saveFiltersButton.message.removeConfirm": "Sure to remove \"{name}\" filter?",
	"components.saveFiltersButton.button.saveToCurrentFilter": "Save to current filter",
	"components.saveFiltersButton.button.saveAsNewFilter": "Save as new filter",
	"components.saveFiltersButton.text.savedFilters": "Saved filters",
	"components.saveFiltersButton.label.filterName": "Filter name",
	"components.saveFiltersButton.error.required.filterName": "Please Input Filter Name!",
	"components.initialRoute.error.examSlotEmpty": "Exam slot list is empty!",
	"components.initialRoute.error.roomEmpty": "Room list is empty!",
	"components.initialRoute.error.integrationSettingError": "Integration setting is not properly set!",
	"components.initialRoute.error.studentsMappingEmpty": "Sample student mapping is not set!",
	"components.initialRoute.error.userEmpty": "User list is empty!",
	"components.schedulingPane.label.calendarOptions": "Calendar options",
	"components.schedulingPane.label.showBookedRooms": "Show booked rooms",
	"components.schedulingPane.label.showCompatibleSlots": "Show compatible slots",
	"components.schedulingPane.button.viewSelectedBookings": "View selected bookings",
	"components.schedulingPane.button.showAndBookSelection": "Show & book selection",
	"components.schedulingPane.button.viewExams": "View exams",
	"components.schedulingPane.button.showScheduling": "Show scheduling",
	"components.roomBookingBookedObjectsPane.message.noBookObjects": "No Booked Objects",
	"components.roomBookingTabbedPane.tab.timeAndDate": "Time & date",
	"components.roomBookingTabbedPane.tab.statistics": "Statistics",
	"components.roomBookingTabbedPane.tab.roomInformation": "Room information",
	"components.roomBookingTabbedPane.tab.exams": "Exams",
	"components.roomBookingTabbedPane.tab.supervisors": "Supervisors",
	"components.editExternalBookingDialog.label.bookingTitle": "Booking title",
	"components.editExternalBookingDialog.message.noLongerNeed": "No longer need this booking?",
	"components.editExternalBookingDialog.message.deleteTitle": "Click here to delete it",
	"components.modal.historicalBooking.title": "This date and time has already passed",
	"components.modal.historicalBooking.content": "You cannot create an event for a date and time that has passed",
	"components.modal.overlappingBooking.title": "Overlapping bookings",
	"components.modal.overlappingBooking.content": "This booking overlaps with a session you are scheduled on",
	"components.supervisorsNeededSelector.label": "Supervisors scheduled",
	"components.supervisorsNeededSelector.popover.title": "Supervisors needed",
	"components.supervisorsNeededSelector.popover.button": "Edit supervisors needed",
	"components.roomBookingStatsDetailPad.label.seatsBooked": "Seats booked",
	"components.roomBookingStatsDetailPad.label.seatsNeeded": "Seats needed",
	"components.roomBookingStatsDetailPad.label.distribution": "Distribution",
	"components.roomBookingStatsDetailPad.label.numberOfRooms": "# of rooms",
	"components.roomBookingStatsDetailPad.label.numberOfExams": "# of exams",
	"components.roomBookingStatsDetailPad.label.needed": "Needed",
	"components.roomBookingStatsDetailPad.label.booked": "Booked",
	"components.roomBookingStatsDetailPad.title.roomBookingStatistics": "Room booking statistics",
	"components.roomSelectionStatsDetailPad.title": "Room selection",
	"components.roomSelectionStatsDetailPad.label.selection": "Selection",
	"components.roomSelectionStatsDetailPad.label.seatsSelected": "Seats selected",
	"components.roomSelectionStatsDetailPad.label.roomsSelected": "Rooms selected",
	"components.examLinkagePane.label.linkedTo": "Linked to",
	"components.examLinkagePane.message.verifySchedulingOnTheChildExams": "Please verify scheduling on the child exams",
	"components.examLinkagePane.message.notScheduled": "Not scheduled",
	"components.examSchedulingTableRow.message.deleteChildExamConfirm": "Delete this child exam will deallocate all students registered on this child exam. Are you sure you want to delete this child exam?",
	"components.selectedExamDetailPad.title": "Id: {id}, Name: {name}",
	"components.selectedExamDetailPad.tab.examInformation": "Exam information",
	"components.selectedExamDetailPad.tab.examObjects": "Exam objects",
	"components.selectedExamDetailPad.tab.scheduling": "Scheduling",
	"components.selectedExamDetailPad.tab.comments": "Comments",
	"components.selectedExamDetailPad.label.schedulingStatusAndPriorities": "Scheduling status & priorities",
	"components.examCommentsTab.message.noCommentsPosted": "No comments have been posted yet",
	"components.examInformationTab.label.examHierarchy": "Exam hierarchy",
	"components.examInformationTab.label.examInformation": "Exam information",
	"pages.examInformationTab.card.numberOfStudents": "Number of students",
	"components.examSchedulingTab.label.dateAndTime": "Date & time",
	"components.examSchedulingTab.label.seats": "Seats",
	"components.examSchedulingTab.message.linkedExamNeedsToBeScheduled": "The linked exam needs to be scheduled before you can schedule this exam.",
	"components.selectedRoomBookingDetailPad.group.supervisors": "Supervisors",
	"components.selectedRoomBookingDetailPad.tab.roomBookingInfo": "Room booking info",
	"components.selectedRoomBookingDetailPad.title.roomBooking": "Booking in {room} on {date}",
	"components.supervisorsTab.group.scheduled": "Scheduled",
	"components.supervisorsTab.group.available": "Available",
	"components.examSlotDateContainer.text.free": "{number}% free",
	"components.examSlotDateContainer.message.childExamHaveToBeScheduleInSameDate": "All child exams have to be scheduled on the same date",
	"components.examSlotDateContainer.message.examHasToBeScheduledOnSameDateAsLinkExam": "The exam has to be scheduled on the same date as its linked exam",
	"components.examSlotRow.message.examSlotIsTooShort": "The exam slot is too short for the selected exam",
	"components.examSlotRow.message.examNeedsToBeScheduledOnSameExamSlot": "The exam needs to be scheduled on the same exam slot as the exam its linked to",
	"components.selectionOverlay.message.tryingToMakeASelectionInAnotherExamSlot": "You are trying to make a selection in another exam slot. To do this you need to discard your existing selections.",
	"components.selectionOverlay.message.doYouWantToContinue": "Do you want to continue?",
	"components.selectionOverlay.button.discardSelection": "Discard selection",
	"pages.examListDetailPad.tab.pendingExams": "Pending exams",
	"pages.examListDetailPad.tab.scheduledExams": "Scheduled exams",
	"components.requestedSchedulingListDetailPad.title": "Scheduling Priorities",
	"components.requestedSchedulingListDetailPad.label.prioritiesAdded": "Priorities added",
	"components.requestedSchedulingListDetailPad.alert.prioritiesDisabled.message": "Scheduling priorities disabled",
	"components.requestedSchedulingListDetailPad.alert.prioritiesDisabled.description": "Your organization's configuration does not allow for scheduling prioritization on exam requests",
	"components.requestedSchedulingListDetailPad.alert.prioritiesAddLeast.message": "Please add at lest {minNumber} additional scheduling priorities",
	"components.requestedSchedulingListDetailPad.alert.prioritiesAddLeast.description": "To save your exam, you have to submit at least {minNumber} scheduling priorities",
	"components.toolBar.defaultPlaceholder": "Select...",
	"common.button.done": "Done",
	"common.button.ok": "OK",
	"common.button.options": "Options",
	"common.label.administratorComment": "Administrator comment",
	"common.label.interval": "Interval",
	"common.label.requestedScheduling": "Requested scheduling",
	"common.model.booking": "booking",
	"common.model.interval": "interval",
	"common.model.room": "room",
	"pages.examInformation.text.namingIsOptional": "Naming your exam is optional, you can always refer to it by its ID",
	"pages.examInformation.collapse.basicInformation": "Basic Information",
	"pages.examInformation.collapse.examObjects": "Exam Objects",
	"pages.examInformation.collapse.additionalInformation": "Additional information",
	"pages.examInformation.card.numberOfStudents": "Number of students",
	"pages.examInformation.card.examStatus": "Exam status",
	"pages.examDetail.tab.checklist": "Checklist",
	"pages.examDetail.tab.basicInformation": "Basic information",
	"pages.examDetail.tab.schedulingPriorities": "Scheduling priorities",
	"pages.examDetail.tab.scheduling": "Scheduling",
	"pages.examDetail.tab.studentRegistration": "Student registration",
	"pages.examDetail.tab.specialNeeds": "Special needs",
	"pages.examDetail.tab.seatAllocation": "Seat allocation",
	"pages.examDetail.tab.comments": "Comments",
	"pages.examDetail.tab.postExamManagement": "Post exam management",
	"pages.examDetail.tab.publicSchedule": "Student site",
	"pages.examDetail.label.showCompatibleRoomBookings": "Show compatible room bookings",
	"pages.examDetail.button.showSelectedRoomBooking": "Show selected room booking",
	"pages.examDetail.button.backToOverview": "Back to overview",
	"pages.examDetail.button.addRegisteredStudents": "Add registered students",
	"pages.examDetail.button.savePostExamNotes": "Save post exam notes",
	"pages.examDetail.button.saveChecklist": "Save checklist",
	"pages.examDetail.button.saveSchedulingPriorities": "Save scheduling priorities",
	"pages.examExportSettings.panel.exportSettings": "Export settings",
	"pages.examExportSettings.card.billingReportSettings": "Billing report settings",
	"pages.examExportSettings.label.includeExamOverview": "Include exam overview",
	"pages.examExportSettings.label.includeSchedulingInformation": "Include scheduling information",
	"pages.examExportSettings.label.includeBillingInformation": "Include billing information",
	"pages.examExportSettings.label.selectedStudentMetric": "Selected student metric",
	"pages.examExportSettings.label.distributeUnderutilization": "Distribute underutilization",
	"pages.examExportSettings.label.includePrepAndCleanUpTime": "Include prep and clean-up time",
	"pages.examExportSettings.label.includePostExamNotes": "Include post exam notes",
	"components.assignSpecialNeedToStudentDropdown.placeholder.notAssigned": "Not assigned",
	"components.availableSupervisorActionButton.button.scheduleHere": "Schedule here",
	"components.examActionsDropdown.message.deleteConfirm": "Are you sure want to delete exam {id}?",
	"components.examActionsDropdown.message.aboutToDeleteWarning": "You are about to delete an exam. This action cannot be undone",
	"components.examActionsDropdown.message.aboutToDeleteInstruction": "Press \"Delete exam\" below to proceed",
	"components.examActionsDropdown.message.unableToDeleteWarning": "Unable to delete exam",
	"components.examActionsDropdown.message.unableToDeleteDescription": "This exam cannot be deleted. Make sure the exam is not schedule, has no child exams, and has not passed yet.",
	"components.examActionsDropdown.button.deleteExam": "Unable to delete exam",
	"components.removeSpecialNeedsAssignmentButton.message.deleteConfirm": "Are you sure you want to remove the special need for this student?",
	"components.roomBookingActionsDropdown.button.viewInExamCalendar": "Schedule exams on room booking",
	"components.roomBookingActionsDropdown.button.viewInSupervisorCalendar": "Book supervisors on room booking",
	"components.scheduledSupervisorActionsDropdown.button.removeFromRoomBooking": "Remove from room booking",
	"components.supervisorPendingActions.message.confirmToAccept": "Are you sure you want to confirm this booking request?",
	"components.supervisorPendingActions.message.confirmToDecline": "Are you sure you want to decline this booking request?",
	"components.examPrioritiesColumn.message.noDate": "No date",
	"components.examPrioritiesColumn.message.noPriorities": "No priorities",
	"components.examTable.group.examInfo": "Exam info",
	"components.examTable.group.scheduling": "Scheduling",
	"components.examTable.group.roomBooking": "Room booking",
	"components.modifyRoomBooking.message.noNonOverlappingExamSlots": "No non-overlapping exam slots to show",
	"components.modifyRoomBooking.alert.unableToModifyAlert.message": "Unable to modify",
	"components.modifyRoomBooking.alert.unableToModifyAlert.singleDescription": "One or many of the room bookings you have selected contains exams or supervisors, so it can't be edited",
	"components.modifyRoomBooking.alert.unableToModifyAlert.multipleDescription": "This room booking contains other exams or supervisors and belongs to a different exam slot, so it can't be moved to the selected exam slot",
	"components.modifyRoomBooking.alert.modifyBooking.message": "Modify room booking",
	"components.modifyRoomBooking.label.original": "Original",
	"components.modifyRoomBooking.label.convertInto": "Convert into",
	"components.modifyRoomBooking.label.addExamSlots": "Add exam slots",
	"components.modifyRoomBooking.button.modifyAndSchedule": "Modify & schedule",
	"components.schedulingFragment.error.scheduledWithinBoundariesOfExamSlot": "The exam must be scheduled within the boundaries of the exam slot",
	"components.schedulingFragment.message.rescheduleConfirm.title": "Are you sure you want to reschedule this exam?",
	"components.schedulingFragment.message.rescheduleConfirm.content": "This exam is already scheduled, are you sure you want to reschedule it?",
	"components.schedulingFragment.error.unableToSchedule": "Unable to schedule",
	"components.schedulingFragment.error.noExamSelected": "No exam has been selected",
	"components.schedulingFragment.error.examScheduledOnBooking": "Exam #{examId} is already scheduled on this room booking",
	"components.schedulingFragment.error.examHasChildExam": "Exam #{examId} has child exams. Please select one of the children for scheduling",
	"components.schedulingFragment.error.examHasMoreStudentsThanCapacity": "Exam #{examId} has more students planned than the room booking has available capacity for. Please select another room booking",
	"components.schedulingFragment.error.schedulingShorterThanExamDuration": "The scheduling is shorter than the requested exam duration",
	"components.schedulingFragment.error.schedulingLongerThanExamDuration": "The scheduling is longer than the requested exam duration",
	"components.schedulingFragment.button.scheduleExamHere": "Schedule exam here",
	"components.roomBookingDetailPad.bookingTitle": "Room booking",
	"components.roomBookingDetailPad.bookingSelectedTitle": "Room booking in {room}, {startTime} - {endTime} ({examSlot})",
	"components.roomBookingDetailPad.multipleBookingsSelectedTitle": "Viewing {number} room bookings",
	"components.roomBookingDetailPad.examTitle": "Schedule exam",
	"components.roomBookingDetailPad.examSelectedTitle": "Schedule exam in {room}, {startTime} - {endTime} ({examSlot})",
	"components.roomBookingDetailPad.modifyRoomBooking.message": "You have selected a room booking on an exam slot that overlaps your selected exam slot. To complete the scheduling, you have convert the room booking.",
	"components.roomDetailPad.label.seats": "Seats",
	"components.roomDetailPad.label.slotAndTime": "Slot & time",
	"components.roomDetailPad.label.supervisorsNeeded": "Supervisors needed",
	"components.roomDetailPad.button.bookSelectedRooms": "Book selected rooms",
	"components.roomDetailPad.message.noRoomsSelected": "No rooms have been selected",
	"components.roomSearchDropdown.placeholder.roomFilters": "Room filters",
	"components.roomSearchDropdown.label.selectedRooms": "Selected rooms",
	"components.roomSearchDropdown.placeholder.searchForRooms": "Search for rooms...",
	"components.selectionRow.label.selection": "Selection",
	"components.childExamFormDialog.message.addChildExamsToScheduledExamWarning": "The current exam scheduling will be deleted.",
	"components.childExamFormDialog.message.processWithCaution": "Proceed with caution.",
	"components.childExamFormDialog.label.childExamName": "Name of child exam",
	"components.childExamFormDialog.label.numberOfStudents": "No. of students",
	"components.childExamFormDialog.text.numberOfSeatsLeft": "/ {number} seats left",
	"common.button.confirm": "Confirm",
	"common.button.decline": "Decline",
	"common.button.newItem": "New {item}",
	"common.button.no": "No",
	"common.label.costCenter": "Cost center",
	"common.label.course": "Course",
	"common.label.courseCode": "Course code",
	"common.label.courseName": "Course name",
	"common.label.courseEvent": "Course event",
	"common.label.credits": "Credits",
	"common.label.departmentCode": "Department code",
	"common.label.examId": "Exam Id",
	"common.label.examHierarchy": "Exam hierarchy",
	"common.label.examName": "Exam name",
	"common.label.examObjects": "Exam objects",
	"common.label.examOwner": "Exam owner",
	"common.label.firstPriority": "First priority",
	"common.label.infoField": "Info field",
	"common.label.isActive": "Is active",
	"common.label.isReadonly": "Is readonly",
	"common.label.language": "Language",
	"common.label.module": "Module",
	"common.label.moduleId": "Module Id",
	"common.label.permittedResources_long": "Permitted resources for students",
	"common.label.professor": "Professor",
	"common.label.professorId": "Professor Id",
	"common.label.schedulingPriorities": "Scheduling priorities",
	"common.label.targetDate": "Target date",
	"common.label.teExtId_short": "ExtId",
	"common.label.typeId": "Type Id",
	"common.message.loadingIndicator": "TE Exam loading indicator",
	"common.model.student": "student",
	"common.valueLabel.filter.contains": "Contains",
	"common.valueLabel.filter.category": "Category",
	"common.valueLabel.filter.lessThan": "Is less than",
	"common.valueLabel.filter.greaterThan": "Is greater than",
	"common.valueLabel.filter.equalTo": "Is equal to",
	"common.valueLabel.filter.true": "Is true",
	"common.valueLabel.filter.false": "Is false",
	"common.valueLabel.filter.greaterThanOrEqualTo": "Is greater than or equal to",
	"common.valueLabel.filter.isLessThanOrEqualTo": "Is less than or equal to",
	"common.valueLabel.filter.between": "Between",
	"common.valueLabel.role.cea": "Central Exam Administrator",
	"common.valueLabel.role.dec": "Departemental Exam Coordinator",
	"common.valueLabel.role.student": "Student",
	"pages.examScheduling.text.showCompatibleRoomBooking": "Show compatible room bookings:",
	"pages.examScheduling.button.showSelectedRoomBooking": "Show selected room booking",
	"pages.createNewExam.tooltip.schedulingPriority": "To save your exam request, please add at least {priorityNumber, plural, one {# scheduling priority} other {# scheduling priorities}}",
	"pages.createNewExam.tab.examInformation": "Exam information",
	"pages.examBatchImport.title.selectFile": "Batch import exams: Select file to import (1/3)",
	"pages.examBatchImport.title.review": "Batch import exams: Make sure everything looks good (2/3)",
	"pages.examBatchImport.title.results": "Batch import exams: Results from the import (3/3)",
	"pages.examBatchImport.button.downloadImportTemplate": "Download import template",
	"pages.examBatchImport.button.saveImport": "Save import",
	"pages.examBatchImport.button.clearData": "Clear data",
	"pages.examBatchImport.button.importAnotherFile": "Import another file",
	"pages.propertySelectionPane.header": "Edit import mapping settings",
	"pages.propertySelectionPane.message.customizeProperties": "Customize the properties you want to use to parse each object type. The import results will update in realtime",
	"pages.uploadFile.message.dropFileHere": "Drop your file here or click to browse your files to start the import.",
	"pages.validationSummary.message.error.message": "Heads up!",
	"pages.validationSummary.message.error.description": "We found {errorNumber} errors and {warningNumber} warnings with your import",
	"pages.validationSummary.message.success.message": "All good!",
	"pages.validationSummary.message.success.description": "Your import has no errors or warnings",
	"pages.exam.tooltip.checklistItemStatus": "You can't mark it as done before you've given it a title",
	"pages.exam.placeholder.checklistItemStatus": "Type to edit me...",
	"pages.examDetailInformationTab.panel.basicInformation": "Basic Information",
	"pages.examDetailInformationTab.panel.additionalInformation": "Additional information",
	"pages.examDetailInformationTab.alert.examIsLocked.message": "Exam information is locked",
	"pages.examDetailInformationTab.alert.examIsLocked.description": "Editing the exam information is not possible after the exam has been scheduled",
	"pages.examDetailInformationTab.text.namingExamIsOptional": "Naming your exam is optional, you can always refer to it by its ID",
	"pages.examDetailInformationTab.text.registeredStudents": "{studentsRegistered} students",
	"pages.examDetailInformationTab.inputGroup.studentsNumber": "Number of students",
	"pages.examDetailInformationTab.input.durationHours.placeholder": "Duration hours",
	"pages.examDetailInformationTab.input.durationMinutes.placeholder": "Duration minutes",
	"pages.examSeatAllocationTab.alert.examDateHasPassed.message": "Exam date has passed",
	"pages.examSeatAllocationTab.alert.examDateHasPassed.description": "The exam date has passed, and registered students cannot be changed",
	"pages.examSeatAllocationTab.alert.registrationOverflow.message": "Too Many Registered Students",
	"pages.examSeatAllocationTab.alert.registrationOverflow.description": "The exam has more registered than planned students. Increase the number of planned students or remove registered students.",
	"pages.examSeatAllocationTab.alert.seatAllocationIncomplete.message": "Seat allocation incomplete",
	"pages.examSeatAllocationTab.alert.seatAllocationIncomplete.description": "Not all registered students have been allocated a seat on the exam yet",
	"pages.examSeatAllocationTab.alert.selectionOverflow.message": "Not Enough Available Seats",
	"pages.examSeatAllocationTab.alert.selectionOverflow.description": "You have selected more students than there are available seats, and thus seat assignment is cannot be provided. Select fewer students or reschedule to a room bigger room.",
	"pages.examSeatAllocationTab.alert.confirmAllocation.message": "Confirm allocation for {number} student",
	"pages.examSeatAllocationTab.modal.allocateSelectedStudents": "Allocate selected students",
	"pages.examSeatAllocationTab.option.examSelection.selectUnallocated": "Select unallocated",
	"pages.examSeatAllocationTab.option.examSelection.selectAllocated": "Select allocated",
	"pages.examSeatAllocationTab.option.examSelection.selectFromTop": "Select from top",
	"pages.examSeatAllocationTab.option.examSelection.selectFromBottom": "Select from bottom",
	"pages.examSeatAllocationTab.option.examSelection.selectFromRandom": "Select from random",
	"pages.examSeatAllocationTab.label.selectChildExam": "Select sub exam",
	"pages.examSeatAllocationTab.label.seatsLeft": "Seats left",
	"pages.examSeatAllocationTab.label.seatingRange": "Seating range",
	"pages.examSeatAllocationTab.label.manageSelection": "Manage selection",
	"pages.examSeatAllocationTab.label.seatingInformation": "Seating information",
	"pages.examSeatAllocationTab.button.allocateSelectedStudents": "Allocate selected students",
	"pages.examSeatAllocationTab.button.deallocateSelectedStudents": "Deallocate selected students",
	"pages.examSpecialNeedsTab.modal.confirmRemoval.title": "Confirm removal",
	"pages.examSpecialNeedsTab.modal.confirmRemoval.content": "Assigned special needs for {selectedNumber} will be removed",
	"pages.examSpecialNeedsTab.alert.examDateHasPassed.message": "Exam date has passed",
	"pages.examSpecialNeedsTab.alert.examDateHasPassed.description": "The exam date has passed, and registered students cannot be changed",
	"pages.examSpecialNeedsTab.button.removeSpecialNeedsForSelection": "Remove special needs for selection",
	"pages.adjustPlannedStudents.alert.adjustPlannedStudents.message": "Adjust planned students",
	"pages.adjustPlannedStudents.alert.adjustPlannedStudents.description.1": "Decrease or increase the number of planned students to free up unused seats or if the exam is over registered.",
	"pages.adjustPlannedStudents.alert.adjustPlannedStudents.description.2": "The edited value have to be greater or equal to registered or allocated students respectively.",
	"pages.listStudents.button.removeSelectedStudents": "Remove selected students",
	"pages.listStudents.button.adjustPlannedStudents": "Adjust planned students",
	"pages.listStudents.modal.confirmRemoval.title": "Confirm removal",
	"pages.listStudents.modal.confirmRemoval.content": "{selectedNumber} students will be removed",
	"pages.listStudents.alert.examDateHasPassed.message": "Exam date has passed",
	"pages.listStudents.alert.examDateHasPassed.description": "The exam date has passed, and registered students cannot be changed",
	"pages.listStudents.alert.registrationOverflow.message": "Registration overflow",
	"pages.listStudents.alert.registrationOverflow.description": "The exam has more registered than planned students, either update planned students or remove registered students",
	"pages.listStudents.alert.studentRegistrationIncomplete.message": "Student registration incomplete",
	"pages.listStudents.alert.studentRegistrationIncomplete.description": "The exam has fewer registered than planned students, either update planned students or add more registered students",
	"pages.listStudents.alert.studentRegistrationComplete.message": "Student registration complete",
	"pages.listStudents.alert.studentRegistrationComplete.description": "Planned and registered students match",
	"pages.uploadStudent.message.dropFile": "Drop your file here to import the registered students.",
	"pages.uploadStudent.message.reviewResult": "Please review the import results below",
	"pages.uploadStudent.label.totalStudents": "Total students",
	"pages.uploadStudent.label.studentsEligibleForImport": "Students eligible for import",
	"pages.uploadStudent.button.removeDuplicateStudents": "Remove duplicate students",
	"pages.uploadStudent.button.importRegisteredStudents": "Import registered students",
	"pages.postExamManagementTab.panel.generalExamNotes": "General exam notes",
	"pages.postExamManagementTab.panel.studentNotes": "Student notes",
	"pages.postExamManagementTab.panel.billingReport": "Billing report",
	"pages.postExamManagementTab.label.studentMetric": "Student metric",
	"pages.postExamManagementTab.label.distributeUnderUtilization": "Distribute under utilization",
	"pages.postExamManagementTab.label.includePrepAndCleanUpTime": "Include prep and clean-up time in billing",
	"pages.postExamManagementTab.label.billingView": "Billing view",
	"pages.postExamManagementTab.group.overview": "Overview",
	"pages.postExamManagementTab.group.examView": "Exam view",
	"pages.examExport.label.selectExamToExport": "Select exams to export",
	"pages.examExport.label.examsSelected": "Exams selected",
	"pages.examExport.tab.pendingExams": "Pending exams",
	"pages.examExport.tab.scheduledExams": "Scheduled exams",
	"pages.examExport.tab.pastExams": "Past exams",
	"pages.examOverview.header.title": "Overview of Exams",
	"pages.examOverview.button.createNewExamRequest": "Create new exam request",
	"pages.examOverview.button.batchImportExamRequests": "Batch import exam requests",
	"pages.examOverview.tab.pendingExams": "Pending exams",
	"pages.examOverview.tab.scheduledExams": "Scheduled exams",
	"pages.examOverview.tab.pastExams": "Past exams",
	"pages.examSlotOverview.title": "Overview of Exam Slots",
	"pages.homeCEA.tab.roomBookings": "Room bookings",
	"pages.homeCEA.tab.scheduledExams": "Scheduled exams",
	"pages.homeCEA.tab.pendingExams": "Pending exams",
	"pages.homeDEC.tab.roomBookings": "Room bookings",
	"pages.homeDEC.tab.scheduledExams": "Scheduled exams",
	"pages.homeDEC.tab.pendingExams": "Pending exams",
	"pages.homeSupervisor.tab.pendingBookings": "Pending bookings",
	"pages.homeSupervisor.tab.confirmedBookingsTab": "Confirmed bookings",
	"pages.roomBooking.tab.overview": "Overview",
	"pages.roomBooking.tab.examOverview": "Exam overview",
	"pages.roomBooking.tab.seatAllocation": "Seat allocation",
	"pages.roomBooking.tab.supervisors": "Supervisors",
	"pages.roomBooking.tab.roomInformation": "Room information",
	"pages.roomBooking.tab.comments": "Comments",
	"pages.roomBooking.tab.publicSchedule": "Student site",
	"pages.roomBookingCommentsTab.channel.roomBooking": "Room booking",
	"pages.searAllocationTab.editExamAllocationLabel": "Edit exam allocation",
	"pages.setting.exam.tab.mandatoryObjects": "Mandatory objects",
	"pages.examSettings.schedulingPrioritiesSettingList.header": "Configure how scheduling priorities are used",
	"pages.examSettings.schedulingPrioritiesList.numberOfRequests.title": "Number of requests",
	"pages.examSettings.schedulingPrioritiesList.numberOfRequests.description": "The number of scheduling priorities a user is allowed to submit",
	"pages.examSettings.schedulingPrioritiesList.intervalsOrExamSlots.title": "Intervals or exam slots",
	"pages.examSettings.schedulingPrioritiesList.intervalsOrExamSlots.description": "If the user should use exam slots or predefined time intervals to prioritize their time preferences",
	"pages.examSettings.schedulingPrioritiesList.allowParamPrioritization.title": "Allow {param} prioritization",
	"pages.examSettings.schedulingPrioritiesList.allowDatePrioritization.description": "Should the user be allowed to add a date to their priorities",
	"pages.examSettings.schedulingPrioritiesList.allowRoomPrioritization.description": "Should the user be allowed to add a room to their priorities",
	"pages.examSettings.schedulingPrioritiesList.allowIntervalOrSlotPrioritization.description": "Should the user be allowed to supply a time preference with their priorities",
	"pages.examSetting.mandatoryList.header": "Configure which objects are mandatory in exams",
	"pages.examSetting.mandatoryList.departmentDescription": "A value indicating if, and / or which, special need the student is authorized for",
	"pages.examSetting.mandatoryList.label.enabled": "Enabled",
	"pages.examSetting.mandatoryList.label.isMandatory": "Is mandatory",
	"pages.examSetting.mandatoryList.label.allowMultiple": "Allow multiple",
	"pages.studentSettings.editMappingList.header": "Configure how TE Exam parses student registration files",
	"pages.studentSettings.editMappingList.studentIdDescription": "A unique student identifier used for seat allocation and locating a student's schedule",
	"pages.studentSettings.editMappingList.studentNameDescription": "The name of the student",
	"pages.studentSettings.editMappingList.studentAnonymizedCodeDescription": "An anonymous code used to identify students",
	"pages.studentSettings.editMappingList.studentPersonalIdentificationNumberDescription": "A student's personal identification number",
	"pages.studentSettings.editMappingList.registrationDateDescription": "A timestamp indicating when the student registered for the exam",
	"pages.studentSettings.editMappingList.externalExamNameDescription": "A string indicating the name of the exam in Ladok",
	"pages.studentSettings.editMappingList.specialNeedsAssignmentDescription": "A value indicating if, and / or which, special need the student is authorized for",
	"pages.studentSettings.registrationMappingInstruction.title": "Student registration mapping",
	"pages.studentSettings.registrationMappingInstruction.content": "Adjust how the Ladok files are used in mangaging the registered students for each exam.",
	"pages.studentSettings.header.studentRegistrationMapping": "Student registration mapping",
	"pages.studentSettings.upload.dropFilePlaceholder": "Drop an export file from Ladok here to start the configuration.",
	"pages.integrationSettings.integrationList.header": "Configure which objects are mandatory in exams",
	"pages.integrationSettings.dangerZoneAlert.message": "Danger zone",
	"pages.integrationSettings.dangerZoneAlert.description": "Editing properties here can break your connection with the TimeEdit server. Proceed with caution",
	"pages.integrationSettings.integrationList.baseUrl.title": "Base URL",
	"pages.integrationSettings.integrationList.baseUrl.description": "The URL TE Exam should use to connect to the TimeEdit server",
	"pages.integrationSettings.integrationList.username.title": "Username",
	"pages.integrationSettings.integrationList.username.description": "The username TE Exam should use to authenticate with the TimeEdit server",
	"pages.integrationSettings.integrationList.password.title": "Password",
	"pages.integrationSettings.integrationList.password.description": "The password TE Exam should use to authenticate with the TimeEdit server",
	"pages.integrationSettings.integrationList.certificateKey.title": "Certificate key",
	"pages.integrationSettings.integrationList.certificateKey.description": "The certificate key TE Exam should use to authenticate with the TimeEdit server",
	"pages.integrationSettings.tab.teExamRooms": "TE Exam Rooms",
	"pages.integrationSettings.tab.timeEditObjects": "TimeEdit Objects",
	"pages.integrationSettings.label.view": "View",
	"pages.integrationSettings.label.selectedTEObjects": "# of selected TE objects:",
	"pages.integrationSettings.content.selectedTEObjects": "{objectNumber} objects",
	"pages.integrationSettings.label.manageSelection": "Manage selection:",
	"pages.integrationSettings.tab.integrationOverview": "Integration overview",
	"pages.integrationSettings.tab.dataMapping": "Data mapping",
	"pages.integrationSettings.tab.reservationSettings": "Reservation settings",
	"pages.integrationSettings.tab.roomObjects": "Room objects",
	"utils.batchImportHelper.error.uploadFile.title": "Error uploading the file",
	"common.label.informationToAdministrators": "Information to the administrators",
	"common.label.informationToStudents": "Information to the students",
	"common.label.informationToSupervisors": "Information to the supervisors",
	"common.label.plannedStudents": "Planned students",
	"common.label.seat": "Seat",
	"common.message.successActivateItem": "The {item} {multi, select, true {were} false {was}} activated successfully",
	"common.message.successAdjustItem": "The {item} {multi, select, true {were} false {was}} adjusted successfully",
	"common.message.successAllocateItem": "The {item} {multi, select, true {were} false {was}} allocated successfully",
	"common.message.successAssignItem": "The {item} {multi, select, true {were} false {was}} assigned successfully",
	"common.message.successConfirmItem": "The {item} {multi, select, true {were} false {was}} confirmed successfully",
	"common.message.successCreateItem": "The {item} {multi, select, true {were} false {was}} created successfully",
	"common.message.successDeactivateItem": "The {item} {multi, select, true {were} false {was}} deactivated successfully",
	"common.message.successDeallocateItem": "The {item} {multi, select, true {were} false {was}} deallocated successfully",
	"common.message.successDeleteItem": "The {item} {multi, select, true {were} false {was}} deleted successfully",
	"common.message.successImportItem": "The {item} {multi, select, true {were} false {was}} imported successfully",
	"common.message.successRemoveItem": "The {item} {multi, select, true {were} false {was}} removed successfully",
	"common.message.successSaveItem": "The {item} {multi, select, true {were} false {was}} saved successfully",
	"common.message.successSubmitItem": "The {item} {multi, select, true {were} false {was}} submitted successfully",
	"common.message.successUpdateItem": "The {item} {multi, select, true {were} false {was}} updated successfully",
	"common.model.bookingRequest": "booking request",
	"common.model.checklist": "checklist",
	"common.model.postExamNotes": "post exam notes",
	"common.model.schedulingRequests": "scheduling request",
	"common.title.public.studentSchedule": "Student schedule",
	"components.freeTextFilter.placeholder.search": "Search...",
	"components.mainMenu.label.logOut": "Log out",
	"components.mainMenu.label.organization": "Organization",
	"components.mainMenu.title.switchOrganization": "Switch Organization",
	"components.schedulingFragment.error.invalidScheduling": "Invalid scheduling",
	"components.supervisorFoldout.title.supervisorDetails": "Supervisor details",
	"pages.examSchedulingRequest.error.priorityMinimum": "Exam needs to have at least {minRequestNumber, plural, one {# scheduling priority} other {# scheduling priorities}}",
	"pages.examSchedulingRequest.error.unique": "All scheduling priorities need to be unique",
	"pages.examSchedulingRequest.errorTitle.invalidSettings": "Invalid settings",
	"pages.examSchedulingRequest.message.notSetValue": "Not set",
	"pages.public.examAddToCalendarButton.button.addToCalendar": "Add to calendar",
	"pages.public.examInformation.panel.examInformation": "Exam information",
	"pages.public.examStatus.valueLabel.examStatus.notScheduled": "Not scheduled",
	"pages.public.examStatus.valueLabel.examStatus.pastExam": "Past exam",
	"pages.public.examStatus.valueLabel.examStatus.upcoming": "Upcoming",
	"pages.public.examStudentScheduleWrapper.error.examNotScheduled.description": "This exam has not scheduled yet, so we can't give you your schedule right now. Please check back in later.",
	"pages.public.examStudentScheduleWrapper.error.examNotScheduled.title": "You're fast! Too fast, almost.",
	"pages.public.examStudentScheduleWrapper.error.initialLoading.description": "We tried our best, but we weren't able to find the organization or the exam.",
	"pages.public.examStudentScheduleWrapper.error.initialLoading.title": "Ooops! Something looks off with your link.",
	"pages.public.examStudentScheduleWrapper.error.notYourSchedule.description": "Your schedule and seating information has not been determined yet. Please check back later.",
	"pages.public.examStudentScheduleWrapper.error.notYourSchedule.title": "Found you! But not your schedule :(",
	"pages.public.examStudentScheduleWrapper.error.pastExam.description": "Please note that this exam has already taken place.",
	"pages.public.examStudentScheduleWrapper.error.pastExam.title": "This is a past exam",
	"pages.public.examStudentScheduleWrapper.label.notesToStudents": "Notes to students",
	"pages.public.examStudentScheduleWrapper.label.yourSchedule": "Your schedule",
	"pages.public.examStudentScheduleWrapper.message.noNotesAdded": "No notes have been added",
	"pages.public.examsOnRoomBookingWrapper.header": "The following exams are scheduled on the room booking",
	"pages.public.readOnlyExamObjects.description.courseEvents": "Course events the exam is offered for",
	"pages.public.readOnlyExamObjects.description.courses": "Courses the exam is offered for",
	"pages.public.readOnlyExamObjects.description.departments": "Departments offering the exam",
	"pages.public.readOnlyExamObjects.description.language": "Language the exam is given in",
	"pages.public.readOnlyExamObjects.description.modules": "Modules the exam is offered for",
	"pages.public.readOnlyExamObjects.description.professors": "Professors responsible for the exam",
	"pages.public.readOnlyExamObjects.description.type": "How the exam is given",
	"pages.public.roomBookingPublicSchedule.title.roomBooking": "Room booking in {room} on {date} between {startTime} and {endTime}",
	"pages.public.studentSignIn.alt.logoAlt": "Student login",
	"pages.public.studentSignIn.button.viewYourExamSchedule": "View your exam schedule",
	"pages.public.studentSignIn.error.studentIdRequired": "Please input your student id to view your schedule.",
	"pages.public.studentSignIn.error.unableLocateStudentIdOnExam": "We were unable to locate your student id on the exam. Please try again.",
	"pages.public.studentSignIn.placeholder.studentId": "Enter your student id",
	"pages.public.studentSignIn.text.enterStudentId": "Enter your student id to locate your exam schedule.",
	"pages.public.studentSignIn.text.hola": "Hola, friend!",
	"pages.requestedSchedulingPane.message.notSetValue": "Not set",
	"pages.studentSeatingInformation.addToCalendarButton.description": "Seating id: {seatingId}. Seating info: {seatingInfo}",
	"pages.studentSeatingInformation.addToCalendarButton.title": "Exam: {exam}",
	"pages.studentSeatingInformation.label.studentAvatar": "Student avatar",
	"providers.examScheduling.message.successDeleteExamSchedule": "The scheduling for the exam was successfully deleted",
	"providers.examScheduling.message.successScheduleExam": "The exam was successfully scheduled",
	"providers.integrationSettings.message.successAddRoom": "The room was successfully added to TE Exam",
	"providers.integrationSettings.message.successRemoveRoom": "The room was successfully removed from TE Exam",
	"providers.integrationSettings.message.successUpdateIntegrationSettings": "Integration settings successfully updated",
	"providers.organization.message.successUpdateMandatoryObjects": "The mandatory objects were successfully updated",
	"providers.organization.message.successUpdateOrganizationName": "The organization name was successfully updated",
	"providers.organization.message.successUpdateSchedulingPrioritiesSettings": "The scheduling priorities settings were successfully updated",
	"providers.organization.message.successUpdateStudentRegistrationMapping": "The student registration mapping was successfully updated",
	"providers.roomBooking.message.successBookRoom": "Your room was successfully booked",
	"providers.roomBooking.message.successOperate": "Operation was successful",
	"providers.roomBooking.message.successUpdateSupervisorsNeed": "Supervisors needed was updated",
	"providers.utils.message.operationCompleted": "Operation completed",
	"providers.utils.message.operationFailed": "Operation failed",
	"common.placeholder.information": "Comments, permitted resources, ..",
	"common.valueLabel.isActive.pending": "Pending",
	"pages.examDetailInformationTab.message.informationToAdministrators": "Only administrators and the exam owner will see this",
	"common.error.emailExists": "The email is already in use.",
	"pages.supervisorSchedulingRequest.error.invalidRequest": "Invalid Request",
	"pages.supervisorSchedulingRequest.error.requestAccepted": "Your request has been accepted. You cannot modify it.",
	"pages.supervisorSchedulingRequest.error.requestDeclined": "Your request has been declined. You cannot change it.",
	"pages.supervisorSchedulingRequest.error.requestNotExist": "Your request does not exist",
	"pages.supervisorSchedulingRequest.message.requestAccepted": "Your request has been accepted",
	"pages.supervisorSchedulingRequest.message.requestDeclined": "Your request has been declined",
	"common.button.addToCalendar": "Add to calendar",
	"common.button.backToOverview": "Back to overview",
	"common.button.batchImportExamRequests": "Batch import exam requests",
	"common.button.createNewItem": "Create new {item}",
	"common.button.deleteSelectedItem": "Delete selected {item}",
	"common.button.matchAll": "Match all",
	"common.button.matchOne": "Match one",
	"common.button.scheduleHere": "Schedule here",
	"common.button.showSelectedRoomBooking": "Show selected room booking",
	"common.button.view": "View",
	"common.error.uploadDuplicateStudentIds": "The file contains duplicate student ids. Please ensure all student ids are unique.",
	"common.label.additionalInformation": "Additional information",
	"common.label.allocateSelectedStudents": "Allocate selected students",
	"common.label.basicInformation": "Basic information",
	"common.label.comments": "Comments",
	"common.label.dataMapping": "Data mapping",
	"common.label.dateAndTime": "Date & time",
	"common.label.editExamAllocation": "Edit exam allocation",
	"common.label.examInformation": "Exam information",
	"common.label.examOverview": "Exam overview",
	"common.label.examSlots": "Exam slots",
	"common.label.filters": "Filters",
	"common.label.integrationOverview": "Integration overview",
	"common.label.key": "Key",
	"common.label.manageSelection": "Manage selection",
	"common.label.mandatoryObjects": "Mandatory objects",
	"common.label.numberOfStudents": "Number of students",
	"common.label.overview": "Overview",
	"common.label.pastExams": "Past exams",
	"common.label.pendingExams": "Pending exams",
	"common.label.postExamManagement": "Post exam management",
	"common.label.publicSchedule": "Public schedule",
	"common.label.reservationSettings": "Reservation settings",
	"common.label.roomBooking": "Room booking",
	"common.label.roomBookings": "Room bookings",
	"common.label.roomInformation": "Room information",
	"common.label.roomObjects": "Room objects",
	"common.label.rule": "Rule",
	"common.label.scheduledExams": "Scheduled exams",
	"common.label.scheduling": "Scheduling",
	"common.label.seatAllocation": "Seat allocation",
	"common.label.seatingInformation": "Seating information",
	"common.label.selectChildExam": "Select child exam",
	"common.label.selectItem": "Select {item}",
	"common.label.selectedItem": "Selected {item}",
	"common.label.selectedObjects": "Selected objects",
	"common.label.selectedTEObjects": "# of selected TE objects",
	"common.label.selection": "Selection",
	"common.label.showCompatibleRoomBookings": "Show compatible room bookings",
	"common.label.specialNeeds": "Special needs",
	"common.label.studentRegistration": "Student registration",
	"common.label.supervisorsAccepted": "Supervisors accepted",
	"common.label.supervisorsNeeded": "Supervisors needed",
	"common.label.supervisorsScheduled": "Supervisors scheduled",
	"common.label.teExamRooms": "TE Exam Rooms",
	"common.label.timeEditObjects": "TimeEdit Objects",
	"common.label.viewMode": "View mode",
	"common.message.atLeastSchedulingPriority": "To save your exam request, please add at least {priorityNumber, plural, one {# scheduling priority} other {# scheduling priorities}}",
	"common.message.checklistNeedTitle": "You can't mark it as done before you've given it a title",
	"common.message.confirmAllocation": "Confirm allocation for {number} student",
	"common.message.confirmDeleteRoomBooking": "Are you sure you want to delete room booking on {date} in {room}?",
	"common.message.confirmDeleteRoomBookingContent": "All exams, supervisors and students scheduled and allocated on the room booking will be removed from them.",
	"common.message.confirmDeleteRoomBookings": "Are you sure you want to delete selected room bookings?",
	"common.message.confirmProceed": "Are you sure you want to proceed?",
	"common.message.examInformationLocked": "Exam information is locked",
	"common.message.examInformationLockedDesc": "Editing the basic information is not possible after the exam has been saved",
	"common.message.examNamingOptional": "Naming your exam is optional, you can always refer to it by its ID",
	"common.message.infoToAdministratorsNotice": "Only administrators and the exam owner will see this",
	"common.message.noFilter": "You have not added any filters yet",
	"common.model.externalBooking": "external booking",
	"common.model.registeredStudents": "registered students",
	"common.placeholder.filterProperties": "Filter properties...",
	"common.placeholder.notAssigned": "Not assigned",
	"common.placeholder.search": "Search...",
	"common.placeholder.select": "Select...",
	"common.placeholder.selectCategory": "Select a category",
	"common.placeholder.selectFilterRule": "Select a filter rule",
	"common.placeholder.selectProperty": "Select a property",
	"common.placeholder.typeToEdit": "Type to edit me...",
	"common.placeholder.untitledExam": "Untitled exam",
	"common.title.common.overviewOfItem": "Overview of {item}",
	"common.title.roomBooking": "Room booking in {room} on {date} between {startTime} and {endTime}",
	"common.valueLabel.examStatus.notScheduled": "Not scheduled",
	"common.valueLabel.examStatus.pastExam": "Past exam",
	"common.valueLabel.examStatus.upcoming": "Upcoming",
	"common.valueLabel.importStatus.duplicate": "Duplicate",
	"common.valueLabel.importStatus.ok": "OK",
	"common.valueLabel.publicationStatus.modified": "Modified",
	"common.valueLabel.publicationStatus.notPublished": "Not published",
	"common.valueLabel.publicationStatus.published": "Published{date, select, NONE {} other { on {date}}}",
	"common.valueLabel.publicationStatus.publishedWithChanges": "Published{date, select, NONE {} other { on {date}}}, but there are changes",
	"common.valueLabel.studentCount.allocated": "{number} students allocated",
	"common.valueLabel.studentCount.capacity": "{number} students capacity",
	"common.valueLabel.studentCount.planned": "{number} students planned",
	"common.valueLabel.studentCount.registered": "{number} students registered",
	"common.valueLabel.studentCount.scheduled": "{number} students scheduled",
	"components.childExamFormDialog.message.confirmDecreaseParentStudents.content": "The total number of students in the child exams is lower than in the main exam.",
	"components.childExamFormDialog.message.confirmDecreaseParentStudents.proceed": "Do you want to decrease the number of students in the main exam to match the number of students in the child exams?",
	"components.childExamFormDialog.message.confirmIncreaseOverbook.content": "By increasing seats of this exam, scheduled room booking and any other exams booked on this room booking will not be able to use seat assignment features for students.",
	"components.childExamFormDialog.message.confirmIncreaseOverbook.title": "Confirm overbooking of room",
	"components.childExamFormDialog.message.confirmIncreaseParentStudents.content": "Total planned students on child exams is now more than planned students on the main exam. Planned students on the main exam will be updated.",
	"components.examCostChart.label.costForExam": "Cost for {examId}",
	"components.examReassignmentModal.message.examOwnershipChanged": "Exam ownership changed",
	"components.examReassignmentModal.message.examOwnershipChangedMessageDesc": "You have been redirected since you are no longer the owner of this exam.",
	"components.examReassignmentModal.message.reassignConfirm": "Are you sure you want to reassign this exam?",
	"components.examReassignmentModal.message.reassignConfirmContent": "Reassigning the exam will permanently change the ownership. Click OK to proceed.",
	"components.examReassignmentModal.message.reassignTitle": "Reassign exam",
	"components.publishPane.message.examCannotBePublished": "Exam cannot be published since it's not scheduled yet",
	"components.scheduledSupervisorActionsDropdown.button.acceptBookingForSupervisor": "Accept booking for supervisor",
	"components.schedulingFragment.message.overbookAlert.description": "By scheduling your exam here, you are overbooking this room.",
	"components.schedulingFragment.message.overbookAlert.message": "Overbooking room",
	"components.schedulingFragment.message.overbookConfirm.content": "By overbooking the room, this and any other exams booked on this room booking will not be able to use seat assignment features for students.",
	"components.schedulingFragment.message.overbookConfirm.title": "Confirm overbooking of room",
	"components.setSupervisorCount.message.bookingHasPast": "This room booking has past, so no edits are allowed",
	"components.studentScheduleError.message": "If you think something is wrong or you need help, please contact your administrator.",
	"components.supervisorAvailabilityCalendar.historicalBooking.content": "You cannot create an event for a date and time that has passed",
	"components.supervisorAvailabilityCalendar.historicalBooking.title": "This date and time has already passed",
	"components.supervisorAvailabilityCalendar.overlappingBooking.content": "This booking overlaps with a session you are scheduled on",
	"components.supervisorAvailabilityCalendar.overlappingBooking.title": "Overlapping bookings",
	"components.totalExamCostChart.label.costForExam": "Cost for exam",
	"components.totalExamCostChart.label.costForExamIdLabel": "Cost for {examId}",
	"pages.examDetail.message.redirectedToParentExam.description": "The exam you clicked on is a child exam, you have been redirected to the main exam",
	"pages.examDetail.message.redirectedToParentExam.message": "Redirected to parent exam",
	"pages.examSeatAllocationTab.alert.overbookedRoom.description": "This exam is scheduled on an overbooked room, and thus seat assignment cannot be provided",
	"pages.examSeatAllocationTab.alert.overbookedRoom.message": "Overbooked Room",
	"pages.examSeatAllocationTab.message.confirmOverbook.content": "You are allocating more students than there is capacity on the room. This means seating numbers will not be available. Are you sure you want to continue?",
	"pages.examSeatAllocationTab.message.confirmOverbook.title": "Confirm overbooking",
	"pages.roomBooking.alert.overbooked.description": "This room booking is overbooked, and thus allocated students will not be given seat assignments on the exams.",
	"pages.roomBooking.alert.overbooked.message": "Overbooked room",
	"pages.roomBooking.alert.overbooked.toChange": "To change this, please remove exams or adjust the planned students.",
	"pages.roomBooking.label.selectBookingsToDelete": "Select room bookings to delete",
	"pages.roomBooking.label.selectBookingsToExport": "Select room bookings to export",
	"common.button.acceptItem": "Accept {item}",
	"common.button.book": "Book",
	"common.button.bookMoreItem": "Book more {item}",
	"common.button.closeWithSaving": "Save and close",
	"common.button.closeWithoutSaving": "Close without saving",
	"common.button.goToNextWeek": "Go to next week",
	"common.button.goToPreviousWeek": "Go to previous week",
	"common.button.help": "Help",
	"common.button.publishExams": "Publish Exams",
	"common.button.selectAllDay": "Select all day",
	"common.button.selectWeek": "Select week",
	"common.button.viewItem": "View {item}",
	"common.error.outsideOfRoomBooking": "The {denominator} is outside of the room booking",
	"common.error.phoneNumber": "The input is not valid phone number.",
	"common.error.required_short": "Required",
	"common.label.availableCapacity": "Available capacity",
	"common.label.bookedSupervisors": "Booked supervisors",
	"common.label.bookingInfo": "Booking info",
	"common.label.bookingTitle": "Booking title",
	"common.label.campuses": "Campuses",
	"common.label.canBeLead_long": "Can be main supervisor",
	"common.label.contractType": "Contract type",
	"common.label.dayView": "Day view",
	"common.label.depublishExam": "Depublish exam",
	"common.label.examLanguages": "Exam languages",
	"common.label.examLength": "Exam length",
	"common.label.examTypes": "Exam types",
	"common.label.externalSupervisorBooking": "External supervisor booking",
	"common.label.hasExams": "Has exams",
	"common.label.hasSupervisors": "Has supervisors",
	"common.label.isEmailSent": "Email sent",
	"common.label.isLead_long": "Is lead",
	"common.label.isOverbooked": "Is overbooked",
	"common.label.label": "Label",
	"common.label.needsSupervisors": "Needs supervisors",
	"common.label.numberOfItem": "Number of {item}",
	"common.label.otherExamsOnRoomBooking": "Other exams on room booking",
	"common.label.phoneNumber1": "Phone number 1",
	"common.label.phoneNumber2": "Phone number 2",
	"common.label.price": "Price",
	"common.label.publishExam": "Publish exam",
	"common.label.requestedDuration": "Requested duration",
	"common.label.roomBookingHours": "Room booking hours",
	"common.label.rooms": "Rooms",
	"common.label.selectedCalendar": "Selected calendar",
	"common.label.sendEmailImmediately": "Send email immediately",
	"common.label.showPagination": "Show pagination",
	"common.label.slotView": "Slot view",
	"common.label.studentDistribution": "Student distribution",
	"common.label.supervisorBooking": "Supervisor booking",
	"common.label.supervisorHours": "Supervisor hours",
	"common.label.supervisorInformation": "Supervisor information",
	"common.label.timeline": "Timeline",
	"common.label.timing": "Timing",
	"common.label.totalCapacity": "Total capacity",
	"common.label.unavailable": "Unavailable",
	"common.message.examHasPast": "Exam has past",
	"common.message.examHasPastDesc": "Scheduling or basic information cannot be edited",
	"common.message.mayNotBeSaved": "There are changes made to the scheduling priorities which are not saved, are you sure you want to leave the page?",
	"common.message.nothingSelected": "Nothing has been selected",
	"common.message.onlyAvailableForScheduledExam": "Only available for scheduled exam",
	"common.message.unscheduled": "unscheduled",
	"common.model.availability": "availability",
	"common.placeholder.noItem": "No {item}",
	"common.placeholder.pleaseSelectItem": "Please select {item}",
	"common.placeholder.searchItem": "Search {item}",
	"common.title.common.publish": "Publish Exams",
	"common.title.leavePage": "Leave page?",
	"common.title.roomBookingInRoom": "Room booking in {room}",
	"common.title.supervisorBookingInRoom": "Booking of {supervisor} in {room}",
	"common.valueLabel.bookingStatus.accepted": "Accepted",
	"common.valueLabel.bookingStatus.pending": "Pending",
	"common.valueLabel.bookingStatus.scheduled": "Scheduled",
	"common.valueLabel.boolean.no": "No",
	"common.valueLabel.boolean.notYet": "Not yet",
	"common.valueLabel.boolean.yes": "Yes",
	"common.valueLabel.contractType.consultant": "Consultant",
	"common.valueLabel.contractType.employee": "Employee",
	"common.valueLabel.itemCount.allocatedPlannedstudents": "{allocated}/{planned} students",
	"common.valueLabel.itemCount.confirmedScheduledNeededSupervisors": "{confirmed}/{scheduled}/{needed} supervisors",
	"common.valueLabel.itemCount.exams": "{number} exams",
	"common.valueLabel.itemCount.pricePerSeatPerHour": "{price} / seat / hour",
	"common.valueLabel.itemCount.students": "{number} students",
	"common.valueLabel.mainSupervisor.isLead": "Is lead supervisor",
	"common.valueLabel.overbooked.notOverbooked": "Not overbooked",
	"common.valueLabel.overbooked.overbooked": "Overbooked",
	"components.childExamFormDialog.button.confirmDecreaseParentStudents.no": "No, keep number of students",
	"components.childExamFormDialog.button.confirmDecreaseParentStudents.yes": "Yes, decrease on main exam",
	"components.childExamFormDialog.message.confirmDecreaseParentStudents.title": "Decrease the number of students",
	"components.dynamicTable.selectColumn.title": "Select columns to display in table",
	"components.publicationStatus.couldNotBePublished.title": "The exam could not be published because {error}.",
	"components.resourceScheduler.acceptSupervisorBookingModal.content": "Are you sure you want to manually accept this booking?",
	"components.resourceScheduler.acceptSupervisorBookingModal.title": "Confirm manually accepting this booking",
	"components.resourceScheduler.declineSupervisorBookingModal.content": "Are you sure you want to decline this supervisor's booking?",
	"components.resourceScheduler.declineSupervisorBookingModal.title": "Confirm declining this booking",
	"components.resourceScheduler.label.eventFilters": "Event filters",
	"components.resourceScheduler.label.resourceFilters": "Resource filters",
	"components.resourceScheduler.removeSupervisorBookingModal.content": "Are you sure you want to cancel this supervisor's booking?",
	"components.resourceScheduler.removeSupervisorBookingModal.title": "Confirm cancelling this booking",
	"components.resourceScheduler.unableToMoveSupervisorBooking.description": "The new time collides with another booking",
	"components.resourceScheduler.unableToMoveSupervisorBooking.message": "Unable to move supervisor booking",
	"components.scheduledSupervisorActionsDropdown.button.sendEmailToSupervisor": "Send email to supervisor",
	"components.supervisorAvailabilityCalendar.alert.selectResponseFor.content": "to change your response after you have submitted it, you need to contact your administrator",
	"components.supervisorAvailabilityCalendar.alert.selectResponseFor.note": "NOTE",
	"components.supervisorAvailabilityCalendar.alert.selectResponseFor.title": "Select your response with the buttons below",
	"components.supervisorAvailabilityCalendar.button.confirmBooking": "I confirm this booking",
	"components.supervisorAvailabilityCalendar.button.declineBooking": "I decline this booking",
	"components.supervisorAvailabilityCalendar.button.selectResponse": "Select your response",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.confirmDeclineBooking.description": "Exam bookings are indicated in green or striped green colors. If you haven't yet accepted a booking (as indicated by its stripes), you can click on it and choose to either accept or decline it",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.confirmDeclineBooking.title": "View, confirm or decline your bookings",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.editAvailability.description": "You can edit your availability by dragging and resizing any of the red events, or click on them to change the title or delete them",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.editAvailability.title": "Edit your availability",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.enterAvailability.description": "Use the drag and drop interface in the calendar to indicate during which days and times you are not able to work",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.enterAvailability.title": "Enter your availability",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.title": "How to use the calendar",
	"components.supervisorAvailabilityCalendar.title.myAvailability": "My availability and bookings",
	"components.supervisorAvailabilityCalendar.title.selectResponseFor": "Select response for {event}",
	"components.teExamCalendar.tooltip.time": "(Prep time start) - (exam time start) --- (exam time end) - (clean-up time end)",
	"pages.studentSettings.message.studentIdLabelDescription": "(Seen by students on the student registration page)",
	"pages.teIntegration.button.applyChanges": "Apply changes",
	"pages.teIntegration.message.applyChangesWarning": "Click here to update the TEX room objects with new values from TE Server, e.g., if the data has been changed in TE Server, or if the mapping has been updated",
	"common.button.close": "Close",
	"common.label.emailStatus": "Email status",
	"common.label.externalReference": "External reference",
	"common.label.inboundLinks": "Inbound links",
	"common.label.linking": "Linking",
	"common.label.sendBookingRrequestEmailToDupervisor": "Send booking request email to supervisor",
	"common.label.sendToUserOn": "Sent to user on",
	"common.label.theSupervisorWillReceiveAnEmail": "The supervisor(s) will receive an email asking them to confirm the booking. You can choose to send this email now by checking the checkbox below, or later from the booked supervisors table.",
	"common.label.thisExamIsLinkedFrom": "This exam is linked from",
	"common.label.thisExamIsLinkedTo": "This exam is linked to",
	"common.message.invalidPriorities": "There are invalid priorities",
	"common.message.prioritiesHaveError": "The following errors are stopping you from saving",
	"common.placeholder.externalExamReference": "External exam reference",
	"common.valueLabel.emailStatus.notSent": "Not sent",
	"common.valueLabel.emailStatus.sent": "Sent",
	"components.childExamFormDialog.button.copyExistingScheduling.no": "Copy existing scheduling",
	"components.childExamFormDialog.button.processWithCautionCoping": "The scheduling from exam {id} will be copied to a new child exam",
	"components.childExamFormDialog.button.publicationWillBeGone.no": "If the exam has been published, the publication will be removed",
	"components.childExamFormDialog.message.copyTheSchedulingFromTheCurrent": "Copy existing scheduling from exam {id} into a new child exam",
	"components.dateRange.nextMonth": "Next month",
	"components.dateRange.nextWeek": "Next week",
	"components.dateRange.thisMonth": "This month",
	"components.dateRange.thisWeek": "This week",
	"components.dateRange.today": "Today",
	"components.requestedSchedulingListDetailPad.alert.prioritiesAddLeast.errorMessage": "The following errors are stopping you from saving",
	"components.requestedSchedulingListDetailPad.alert.prioritiesInvalidWarning.message": "There are invalid priorities",
	"components.requestedSchedulingListDetailPad.alert.prioritiesMaximumWarning.message": "Please add maximun {maxNumber} additional scheduling priorities",
	"pages.examOverview.selectExamToPublish": "Select exams to publish",
	"pages.examSetting.mandatoryList.error.minMandatoryObjectToPublish": "You need at least 1 object designated as mandatory to publish to TE Server",
	"pages.examSetting.mandatoryList.label.shouldPublish": "Publish to TE Server",
	"pages.homeSupervisor.tab.pastBookingsTab": "Past bookings",
	"common.button.blockAllDay": "Block all day",
	"common.label.bookings": "Bookings",
	"common.label.bulkActions": "Bulk actions",
	"common.label.capacityOverview": "Capacity overview",
	"common.label.greeting": "Greeting",
	"common.label.hasLink": "Has link",
	"common.label.itemsSelected": "Items selected",
	"common.label.otherEventsOnSameDay": "Other events on the same day",
	"common.label.published": "Published",
	"common.message.errorSendEmails": "{number} emails were unable to send",
	"common.message.successBookRoom": "Your room was successfully booked",
	"common.message.successOperate": "Operation was successful",
	"common.message.successSendEmail": "The email was sent successfully",
	"common.message.successSendEmails": "{number} emails were sent successfully",
	"common.message.successSendNoEmails": "No emails were sent",
	"common.message.successUpdateSupervisorsNeed": "Supervisors needed was updated",
	"common.title.common.addNewItem": "Add new {item}",
	"common.valueLabel.examSchedulingStatus.past": "Past",
	"common.valueLabel.examSchedulingStatus.pending": "Pending",
	"common.valueLabel.examSchedulingStatus.scheduled": "Scheduled",
	"pages.exam.message.publishedExamFailure": "Published exam {examId} unsuccessfully",
	"pages.exam.message.publishedExamSuccess": "Published exam {examId} successfully",
	"common.label.hasNoExams": "Has no exams",
	"common.label.supervisorsSelected": "Supervisors selected",
	"common.message.SendConfirmationEmailsToSupervisors": "Send confirmation emails to supervisors",
	"common.message.thisWillSendABookingConfirmationEmail": "This will send a booking confirmation email to all supervisors on the selected room bookings who have not yet received an email and have not yet confirmed the request. Do you wish to proceed?",
	"common.message.useThisButtonToSaveChanges": "Use this button to save changes to the supervisors work hours and main supervisor",
	"common.valueLabel.role.examAdministrator": "Exam Administrator",
	"common.valueLabel.role.examCoordinator": "Exam Coordinator",
	"common.valueLabel.role.examManager": "Exam Manager",
	"common.valueLabel.role.supervisorCoordinator": "Supervisor Coordinator",
	"components.scheduledSupervisorActionsDropdown.button.scheduleSupervisor": "Schedule supervisor",
	"components.supervisorAvailabilityCalendar.button.bookAllDay": "Book all day",
	"components.supervisorAvailabilityCalendar.label.displayingDates": "Displaying dates",
	"components.supervisorAvailabilityCalendar.weekPicker.format": "{from} - {to} {year} (Week {week})",
	"common.label.hasNoSupervisors": "Has no supervisors",
	"common.label.hasRightNumber": "Has right number",
	"common.label.hasTooFew": "Has too few",
	"common.label.isReExam": "Is re-exam",
	"common.label.requestedDate": "Requested date",
	"common.label.scheduledDate": "Scheduled date",
	"common.valueLabel.bookingStatus.declined": "Declined",
	"common.valueLabel.isReExam.reExam": "Re-exam",
	"common.error.theSchedulingDoesNotMatchAnyOfTheSubmittedSchedulingPriorities": "The scheduling does not match any of the submitted scheduling priorities",
	"common.label.priorities": "Priorities",
	"common.label.roomBookingOverview": "Room booking overview",
	"common.label.studentInformation": "Student information",
	"common.label.visible": "Visible",
	"common.message.makeTheBookingVisibleToSupervisor": "Make booking request visible to supervisor",
	"common.title.settings.profile": "Profile",
	"common.valueLabel.filter.myExams": "My exams",
	"components.scheduledSupervisorActionsDropdown.button.setInvisibleForSupervisor": "Set invisible for supervisor",
	"components.scheduledSupervisorActionsDropdown.button.setVisibleForSupervisor": "Set visible for supervisor",
	"components.schedulingFragment.error.importantInformationAboutYourScheduling": "Important information about your scheduling",
	"common.button.duplicateExam": "Duplicate exam",
	"common.button.selectAllWithBbookingsThisWeek": "Select all with bookings this week",
	"common.label.ascending": "Ascending",
	"common.label.childExams": "Child exams",
	"common.label.confirmToDeleteExams": "Do you want to delete {multi, select, true {these exams scheduling} false {this exam scheduling}}?",
	"common.label.confirmToDeleteRoomBooking": "Do you want to delete this room booking?",
	"common.label.confirmToDeleteSupervisors": "Do you want to delete {multi, select, true {these supervisors scheduling} false {this supervisor scheduling}}?",
	"common.label.deleteAllExams": "Delete all exam scheduling",
	"common.label.deleteAllSupervisors": "Delete all supervisor scheduling",
	"common.label.deleteRoomBooking": "Delete room booking",
	"common.label.descending": "Descending",
	"common.label.duplicateAnExamRequest": "Duplicate an exam request",
	"common.label.empty": "Empty",
	"common.label.examCalendar": "Exam calendar",
	"common.label.greenRed": "Green - Red",
	"common.label.lastUpdated": "Last Updated",
	"common.label.redGreen": "Red - Green",
	"common.label.roomBookingCalendar": "Room booking calendar",
	"common.label.roomSeats": "Room seats",
	"common.label.setMyselfAsOwner": "Set myself as owner",
	"common.label.showAll": "Show all",
	"common.label.supervisorCalendar": "Supervisor calendar",
	"common.label.viewIn": "View in ...",
	"common.message.successCloneItem": "The {item} {multi, select, true {were} false {was}} cloned successfully",
	"pages.examExportSettings.label.includeSchedulingPrioritiesLabel": "Include scheduling priorities",
	"common.button.depublishExams": "Depublish Exams",
	"common.button.deselectAll": "Deselect all",
	"common.button.previewAsItem": "Preview as {item}",
	"common.button.selectAll": "Select all",
	"common.button.selectAllWithBookingsToday": "Select all with bookings today",
	"common.error.empty": "{item} cannot be empty.",
	"common.label.allocatedExam": "Allocated exam",
	"common.label.allocationStatus": "Allocation status",
	"common.label.archiveOrDeleteGDPR": "Archive or delete personal data from database",
	"common.label.blank": "Blank",
	"common.label.children_modified": "Children modified",
	"common.label.confirmToDeleteConfig": "Do you want to delete this config?",
	"common.label.created": "Created",
	"common.label.customField1": "Custom field 1",
	"common.label.customField2": "Custom field 2",
	"common.label.customField3": "Custom field 3",
	"common.label.customField4": "Custom field 4",
	"common.label.customField5": "Custom field 5",
	"common.label.deallocated": "Deallocated",
	"common.label.deleteAllPersonalData": "Delete all personal data",
	"common.label.deleteExams": "Delete all exams",
	"common.label.deleteStudents": "Delete all students",
	"common.label.deleteSupervisors": "Delete all supervisors",
	"common.label.deleteUsers": "Delete all users",
	"common.label.deleted": "Deleted",
	"common.label.depublished": "Depublished",
	"common.label.depublishedExams": "Depublished exams",
	"common.label.eventLog": "Event log",
	"common.label.events": "Events",
	"common.label.examTitle": "Exam title",
	"common.label.exam_checklist": "Exam checklist",
	"common.label.exam_comment": "Exam comment",
	"common.label.exam_student": "Exam student",
	"common.label.exportPersonal": "Export personal data",
	"common.label.filterItem": "Filter {item}",
	"common.label.freeTextFields": "Free text fields",
	"common.label.from_until": "From - until",
	"common.label.gdpr": "GDPR",
	"common.label.generateReport": "Generate report",
	"common.label.hasExpiredRequests": "Has expired requests",
	"common.label.imported": "Imported",
	"common.label.isAllocated": "Is allocated",
	"common.label.landscape": "Landscape",
	"common.label.modified": "Modified",
	"common.label.noEvents": "No events",
	"common.label.orientation": "Orientation",
	"common.label.portrait": "Portrait",
	"common.label.postExamNotes": "Post exam notes",
	"common.label.reassigned": "Reassigned",
	"common.label.registeredExam": "Registered exam",
	"common.label.reportFormat": "Report format",
	"common.label.reportInformation": "Report information",
	"common.label.reportTemplate": "Report template",
	"common.label.reportType": "Report Type",
	"common.label.resources": "Resources",
	"common.label.roomBookingId": "Room booking id",
	"common.label.scheduled": "Scheduled",
	"common.label.search": "Search",
	"common.label.searchAmong": "Search among",
	"common.label.searchForGDPR": "Search for email, name or personal number",
	"common.label.searchResult": "Search result",
	"common.label.secondaryLabel": "Secondary label",
	"common.label.selectDate": "Select date",
	"common.label.showing": "Showing",
	"common.label.sortBy": "Sort by",
	"common.label.title": "Title",
	"common.label.unscheduled": "Unscheduled",
	"common.label.updated": "Updated",
	"common.label.username": "Username",
	"common.label.users": "Users",
	"common.label.width": "Width",
	"common.model.row": "row",
	"common.model.template": "template",
	"common.title.newReportingTemplate": "New reporting template",
	"common.title.reportingTemplates": "Reporting templates",
	"common.title.supervisorExternalBookingInRoom": "External booking by {supervisor}",
	"common.valueLabel.bookingStatus.expired": "Expired",
	"common.valueLabel.examSchedulingStatus.depublished": "Depublished",
	"common.valueLabel.publicationStatus.depublished": "Depublished",
	"components.childExamFormDialog.button.addNewChildExam": "Add new child exam",
	"components.childExamFormDialog.label.seatLeftNumber": "Number of seats left",
	"components.childExamFormDialog.label.totalChildExamNumber": "Total number of child exams",
	"components.childExamFormDialog.message.confirmIncreaseParentStudents.title": "Planned students to be updated",
	"components.childExamFormDialog.message.copyTheSchedulingFromTheCurrentNote": "(If not, the current exam scheduling will be deleted)",
	"components.childExamFormDialog.title.editChildExam": "Edit child exams for {id} - {name}",
	"components.reportingTemplate.adjustedColumnWidthContent": "The column width will be adjusted in order to not line break in the middle of a word.",
	"components.reportingTemplate.adjustedColumnWidthTitle": "Adjusted Column Width",
	"components.reportingTemplate.columnCountInvalid": "Please add at least 1 column",
	"components.reportingTemplate.columnIsMissing": "Column {item} is required",
	"components.reportingTemplate.nameIsRequired": "Template name is required",
	"components.reportingTemplate.validationFailed": "Validation Failed",
	"components.resourceScheduler.removeUnavailableSupervisorBookingModal.content": "Are you sure you want to cancel this supervisor's unavailable booking?",
	"components.resourceScheduler.removeUnavailableSupervisorBookingModal.title": "Confirm cancelling this unavailable booking",
	"components.teExamCalendar.supervisorBookingExpiration.content": "Select the number of days the supervisor(s) has to answer to this booking request.",
	"components.teExamCalendar.supervisorBookingExpiration.expirationDate": "Booking request expires on {expirationDate}",
	"components.teExamCalendar.supervisorBookingExpiration.title": "Deadline to answer booking request",
	"pages.examOverview.selectExamToDepublish": "Select exams to depublish",
	"pages.examSetting.examCustomizations.description": "Create certain customizations",
	"pages.examSetting.examCustomizations.examTitleInstruction.description": "An instruction for what to enter as the exam title on an exam request",
	"pages.examSetting.examCustomizations.examTitleInstruction.title": "Exam title instruction",
	"pages.examSetting.examCustomizations.supervisorBookingExpirationDays.description": "Default number of days for the supervisor to answer to a booking request",
	"pages.examSetting.examCustomizations.supervisorBookingExpirationDays.title": "Supervisor booking request deadline",
	"pages.examSetting.tab.otherCustomizations": "Other customizations",
	"pages.homeSupervisor.tab.expiredBookingsTab": "Expired bookings",
	"providers.organization.message.successUpdateExamSettingsMessage": "The exam settings were successfully updated",
	"common.button.cancelExam": "Cancel exam",
	"common.button.cancelExams": "Cancel Exams",
	"common.button.selectItem": "Select {item}",
	"common.button.unCancelExam": "Uncancel exam",
	"common.label.cancelExam": "Cancel exam",
	"common.label.cancelledExams": "Cancelled exams",
	"common.label.coordinators": "Coordinators",
	"common.label.deactivationDate": "Deactivation date",
	"common.label.studentSeat": "Student Seat",
	"common.valueLabel.examSchedulingStatus.cancelled": "Cancelled",
	"components.moveRoomBookingDialog.action.cancelBooking": "Cancel booking",
	"components.moveRoomBookingDialog.action.keepOldBooking": "Keep old booking",
	"components.moveRoomBookingDialog.action.sendNewBooking": "Send new booking request",
	"components.moveRoomBookingDialog.alert.examTimeLongerOrShorter": "Please note that the requested exam time is longer or shorter than the selected slot time.",
	"components.moveRoomBookingDialog.alert.supervisorUnavailable": "Please note that one or several supervisors are unavailable in the selected time slot.",
	"components.moveRoomBookingDialog.retainRoomBookingCheckbox.description": "This will create a new room booking on the selected slot and retain the current one.",
	"components.moveRoomBookingDialog.retainRoomBookingCheckbox.label": "Retain current room booking",
	"components.moveRoomBookingDialog.selectExamAndSupervisorTitle": "Those room bookings contains exam(s) and supervisor(s), please select what you want to move.",
	"components.moveRoomBookingDialog.status.canBeMoved": "Can be moved",
	"components.moveRoomBookingDialog.status.cannotBeMoved": "Cannot be moved",
	"components.moveRoomBookingDialog.title": "Move room booking {room} to {examSlot} slot {date}",
	"pages.examOverview.selectExamToCancel": "Select exams to cancel",
	"pages.examSettings.labelShouldPublishToStudentSchedule": "Publish to student’s schedule",
	"pages.studentSettings.editMappingList.studentSeatDescription": "Select if you want the seat to be shown on the student’s schedule",
	"common.button.editLength": "Edit length",
	"common.label.cancelled": "Cancelled",
	"common.label.dueDate": "Due date",
	"common.label.freeText": "Free text",
	"common.label.itemCompleted": "{item} completed",
	"common.label.noPageBreak": "No page break",
	"common.label.pageBreak": "Page break",
	"common.label.pageHeaderSettings": "Page header settings",
	"common.label.perExam": "Per exam",
	"common.label.perRoom": "Per room",
	"common.label.reportTemplateSettings": "Report template settings",
	"common.label.sortByPrimary": "Sort by primary",
	"common.label.sortBySecondary": "Sort by secondary",
	"common.label.studentPublicSchedule": "Student public schedule",
	"common.label.studentSeatAllocation": "Student seat allocation",
	"common.label.studentSpecialNeeds": "Student special needs",
	"common.label.usePrintDate": "Use print date",
	"common.message.confirmDeleteReportingTemplate": "You are about to delete this report template, are you sure you want to proceed?",
	"common.message.successAcceptBookingForSupervisor": "The bookings was accepted successfully",
	"common.message.successDeclineBookingForSupervisor": "The bookings was declined successfully",
	"components.moveRoomBookingDialog.alert.associatedExamMustBeInSameRoomBooking": "Please note that all associated child or linked exams needs to be schedudeld the same date and time slot, isolated ones can not be moved. These room booking(s) has exams linked with bookings:",
	"components.moveRoomBookingDialog.description": "You are about to move this room booking to another slot, please confirm you want to proceed?",
	"components.moveRoomBookingDialog.unableToMoveRoomBooking.description": "The room is already occupied in TE Exam or TE Core",
	"components.moveRoomBookingDialog.unableToMoveRoomBooking.message": "Unable to move room bookings",
	"components.scheduledSupervisorActionsDropdown.button.declineRoomBookingForSupervisorButton": "Decline booking for supervisor",
	"pages.examSetting.examCustomizations.supervisorsNeededsDesc.description": "Set the default number of supervisors needed for any room booking",
	"pages.examSetting.examCustomizations.supervisorsNeededsTitle.description": "Number of supervisors needed",
	"common.button.goBack": "Go back",
	"common.label.allocatedStudents": "Allocated students",
	"common.label.availability": "Availability",
	"common.message.successMoveRoomBooking": "Your room was successfully moved to another slot",
	"common.title.common.confirmation": "Confirmation",
	"common.valueLabel.moveRoomBookingAction.cancelBooking": "Cancel supervisor booking",
	"common.valueLabel.moveRoomBookingAction.moveAndSendBooking": "Move and send new booking request",
	"common.valueLabel.moveRoomBookingAction.moveScheduling": "Move to new slot",
	"common.valueLabel.moveRoomBookingAction.moveWithoutSendBooking": "Move without sending new booking request",
	"common.valueLabel.moveRoomBookingAction.removeScheduling": "Remove scheduling",
	"common.valueLabel.moveRoomBookingAction.retainBooking": "Retain on current room booking",
	"common.valueLabel.moveRoomBookingAction.retainScheduling": "Retain on current room booking",
	"components.moveRoomBookingDialog.action.newEmptyRoomBooking": "Create a new room booking for {room} in slot \"{examSlot}\" {date}",
	"components.moveRoomBookingDialog.action.newRoomBooking": "Create a new room booking for {room} in slot \"{examSlot}\" {date} containing:",
	"components.moveRoomBookingDialog.action.removeScheduling": "Remove scheduling in {room} {date} for the following:",
	"components.moveRoomBookingDialog.action.retainRoomBooking": "Retain current room booking for {room} in slot \"{examSlot}\" {date} containing:",
	"components.moveRoomBookingDialog.alert.confirmActions": "This operation will make the following changes, are you sure you want to proceed?",
	"components.moveRoomBookingDialog.error.childExamsInOtherBookings": "Has other child exams in other room booking",
	"components.moveRoomBookingDialog.error.linkedExamCannotMove": "Linked exam cannot be moved",
	"components.moveRoomBookingDialog.error.linkedExamsInOtherBookings": "Has linked exams in other room booking",
	"components.moveRoomBookingDialog.noExamAndSupervisorTitle": "You are about to move this room booking to another slot, please confirm you want to proceed?",
	"components.moveRoomBookingDialog.success.canBeMoved": "Can be moved",
	"components.moveRoomBookingDialog.titleMultiple": "Move room bookings to {examSlot} slot {date}",
	"pages.examSetting.examCustomizations.defaultChecklistDesc.description": "Enable the option if you wish to configure a default checklist for exam requests",
	"pages.examSetting.examCustomizations.defaultChecklistTitle.description": "Use default checklist",
	"common.label.configureHowTheStudentScheduleIsDisplayed": "Configure how the student schedule is displayed",
	"common.label.enterYourStudentIdToSeeYourSchedule": "Enter your student id to see your schedule",
	"common.label.letUsersAccessTheExamScheduleWithoutStudentId": "Let users access the exam schedule without a student id. A student id is only required to see seat assignment",
	"common.label.pleaseEnterAStudentId": "Please enter a student id",
	"common.label.publicStudentSchedule": "Public student schedule",
	"common.label.seeSchedule": "See schedule",
	"common.valueLabel.moveRoomBookingAction.removeBooking": "Remove supervisor booking",
	"components.moveRoomBookingDialog.alert.linkedRoomBooking.insertButton": "Insert",
	"components.moveRoomBookingDialog.alert.linkedRoomBooking.item": "Room {room} in slot \"{examSlot}\" {date}",
	"components.moveRoomBookingDialog.alert.linkedRoomBooking.title": "These room bookings have exams linked with bookings:",
	"components.moveRoomBookingDialog.error.cannotBeInserted": "Cannot be inserted",
	"components.moveRoomBookingDialog.unableToMoveRoomBooking.occupiedError": "The room is already occupied in TE Exam or TE Core",
	"components.moveRoomBookingDialog.unableToMoveRoomBooking.roomsDuplicatedError": "One room can not have two bookings in the same exam slot",
	"common.label.cancel": "Cancel",
	"common.label.cancelSupBookings": "Cancel supervisor booking(s)",
	"common.label.cancelSupBookingsDes": "You are about to cancel one or several supervisor bookings, This means the booking will be marked as \"Cancelled\" but the supervisor(s) will still be available for other bookings. The supervisor(s) will also recieve an email with this information, are you sure you want to proceeed?",
	"common.label.cancelSupBookingsOk": "Yes cancel booking(s)",
	"common.label.cancelSupBookingsReason": "Enter cancellation reason:",
	"common.label.cancellationReason": "Cancellation reason",
	"common.label.declineSupBookings": "Decline supervisor booking(s)",
	"common.label.declineSupBookingsDes": "You are about to decline one or several supervisor bookings, This means the booking will be marked as \"Declined\" and the supervisor(s) won't be available for other bookings. Are you sure you want to proceeed?",
	"common.label.declineSupBookingsOk": "Yes decline booking(s)",
	"common.label.examDateAndEndTime": "Exam date & end time",
	"common.label.examDateAndStartTime": "Exam date & start time",
	"common.label.saveWithoutSendingEmail": "Save without sending email",
	"common.label.sendUpdatedBooking": "Send updated booking request",
	"common.label.theWorkingHoursForOneOrSevaralSupervisor": "The working hours for one or sevaral supervisor(s) have been updated, do you wish to send an updated booking request to the concerned supervisor(s)?",
	"common.label.unableToSave": "Unable to save",
	"common.label.workHours": "Work hours",
	"common.message.successCancelBookingForSupervisor": "The bookings was cancelled successfully",
	"common.valueLabel.bookingStatus.cancelled": "Cancelled",
	"components.scheduledSupervisorActionsDropdown.button.cancelRoomBookingForSupervisorButton": "Cancel booking for supervisor",
	"common.label.mapping": "Mapping",
	"common.label.roomOccupation": "Room occupation",
	"common.label.settings": "Settings",
	"common.label.viewRoomBookingDetails": "View room booking details",
	"pages.examSeatAllocationTab.button.allocateStudents": "Allocate students",
	"pages.examSeatAllocationTab.label.specialNeedsStudents": "Number of students with special needs",
	"pages.examSeatAllocationTab.label.studentsLeftToAllocate": "Students left to allocate",
	"pages.examSeatAllocationTab.label.studentsToAllocate": "Number of students to allocate",
	"pages.examSeatAllocationTab.label.totalRegisterStudents": "Total registered students",
	"pages.examSeatAllocationTab.label.useStandardAllocation": "Use standard student allocation for this exam",
	"pages.examSeatAllocationTab.label.useStandardAllocation.description": "This will make it possible to upload a student registration list and allocate individual students, as well as assign special needs.",
	"pages.postExamManagementTab.label.attendingStudents": "Number of students attending the exam",
	"pages.postExamManagementTab.panel.attendingStudents": "Attending students",
	"pages.studentSettings.simpleStudentAllocation.description": "This will replace the option to upload a student registration list with a number input field to enter the number of students to allocate. It will limit the option to allocate individual students to certain seats and to assign special needs.",
	"pages.studentSettings.simpleStudentAllocation.label": "Enable simple student allocation",
	"providers.organization.message.successUpdateSettingsMessage": "The settings were successfully updated",
	"common.label.confirmedBooking": "Confirmed booking",
	"common.label.expired": "Expired",
	"common.label.pendingBooking": "Pending booking",
	"common.label.updatedBookingRequest": "Updated booking request",
	"pages.homeSupervisor.tab.currentBookings": "Current bookings",
	"components.moveRoomBookingDialog.alert.linkedExam.item": "{exam} in {room} in slot {examSlot}",
	"components.moveRoomBookingDialog.alert.rangeOfSeatBeAdjusted": "Please note that in the case the exam has allocated students, the seat range might be adjusted on exams in the current room as well as in the room where the exam is moved to.",
	"components.moveRoomBookingDialog.titleExams": "Move exams to {room} in slot {examSlot}",
	"common.label.yourWorkHours": "Your work hours",
	"components.moveRoomBookingDialog.alert.associatedExamMustBeInSameRoomBookingForExam": "Please note that all associated child or linked exams needs to be schedudeld the same date, isolated ones can not be moved to another day. The exam(s) has the following dependencies:",
	"common.label.studentsSelected": "Students selected",
	"components.moveRoomBookingDialog.titleSupervisors": "Move supervisors to {room} in slot {examSlot}",
	"pages.settings.supervisorSettings.informationAboutOtherSupervisors.description": "Enable if you want the supervisor to see information regarding  other supervisors working in the same room and day",
	"pages.settings.supervisorSettings.informationAboutOtherSupervisors.title": "Information about other supervisors",
	"pages.settings.supervisorSettings.title": "Configure the information visible in the supervisor interface",
	"common.label.confirmUpdatedRequest": "Confirm updated request",
	"common.label.scheduleSupervisors": "Schedule supervisors",
	"common.label.updatedRequest": "Decline updated request",
	"common.valueLabel.moveRoomBookingAction.moveExamToNewRoomBooking": "Move exam to new room booking",
	"common.button.allocate": "Allocate",
	"common.label.examDetails": "Exam details",
	"common.label.reassignExamOwner": "Reassign exam owner",
	"common.label.showPageHeaderOnAllPages": "Show page header on all pages",
	"common.valueLabel.mainSupervisor.lead": "Lead",
	"common.label.pageBreakPerRoomBooking": "Page break per room booking",
	"common.message.successMoveExamsToRoomBooking": "The exams were successfully moved to another room booking",
	"common.message.successMoveSupervisorsToRoomBooking": "The supervisors were successfully moved to another room booking",
	"common.label.schedulePastSupervisor": "You are about to schedule a supervisor for a date or time that has already passed, are you sure you want to proceed?",
	"pages.examSeatAllocationTab.option.examSelection.removeSelection": "Remove selection",
	"common.label.actions": "Actions",
	"common.label.batchOperations": "Batch operations",
	"common.label.bookingsSelected": "Bookings selected",
	"common.label.calendarOptions": "Calendar options",
	"common.label.deSelectAll": "DeselectAll",
	"common.label.deselectAll": "Deselect all",
	"common.label.move": "moved",
	"common.label.personalNumber": "Personal number",
	"common.label.roombooking": "Room booking",
	"common.label.selectAll": "Select all",
	"common.label.studentSchedule": "Student Schedule",
	"common.label.templateName": "Template name",
	"common.message.successPublishedExams": "Published exam successfully",
	"common.label.addSorting": "Add sorting",
	"common.label.selectExam": "Select exam",
	"common.label.selectOne": "Select one",
	"common.label.weekOf": "Week of",
	"components.moveRoomBookingDialog.alert.examTimeLongerExamSlotTime": "Please note that the requested exam time is longer than the selected slot time.",
	"common.label.logout": "Log out",
	"pages.label.attendingStudents": "Attending students",
	"common.label.relations": "Relations",
	"pages.exam.label.showRelations": "Show relations",
	"common.label.acceptedBookings": "Accepted bookings",
	"common.label.availableSupervisors": "Available supervisors",
	"common.label.bookingRequests": "Booking requests",
	"common.label.cancelledBookings": "Cancelled bookings",
	"common.label.commentToScheduler": "External comment",
	"common.label.day": "Day",
	"common.label.declinedBookings": "Declined bookings",
	"common.label.examTime": "Exam time",
	"common.label.expiredBookings": "Expired bookings",
	"common.label.filterBookings": "Filter bookings",
	"common.label.hasBookings": "Has bookings",
	"common.label.hasNoBookings": "Has no bookings",
	"common.label.pendingHours": "Pending hours",
	"common.label.schedule": "Schedule",
	"common.label.scheduledHours": "Scheduled hours",
	"common.label.searchForSupervisor": "Search for supervisor",
	"common.label.totalAcceptedHours": "Total accepted hours",
	"common.label.totalRequestedHours": "Total requested hours",
	"common.label.workingHours": "Working hours",
	"common.message.commentToSchedulerNotice": "This comment will be visible in TimeEdit",
	"components.scheduledSupervisorActionsDropdown.button.addRow": "Add row",
	"components.scheduledSupervisorActionsDropdown.button.removeRow": "Remove row",
	"common.button.secondaryAxis": "Secondary axis",
	"common.button.selectChartValue": "Select chart series",
	"common.button.selectSecondChartValue": "Select second chart series",
	"common.button.selectSeries": "Selected series",
	"common.label.bookedRooms": "Booked rooms",
	"common.label.bookingRequestExpires": "Booking request expires",
	"common.label.examRequests": "Exam requests",
	"common.label.expiredBookingRequest": "Expired booking request",
	"common.label.neededSupervisors": "Needed supervisors",
	"common.label.pendingBookings": "Pending bookings",
	"common.label.pendingRequests": "Pending requests",
	"common.label.scheduledSupervisors": "Scheduled supervisors",
	"common.label.secondaryAxis": "Secondary axis",
	"common.label.selectedSeries": "Selected series",
	"common.label.statistics": "Statistics",
	"common.label.unableScheduleSupervisor": "Unable to schedule supervisor",
	"common.label.unableScheduleSupervisorDesc": "The supervisor is not available in the selected time and day.",
	"common.message.examInformationCancelledLockedDesc": "The exam information can not be edited for cancelled exams",
	"common.title.common.dashboardOverview": "Dashboard overview",
	"common.valueLabel.chartOptions.numberOfAcceptedBookings": "Accepted bookings",
	"common.valueLabel.chartOptions.numberOfAllocatedStudents": "Allocated students",
	"common.valueLabel.chartOptions.numberOfExamRequests": "Exam requests",
	"common.valueLabel.chartOptions.numberOfNeededSupervisors": "Needed supervisors",
	"common.valueLabel.chartOptions.numberOfPendingBookings": "Pending bookings",
	"common.valueLabel.chartOptions.numberOfPlannedStudents": "Planned students",
	"common.valueLabel.chartOptions.numberOfRegisteredStudents": "Registered students",
	"common.valueLabel.chartOptions.numberOfRoomsBooked": "Rooms booked",
	"common.valueLabel.chartOptions.numberOfScheduledExams": "Scheduled exams",
	"common.valueLabel.chartOptions.numberOfScheduledSupervisors": "Scheduled supervisors",
	"common.valueLabel.chartOptions.numberOfSupervisorsAvailable": "Supervisors available",
	"pages.public.examStudentScheduleWrapper.label.yourAnonymizedCode": "Your Anonymized Code",
	"pages.studentSettings.editMappingList.studentAnonymizedCodeToggleDescription": "Select if you want the anonymized code to be shown on the student’s schedule",
	"pages.supervisorOverview.selections.emailUnsent": "Select emails \"not sent\"",
	"common.label.additionalInfor": "",
	"common.label.bookedSeats": "",
	"common.label.bookingInformation": "",
	"common.label.deleteSupervisorGDPR": "Delete supervisors",
	"common.label.examSelecionInstruction": "",
	"common.label.examsSelected": "",
	"common.label.multipleRoomsSelectedError": "",
	"common.label.pleaseConfirmYouWantToReschedule": "",
	"common.label.roomSelected": "",
	"common.label.scheduledStudents": "",
	"common.label.seatsSelected": "",
	"common.label.siblingExamScheduleInSameRoomWarning": "",
	"common.label.swithRoomBookingMode": "",
	"common.label.tag": "",
	"common.label.toAdministrators": "",
	"common.label.toStudents": "",
	"common.label.toSupervisors": "",
	"common.valueLabel.chartOptions.bookedSeats": "",
	"common.valueLabel.chartOptions.scheduledStudents": "",
	"components.examTagActions.deleteTagConfirmDesription": "",
	"components.examTagActions.deleteTagConfirmTitle": "",
	"components.examTagActions.noEditingNewTagInfo": "",
	"components.examTagActions.renameTagConfirmDesription": "",
	"components.examTagActions.renameTagConfirmTitle": "",
	"components.moveRoomBookingDialog.alert.supervisorMovingSameDateAndSlot": "",
	"pages.examDetail.message.redirectedOnCancelledExam.description": "",
	"pages.examDetail.message.redirectedOnCancelledExam.message": "",
	"pages.supervisorOverview.selections.selectAll": "",
	"pages.supervisorOverview.selections.selectNone": "",
	"common.label.plannedStudentsOnSelectedExams": "",
	"common.label.removeRoom": ""
};

var sv = {
	"_i.error.request.endPointNotFound": "Den begärda URLen finns inte.",
	"_i.error.request.invalidParams": "Åtgärden innehåller ogiltiga parametrar.",
	"_i.error.server.internalError": "Servern stötte på ett internt fel.",
	"_i.error.server.unknown": "Servern stötte på ett okänt fel.",
	"_i.error.server.unsuccessfulRequest": "Begäran kan inte uppfyllas.",
	"_i.error.validation.notPass": "Anropet innehåller ogilitiga värden",
	"_i.exam.createChild.error.exceedingRemainStudents": "Studenter som planeras för undertentamen får inte överstiga kvarvarande studenter. (Återstår: {remainStudents}).",
	"_i.exam.createChild.error.parentNotFound": "Huvudtentamen med id {parentExamId} hittades inte.",
	"common.label.action": "Åtgärder",
	"common.button.activateItem": "Aktivera {item}",
	"common.label.active": "Aktiv",
	"common.valueLabel.isActive.active": "Aktiv",
	"common.placeholder.commentToAdmin": "Lägg till en kommentar",
	"common.button.addNewItem": "Skapa {item}",
	"common.button.addItem": "Lägg till {item}",
	"common.placeholder.addItem": "Skapa {item}...",
	"common.label.address": "Adress",
	"common.valueLabel.commentScope.admin": "Administratörsinställningar",
	"common.valueLabel.role.admin": "Administratörsinställningar",
	"common.valueLabel.commentScope.administrator": "Administratör",
	"common.valueLabel.commentScope.all": "Alla",
	"common.title.allRooms": "Alla lokaler",
	"common.label.allocated": "Allokerade",
	"common.valueLabel.allocationStatus.allocated": "Allokerade",
	"common.valueLabel.usePlannedStudents.allocated": "Allokerade studenter",
	"common.label.allowItem": "Tillåt {param}",
	"common.error.unknownUpload": "Ett oväntat fel inträffade. Vänligen försök igen.",
	"common.label.studentAnonymizedCode": "Anonymiseringskod",
	"pages.examSlotDetail.deletePopover.title": "Är du säker på att du vill inaktivera den här slotten?",
	"common.message.deleteItemConfirm": "Är du säker på att du vill ta bort {item}?",
	"common.label.assignedSpecialNeeds": "Tilldelade särskilda behov",
	"common.label.attributes": "Attribut",
	"common.title.availability": "Tillgänglighet",
	"common.title.exams.batchImport": "Massimport",
	"common.button.viewSupervisorsOnBooking": "Boka tentamensvärdar för lokalbokningen",
	"common.label.bookedObjects": "Bokade objekt",
	"common.title.bookings.detail": "Bokning på {data} i {room}",
	"common.label.building": "Byggnad",
	"common.label.campus": "Campus",
	"common.label.mainSupervisor_short": "Kan vara huvudvärd",
	"common.button.cancel": "Avbryt",
	"common.label.capacity": "Kapacitet",
	"common.valueLabel.mainSupervisor.certified": "Certifierad",
	"common.label.mainSupervisor_long": "Kan vara huvudvärd",
	"common.label.checklist": "Checklista",
	"common.label.postEndTime_long": "Städtid slut",
	"common.label.comment": "Kommentar",
	"common.label.commentToAdmin": "Administratörskommentar",
	"common.button.configureNow": "Ställ in nu",
	"common.title.common.confirm": "Bekräfta",
	"common.label.costCenters": "Kostnadsställen",
	"common.model.costCenters": "Kostnadsställen",
	"common.valueLabel.importStatus.couldNotBeImported": "Kunde inte importeras",
	"common.label.courseEvents": "Kurstillfällen",
	"common.label.courses": "Kurser",
	"common.button.createItem": "Skapa {item}",
	"common.label.date": "Datum",
	"common.label.dateFormat": "Datumformat",
	"common.button.deactivateItem": "Inaktivera {item}",
	"common.valueLabel.isActive.deactivated": "Inaktiverad",
	"common.button.deleteItem": "Ta bort {item}",
	"common.label.department": "Institution",
	"common.label.departments": "Institutioner",
	"common.label.description": "Beskrivning",
	"common.button.deselectAllItem": "Avmarkera alla {item}",
	"common.button.disable": "Inaktivera",
	"common.button.discard": "Avbryt",
	"common.label.duration": "Längd",
	"common.placeholder.durationHours": "Längd i timmar",
	"common.placeholder.durationMinutes": "Längd i minuter",
	"common.button.editItem": "Redigera {item}",
	"common.title.common.editItem": "Redigera {item}",
	"pages.examSlotDetail.readonly.description": "Slotten kan inte redigeras eftersom lokaler är bokade på den",
	"common.label.email": "Email",
	"common.button.enable": "Aktivera",
	"common.label.endTime": "Sluttid",
	"common.label.exam": "Tentamen",
	"common.label.examDuration": "Längd",
	"common.label.endTime_long": "Sluttid för tentamen",
	"common.label.examLanguage": "Tentamensspråk",
	"common.button.examScheduling": "Tentamensschemaläggning",
	"common.title.settings.exams": "Tentamensinställningar",
	"common.label.examSlot": "Slott",
	"pages.examSlotDetail.readonly.message": "Tiden för slotten är låst",
	"common.title.examSlots": "Slottar",
	"common.label.startTime_long": "Starttid för tentamen",
	"common.label.examStatus": "Tentamensstatus",
	"common.label.examType": "Tentamenstyp",
	"common.title.settings.examTypes": "Tentamenstyper",
	"common.label.exams": "Tentamen",
	"common.title.exams": "Tentamen",
	"common.label.examsScheduled": "Schemalagda tentamen",
	"common.title.exams.export": "Exportera tentor",
	"common.button.exportExams": "Exportera {item}",
	"common.label.externalExamName": "Externt tentamensnamn",
	"common.placeholder.filterItem": "Filter {item}",
	"common.label.firstName": "Förnamn",
	"common.label.floor": "Våning",
	"common.title.home": "Hem",
	"common.label.hours": "Timmar",
	"common.label.id": "ID",
	"common.title.exams.update": "ID #{id} ({name})",
	"common.label.idAndName": "ID & namn",
	"common.label.importStatus": "Importstatus",
	"common.button.importItem": "Importera {item}",
	"common.valueLabel.importStatus.imported": "Importerad",
	"common.label.importedSpecialNeeds": "Importerade särskilda behov",
	"common.label.importedToExam": "Importerad till tentamen",
	"common.valueLabel.isActive.inactive": "Inaktiv",
	"common.label.info": "Info",
	"common.label.infoField1": "Infofält 1",
	"common.label.infoField2": "Infofält 2",
	"common.label.infoField3": "Infofält 3",
	"common.label.infoField4": "Infofält 4",
	"common.label.infoField5": "Infofält 5",
	"common.valueLabel.allowIntervalOrSlotParam.interval": "Intervall",
	"common.label.knowledgeAreas": "Kunskapsområden",
	"common.title.settings.knowledgeAreas": "Kunskapsområden",
	"common.title.settings.languages": "Språk",
	"common.label.lastName": "Efternamn",
	"common.label.isLead": "Huvudvärd",
	"common.label.linkedExam": "Länkade tentamen",
	"common.label.mainSupervisor": "Huvudvärd",
	"common.label.isReExam_short": "Omtentamen",
	"common.valueLabel.isReExam.makeUp": "Omtentamen",
	"common.label.mappedValue": "Mappat värde",
	"common.label.maxRequestNumber": "Max antal önskemål",
	"common.label.minRequestNumber": "Min antal önskemål",
	"common.label.minutes": "Minuter",
	"common.label.modules": "Moduler",
	"common.title.myAvailability": "Min tillgänglighet",
	"common.label.name": "Namn",
	"common.title.exams.create": "Ny tentamen",
	"common.title.examSlots.create": "Ny slott",
	"common.title.common.newItem": "Skapa {item}",
	"common.message.noExamScheduled": "Inga tentamen har schemalagts på den här lokalbokningen",
	"common.message.noItemSelected": "Inget {item} har valts",
	"common.valueLabel.allocationStatus.notAllocated": "Inte allokerad",
	"common.valueLabel.mainSupervisor.notCertified": "Kan inte vara huvudvärd",
	"common.label.notes": "Anteckningar",
	"common.title.common.overview": "Översikt",
	"common.label.owner": "Ägare",
	"common.label.permittedResources": "Tillåtna hjälpmedel",
	"common.label.studentPersonalIdentificationNumber": "Personnummer",
	"common.label.planned": "Planerade",
	"common.label.studentsPlanned": "Planerat antal studenter",
	"common.valueLabel.usePlannedStudents.planned": "Planerat antal studenter",
	"common.label.postEndTime": "Städtid slut",
	"common.label.preStartTime": "Förberedelsetid start",
	"common.label.preStartTime_long": "Förberedelsetid start",
	"common.label.pricePerSeatPerHour_short": "Pris",
	"common.label.pricePerSeatPerHour_long": "Pris / plats / timme",
	"common.label.pricePerSeatPerHour": "Pris per plats per timme",
	"common.label.professors": "Professorer",
	"common.label.registered": "Anmälda",
	"common.label.registeredStudents": "Anmälda studenter",
	"common.label.registrationDate": "Anmälningsdatum",
	"common.valueLabel.isReExam.regular": "Ordinarie tentamen",
	"common.label.isReExam_long": "Ordinarie eller omtentamen",
	"common.button.removeFromTEExam": "Ta bort från TE Exam",
	"common.button.removeItem": "Ta bort {item}",
	"common.title.scheduling.requested": "Schemaönskemål för {exam}",
	"common.button.resetConfiguration": "Återställ konfigurering",
	"common.label.role": "Roll",
	"common.label.room": "Lokal",
	"common.button.roomBooking": "Bokade lokaler",
	"common.title.bookings": "Lokalbokningar",
	"common.label.roomName": "Lokalnamn",
	"common.label.roomType": "Lokaltyp",
	"common.label.roomUtilization": "Lokalutnyttjande",
	"common.title.rooms": "Lokal",
	"common.title.scheduling.rooms": "Lokaler",
	"common.button.saveChanges": "Spara ändringar",
	"common.button.saveItem": "Spara {item}",
	"common.valueLabel.savingStatus.saved": "Sparad",
	"common.menu.scheduling": "Schemaläggning",
	"common.valueLabel.isScheduled.completed": "Schemaläggning färdig",
	"common.valueLabel.isScheduled.incomplete": "Schemaläggning ej färdig",
	"common.label.schedulingStatus": "Schemaläggningsstatus",
	"common.title.scheduling": "Schemaläggning {exam, select, NONE {} other {for {exam}}}",
	"common.label.seatingNo": "Platsnummer",
	"common.label.seatingStatus": "Platsstatus",
	"common.placeholder.selectItem": "Välj {item}",
	"common.button.selectAllItem": "Välj alla {item}",
	"common.label.selected": "Valda",
	"common.label.selectedStudents": "Valda studenter",
	"common.button.send": "Skicka",
	"common.title.settings": "Inställningar",
	"common.valueLabel.allowIntervalOrSlotParam.slot": "Slott",
	"common.title.settings.specialNeeds": "Särskilda behov",
	"common.label.specialNeedsAssignment": "Tilldelade särskilda behov",
	"common.label.startTime": "Starttid",
	"common.label.status": "Status",
	"common.label.studentId": "Student ID",
	"common.label.studentName": "Studentnamn",
	"common.menu.settings.students": "Anmälda studenter",
	"common.title.settings.students": "Mappning för anmälda studenter",
	"common.label.students": "Studenter",
	"common.label.studentsRegistered": "Anmälda studenter",
	"common.label.supervisor": "Tentamensvärd",
	"common.valueLabel.role.supervisor": "Tentamensvärd",
	"common.button.supervisorScheduling": "Tentamensvärdsschemaläggning",
	"common.label.supervisors": "Tentamensvärdar",
	"common.title.scheduling.supervisors": "Tentamensvärdar",
	"common.title.settings.supervisors": "Tentamensvärdar",
	"common.label.teExtId": "TE ExtId",
	"common.menu.teIntegration": "TE Integration",
	"common.error.readFile": "Filen kunde inte läsas. Vänligen försök igen.",
	"common.error.findingDataSheet": "Filen innehåller inte ett ark som heter 'data_sheet', vänligen redigera din fil och försök igen.",
	"common.error.email": "Fältet innehåller inte en giltig emailadress",
	"common.error.uploadFile": "Uppladdningen avbröts i förtid, vänligen kontrollera din internetuppkoppling och försök igen.",
	"common.message.actionCannotUndoneWarning": "Den här operationen kan inte ångras",
	"common.label.time": "Tid",
	"common.title.settings.time-intervals": "Tidsintervall",
	"common.title.settings.teIntegration": "TimeEdit integration",
	"common.label.totalStudentsAllocated": "Totalt antal allokerade studenter",
	"common.label.totalStudentsPlanned": "Totalt antal planerade studenter",
	"common.label.totalStudentsRegistered": "Totalt antal anmälda studenter",
	"common.label.type": "Typ",
	"common.placeholder.comment": "Skriv din kommentar här...",
	"common.valueLabel.savingStatus.unsaved": "Osparade ändringar",
	"common.button.update": "Uppdatera",
	"common.label.useIntervals": "Använd tidsintervall",
	"common.title.settings.users": "Användare",
	"common.label.utilization": "Utnyttjande",
	"common.label.value": "Värde",
	"common.label.valueFormat": "Värdeformat",
	"common.label.view": "Visa",
	"common.button.viewAndEdit": "Visa & redigera",
	"common.button.viewInCalendar": "Visa i kalendern",
	"common.button.viewInExamCalendar": "Visa i kalendern för tentamina",
	"common.button.viewInSupervisorCalendar": "Visa i kalendern för tentamensvärdar",
	"common.button.viewRoomBooking": "Visa lokalbokning",
	"common.button.yes": "Ja",
	"common.model.campus": "campus",
	"common.model.childExam": "Undertentamen",
	"common.model.column": "kolumn",
	"common.model.comment": "kommentar",
	"common.model.courseEvents": "kurstillfällen",
	"common.model.courses": "kurser",
	"common.model.departments": "institutioner",
	"common.model.exam": "tentamen",
	"common.model.examLanguage": "tentamensspråk",
	"common.model.examRequest": "tentamensbeställning",
	"common.model.examSlot": "slott",
	"common.model.examSlots": "Slottar",
	"common.model.examType": "tentamenstyp",
	"common.model.examTypes": "tentamenstyper",
	"common.model.exams": "tentamen",
	"common.model.filter": "filter",
	"common.model.item": "objekt",
	"common.model.knowledgeArea": "kunskapsområde",
	"common.model.knowledgeAreas": "kunskapsområden",
	"common.model.language": "språk",
	"common.model.languages": "språk",
	"common.model.linkedExam": "länkade tentamen",
	"common.model.modules": "moduler",
	"common.model.objects": "objekt",
	"common.model.professors": "professorer",
	"common.model.roomBooking": "lokalbokning",
	"common.model.rooms": "lokaler",
	"common.model.scheduling": "schemaläggning",
	"common.model.specialNeed": "särskilda behov",
	"common.model.specialNeeds": "särskilda behov",
	"common.model.supervisor": "tentamensvärd",
	"common.model.supervisors": "tentamensvärdar",
	"common.model.timeInterval": "tidsintervall",
	"common.model.timeIntervals": "tidsintervall",
	"common.model.user": "användare",
	"common.model.users": "användare",
	"common.model.value": "värde",
	"common.error.required": "{field} är obligatoriskt{item, select, NONE {} other { for the {item}}}",
	"common.title.common.itemOverview": "{item} översikt",
	"common.valueLabel.supervisorCount.accepted": "{number} bekräftade",
	"common.valueLabel.supervisorCount.required": "{number} behövs",
	"common.valueLabel.supervisorCount.scheduled": "{number} schemalagda",
	"common.valueLabel.savingStatus.allocated": "{number} allokerade studenter",
	"common.valueLabel.savingStatus.planned": "{number} planerade studenter",
	"common.valueLabel.savingStatus.registered": "{number} anmälda studenter",
	"components.totalExamCostChart.label.seatsUsed": "Upptagna platser",
	"components.totalExamCostChart.label.totalRoomCost": "Total lokalkostnad",
	"components.totalExamCostChart.label.costForExam}": "Kostnad för {examId}",
	"components.examCostChart.label.totalRoomCost": "Total lokalkostnad",
	"components.examCostChart.label.costForExam}": "Kostnad för {examId}",
	"components.examCostChart.label.costsForOtherExams": "Kostnad för andra tentamen",
	"components.examCostChart.label.costOfUnderUtilization": "Kostnad från underutnyttjande",
	"components.examCostChart.label.totalCostForRoom": "Totalkostnad för lokalen",
	"components.examCostChart.label.costBreakdown": "Kostnadsnedbrytninng",
	"components.totalExamCostChart.label.costsForOtherExams": "Kostnad för andra tentamen",
	"components.totalExamCostChart.label.costOfUnderUtilization": "Kostnad från underutnyttjande",
	"components.totalExamCostChart.label.totalCostForAllRooms": "Total kostnad för alla lokaler",
	"components.totalExamCostChart.label.costBreakdown": "Kostnadsnedbrytninng",
	"components.commentChannelSelectorPane.label": "Välj kanal",
	"components.commentChannelSelectorPane.group.roomBooking": "Lokalbokning",
	"components.commentChannelSelectorPane.group.examGroup": "Tentamensgrupp",
	"components.commentChannelSelectorPane.group.exams": "Tentamen",
	"components.bootstrapConfigError.message": "Om du tror att något är fel och behöver hjälp, vänligen kontakta din administratör.",
	"components.bootstrapConfigError.link": "Konfigurera",
	"components.examComment.text.timeAgo": "{time} sedan",
	"components.examPropertySelection.selectTypeTable.column.type": "Typ",
	"components.examPropertySelection.selectTypeTable.column.selectedObjects": "Valda objekt",
	"components.examPropertySelection.selectPropertyTable.title": "Välj {property}",
	"components.examPropertySelection.search.placeholder": "Sök...",
	"components.examSchedulingStatusPane.label.studentsScheduled": "Schemalagda studenter",
	"components.examSchedulingStatusPane.label.numberOfChildExams": "Antal undertentor",
	"components.filterBar.title": "Filter",
	"components.filterBar.title.dataset": "Visa mig alla {title}",
	"components.filterBar.title.filterMode": "Som matchar",
	"components.filterBar.title.filter": "Filter:",
	"components.filterBar.message.noFiltersAdded": "Du har inte lagt till några filter än",
	"components.filterBarFilter.placeholder.category": "Välj en kategori",
	"components.filterBarFilter.placeholder.property": "Välj ett attribut",
	"components.filterBarFilter.placeholder.filterRule": "Välj en filterregel",
	"components.filterBarFilter.label.key": "ATTRIBUT",
	"components.filterBarFilter.label.rule": "REGEL",
	"components.filterBarFilter.label.value": "VÄRDE",
	"components.filterButton.header": "Filter",
	"components.filterButton.button.matchOne": "Matcha en",
	"components.filterButton.button.matchAll": "Matcha alla",
	"components.filterButton.label.key": "ATTRIBUT",
	"components.filterButton.label.rule": "REGEL",
	"components.filterButton.label.value": "VÄRDE",
	"components.filterButton.message.noFilter": "Du har inte lagt till några filter än",
	"components.filterModeLinkDropdown.button.matchOne": "Ett av filtrena",
	"components.filterModeLinkDropdown.button.matchAll": "Alla filter",
	"components.filterRow.placeholder.category": "Välj en kategori",
	"components.filterRow.placeholder.property": "Välj ett attribut",
	"components.filterRow.placeholder.filterRule": "Välj en filterregel",
	"components.saveFiltersButton.message.noFilter": "Inga filter",
	"components.saveFiltersButton.message.removeConfirm": "Är du säker på att du vill ta bort \"{name}\"?",
	"components.saveFiltersButton.button.saveToCurrentFilter": "Spara till valt filter",
	"components.saveFiltersButton.button.saveAsNewFilter": "Spara som nytt filter",
	"components.saveFiltersButton.text.savedFilters": "Sparade filter",
	"components.saveFiltersButton.label.filterName": "Filternamn",
	"components.saveFiltersButton.error.required.filterName": "Vänligen ge filtret ett namn",
	"components.initialRoute.error.examSlotEmpty": "Det finns inga slottar!",
	"components.initialRoute.error.roomEmpty": "Det finns inga lokaler i TE Exam!",
	"components.initialRoute.error.integrationSettingError": "Integrationen till TimeEdit är inte konfigurerad",
	"components.initialRoute.error.studentsMappingEmpty": "Studentmappningen är inte konfigurerad!",
	"components.initialRoute.error.userEmpty": "Inga användare finns i TE Exam!",
	"components.schedulingPane.label.calendarOptions": "Kalenderinställningar",
	"components.schedulingPane.label.showBookedRooms": "Visa bokade lokaler",
	"components.schedulingPane.label.showCompatibleSlots": "Visa kompatibla slottar",
	"components.schedulingPane.button.viewSelectedBookings": "Visa valda bokningar",
	"components.schedulingPane.button.showAndBookSelection": "Visa & boka",
	"components.schedulingPane.button.viewExams": "Visa tentamen",
	"components.schedulingPane.button.showScheduling": "Visa schemaläggning",
	"components.roomBookingBookedObjectsPane.message.noBookObjects": "Inga bokade objekt",
	"components.roomBookingTabbedPane.tab.timeAndDate": "Tid & datum",
	"components.roomBookingTabbedPane.tab.statistics": "Statistik",
	"components.roomBookingTabbedPane.tab.roomInformation": "Lokalinformation",
	"components.roomBookingTabbedPane.tab.exams": "Tentamen",
	"components.roomBookingTabbedPane.tab.supervisors": "Tentamensvärdar",
	"components.editExternalBookingDialog.label.bookingTitle": "Bokningstitel",
	"components.editExternalBookingDialog.message.noLongerNeed": "Behöver du inte längre den här bokningen?",
	"components.editExternalBookingDialog.message.deleteTitle": "Klicka här för att ta bort den",
	"components.modal.historicalBooking.title": "Det här datumet har redan passerat",
	"components.modal.historicalBooking.content": "Du kan inte skapa ett event för ett datum som redan har passerat",
	"components.modal.overlappingBooking.title": "Överlappande bokningar",
	"components.modal.overlappingBooking.content": "Det här eventet krockar med en bokning som du är schemalagd på",
	"components.supervisorsNeededSelector.label": "Schemalagda tentamensvärdar",
	"components.supervisorsNeededSelector.popover.title": "Behövt antal tentamensvärdar",
	"components.supervisorsNeededSelector.popover.button": "Redigera behövt antal tentamensvärdar",
	"components.roomBookingStatsDetailPad.label.seatsBooked": "Bokade platser",
	"components.roomBookingStatsDetailPad.label.seatsNeeded": "Behövt antal platser",
	"components.roomBookingStatsDetailPad.label.distribution": "Fördelning",
	"components.roomBookingStatsDetailPad.label.numberOfRooms": "# lokaler",
	"components.roomBookingStatsDetailPad.label.numberOfExams": "# tentamen",
	"components.roomBookingStatsDetailPad.label.needed": "Behövt",
	"components.roomBookingStatsDetailPad.label.booked": "Bokade",
	"components.roomBookingStatsDetailPad.title.roomBookingStatistics": "Lokalbokningsstatistik",
	"components.roomSelectionStatsDetailPad.title": "Lokalval",
	"components.roomSelectionStatsDetailPad.label.selection": "Val",
	"components.roomSelectionStatsDetailPad.label.seatsSelected": "Valda platser",
	"components.roomSelectionStatsDetailPad.label.roomsSelected": "Valda lokaler",
	"components.examLinkagePane.label.linkedTo": "Länkad till",
	"components.examLinkagePane.message.verifySchedulingOnTheChildExams": "Vänligen kontrollera schemaläggning av undertentamen",
	"components.examLinkagePane.message.notScheduled": "Ej schemalagd",
	"components.examSchedulingTableRow.message.deleteChildExamConfirm": "Om du tar bort den här undertentamen kommer alla anmälda studenter avallokeras. Är du säker på att du vill ta bort den här undertentamen?",
	"components.selectedExamDetailPad.title": "ID: {id}, Namn: {name}",
	"components.selectedExamDetailPad.tab.examInformation": "Tentamensinformation",
	"components.selectedExamDetailPad.tab.examObjects": "Objekt",
	"components.selectedExamDetailPad.tab.scheduling": "Schemaläggning",
	"components.selectedExamDetailPad.tab.comments": "Kommentarer",
	"components.selectedExamDetailPad.label.schedulingStatusAndPriorities": "Schemaläggningsstatus- och önskemål",
	"components.examCommentsTab.message.noCommentsPosted": "Det finns inga kommentarer än",
	"components.examInformationTab.label.examHierarchy": "Tentamenshierarki",
	"components.examInformationTab.label.examInformation": "Tentamensinformation",
	"pages.examInformationTab.card.numberOfStudents": "Antal studenter",
	"components.examSchedulingTab.label.dateAndTime": "Datum & tid",
	"components.examSchedulingTab.label.seats": "Platser",
	"components.examSchedulingTab.message.linkedExamNeedsToBeScheduled": "Den länkade tentamen måste schemaläggas innan du kan schemalägga den här tentamen.",
	"components.selectedRoomBookingDetailPad.group.supervisors": "Tentamensvärdar",
	"components.selectedRoomBookingDetailPad.tab.roomBookingInfo": "Lokalbokningsinformation",
	"components.selectedRoomBookingDetailPad.title.roomBooking": "Bokning i {room} den {date}",
	"components.supervisorsTab.group.scheduled": "Schemalagd",
	"components.supervisorsTab.group.available": "Tillgänglig",
	"components.examSlotDateContainer.text.free": "{number}% tillgänglig",
	"components.examSlotDateContainer.message.childExamHaveToBeScheduleInSameDate": "Alla undertentamen måste schemaläggas samma dag",
	"components.examSlotDateContainer.message.examHasToBeScheduledOnSameDateAsLinkExam": "Tentamen måste schemaläggas på samma datum som den länkade tentamen",
	"components.examSlotRow.message.examSlotIsTooShort": "Slotten är för kort för den valda tentamen",
	"components.examSlotRow.message.examNeedsToBeScheduledOnSameExamSlot": "Tentamen måste schemaläggas på samma slott som den länkade tentamen",
	"components.selectionOverlay.message.tryingToMakeASelectionInAnotherExamSlot": "Du försöker göra val i en annan slott. För att göra det måste du ta bort ditt nuvarande val.",
	"components.selectionOverlay.message.doYouWantToContinue": "Vill du fortsätta?",
	"components.selectionOverlay.button.discardSelection": "Ta bort val",
	"pages.examListDetailPad.tab.pendingExams": "Tentamensbeställningar",
	"pages.examListDetailPad.tab.scheduledExams": "Schemalagda tentamen",
	"components.requestedSchedulingListDetailPad.title": "Schemaönskemål",
	"components.requestedSchedulingListDetailPad.label.prioritiesAdded": "Tillagda önskemål",
	"components.requestedSchedulingListDetailPad.alert.prioritiesDisabled.message": "Schemaläggningsönskemål är avstängt",
	"components.requestedSchedulingListDetailPad.alert.prioritiesDisabled.description": "Din organisations konfiguration tillåter inte schemaläggningsönskemål på tentamensbeställningar",
	"components.requestedSchedulingListDetailPad.alert.prioritiesAddLeast.message": "Vänligen lägg till fler schemaläggningsönskemål",
	"components.requestedSchedulingListDetailPad.alert.prioritiesAddLeast.description": "För att spara din tentamen måste du lägga till minst {minNumber} schemaläggningsönskemål",
	"components.toolBar.defaultPlaceholder": "Välj...",
	"common.button.done": "Klar",
	"common.button.ok": "OK",
	"common.button.options": "Alternativ",
	"common.label.administratorComment": "Kommentar till administratörer",
	"common.label.interval": "Intervall",
	"common.label.requestedScheduling": "Schemaönskemål",
	"common.model.booking": "bokning",
	"common.model.interval": "intervall",
	"common.model.room": "lokal",
	"pages.examInformation.text.namingIsOptional": "Namngivning är frivilligt, alla tentamen har alltid ett unikt ID",
	"pages.examInformation.collapse.basicInformation": "Tentamensinformation",
	"pages.examInformation.collapse.examObjects": "Objekt",
	"pages.examInformation.collapse.additionalInformation": "Ytterligare information",
	"pages.examInformation.card.numberOfStudents": "Antal studenter",
	"pages.examInformation.card.examStatus": "Tentamensstatus",
	"pages.examDetail.tab.checklist": "Checklista",
	"pages.examDetail.tab.basicInformation": "Grundläggande info",
	"pages.examDetail.tab.schedulingPriorities": "Schemaönskemål",
	"pages.examDetail.tab.scheduling": "Schemaläggning",
	"pages.examDetail.tab.studentRegistration": "Anmälda studenter",
	"pages.examDetail.tab.specialNeeds": "Särskilda behov",
	"pages.examDetail.tab.seatAllocation": "Platsallokering",
	"pages.examDetail.tab.comments": "Kommentarer",
	"pages.examDetail.tab.postExamManagement": "Tentamensuppföljning",
	"pages.examDetail.tab.publicSchedule": "Studentsida",
	"pages.examDetail.label.showCompatibleRoomBookings": "Visa kompatibla lokalbokningar",
	"pages.examDetail.button.showSelectedRoomBooking": "Visa vald lokalbokning",
	"pages.examDetail.button.backToOverview": "Tillbaka till översikt",
	"pages.examDetail.button.addRegisteredStudents": "Lägg till anmälda studenter",
	"pages.examDetail.button.savePostExamNotes": "Spara uppföljningsanteckningar",
	"pages.examDetail.button.saveChecklist": "Spara checklista",
	"pages.examDetail.button.saveSchedulingPriorities": "Spara schemaläggningsönskemål",
	"pages.examExportSettings.panel.exportSettings": "Exportinställningar",
	"pages.examExportSettings.card.billingReportSettings": "Inställningar för kostnadsrapport",
	"pages.examExportSettings.label.includeExamOverview": "Inkludera tentamensöversikt",
	"pages.examExportSettings.label.includeSchedulingInformation": "Inkludera schemaläggningsinformation",
	"pages.examExportSettings.label.includeBillingInformation": "Inkludera kostnadsinformation",
	"pages.examExportSettings.label.selectedStudentMetric": "Valt studentmått",
	"pages.examExportSettings.label.distributeUnderutilization": "Fördela underutnyttjande",
	"pages.examExportSettings.label.includePrepAndCleanUpTime": "Inkludera förberedelse- och städtid",
	"pages.examExportSettings.label.includePostExamNotes": "Inkludera uppföljningsanteckningar",
	"components.assignSpecialNeedToStudentDropdown.placeholder.notAssigned": "N/A",
	"components.availableSupervisorActionButton.button.scheduleHere": "Schemalägg här",
	"components.examActionsDropdown.message.deleteConfirm": "Är du säker på att du vill ta bort tentamen {id}",
	"components.examActionsDropdown.message.aboutToDeleteWarning": "Du har valt att ta bort en tentamen. Den här operationen kan inte ångras.",
	"components.examActionsDropdown.message.aboutToDeleteInstruction": "Klicka på \"Ta bort tentamen\" för att fortsätta",
	"components.examActionsDropdown.message.unableToDeleteWarning": "Kan inte ta bort tentamen",
	"components.examActionsDropdown.message.unableToDeleteDescription": "Den här tentamen kan inte tas bort. Se till att tentamen inte är schemalagd, inte har några undertentamen och inte har passerat än.",
	"components.examActionsDropdown.button.deleteExam": "Kan inte ta bort tentamen",
	"components.removeSpecialNeedsAssignmentButton.message.deleteConfirm": "Är du säker på att du vill ta bort särskilda behov för den här studenten?",
	"components.roomBookingActionsDropdown.button.viewInExamCalendar": "Schemalägg tentamen på lokalbokning",
	"components.roomBookingActionsDropdown.button.viewInSupervisorCalendar": "Schemalägg tentamensvärdar på lokalbokning",
	"components.scheduledSupervisorActionsDropdown.button.removeFromRoomBooking": "Ta bort tentamensvärd från lokalbokning",
	"components.supervisorPendingActions.message.confirmToAccept": "Är du säker på att du vill bekräfta den här bokningsförfrågan?",
	"components.supervisorPendingActions.message.confirmToDecline": "Är du säker på att du vill tacka nej till den här bokningsförfrågan?",
	"components.examPrioritiesColumn.message.noDate": "Inget datum",
	"components.examPrioritiesColumn.message.noPriorities": "Inga schemaläggningsönskemål",
	"components.examTable.group.examInfo": "Tentamensinformation",
	"components.examTable.group.scheduling": "Schemaläggning",
	"components.examTable.group.roomBooking": "Lokalbokning",
	"components.modifyRoomBooking.message.noNonOverlappingExamSlots": "Inga icke-överlappande slottar att visa",
	"components.modifyRoomBooking.alert.unableToModifyAlert.message": "Kan inte ändra",
	"components.modifyRoomBooking.alert.unableToModifyAlert.singleDescription": "En eller flera av lokalbokningarna innehåller tentamen eller tentamensvärdar och kan inte redigeras",
	"components.modifyRoomBooking.alert.unableToModifyAlert.multipleDescription": "Lokalbokningen innnehåller andra tentamen eller tentamensvärdar och tillhör en annan slott, och kan därför inte flyttas till den valda slotten",
	"components.modifyRoomBooking.alert.modifyBooking.message": "Ändra lokalbokning",
	"components.modifyRoomBooking.label.original": "Original",
	"components.modifyRoomBooking.label.convertInto": "Konvertera till",
	"components.modifyRoomBooking.label.addExamSlots": "Lägg till slottar",
	"components.modifyRoomBooking.button.modifyAndSchedule": "Ändra & schemalägg",
	"components.schedulingFragment.error.scheduledWithinBoundariesOfExamSlot": "Tentamen måste schemaläggas innanför start- och sluttiden på slotten",
	"components.schedulingFragment.message.rescheduleConfirm.title": "Är du säker på att du vill ändra schemaläggningen på den här tentamen?",
	"components.schedulingFragment.message.rescheduleConfirm.content": "Den här tentamen är redan schemalagd, är du säker på att du vill flytta den?",
	"components.schedulingFragment.error.unableToSchedule": "Kan inte schemalägga",
	"components.schedulingFragment.error.noExamSelected": "Ingen tentamen är vald",
	"components.schedulingFragment.error.examScheduledOnBooking": "Tentamen #{examId} är redan schemalagd på den här lokalbokningen",
	"components.schedulingFragment.error.examHasChildExam": "Tentamen #{examId} har undertentamen. Välj en undertentamen för schemaläggning.",
	"components.schedulingFragment.error.examHasMoreStudentsThanCapacity": "Tentamen #{examId} har fler planerade studenter än det finns plats för. Vänligen välj en annan lokalbokning",
	"components.schedulingFragment.error.schedulingShorterThanExamDuration": "Schemaläggningen är kortare än den önskade längden",
	"components.schedulingFragment.error.schedulingLongerThanExamDuration": "Schemaläggningen är längre än den önskade längden",
	"components.schedulingFragment.button.scheduleExamHere": "Schemalägg tentamen här",
	"components.roomBookingDetailPad.bookingTitle": "Lokalbokning",
	"components.roomBookingDetailPad.bookingSelectedTitle": "Lokalbokning i {room}, {startTime} - {endTime} ({examSlot})",
	"components.roomBookingDetailPad.multipleBookingsSelectedTitle": "Visar {number} lokalbokningar",
	"components.roomBookingDetailPad.examTitle": "Schemalägg tentamen",
	"components.roomBookingDetailPad.examSelectedTitle": "Schemalägg tentamen i {room}, {startTime} - {endTime} ({examSlot})",
	"components.roomBookingDetailPad.modifyRoomBooking.message": "Du har valt en lokalbokning på en slott som överlappar med din valda slott. För att genomföra den här schemaläggning måste du konvertera lokalbokningen.",
	"components.roomDetailPad.label.seats": "Platser",
	"components.roomDetailPad.label.slotAndTime": "Slott & tid",
	"components.roomDetailPad.label.supervisorsNeeded": "Behövt antal tentamensvärdar",
	"components.roomDetailPad.button.bookSelectedRooms": "Boka valda lokaler",
	"components.roomDetailPad.message.noRoomsSelected": "Inga lokaler har valts",
	"components.roomSearchDropdown.placeholder.roomFilters": "Lokalfilter",
	"components.roomSearchDropdown.label.selectedRooms": "Valda lokaler",
	"components.roomSearchDropdown.placeholder.searchForRooms": "Sök lokaler...",
	"components.selectionRow.label.selection": "Val",
	"components.childExamFormDialog.message.addChildExamsToScheduledExamWarning": "Om du lägger till undertentamen på en schemalagd tentamen kommer den gamla schemaläggningen tas bort",
	"components.childExamFormDialog.message.processWithCaution": "Var försiktig.",
	"components.childExamFormDialog.label.childExamName": "Namn på undertentamen",
	"components.childExamFormDialog.label.numberOfStudents": "Antal studenter",
	"components.childExamFormDialog.text.numberOfSeatsLeft": "/ {number} platser kvar",
	"common.button.confirm": "Bekräfta",
	"common.button.decline": "Avböj",
	"common.button.newItem": "Skapa {item}",
	"common.button.no": "Nej",
	"common.label.costCenter": "Kostnadsställe",
	"common.label.course": "Kurs",
	"common.label.courseCode": "Kurskod",
	"common.label.courseName": "Kursnamn",
	"common.label.courseEvent": "Kurstillfälle",
	"common.label.credits": "Poäng",
	"common.label.departmentCode": "Institutionskod",
	"common.label.examId": "Tentamens ID",
	"common.label.examHierarchy": "Tentamenshierarki",
	"common.label.examName": "Tentamensnamn",
	"common.label.examObjects": "Objekt",
	"common.label.examOwner": "Tentamensägare",
	"common.label.firstPriority": "Första önskemål",
	"common.label.infoField": "Infofält",
	"common.label.isActive": "Aktiv",
	"common.label.isReadonly": "Bara läsning",
	"common.label.language": "Språk",
	"common.label.module": "Modul",
	"common.label.moduleId": "Modul-ID",
	"common.label.permittedResources_long": "Tillåtna studenthjälpmedel",
	"common.label.professor": "Professor",
	"common.label.professorId": "Professor-ID",
	"common.label.schedulingPriorities": "Schemaönskemål",
	"common.label.targetDate": "Önskat datum",
	"common.label.teExtId_short": "ExtId",
	"common.label.typeId": "Typ-ID",
	"common.message.loadingIndicator": "TE Exam laddningsindikator",
	"common.model.student": "student",
	"common.valueLabel.filter.contains": "Innehåller",
	"common.valueLabel.filter.category": "Kategori",
	"common.valueLabel.filter.lessThan": "Är mindre än",
	"common.valueLabel.filter.greaterThan": "Är mer än",
	"common.valueLabel.filter.equalTo": "Är lika med",
	"common.valueLabel.filter.true": "Är sant",
	"common.valueLabel.filter.false": "Är falskt",
	"common.valueLabel.filter.greaterThanOrEqualTo": "Är mer eller lika med",
	"common.valueLabel.filter.isLessThanOrEqualTo": "Är mindre eller lika med",
	"common.valueLabel.filter.between": "Mellan",
	"common.valueLabel.role.cea": "Central tentamensadministratör",
	"common.valueLabel.role.dec": "Tentamenskoordinator",
	"common.valueLabel.role.student": "Student",
	"pages.examScheduling.text.showCompatibleRoomBooking": "Visa kompatibla lokalbokningar",
	"pages.examScheduling.button.showSelectedRoomBooking": "Visa vald lokalbokning",
	"pages.createNewExam.tooltip.schedulingPriority": "För att spara din tentamensbeställning, vänlig lägg till minst {priorityNumber, plural, one {# scheduling priority} other {# scheduling priorities}}",
	"pages.createNewExam.tab.examInformation": "Tentamensinformation",
	"pages.examBatchImport.title.selectFile": "Massimport: Välj fil",
	"pages.examBatchImport.title.review": "Massimport: Kontrollera informationen",
	"pages.examBatchImport.title.results": "Massimport: Importresultat",
	"pages.examBatchImport.button.downloadImportTemplate": "Ladda ned importmall",
	"pages.examBatchImport.button.saveImport": "Spara import",
	"pages.examBatchImport.button.clearData": "Rensa data",
	"pages.examBatchImport.button.importAnotherFile": "Importera en annan fil",
	"pages.propertySelectionPane.header": "Ändra importinställningar",
	"pages.propertySelectionPane.message.customizeProperties": "Redigera de attribut som ska användas för att läsa importen",
	"pages.uploadFile.message.dropFileHere": "Släpp filen här eller klicka på \"Bläddra\" för att start importen ",
	"pages.validationSummary.message.error.message": "OBS!",
	"pages.validationSummary.message.error.description": "Vi hittade {errorNumber} fel och {warningNumber} varningar i importen",
	"pages.validationSummary.message.success.message": "Ser bra ut!",
	"pages.validationSummary.message.success.description": "Din import har inga fel eller varningar",
	"pages.exam.tooltip.checklistItemStatus": "Du kan inte markera den som färdig innan du gett den en titel",
	"pages.exam.placeholder.checklistItemStatus": "Skriv här...",
	"pages.examDetailInformationTab.panel.basicInformation": "Grundläggande info",
	"pages.examDetailInformationTab.panel.additionalInformation": "Ytterligare information",
	"pages.examDetailInformationTab.alert.examIsLocked.message": "Tentamensinformationen är låst",
	"pages.examDetailInformationTab.alert.examIsLocked.description": "Du kan inte redigera tentamensinformationen efter att tentamen är schemalagd",
	"pages.examDetailInformationTab.text.namingExamIsOptional": "Namngivning är frivilligt, alla tentamen har alltid ett unikt ID",
	"pages.examDetailInformationTab.text.registeredStudents": "{studentsRegistered} students",
	"pages.examDetailInformationTab.inputGroup.studentsNumber": "Antal studenter",
	"pages.examDetailInformationTab.input.durationHours.placeholder": "Längd i timmar",
	"pages.examDetailInformationTab.input.durationMinutes.placeholder": "Längd i minuter",
	"pages.examSeatAllocationTab.alert.examDateHasPassed.message": "Tentamensdatumet har passerat",
	"pages.examSeatAllocationTab.alert.examDateHasPassed.description": "Tentamensdatumet har passerat och anmälda studenter går inte att ändra",
	"pages.examSeatAllocationTab.alert.registrationOverflow.message": "För många anmälda studenter",
	"pages.examSeatAllocationTab.alert.registrationOverflow.description": "Tentamen har fler anmälda än planerade studenter, antingen uppdatera antalet planerade studenter eller ta bort anmälda studenter",
	"pages.examSeatAllocationTab.alert.seatAllocationIncomplete.message": "Platstilldelning ej färdig",
	"pages.examSeatAllocationTab.alert.seatAllocationIncomplete.description": "Det finns anmälda studenter kvar som ännu ej blivit tilldelade en plats",
	"pages.examSeatAllocationTab.alert.selectionOverflow.message": "För många studenter valda",
	"pages.examSeatAllocationTab.alert.selectionOverflow.description": "Du har valt fler studenter än det finns platser kvar i lokalen. Välj färre studenter eller schemalägg tentamen i en större lokal.",
	"pages.examSeatAllocationTab.alert.confirmAllocation.message": "Bekräfta allokering av {number} studenter",
	"pages.examSeatAllocationTab.modal.allocateSelectedStudents": "Allokera valda studenter",
	"pages.examSeatAllocationTab.option.examSelection.selectUnallocated": "Välj ej allokerade",
	"pages.examSeatAllocationTab.option.examSelection.selectAllocated": "Välj allokerade",
	"pages.examSeatAllocationTab.option.examSelection.selectFromTop": "Välj från toppen",
	"pages.examSeatAllocationTab.option.examSelection.selectFromBottom": "Välj från botten",
	"pages.examSeatAllocationTab.option.examSelection.selectFromRandom": "Välj slumpmässigt",
	"pages.examSeatAllocationTab.label.selectChildExam": "Välj undertentamen",
	"pages.examSeatAllocationTab.label.seatsLeft": "Platser kvar",
	"pages.examSeatAllocationTab.label.seatingRange": "Platsserie",
	"pages.examSeatAllocationTab.label.manageSelection": "Hantera val",
	"pages.examSeatAllocationTab.label.seatingInformation": "Platsinformation",
	"pages.examSeatAllocationTab.button.allocateSelectedStudents": "Allokera valda studenter",
	"pages.examSeatAllocationTab.button.deallocateSelectedStudents": "Avallokera valda studenter",
	"pages.examSpecialNeedsTab.modal.confirmRemoval.title": "Bekräfta borttagning",
	"pages.examSpecialNeedsTab.modal.confirmRemoval.content": "Tilldelade särskilda behov för {selectedNumber} kommer tas bort",
	"pages.examSpecialNeedsTab.alert.examDateHasPassed.message": "Tentamensdatumet har passerat",
	"pages.examSpecialNeedsTab.alert.examDateHasPassed.description": "Tentamensdatumet har passerat och anmälda studenter går inte att ändra",
	"pages.examSpecialNeedsTab.button.removeSpecialNeedsForSelection": "Ta bort särskilda behov för valda studenter",
	"pages.adjustPlannedStudents.alert.adjustPlannedStudents.message": "Redigera antal beställda platser",
	"pages.adjustPlannedStudents.alert.adjustPlannedStudents.description.1": "Redigera antalet planerade studenter för att frigöra oanvända platser efter anmälan.",
	"pages.adjustPlannedStudents.alert.adjustPlannedStudents.description.2": "Det nya värdet måste vara större eller lika med anmälda och allokerade studenter.",
	"pages.listStudents.button.removeSelectedStudents": "Ta bort valda studenter",
	"pages.listStudents.button.adjustPlannedStudents": "Redigera antal beställda platser",
	"pages.listStudents.modal.confirmRemoval.title": "Bekräfta borttagning",
	"pages.listStudents.modal.confirmRemoval.content": "{selectedNumber} studenter kommer tas bort",
	"pages.listStudents.alert.examDateHasPassed.message": "Tentamensdatumet har passerat",
	"pages.listStudents.alert.examDateHasPassed.description": "Tentamensdatumet har passerat och anmälda studenter går inte att ändra",
	"pages.listStudents.alert.registrationOverflow.message": "För många anmälda studenter",
	"pages.listStudents.alert.registrationOverflow.description": "Tentamen har fler anmälda än planerade studenter, antingen uppdatera antalet planerade studenter eller ta bort anmälda studenter",
	"pages.listStudents.alert.studentRegistrationIncomplete.message": "Studentanmälan ej färdig",
	"pages.listStudents.alert.studentRegistrationIncomplete.description": "Tentamen har färre anmälda än planerade studenter, antingen uppdatera antalet planerade studenter eller lägg till fler anmälda studenter",
	"pages.listStudents.alert.studentRegistrationComplete.message": "Studentanmälan färdig",
	"pages.listStudents.alert.studentRegistrationComplete.description": "Planerade och anmälda studenter matchar",
	"pages.uploadStudent.message.dropFile": "Släpp filen här för att importera anmälda studenter",
	"pages.uploadStudent.message.reviewResult": "Kolla igenom importresultaten nedan",
	"pages.uploadStudent.label.totalStudents": "Totalt antal studenter",
	"pages.uploadStudent.label.studentsEligibleForImport": "Studenter som kan importeras",
	"pages.uploadStudent.button.removeDuplicateStudents": "Ta bort dubletter",
	"pages.uploadStudent.button.importRegisteredStudents": "Importera anmälda studenter",
	"pages.postExamManagementTab.panel.generalExamNotes": "Almänna tentamensanteckningar",
	"pages.postExamManagementTab.panel.studentNotes": "Studentanteckningar",
	"pages.postExamManagementTab.panel.billingReport": "Kostnadsrapport",
	"pages.postExamManagementTab.label.studentMetric": "Studentmått",
	"pages.postExamManagementTab.label.distributeUnderUtilization": "Fördela underutnyttjande",
	"pages.postExamManagementTab.label.includePrepAndCleanUpTime": "Inkludera förberedelse- och städtid",
	"pages.postExamManagementTab.label.billingView": "Kostnadsöversikt",
	"pages.postExamManagementTab.group.overview": "Översikt",
	"pages.postExamManagementTab.group.examView": "Tentamensöversikt",
	"pages.examExport.label.selectExamToExport": "Välj tentamen att exportera",
	"pages.examExport.label.examsSelected": "Valda tentamen",
	"pages.examExport.tab.pendingExams": "Tentamensbeställningar",
	"pages.examExport.tab.scheduledExams": "Schemalagda tentamen",
	"pages.examExport.tab.pastExams": "Passerade tentamen",
	"pages.examOverview.header.title": "Tentamensöversikt",
	"pages.examOverview.button.createNewExamRequest": "Skapa en ny tentamensbeställning",
	"pages.examOverview.button.batchImportExamRequests": "Importera tentamensbeställningar",
	"pages.examOverview.tab.pendingExams": "Tentamensbeställningar",
	"pages.examOverview.tab.scheduledExams": "Schemalagda tentamen",
	"pages.examOverview.tab.pastExams": "Passerade tentamen",
	"pages.examSlotOverview.title": "Slottsöversikt",
	"pages.homeCEA.tab.roomBookings": "Lokalbokningar",
	"pages.homeCEA.tab.scheduledExams": "Schemalagda tentamen",
	"pages.homeCEA.tab.pendingExams": "Tentamensbeställningar",
	"pages.homeDEC.tab.roomBookings": "Lokalbokningar",
	"pages.homeDEC.tab.scheduledExams": "Schemalagda tentamen",
	"pages.homeDEC.tab.pendingExams": "Tentamensbeställningar",
	"pages.homeSupervisor.tab.pendingBookings": "Planerade bokningar",
	"pages.homeSupervisor.tab.confirmedBookingsTab": "Bekräftade bokningar",
	"pages.roomBooking.tab.overview": "Översikt",
	"pages.roomBooking.tab.examOverview": "Tentamensöversikt",
	"pages.roomBooking.tab.seatAllocation": "Platsallokering",
	"pages.roomBooking.tab.supervisors": "Tentamensvärdar",
	"pages.roomBooking.tab.roomInformation": "Lokalinformation",
	"pages.roomBooking.tab.comments": "Kommentarer",
	"pages.roomBooking.tab.publicSchedule": "Studentsida",
	"pages.roomBookingCommentsTab.channel.roomBooking": "Lokalbokning",
	"pages.searAllocationTab.editExamAllocationLabel": "Redigera tentamensallokering",
	"pages.setting.exam.tab.mandatoryObjects": "Obligatoriska objekt",
	"pages.examSettings.schedulingPrioritiesSettingList.header": "Konfigurera hur schemaläggningsönskemål ska användas",
	"pages.examSettings.schedulingPrioritiesList.numberOfRequests.title": "Antal önskemål",
	"pages.examSettings.schedulingPrioritiesList.numberOfRequests.description": "Antal schemaläggningsönskemål en användare får skapa",
	"pages.examSettings.schedulingPrioritiesList.intervalsOrExamSlots.title": "Tidsintervall eller slottar",
	"pages.examSettings.schedulingPrioritiesList.intervalsOrExamSlots.description": "Ska användaren använda slottar eller fördefinerade tidsintervall för sina schemaläggningsönskemål",
	"pages.examSettings.schedulingPrioritiesList.allowParamPrioritization.title": "Tillåt {param}-prioritering",
	"pages.examSettings.schedulingPrioritiesList.allowDatePrioritization.description": "Ska användaren kunna ange datum i sina önskemål",
	"pages.examSettings.schedulingPrioritiesList.allowRoomPrioritization.description": "Ska användaren kunna ange lokal i sina önskemål",
	"pages.examSettings.schedulingPrioritiesList.allowIntervalOrSlotPrioritization.description": "Ska användaren kunna ange en tidspreferens i sina önskemål",
	"pages.examSetting.mandatoryList.header": "Konfigurera vilka objekt som ska vara obligatoriska i tentamensbeställningar",
	"pages.examSetting.mandatoryList.departmentDescription": "Ett värde som indikerar om eller vilket särskilt behov en student har rätt till",
	"pages.examSetting.mandatoryList.label.enabled": "Aktiverad",
	"pages.examSetting.mandatoryList.label.isMandatory": "Är obligatoriskt",
	"pages.examSetting.mandatoryList.label.allowMultiple": "Tillåt flera",
	"pages.studentSettings.editMappingList.header": "Ställ in hur TE Exam tolkar filer för studentanmälan",
	"pages.studentSettings.editMappingList.studentIdDescription": "En unik studentkod som används för platsallokering och av studenten för att hitta sitt schema",
	"pages.studentSettings.editMappingList.studentNameDescription": "Studentens namn",
	"pages.studentSettings.editMappingList.studentAnonymizedCodeDescription": "Studentanonymiseringskod",
	"pages.studentSettings.editMappingList.studentPersonalIdentificationNumberDescription": "Studentens personnummer",
	"pages.studentSettings.editMappingList.registrationDateDescription": "Tidsangivelse för när studenten anmälde sig på tentamen",
	"pages.studentSettings.editMappingList.externalExamNameDescription": "Ett textfält med tentamens namn i källsystemet",
	"pages.studentSettings.editMappingList.specialNeedsAssignmentDescription": "Ett värde som indikerar om eller vilket särskilt behov en student har rätt till",
	"pages.studentSettings.registrationMappingInstruction.title": "Mappning för studentanmälan",
	"pages.studentSettings.registrationMappingInstruction.content": "Ställ in hur Ladok-filer används för att hantera anmälda studenter på varje tentamen",
	"pages.studentSettings.header.studentRegistrationMapping": "Mappning för studentanmälan",
	"pages.studentSettings.upload.dropFilePlaceholder": "Släpp en fil från Ladok här för att börja konfigurationen",
	"pages.integrationSettings.integrationList.header": "Konfigurera vilka objekt som ska vara obligatoriska i tentamensbeställningar",
	"pages.integrationSettings.dangerZoneAlert.message": "Var försiktig!",
	"pages.integrationSettings.dangerZoneAlert.description": "Om du redigerar inställningarna här kan integrationen mot TimeEdit-servern brytas",
	"pages.integrationSettings.integrationList.baseUrl.title": "URL",
	"pages.integrationSettings.integrationList.baseUrl.description": "Adressen TE Exam ska använda för att koppla upp sig mot TimeEdit-servern",
	"pages.integrationSettings.integrationList.username.title": "Användarnamn",
	"pages.integrationSettings.integrationList.username.description": "Användarnamnet TE Exam ska använda för att autentisera sig mot TimeEdit-servern",
	"pages.integrationSettings.integrationList.password.title": "Lösenord",
	"pages.integrationSettings.integrationList.password.description": "Lösenordet TE Exam ska använda för att autentisera sig mot TimeEdit-servern",
	"pages.integrationSettings.integrationList.certificateKey.title": "Certifikatnyckel",
	"pages.integrationSettings.integrationList.certificateKey.description": "Certifikatnyckeln TE Exam ska använda för att autentisera sig med TimeEdit-servern",
	"pages.integrationSettings.tab.teExamRooms": "TE Exam-lokal",
	"pages.integrationSettings.tab.timeEditObjects": "TimeEdit-objekt",
	"pages.integrationSettings.label.view": "Visa",
	"pages.integrationSettings.label.selectedTEObjects": "# av valda TE-objekt",
	"pages.integrationSettings.content.selectedTEObjects": "{objectNumber} objekt",
	"pages.integrationSettings.label.manageSelection": "Hantera val:",
	"pages.integrationSettings.tab.integrationOverview": "Integrationsöversikt",
	"pages.integrationSettings.tab.dataMapping": "Datamapping",
	"pages.integrationSettings.tab.reservationSettings": "Reservationsinställningar",
	"pages.integrationSettings.tab.roomObjects": "Lokalobjekt",
	"utils.batchImportHelper.error.uploadFile.title": "Fel vid uppladdning av fil",
	"common.label.informationToAdministrators": "Administratörsinformation",
	"common.label.informationToStudents": "Studentinformation",
	"common.label.informationToSupervisors": "Tentamensvärdsinformation",
	"common.label.plannedStudents": "Planerat antal studenter",
	"common.label.seat": "Plats",
	"common.message.successActivateItem": "{item} aktiverades",
	"common.message.successAdjustItem": "{item} ändrat",
	"common.message.successAllocateItem": "{item} allokerat",
	"common.message.successAssignItem": "{item} tilldelat",
	"common.message.successConfirmItem": "{item} bekräftat",
	"common.message.successCreateItem": "{item} skapat",
	"common.message.successDeactivateItem": "{item} avaktiverat",
	"common.message.successDeallocateItem": "{item} avallokerat",
	"common.message.successDeleteItem": "{item} borttaget",
	"common.message.successImportItem": "{item} importerat",
	"common.message.successRemoveItem": "{item} borttaget",
	"common.message.successSaveItem": "{item} sparat",
	"common.message.successSubmitItem": "{item} sparat",
	"common.message.successUpdateItem": "{item} uppdaterat",
	"common.model.bookingRequest": "bokningsförfrågan",
	"common.model.checklist": "Checklista",
	"common.model.postExamNotes": "uppföljningsanteckningar",
	"common.model.schedulingRequests": "schemaläggningsönskemål",
	"common.title.public.studentSchedule": "Studentsida",
	"components.freeTextFilter.placeholder.search": "Sök...",
	"components.mainMenu.label.logOut": "Logga ut",
	"components.mainMenu.label.organization": "Organisation",
	"components.mainMenu.title.switchOrganization": "Byt organisation",
	"components.schedulingFragment.error.invalidScheduling": "Ogiltig schemaläggning",
	"components.supervisorFoldout.title.supervisorDetails": "Tentamensvärdsinformation",
	"pages.examSchedulingRequest.error.priorityMinimum": "Tentamen behöver minst {minRequestNumber, plural, one {# scheduling priority} other {# scheduling priorities}",
	"pages.examSchedulingRequest.error.unique": "Alla schemaläggningsönskemål måste vara unika",
	"pages.examSchedulingRequest.errorTitle.invalidSettings": "Ogiltiga inställningar",
	"pages.examSchedulingRequest.message.notSetValue": "Inte inställt",
	"pages.public.examAddToCalendarButton.button.addToCalendar": "Lägg till i kalender",
	"pages.public.examInformation.panel.examInformation": "Tentamensinformation",
	"pages.public.examStatus.valueLabel.examStatus.notScheduled": "Ej schemalagt",
	"pages.public.examStatus.valueLabel.examStatus.pastExam": "Passerad tentamen",
	"pages.public.examStatus.valueLabel.examStatus.upcoming": "Kommande",
	"pages.public.examStudentScheduleWrapper.error.examNotScheduled.description": "Tentamen har inte schemalagts än, så vi kan inte visa ditt schema.",
	"pages.public.examStudentScheduleWrapper.error.examNotScheduled.title": "Du är snabb! Nästan lite för snabb.",
	"pages.public.examStudentScheduleWrapper.error.initialLoading.description": "Vi har letat överallt, men vi kunde inte hitta organisationen eller tentamen du sökte efter.",
	"pages.public.examStudentScheduleWrapper.error.initialLoading.title": "Oooops! Det verkar som om något är fel med din länk.",
	"pages.public.examStudentScheduleWrapper.error.notYourSchedule.description": "Ditt schema och platstilldelning är inte färdig än. Vänligen försök igen senare.",
	"pages.public.examStudentScheduleWrapper.error.notYourSchedule.title": "Vi hittade dig! Men tyvärr inte ditt schema :(",
	"pages.public.examStudentScheduleWrapper.error.pastExam.description": "Vänligen notera att den här tentamen redan har varit.",
	"pages.public.examStudentScheduleWrapper.error.pastExam.title": "Det här är en passerad tentamen",
	"pages.public.examStudentScheduleWrapper.label.notesToStudents": "Studentinformation",
	"pages.public.examStudentScheduleWrapper.label.yourSchedule": "Ditt schema",
	"pages.public.examStudentScheduleWrapper.message.noNotesAdded": "Ingen information har lagts till",
	"pages.public.examsOnRoomBookingWrapper.header": "Följande tentamen är schemalagda på lokalbokningen",
	"pages.public.readOnlyExamObjects.description.courseEvents": "Kurstillfällen på tentamen",
	"pages.public.readOnlyExamObjects.description.courses": "Kurser på tentamen",
	"pages.public.readOnlyExamObjects.description.departments": "Institutioner på tentamen",
	"pages.public.readOnlyExamObjects.description.language": "Tentamensspråk",
	"pages.public.readOnlyExamObjects.description.modules": "Moduler på tentamen",
	"pages.public.readOnlyExamObjects.description.professors": "Professorer på tentamen",
	"pages.public.readOnlyExamObjects.description.type": "Tentamenstyp",
	"pages.public.roomBookingPublicSchedule.title.roomBooking": "Lokalbokning i {room} den {date} mellan {startTime} och {endTime}",
	"pages.public.studentSignIn.alt.logoAlt": "Studentinloggning",
	"pages.public.studentSignIn.button.viewYourExamSchedule": "Visa din studentsida",
	"pages.public.studentSignIn.error.studentIdRequired": "Skriv in ditt student-ID för att visa ditt schema",
	"pages.public.studentSignIn.error.unableLocateStudentIdOnExam": "Vi kunde hitta ditt student-ID på tentamen. Vänligen försök igen",
	"pages.public.studentSignIn.placeholder.studentId": "Skriv in ditt student-ID",
	"pages.public.studentSignIn.text.enterStudentId": "Skriv in ditt student-ID för att hitta din tentamen",
	"pages.public.studentSignIn.text.hola": "Tjenare, kompis!",
	"pages.requestedSchedulingPane.message.notSetValue": "Inte inställt",
	"pages.studentSeatingInformation.addToCalendarButton.description": "Plats-ID: {seatingId}. Platsinformation: {seatingInfo}",
	"pages.studentSeatingInformation.addToCalendarButton.title": "Tentamen: {exam}",
	"pages.studentSeatingInformation.label.studentAvatar": "Studentavatar",
	"providers.examScheduling.message.successDeleteExamSchedule": "Schemaläggningen borttagen",
	"providers.examScheduling.message.successScheduleExam": "Tentamen har schemalagts",
	"providers.integrationSettings.message.successAddRoom": "Lokalen tillagd i TE Exam",
	"providers.integrationSettings.message.successRemoveRoom": "Lokalinformationen har uppdaterats i TE Exam",
	"providers.integrationSettings.message.successUpdateIntegrationSettings": "Integrationsinställningar uppdaterade",
	"providers.organization.message.successUpdateMandatoryObjects": "Obligatoriska objekt uppdaterade",
	"providers.organization.message.successUpdateOrganizationName": "Organisationsnamnet uppdaterat",
	"providers.organization.message.successUpdateSchedulingPrioritiesSettings": "Inställningarna för schemaläggningsönskemål uppdaterade",
	"providers.organization.message.successUpdateStudentRegistrationMapping": "Inställningar för studentanmälan uppdaterade",
	"providers.roomBooking.message.successBookRoom": "Lokalbokningen skapad",
	"providers.roomBooking.message.successOperate": "Åtgärden slutförd",
	"providers.roomBooking.message.successUpdateSupervisorsNeed": "Antal tentamensvärdar som behövs uppdaterat",
	"providers.utils.message.operationCompleted": "Åtgärden slutförd",
	"providers.utils.message.operationFailed": "Åtgärden misslyckades",
	"common.placeholder.information": "Kommentarer, tillåtna hjälpmedel, ...",
	"common.valueLabel.isActive.pending": "pågående",
	"pages.examDetailInformationTab.message.informationToAdministrators": "Detta visas endast för administratören och ägaren av tentan",
	"common.error.emailExists": "E-postadressen finns redan registrerad",
	"pages.supervisorSchedulingRequest.error.invalidRequest": "Ogiltig förfrågan",
	"pages.supervisorSchedulingRequest.error.requestAccepted": "Din förfrågan är godkänd. Du kan inte längre ändra den.",
	"pages.supervisorSchedulingRequest.error.requestDeclined": "Din förfrågan är avböjd. Du kan inte längre ändra den.",
	"pages.supervisorSchedulingRequest.error.requestNotExist": "Din förfrågan saknas",
	"pages.supervisorSchedulingRequest.message.requestAccepted": "Du är nu bokad som tentamensvärd",
	"pages.supervisorSchedulingRequest.message.requestDeclined": "Din förfrågan är avböjd",
	"common.button.addToCalendar": "Lägg till i kalender",
	"common.button.backToOverview": "Tillbaka till översikt",
	"common.button.batchImportExamRequests": "Importera tentamensbeställningar",
	"common.button.createNewItem": "Skapa ny {item}",
	"common.button.deleteSelectedItem": "Ta bort vald {item}",
	"common.button.matchAll": "Matcha alla",
	"common.button.matchOne": "Matcha en",
	"common.button.scheduleHere": "Schemalägg här",
	"common.button.showSelectedRoomBooking": "Visa vald lokalbokning",
	"common.button.view": "Visa",
	"common.error.uploadDuplicateStudentIds": "Filen får inte innehålla dubletter av student-ID. Se till att student-ID endast förekommer en gång.",
	"common.label.additionalInformation": "Ytterligare information",
	"common.label.allocateSelectedStudents": "Allokera valda studenter",
	"common.label.basicInformation": "Grundläggande info",
	"common.label.comments": "Kommentarer",
	"common.label.dataMapping": "Datamapping",
	"common.label.dateAndTime": "Datum & tid",
	"common.label.editExamAllocation": "Redigera tentamensallokering",
	"common.label.examInformation": "Tentamensinformation",
	"common.label.examOverview": "Tentamensöversikt",
	"common.label.examSlots": "Slottar",
	"common.label.filters": "Filter",
	"common.label.integrationOverview": "Integrationsöversikt",
	"common.label.key": "ATTRIBUT",
	"common.label.manageSelection": "Hantera val",
	"common.label.mandatoryObjects": "Obligatoriska objekt",
	"common.label.numberOfStudents": "Antal studenter",
	"common.label.overview": "Översikt",
	"common.label.pastExams": "Passerad tentamen",
	"common.label.pendingExams": "Tentamensbeställningar",
	"common.label.postExamManagement": "Tentamensuppföljning",
	"common.label.publicSchedule": "Studentsida",
	"common.label.reservationSettings": "Reservationsinställningar",
	"common.label.roomBooking": "Lokalbokning",
	"common.label.roomBookings": "Lokalbokningar",
	"common.label.roomInformation": "Lokalinformation",
	"common.label.roomObjects": "Lokalobjekt",
	"common.label.rule": "REGEL",
	"common.label.scheduledExams": "Schemalagda tentamen",
	"common.label.scheduling": "Schemaläggning",
	"common.label.seatAllocation": "Platsallokering",
	"common.label.seatingInformation": "Platsinformation",
	"common.label.selectChildExam": "Välj undertentamen",
	"common.label.selectItem": "Välj {item}",
	"common.label.selectedItem": "Vald {item}",
	"common.label.selectedObjects": "Valda objekt",
	"common.label.selectedTEObjects": "Antal valda TE-objekt",
	"common.label.selection": "Val",
	"common.label.showCompatibleRoomBookings": "Visa kompatibla lokalbokningar",
	"common.label.specialNeeds": "Särskilda behov",
	"common.label.studentRegistration": "Anmälda studenter",
	"common.label.supervisorsAccepted": "Godkända tentamensvakter",
	"common.label.supervisorsNeeded": "Behövt antal tentamensvärdar",
	"common.label.supervisorsScheduled": "Schemalagda tentamensvärdar",
	"common.label.teExamRooms": "TE Exam-lokaler",
	"common.label.timeEditObjects": "TimeEdit-objekt",
	"common.label.viewMode": "Visa",
	"common.message.atLeastSchedulingPriority": "För att spara din tentamensbeställning, vänligen lägg till minst {priorityNumber, plural, one {# scheduling priority} other {# scheduling priorities}}",
	"common.message.checklistNeedTitle": "Du kan inte markera den som färdig innan du gett den en titel",
	"common.message.confirmAllocation": "Bekräfta tilldelning av {number} studenter",
	"common.message.confirmDeleteRoomBooking": "Är du säker på att du vill ta bort bokningen med datum {date} i lokalen {room}?",
	"common.message.confirmDeleteRoomBookingContent": "Alla tentamina, tentamensvakter och studenter som är bokade och allokerade på lokalbokningen kommer att tas bort.",
	"common.message.confirmDeleteRoomBookings": "Är du säker på att du vill ta bort {number} lokalbokningar?",
	"common.message.confirmProceed": "Är du säker på att du vill fortsätta?",
	"common.message.examInformationLocked": "Grundinformationen är låst",
	"common.message.examInformationLockedDesc": "Du kan inte redigera grundinformationen efter att tentamen är schemalagd",
	"common.message.examNamingOptional": "Namngivning är frivilligt, alla tentamen har alltid ett unikt ID",
	"common.message.infoToAdministratorsNotice": "Detta visas endast för administratören och ägaren av tentan",
	"common.message.noFilter": "Du har inte lagt till några filter än",
	"common.model.externalBooking": "Extern bokning",
	"common.model.registeredStudents": "Anmälda studenter",
	"common.placeholder.filterProperties": "Sök...",
	"common.placeholder.notAssigned": "N/A",
	"common.placeholder.search": "Sök...",
	"common.placeholder.select": "Välj...",
	"common.placeholder.selectCategory": "Välj en kategori",
	"common.placeholder.selectFilterRule": "Välj en filterregel",
	"common.placeholder.selectProperty": "Välj ett attribut",
	"common.placeholder.typeToEdit": "Skriv här...",
	"common.placeholder.untitledExam": "Ange namn",
	"common.title.common.overviewOfItem": "Översikt {item}",
	"common.title.roomBooking": "Lokalbokning i {room} den {date} mellan {startTime} och {endTime}",
	"common.valueLabel.examStatus.notScheduled": "Ej schemalagt",
	"common.valueLabel.examStatus.pastExam": "Passerad tentamen",
	"common.valueLabel.examStatus.upcoming": "Kommande",
	"common.valueLabel.importStatus.duplicate": "Dubblett",
	"common.valueLabel.importStatus.ok": "OK",
	"common.valueLabel.publicationStatus.modified": "Ändrad",
	"common.valueLabel.publicationStatus.notPublished": "Ej publicerad",
	"common.valueLabel.publicationStatus.published": "Publicerad {date, select, NONE {} other { on {date}}}",
	"common.valueLabel.publicationStatus.publishedWithChanges": "Publicerad{date, select, NONE {} other { on {date}}}, but there are changes",
	"common.valueLabel.studentCount.allocated": "{number} allokerade studenter",
	"common.valueLabel.studentCount.capacity": "{number} studentplatser",
	"common.valueLabel.studentCount.planned": "{number} planerade studenter",
	"common.valueLabel.studentCount.registered": "{number} anmälda studenter",
	"common.valueLabel.studentCount.scheduled": "{number} schemalagda studenter",
	"components.childExamFormDialog.message.confirmDecreaseParentStudents.content": "Antal planerade studenter på undertentamen är färre än på huvudtentamen.",
	"components.childExamFormDialog.message.confirmDecreaseParentStudents.proceed": "Vill du ändra antal planerade studenter på huvudtentamen för att stämma med undertentamen?",
	"components.childExamFormDialog.message.confirmIncreaseOverbook.content": "Om du ökar antal platser på den här tentamen kommer du inte längre kunna nyttja platsallokering. Platsallokering kommer inte att finnas tillgänglig på den här tentamen, inte heller på andra tentor kopplade till samma lokalbokning.",
	"components.childExamFormDialog.message.confirmIncreaseOverbook.title": "Bekräfta lokalöverbokning",
	"components.childExamFormDialog.message.confirmIncreaseParentStudents.content": "Antal planerade studenter på dina undertentamen är högre än på huvudtentamen. Huvudtentamen kommer nu att uppdateras för att stämma överens med undertentamen.",
	"components.examCostChart.label.costForExam": "Kostnad för {examId}",
	"components.examReassignmentModal.message.examOwnershipChanged": "Ägandeskap av tentamen har ändrats",
	"components.examReassignmentModal.message.examOwnershipChangedMessageDesc": "Du skickas vidare eftersom du inte längre är ägare av den här tentamen.",
	"components.examReassignmentModal.message.reassignConfirm": "Är du säker på att du vill ändra ägandeskap av tentan?",
	"components.examReassignmentModal.message.reassignConfirmContent": "Gå vidare för att permant ändra ägandeskap av tentan.",
	"components.examReassignmentModal.message.reassignTitle": "Ändra ägandeskap",
	"components.publishPane.message.examCannotBePublished": "Tentan kan inte publiceras eftersom den inte är schemalagd. Schemalägg tentan först.",
	"components.scheduledSupervisorActionsDropdown.button.acceptBookingForSupervisor": "Acceptera bokning åt tentamensvärd",
	"components.schedulingFragment.message.overbookAlert.description": "Lägg märke till att du överbokar lokalen om du bokar in tentamen här",
	"components.schedulingFragment.message.overbookAlert.message": "Överbokning av lokal",
	"components.schedulingFragment.message.overbookConfirm.content": "Du inte kommer kunna nyttja platsallokering för någon av tentorna i denna lokal om du väljer att överboka det",
	"components.schedulingFragment.message.overbookConfirm.title": "Bekräfta lokalöverbokning",
	"components.setSupervisorCount.message.bookingHasPast": "Bokningen går inte att ändra då den redan har skett",
	"components.studentScheduleError.message": "Om du har funderingar eller behöver hjälp, kontakta din systemadministratör",
	"components.supervisorAvailabilityCalendar.historicalBooking.content": "Du kan inte skapa ett event för ett datum som redan har passerat",
	"components.supervisorAvailabilityCalendar.historicalBooking.title": "Det här datumet har redan passerat",
	"components.supervisorAvailabilityCalendar.overlappingBooking.content": "Det här eventet krockar med en bokning som du är schemalagd på",
	"components.supervisorAvailabilityCalendar.overlappingBooking.title": "Överlappande bokningar",
	"components.totalExamCostChart.label.costForExam": "Tentamenskostnad",
	"components.totalExamCostChart.label.costForExamIdLabel": "Kostnad för {examId}",
	"pages.examDetail.message.redirectedToParentExam.description": "Du valde en undertentamen och har därför blivit omdirigerad till huvudtentamen",
	"pages.examDetail.message.redirectedToParentExam.message": "Omdirigerad till huvudtentamen",
	"pages.examSeatAllocationTab.alert.overbookedRoom.description": "Tentamen är schemalagd i en lokal som är överbokad. Platsnumrering är därför inte tillgängligt.",
	"pages.examSeatAllocationTab.alert.overbookedRoom.message": "Överbokad lokal",
	"pages.examSeatAllocationTab.message.confirmOverbook.content": "Du försöker allokera fler studenter än det finns platser i lokalen. Det innebär att platsnumrering inte kommer att vara tillgängligt. Vill du fortsätta?",
	"pages.examSeatAllocationTab.message.confirmOverbook.title": "Bekräfta överbokning",
	"pages.roomBooking.alert.overbooked.description": "Platsallokering är inte tillgängligt då denna lokal är överbokad.",
	"pages.roomBooking.alert.overbooked.message": "Överbokad lokal",
	"pages.roomBooking.alert.overbooked.toChange": "För att ändra detta, ta bort tentamen eller ändra antal planerade studenter.",
	"pages.roomBooking.label.selectBookingsToDelete": "Välj lokalbokningar att ta bort",
	"pages.roomBooking.label.selectBookingsToExport": "Välj lokalbokningar för export",
	"common.button.acceptItem": "Godkänn {item}",
	"common.button.book": "Boka",
	"common.button.bookMoreItem": "Boka fler {item}",
	"common.button.closeWithSaving": "Spara och stäng",
	"common.button.closeWithoutSaving": "Stäng",
	"common.button.goToNextWeek": "Nästa vecka",
	"common.button.goToPreviousWeek": "Föregående vecka",
	"common.button.help": "Hjälp",
	"common.button.publishExams": "Publicera tentamen",
	"common.button.selectAllDay": "Välj dag",
	"common.button.selectWeek": "Välj vecka",
	"common.button.viewItem": "Se {item}",
	"common.error.outsideOfRoomBooking": "{denominator} ligger utanför lokalbokningen",
	"common.error.phoneNumber": "Ogiltigt telefonnummer",
	"common.error.required_short": "Obligatoriskt",
	"common.label.availableCapacity": "Tillgänglig kapacitet",
	"common.label.bookedSupervisors": "Bokade tentamensvärdar",
	"common.label.bookingInfo": "Bokningsinfo",
	"common.label.bookingTitle": "Bokningstitel",
	"common.label.campuses": "Campus",
	"common.label.canBeLead_long": "Kan vara huvudtentamensvärd",
	"common.label.contractType": "Typ av kontrakt",
	"common.label.dayView": "Dagsvy",
	"common.label.depublishExam": "Avpublicera tentamen",
	"common.label.examLanguages": "Tentamensspråk",
	"common.label.examLength": "Längd",
	"common.label.examTypes": "Tentamenstyp",
	"common.label.externalSupervisorBooking": "Bokning extern tentamensvärd",
	"common.label.hasExams": "Har tentamen",
	"common.label.hasSupervisors": "Har tentamensvärdar",
	"common.label.isEmailSent": "E-post skickat",
	"common.label.isLead_long": "Huvudvärd",
	"common.label.isOverbooked": "Överbokad",
	"common.label.label": "Visningsfält",
	"common.label.needsSupervisors": "Behöver tentamensvärdar",
	"common.label.numberOfItem": "Antal {item}",
	"common.label.otherExamsOnRoomBooking": "Andra tentamen på lokalbokningen",
	"common.label.phoneNumber1": "Telefonnummer 1",
	"common.label.phoneNumber2": "Telefonnummer 2",
	"common.label.price": "Pris",
	"common.label.publishExam": "Publicera tentamen",
	"common.label.requestedDuration": "Längd på förfrågan",
	"common.label.roomBookingHours": "Tid för lokalbokning",
	"common.label.rooms": "Lokaler",
	"common.label.selectedCalendar": "Välj kalender",
	"common.label.sendEmailImmediately": "Skicka e-post",
	"common.label.showPagination": "Visa sidor",
	"common.label.slotView": "Slott-vy",
	"common.label.studentDistribution": "Studentfördelning",
	"common.label.supervisorBooking": "Bokning för tentamensvakt",
	"common.label.supervisorHours": "Timmar för tentamensvärd",
	"common.label.supervisorInformation": "Information för tentamensvakt",
	"common.label.timeline": "Tidslinje",
	"common.label.timing": "Timing",
	"common.label.totalCapacity": "Total kapacitet",
	"common.label.unavailable": "Otillgänglig",
	"common.message.examHasPast": "Tentamen har utgått",
	"common.message.examHasPastDesc": "Grundinformation och schemaläggning kan inte redigeras",
	"common.message.mayNotBeSaved": "Dina ändringar har inte sparats",
	"common.message.nothingSelected": "Ingenting valt",
	"common.message.onlyAvailableForScheduledExam": "Endast tillgänglig för schemalagda tentamen",
	"common.message.unscheduled": "Ej schemalagd",
	"common.model.availability": "Tillgänglighet",
	"common.placeholder.noItem": "Inga {item}",
	"common.placeholder.pleaseSelectItem": "Välj {item}",
	"common.placeholder.searchItem": "Sök {item}",
	"common.title.common.publish": "Publicera tentor",
	"common.title.leavePage": "Lämna sidan?",
	"common.title.roomBookingInRoom": "Lokalbokning i {room}",
	"common.title.supervisorBookingInRoom": "Bokning för {supervisor} i {room}",
	"common.valueLabel.bookingStatus.accepted": "Accepterad",
	"common.valueLabel.bookingStatus.pending": "Pågående",
	"common.valueLabel.bookingStatus.scheduled": "Schemalagd",
	"common.valueLabel.boolean.no": "Nej",
	"common.valueLabel.boolean.notYet": "Inte än",
	"common.valueLabel.boolean.yes": "Ja",
	"common.valueLabel.contractType.consultant": "Konsult",
	"common.valueLabel.contractType.employee": "Anställd",
	"common.valueLabel.itemCount.allocatedPlannedstudents": "{allocated}/{planned} studenter",
	"common.valueLabel.itemCount.confirmedScheduledNeededSupervisors": "{confirmed}/{scheduled}/{needed} tentamensvärdar",
	"common.valueLabel.itemCount.exams": "{number} tentamen",
	"common.valueLabel.itemCount.pricePerSeatPerHour": "{price} / plats / timme",
	"common.valueLabel.itemCount.students": "{number} studenter",
	"common.valueLabel.mainSupervisor.isLead": "Är huvudtentamensvärd",
	"common.valueLabel.overbooked.notOverbooked": "Ej överbokad",
	"common.valueLabel.overbooked.overbooked": "Överbokad",
	"components.childExamFormDialog.button.confirmDecreaseParentStudents.no": "Nej, behåll antalet studenter",
	"components.childExamFormDialog.button.confirmDecreaseParentStudents.yes": "Ja, ändra antalet på huvudtentamen",
	"components.childExamFormDialog.message.confirmDecreaseParentStudents.title": "För få studenter på undertentamen",
	"components.dynamicTable.selectColumn.title": "Välj kolumner",
	"components.publicationStatus.couldNotBePublished.title": "Tentamen kunde ej publiceras - {error}",
	"components.resourceScheduler.acceptSupervisorBookingModal.content": "Är du säker på att du vill acceptera bokningen?",
	"components.resourceScheduler.acceptSupervisorBookingModal.title": "Bekräfta bokning",
	"components.resourceScheduler.declineSupervisorBookingModal.content": "Är du säker på att du vill avböja bokningen för tentamensvärden?",
	"components.resourceScheduler.declineSupervisorBookingModal.title": "Bekräfta",
	"components.resourceScheduler.label.eventFilters": "Bokningsfilter",
	"components.resourceScheduler.label.resourceFilters": "Objektsfilter",
	"components.resourceScheduler.removeSupervisorBookingModal.content": "Är du säker på att du vill avbryta bokningen för tentamensvakten?",
	"components.resourceScheduler.removeSupervisorBookingModal.title": "Bekräfta",
	"components.resourceScheduler.unableToMoveSupervisorBooking.description": "Den nya tiden kolliderar med en annan bokning",
	"components.resourceScheduler.unableToMoveSupervisorBooking.message": "Det gick inte att flytta bokningen för tentamensvärden",
	"components.scheduledSupervisorActionsDropdown.button.sendEmailToSupervisor": "Skicka email till tentamensvärd",
	"components.supervisorAvailabilityCalendar.alert.selectResponseFor.content": "om du vill ändra ditt svar i efterhand får du kontakta din systemadministratör",
	"components.supervisorAvailabilityCalendar.alert.selectResponseFor.note": "OBS",
	"components.supervisorAvailabilityCalendar.alert.selectResponseFor.title": "Välj ditt svar genom att klicka på en av knapparna nedan",
	"components.supervisorAvailabilityCalendar.button.confirmBooking": "Jag bekräftar bokningen",
	"components.supervisorAvailabilityCalendar.button.declineBooking": "Jag avböjer bokningen",
	"components.supervisorAvailabilityCalendar.button.selectResponse": "Välj ett svar",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.confirmDeclineBooking.description": "Tentamensbokningar visas med grön prick (godkänd bokning) eller som randig med gul prick (bokning som väntar på svar). Om du ännu inte tagit ställning till bokningen, klicka på \"Välj ett svar\" för att godkänna eller avböja bokningen.",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.confirmDeclineBooking.title": "Titta igenom, bekräfta eller avböj dina bokningar",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.editAvailability.description": "Du kan ändra din tillgänglighet genom att sätta ut röda områden i kalendern. Klicka i kalendern, dra och släpp för att sätta din tillgänglighet. Klicka på de röda områderna för att ändra namn eller ta bort dem.",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.editAvailability.title": "Ändra din tillgänglighet",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.enterAvailability.description": "Ställ in de dagar och tider du inte är tillgänglig. Det gör du genom att klicka i kalendern och sedan dra för att markera när du inte kan arbeta.",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.enterAvailability.title": "Sätt din tillgänglighet",
	"components.supervisorAvailabilityCalendar.supervisorCalendarHelp.title": "Så gör du i kalendern",
	"components.supervisorAvailabilityCalendar.title.myAvailability": "Min tillgänglighet och bokningar",
	"components.supervisorAvailabilityCalendar.title.selectResponseFor": "Välj svar för {event}",
	"components.teExamCalendar.tooltip.time": "(Start förberedelsetid) -  (start tentamen) --- (slut tentamen) - (slut städtid)",
	"pages.studentSettings.message.studentIdLabelDescription": "(Visas för studenter på registreringssidan)",
	"pages.teIntegration.button.applyChanges": "Genomför förändringar",
	"pages.teIntegration.message.applyChangesWarning": "Klicka här för att uppdatera TEX lokalobjekt med nya värden från TE Server, t.ex. om data har uppdaterats i TE Server eller om mappningen har uppdaterats.",
	"common.button.close": "Stäng",
	"common.label.emailStatus": "Epost-status",
	"common.label.externalReference": "Extern referens",
	"common.label.inboundLinks": "Inkommande länkar",
	"common.label.linking": "Länkning",
	"common.label.sendBookingRrequestEmailToDupervisor": "Skicka bokningsemail till tentamensvärden",
	"common.label.sendToUserOn": "Skickat den",
	"common.label.theSupervisorWillReceiveAnEmail": "Tentamensvärdarna kommer få ett email om att bekräfta bokningen. Du kan skicka mailet nu genom att bocka i kryssrutan nedanför, eller senare från översikten av bokade tentamensvärdar",
	"common.label.thisExamIsLinkedFrom": "Tentamen länkas till från",
	"common.label.thisExamIsLinkedTo": "Tentamen är länkad till",
	"common.message.invalidPriorities": "Det finns ogiltiga schemaläggningsönskemål",
	"common.message.prioritiesHaveError": "Följande fel hindrar dig från att spara",
	"common.placeholder.externalExamReference": "Extern tentamensreferens",
	"common.valueLabel.emailStatus.notSent": "Ej skickat",
	"common.valueLabel.emailStatus.sent": "Skickat",
	"components.childExamFormDialog.button.copyExistingScheduling.no": "Kopiera schemaläggning",
	"components.childExamFormDialog.button.processWithCautionCoping": "Tentamen med id {id} är redan schemalagd. Vill du kopiera den schemaläggningen till en ny undertentamen?",
	"components.childExamFormDialog.button.publicationWillBeGone.no": "Om tentamen är pulicerad, kommer den här operationen att avpublicera den.",
	"components.childExamFormDialog.message.copyTheSchedulingFromTheCurrent": "Ja, kopiera schemaläggningen av tentamen {id} till en ny tentamen",
	"components.dateRange.nextMonth": "Nästa månad",
	"components.dateRange.nextWeek": "Nästa vecka",
	"components.dateRange.thisMonth": "Den här månaden",
	"components.dateRange.thisWeek": "Den här veckan",
	"components.dateRange.today": "Idag",
	"components.requestedSchedulingListDetailPad.alert.prioritiesAddLeast.errorMessage": "Följande fel hindrar dig från att spara",
	"components.requestedSchedulingListDetailPad.alert.prioritiesInvalidWarning.message": "Det finns ogiltiga schemaläggningsönskemål",
	"components.requestedSchedulingListDetailPad.alert.prioritiesMaximumWarning.message": "Det går inte att lägga till fler än {maxNumber} schemaläggningsönskemål.",
	"pages.examOverview.selectExamToPublish": "Välj tentor att publicera",
	"pages.examSetting.mandatoryList.error.minMandatoryObjectToPublish": "Du behöver åtminstone ett obligatoriskt objekt för att publicera till TE Server",
	"pages.examSetting.mandatoryList.label.shouldPublish": "Publicera till TE Server",
	"pages.homeSupervisor.tab.pastBookingsTab": "Inaktuella bokningar",
	"common.button.blockAllDay": "Blockera hela dagen",
	"common.label.bookings": "Bokningar",
	"common.label.bulkActions": "Massoperationer",
	"common.label.capacityOverview": "Kapacitetsöversikt",
	"common.label.greeting": "Hälsning",
	"common.label.hasLink": "Länkad",
	"common.label.itemsSelected": "Valda objekt",
	"common.label.otherEventsOnSameDay": "Andra bokningar på samma dag",
	"common.label.published": "Publicerad",
	"common.message.errorSendEmails": "{number} mail kunde inte skickas",
	"common.message.successBookRoom": "Lokalbokningen skapad",
	"common.message.successOperate": "Åtgärden slutförd",
	"common.message.successSendEmail": "Mailen skickade",
	"common.message.successSendEmails": "{number} email har skickats",
	"common.message.successSendNoEmails": "Inga email skickades",
	"common.message.successUpdateSupervisorsNeed": "Antal tentamensvärdar som behövs har uppdaterats",
	"common.title.common.addNewItem": "Skapa {item}",
	"common.valueLabel.examSchedulingStatus.past": "Passerad",
	"common.valueLabel.examSchedulingStatus.pending": "Pågående",
	"common.valueLabel.examSchedulingStatus.scheduled": "Schemalagda",
	"pages.exam.message.publishedExamFailure": "Tentamen {examId} kunde inte publiceras",
	"pages.exam.message.publishedExamSuccess": "Tentamen {examId} publicerad",
	"common.label.hasNoExams": "Har inga tentor",
	"common.label.supervisorsSelected": "Valda tentamensvärdar",
	"common.message.SendConfirmationEmailsToSupervisors": "Skicka email till tentamensvärdar",
	"common.message.thisWillSendABookingConfirmationEmail": "En bokningsbekräftelse kommer skickas till alla tentamensvärdar på de valda lokalbokningarna som ännu ej fått ett mail. Vill du fortsätta?",
	"common.message.useThisButtonToSaveChanges": "Använd knappen till att spara ändringar i tentamensvärdarnas arbetstider och vem som är huvudvärd",
	"common.valueLabel.role.examAdministrator": "Administratör",
	"common.valueLabel.role.examCoordinator": "Koordinator - Tentamen",
	"common.valueLabel.role.examManager": "Beställare",
	"common.valueLabel.role.supervisorCoordinator": "Koordinator - Tentamensvärd",
	"components.scheduledSupervisorActionsDropdown.button.scheduleSupervisor": "Schemalägg tentamensvärdar",
	"components.supervisorAvailabilityCalendar.button.bookAllDay": "Blockera hela dagen",
	"components.supervisorAvailabilityCalendar.label.displayingDates": "Datum",
	"components.supervisorAvailabilityCalendar.weekPicker.format": "{from} - {to} {year} (Vecka {week})",
	"common.label.hasNoSupervisors": "Saknar tentamensvärdar",
	"common.label.hasRightNumber": "Rätt antal",
	"common.label.hasTooFew": "För få",
	"common.label.isReExam": "Omtentamen",
	"common.label.requestedDate": "Önskat datum",
	"common.label.scheduledDate": "Datum",
	"common.valueLabel.bookingStatus.declined": "Avböjt",
	"common.valueLabel.isReExam.reExam": "Omtentamen",
	"common.error.theSchedulingDoesNotMatchAnyOfTheSubmittedSchedulingPriorities": "Vald schemaläggning matchar inget av de inskickade önskemålen",
	"common.label.priorities": "Önskemål",
	"common.label.roomBookingOverview": "Lokalöversikt",
	"common.label.studentInformation": "Studentinformation",
	"common.label.visible": "Synlig",
	"common.message.makeTheBookingVisibleToSupervisor": "Gör bokningen synlig för tentamensvärden",
	"common.title.settings.profile": "Profil",
	"common.valueLabel.filter.myExams": "Mina tentor",
	"components.scheduledSupervisorActionsDropdown.button.setInvisibleForSupervisor": "Osynlig för tentamensvärd",
	"components.scheduledSupervisorActionsDropdown.button.setVisibleForSupervisor": "Synlig för tentamensvärd",
	"components.schedulingFragment.error.importantInformationAboutYourScheduling": "Viktig information angående din schemaläggning",
	"common.button.duplicateExam": "Kopiera tentamen",
	"common.button.selectAllWithBbookingsThisWeek": "Välj alla med bokningar denna vecka",
	"common.label.ascending": "Stigande",
	"common.label.childExams": "Undertentamen",
	"common.label.confirmToDeleteExams": "Ta bort tentor",
	"common.label.confirmToDeleteRoomBooking": "Ta bort lokalbokning",
	"common.label.confirmToDeleteSupervisors": "Ta bort tentamensvärdar",
	"common.label.deleteAllExams": "Ta bort alla tentor",
	"common.label.deleteAllSupervisors": "Ta bort alla tentamensvärdar",
	"common.label.deleteRoomBooking": "Ta bort lokalbokning",
	"common.label.descending": "Fallande",
	"common.label.duplicateAnExamRequest": "Kopiera en tentamensbeställning",
	"common.label.empty": "Tomt",
	"common.label.examCalendar": "Tentamens kalender",
	"common.label.greenRed": "Grön till röd",
	"common.label.lastUpdated": "Senast uppdaterad",
	"common.label.redGreen": "Röd till grön",
	"common.label.roomBookingCalendar": "Lokalbokningskalendern",
	"common.label.roomSeats": "Platser",
	"common.label.setMyselfAsOwner": "Gör mig själv till ägare",
	"common.label.showAll": "Visa alla",
	"common.label.supervisorCalendar": "Tentamensvärdskalendern",
	"common.label.viewIn": "Se i",
	"common.message.successCloneItem": "Kopiering lyckad",
	"pages.examExportSettings.label.includeSchedulingPrioritiesLabel": "Inkludera schemaönskemål",
	"common.button.depublishExams": "Avpublicera tentamen",
	"common.button.deselectAll": "Avmarkera alla",
	"common.button.previewAsItem": "Visa som {item}",
	"common.button.selectAll": "Välj alla",
	"common.button.selectAllWithBookingsToday": "Välj alla med bokningar idag",
	"common.error.empty": "{item} kan inte vara tom",
	"common.label.allocatedExam": "Allokerad tentamen",
	"common.label.allocationStatus": "Allokeringsstatus",
	"common.label.archiveOrDeleteGDPR": "Gallra eller radera personlig data",
	"common.label.blank": "Tom",
	"common.label.children_modified": "Undertentamen redigerad",
	"common.label.confirmToDeleteConfig": "Vill du radera denna konfigurering?",
	"common.label.created": "Skapad",
	"common.label.customField1": "Anpassat fält 1",
	"common.label.customField2": "Anpassat fält 2",
	"common.label.customField3": "Anpassat fält 3",
	"common.label.customField4": "Anpassat fält 4",
	"common.label.customField5": "Anpassat fält 5",
	"common.label.deallocated": "Frigöra",
	"common.label.deleteAllPersonalData": "Radera personlig data",
	"common.label.deleteExams": "Radera tentamina",
	"common.label.deleteStudents": "Radera studenter",
	"common.label.deleteSupervisors": "Radera tentamensvärdar",
	"common.label.deleteUsers": "Radera användare",
	"common.label.deleted": "Raderad",
	"common.label.depublished": "Avpublicerad",
	"common.label.depublishedExams": "Avpublicera tentamen",
	"common.label.eventLog": "Historik",
	"common.label.events": "Event",
	"common.label.examTitle": "Tentamenstitel",
	"common.label.exam_checklist": "Checklista",
	"common.label.exam_comment": "Tentamenskommentar",
	"common.label.exam_student": "Student",
	"common.label.exportPersonal": "Exportera personlig data",
	"common.label.filterItem": "Filter {item}",
	"common.label.freeTextFields": "Fritext fält",
	"common.label.from_until": "Från - till",
	"common.label.gdpr": "GDPR",
	"common.label.generateReport": "Generera rapport",
	"common.label.hasExpiredRequests": "Har förfallna bokningar",
	"common.label.imported": "Importerade",
	"common.label.isAllocated": "Är allokerade",
	"common.label.landscape": "Liggande",
	"common.label.modified": "Redigerad",
	"common.label.noEvents": "Inga event",
	"common.label.orientation": "Riktning",
	"common.label.portrait": "Stående",
	"common.label.postExamNotes": "Uppföljningsanteckningar",
	"common.label.reassigned": "Gör om tilldelning",
	"common.label.registeredExam": "Registrerad tentamen",
	"common.label.reportFormat": "Rapportformat",
	"common.label.reportInformation": "Rapportinformation",
	"common.label.reportTemplate": "Rapportmall",
	"common.label.reportType": "Rapporttyp",
	"common.label.resources": "Resurser",
	"common.label.roomBookingId": "Lokalboknings ID",
	"common.label.scheduled": "Schemalagd",
	"common.label.search": "Sök",
	"common.label.searchAmong": "Sök bland",
	"common.label.searchForGDPR": "Sök efter namn, email eller personnummer",
	"common.label.searchResult": "Sökresultat",
	"common.label.secondaryLabel": "Sekundär label",
	"common.label.selectDate": "Välj datum",
	"common.label.showing": "Visa",
	"common.label.sortBy": "Sortera",
	"common.label.title": "Titel",
	"common.label.unscheduled": "Ej schemalagd",
	"common.label.updated": "Uppdaterad",
	"common.label.username": "Användarnamn",
	"common.label.users": "Användare",
	"common.label.width": "Kolumnbredd",
	"common.model.row": "rad",
	"common.model.template": "mall",
	"common.title.newReportingTemplate": "Ny rapportmall",
	"common.title.reportingTemplates": "Rapportmallar",
	"common.title.supervisorExternalBookingInRoom": "Extern bokning av {supervisor}",
	"common.valueLabel.bookingStatus.expired": "Förfallen",
	"common.valueLabel.examSchedulingStatus.depublished": "Avpublicerad",
	"common.valueLabel.publicationStatus.depublished": "Avpublicerad",
	"components.childExamFormDialog.button.addNewChildExam": "Lägg till ny undertentamen",
	"components.childExamFormDialog.label.seatLeftNumber": "Antal platser kvar",
	"components.childExamFormDialog.label.totalChildExamNumber": "Totalt antal undertentor",
	"components.childExamFormDialog.message.confirmIncreaseParentStudents.title": "Uppdatera antalet planerade studenter",
	"components.childExamFormDialog.message.copyTheSchedulingFromTheCurrentNote": "(om inte så kommer nuvarande schemaläggning att tas bort)",
	"components.childExamFormDialog.title.editChildExam": "Redigera undertentamen för {id} - {name}",
	"components.reportingTemplate.adjustedColumnWidthContent": "Kolumnbredden kommer bli justerad för att undvika radbrytning mitt i ett ord.",
	"components.reportingTemplate.adjustedColumnWidthTitle": "Justerad kolumnbredd",
	"components.reportingTemplate.columnCountInvalid": "Vänligen lägg till minst en kolumn",
	"components.reportingTemplate.columnIsMissing": "Kolumn {item} är obligatorisk",
	"components.reportingTemplate.nameIsRequired": "Obligatoriskt att namnge mallen",
	"components.reportingTemplate.validationFailed": "Validering misslyckades",
	"components.resourceScheduler.removeUnavailableSupervisorBookingModal.content": "Otillgänglighetsbokningen för den här tentamensvärden kommer tas bort, är du säker på att du vill fortsätta?",
	"components.resourceScheduler.removeUnavailableSupervisorBookingModal.title": "Ta bort otillgänglighetsbokning",
	"components.teExamCalendar.supervisorBookingExpiration.content": "Välj antal dagar som tentamensvärden har på sig att besvara denna bokningsförfrågan.",
	"components.teExamCalendar.supervisorBookingExpiration.expirationDate": "Bokningsförfrågan förfaller {expirationDate}",
	"components.teExamCalendar.supervisorBookingExpiration.title": "Deadline för att besvara bokningsförfrågan",
	"pages.examOverview.selectExamToDepublish": "Välj tentor för att avpublicera",
	"pages.examSetting.examCustomizations.description": "Skapa anpassade inställningar",
	"pages.examSetting.examCustomizations.examTitleInstruction.description": "En instruktionstext för hur tentamensbeställningen skall benämnas",
	"pages.examSetting.examCustomizations.examTitleInstruction.title": "Instruktionstext för tentamenstiteln",
	"pages.examSetting.examCustomizations.supervisorBookingExpirationDays.description": "Antal dagar en tentamensbeställare har på sig att besvara en bokningsförfrågan innan den förfaller",
	"pages.examSetting.examCustomizations.supervisorBookingExpirationDays.title": "Förfallodag för tentamensvärdar",
	"pages.examSetting.tab.otherCustomizations": "Anpassade inställningar",
	"pages.homeSupervisor.tab.expiredBookingsTab": "Förfallna bokningar",
	"providers.organization.message.successUpdateExamSettingsMessage": "Tentamensinställningarna är uppdaterade",
	"common.button.cancelExam": "Avbeställ tentamen",
	"common.button.cancelExams": "Avbeställ tentamen",
	"common.button.selectItem": "Välj",
	"common.button.unCancelExam": "Återskapa tentamen",
	"common.label.cancelExam": "Avbeställ tentamen",
	"common.label.cancelledExams": "Avbeställda tentamen",
	"common.label.coordinators": "Koordinatorer",
	"common.label.deactivationDate": "Inaktiveringsdatum",
	"common.label.studentSeat": "Studentens plats",
	"common.valueLabel.examSchedulingStatus.cancelled": "Avbokad",
	"components.moveRoomBookingDialog.action.cancelBooking": "Avboka bokningen",
	"components.moveRoomBookingDialog.action.keepOldBooking": "Behåll nuvarande bokning",
	"components.moveRoomBookingDialog.action.sendNewBooking": "Skicka ny bokningsförfrågan",
	"components.moveRoomBookingDialog.alert.examTimeLongerOrShorter": "Vänligen observera att den efterfrågade tentamenstiden är längre än den valda slotten.",
	"components.moveRoomBookingDialog.alert.supervisorUnavailable": "Tentamensvärd otillgänglig",
	"components.moveRoomBookingDialog.retainRoomBookingCheckbox.description": "Detta innebär att det skapas en ny lokalbokning på den nya slotten och nedan valda objekt flyttas till den nya bokningen. Resterande objekt kommer vara kvar på nuvarande bokning.",
	"components.moveRoomBookingDialog.retainRoomBookingCheckbox.label": "Behåll nuvarande lokalbokning",
	"components.moveRoomBookingDialog.selectExamAndSupervisorTitle": "Den här lokalbokningen innehåller en eller flera tentamensvakter och tentamina, vänligen välj vilka du vill flytta.",
	"components.moveRoomBookingDialog.status.canBeMoved": "KAN FLYTTAS",
	"components.moveRoomBookingDialog.status.cannotBeMoved": "KAN INTE FLYTTAS",
	"components.moveRoomBookingDialog.title": "Flytta lokalbokningen",
	"pages.examOverview.selectExamToCancel": "Avbeställ tentamen",
	"pages.examSettings.labelShouldPublishToStudentSchedule": "Publicera till studentsida",
	"pages.studentSettings.editMappingList.studentSeatDescription": "(Välj om du önskar att numret på studentens plats skall synas på studentsidan)",
	"common.button.editLength": "Redigera",
	"common.label.cancelled": "Avbeställd",
	"common.label.dueDate": "Förfallodag",
	"common.label.freeText": "Fritext",
	"common.label.itemCompleted": "Slutförd",
	"common.label.noPageBreak": "Ingen sidbrytning",
	"common.label.pageBreak": "Sidbrytning",
	"common.label.pageHeaderSettings": "Inställningar för sidhuvud",
	"common.label.perExam": "Per tentamen",
	"common.label.perRoom": "Per lokal",
	"common.label.reportTemplateSettings": "Generella inställningar",
	"common.label.sortByPrimary": "Primär sortering",
	"common.label.sortBySecondary": "Sekundär sortering",
	"common.label.studentPublicSchedule": "Studentsida",
	"common.label.studentSeatAllocation": "Platsallokering av studenter",
	"common.label.studentSpecialNeeds": "Studenters särskilda behov",
	"common.label.usePrintDate": "Använd utskriftsdatum",
	"common.message.confirmDeleteReportingTemplate": "Ta bort rapportmall",
	"common.message.successAcceptBookingForSupervisor": "Acceptera bokning åt tentamensvärd",
	"common.message.successDeclineBookingForSupervisor": "Avböj bokning åt tentamensvärden",
	"components.moveRoomBookingDialog.alert.associatedExamMustBeInSameRoomBooking": "Vänligen notera att alla relaterade undertentor måste vara schemalagda samma dag, enskilda undertentor kan inte flyttas.",
	"components.moveRoomBookingDialog.description": "Vänligen bekräfta att du vill flytta denna lokalbokning till en ny slott?",
	"components.moveRoomBookingDialog.unableToMoveRoomBooking.description": "Lokalen är redan bokad i TE Exam eller i TE Core",
	"components.moveRoomBookingDialog.unableToMoveRoomBooking.message": "Lokalbokningen kan inte flyttas",
	"components.scheduledSupervisorActionsDropdown.button.declineRoomBookingForSupervisorButton": "Avböj bokning åt tentamensvärd",
	"pages.examSetting.examCustomizations.supervisorsNeededsDesc.description": "Ange ett standardantal tentamensvärdar som behövs för en lokalbokning",
	"pages.examSetting.examCustomizations.supervisorsNeededsTitle.description": "Antal behövda tentamensvärdar",
	"common.button.goBack": "Gå tillbaka",
	"common.label.allocatedStudents": "Allokerade studenter",
	"common.label.availability": "Tillgänglighet",
	"common.message.successMoveRoomBooking": "Lokalen är flyttad till en ny slott",
	"common.title.common.confirmation": "Godkännande",
	"common.valueLabel.moveRoomBookingAction.cancelBooking": "Avboka tentamensvärden",
	"common.valueLabel.moveRoomBookingAction.moveAndSendBooking": "Flytta och skicka en ny bokningsförfrågan",
	"common.valueLabel.moveRoomBookingAction.moveScheduling": "Flytta till ny slott",
	"common.valueLabel.moveRoomBookingAction.moveWithoutSendBooking": "Flytta utan att skicka en ny bokningsförfrågan",
	"common.valueLabel.moveRoomBookingAction.removeScheduling": "Ta bort schemaläggning",
	"common.valueLabel.moveRoomBookingAction.retainBooking": "Behåll på nuvarande lokalbokning",
	"common.valueLabel.moveRoomBookingAction.retainScheduling": "Behåll på nuvarande lokalbokning",
	"components.moveRoomBookingDialog.action.newEmptyRoomBooking": "Skapa en ny lokalbokning för lokal {room} i slott \"{examSlot}\" {date}",
	"components.moveRoomBookingDialog.action.newRoomBooking": "Skapa en ny bokning för {room} i slott \"{examSlot}\" {date} innehållandes:",
	"components.moveRoomBookingDialog.action.removeScheduling": "Ta bort schemaläggning i {room} {date} för följande:",
	"components.moveRoomBookingDialog.action.retainRoomBooking": "Behåll nuvarande lokalbokning för {room} i slott \"{examSlot}\" {date} innehållandes:",
	"components.moveRoomBookingDialog.alert.confirmActions": "Dina val kommer innebära följande förändringar, vill du fortsätta?",
	"components.moveRoomBookingDialog.error.childExamsInOtherBookings": "Har tillhörande undertentor i andra lokalbokningar",
	"components.moveRoomBookingDialog.error.linkedExamCannotMove": "Länkade tentamina kan inte flyttas",
	"components.moveRoomBookingDialog.error.linkedExamsInOtherBookings": "Har länkade tentamina i andra lokalbokningar",
	"components.moveRoomBookingDialog.noExamAndSupervisorTitle": "Vänligen bekräfta att du vill flytta denna lokalbokning till en ny slott?",
	"components.moveRoomBookingDialog.success.canBeMoved": "KAN FLYTTAS",
	"components.moveRoomBookingDialog.titleMultiple": "Flytta lokalbokning till {examSlot} slot {date}",
	"pages.examSetting.examCustomizations.defaultChecklistDesc.description": "Aktivera om du önskar att skapa en fördefinierad checklista för alla tentamina",
	"pages.examSetting.examCustomizations.defaultChecklistTitle.description": "Använd en fördefinierad checklista",
	"common.label.configureHowTheStudentScheduleIsDisplayed": "Konfigurera hur studentsidan skall visas",
	"common.label.enterYourStudentIdToSeeYourSchedule": "Ange ditt student-ID för att se ditt schema",
	"common.label.letUsersAccessTheExamScheduleWithoutStudentId": "Tillåt studenten att se schemat för tentamen utan att ange student-ID",
	"common.label.pleaseEnterAStudentId": "Vänligen ange student-ID",
	"common.label.publicStudentSchedule": "Studentsida",
	"common.label.seeSchedule": "Se schema",
	"common.valueLabel.moveRoomBookingAction.removeBooking": "Flytta lokalbokning",
	"components.moveRoomBookingDialog.alert.linkedRoomBooking.insertButton": "Infoga",
	"components.moveRoomBookingDialog.alert.linkedRoomBooking.item": "Lokal {room} i slott \"{examSlot}\" {date}",
	"components.moveRoomBookingDialog.alert.linkedRoomBooking.title": "Lokalbokningarna har länkade tentamina i andra lokaler:",
	"components.moveRoomBookingDialog.error.cannotBeInserted": "Kan inte infogas",
	"components.moveRoomBookingDialog.unableToMoveRoomBooking.occupiedError": "Lokalbokning kan inte flyttas",
	"components.moveRoomBookingDialog.unableToMoveRoomBooking.roomsDuplicatedError": "Lokalbokningarna kan inte flyttas",
	"common.label.cancel": "Avbryt",
	"common.label.cancelSupBookings": "Avboka tentamensvärd",
	"common.label.cancelSupBookingsDes": "Du håller på att avboka en eller flera tentamensvärdars bokningar. Detta innebär att bokningen kommer markeras som \"Avbokad\" men tentamensvärden kommer vara tillgänglig för nya bokningar. Tentamensvärden kommer få ett mail med informationen om att passet blivit avbokat, vill du fortsätta?",
	"common.label.cancelSupBookingsOk": "Ja avboka",
	"common.label.cancelSupBookingsReason": "Ange en anledning för avbokningen:",
	"common.label.cancellationReason": "Anledning för avbokning",
	"common.label.declineSupBookings": "Avböj bokning åt tentamensvärd",
	"common.label.declineSupBookingsDes": "Du håller på att avböja en eller flera tentamensvärdars bokningar. Detta innebär att bokningen kommer markeras som \"Avböjd\" och tentamensvärden kommer inte vara tillgänglig för andra bokningar. Vill du fortsätta?",
	"common.label.declineSupBookingsOk": "Ja avböj bokning",
	"common.label.examDateAndEndTime": "Tentamen sluttid & datum",
	"common.label.examDateAndStartTime": "Tentamen starttid & datum",
	"common.label.saveWithoutSendingEmail": "Spara utan att skicka email",
	"common.label.sendUpdatedBooking": "Skicka uppdaterad bokingsförfrågan",
	"common.label.theWorkingHoursForOneOrSevaralSupervisor": "Arbetstiden har uppdaterats för en eller flera tentamensvärdar, vill du skicka en uppdaterad bokningsförfrågan till berörda tentamensvärdar?",
	"common.label.unableToSave": "Går ej att spara",
	"common.label.workHours": "Arbetstid",
	"common.message.successCancelBookingForSupervisor": "Tentamensvärdsbokningarna har blivit avbokade",
	"common.valueLabel.bookingStatus.cancelled": "Avbokad",
	"components.scheduledSupervisorActionsDropdown.button.cancelRoomBookingForSupervisorButton": "Avboka tentamensvärd",
	"common.label.mapping": "Mappning",
	"common.label.roomOccupation": "Beläggning lokal",
	"common.label.settings": "Inställningar",
	"common.label.viewRoomBookingDetails": "Visa loklbokning",
	"pages.examSeatAllocationTab.button.allocateStudents": "Allokera studenter",
	"pages.examSeatAllocationTab.label.specialNeedsStudents": "Studenter med särskilda behov",
	"pages.examSeatAllocationTab.label.studentsLeftToAllocate": "Antal studenter kvar att allokera",
	"pages.examSeatAllocationTab.label.studentsToAllocate": "Studenter att allokera",
	"pages.examSeatAllocationTab.label.totalRegisterStudents": "Totalt antal anmälda studenter",
	"pages.examSeatAllocationTab.label.useStandardAllocation": "Använd standardallokering",
	"pages.examSeatAllocationTab.label.useStandardAllocation.description": "Detta ger möjligheten att ladda upp en lista med anmälda studenter, tilldela platser i lokalen, samt tilldela särskilda behov.",
	"pages.postExamManagementTab.label.attendingStudents": "Skrivande studenter",
	"pages.postExamManagementTab.panel.attendingStudents": "Antal skrivande studenter",
	"pages.studentSettings.simpleStudentAllocation.description": "Möjligheten att ladda upp en lista för anmälda studenter kommer ersättas med ett enkelt fält för att ange antalet studenter. Det kommer innebära begränsningar kring möjligheterna att allokera studenter till platser i lokalen, tilldela särskilda behov, samt exportera listor över studenter.",
	"pages.studentSettings.simpleStudentAllocation.label": "Förenklad allokering",
	"providers.organization.message.successUpdateSettingsMessage": "Inställningarna är uppdaterade",
	"common.label.confirmedBooking": "Bekräftad bokning",
	"common.label.expired": "Förfallen",
	"common.label.pendingBooking": "Obesvarad bokning",
	"common.label.updatedBookingRequest": "Uppdaterad bokningsförfrågan",
	"pages.homeSupervisor.tab.currentBookings": "Aktuella bokningar",
	"components.moveRoomBookingDialog.alert.linkedExam.item": "{exam} i {room} i slott {examSlot}",
	"components.moveRoomBookingDialog.alert.rangeOfSeatBeAdjusted": "Vänligen notera att för de fall en tentamen som flyttas har allokerade studenter så kan platsnumreringen komma att uppdateras för övriga schemalagda tentamina i den lokalbokning som tentamen flyttas till och ifrån.",
	"components.moveRoomBookingDialog.titleExams": "Namn tentamen",
	"common.label.yourWorkHours": "Din arbetstid",
	"components.moveRoomBookingDialog.alert.associatedExamMustBeInSameRoomBookingForExam": "Vänligen notera att alla undertentamina och länkade tentamina måste vara schemalagda samma dag, enskilda kan inte flyttas. Följande beroenden finns:",
	"common.label.studentsSelected": "Valda studenter",
	"components.moveRoomBookingDialog.titleSupervisors": "Tentamensvärdar",
	"pages.settings.supervisorSettings.informationAboutOtherSupervisors.description": "Aktivera om du vill att tentamensvärdarna skall ha möjlighet att se information om vilka andra tentamensvärdar som arbetar samma dag och tid",
	"pages.settings.supervisorSettings.informationAboutOtherSupervisors.title": "Information om tentamensvärdar",
	"pages.settings.supervisorSettings.title": "Inställningar",
	"common.label.confirmUpdatedRequest": "Bekräfta uppdaterad tid",
	"common.label.scheduleSupervisors": "Schemalägg tentamensvärdar",
	"common.label.updatedRequest": "Avböj uppdaterad tid",
	"common.valueLabel.moveRoomBookingAction.moveExamToNewRoomBooking": "Flytta tentamen till ny lokalbokning",
	"common.button.allocate": "Allokera",
	"common.label.examDetails": "Detaljer",
	"common.label.reassignExamOwner": "Tilldela ägare",
	"common.label.showPageHeaderOnAllPages": "Visa sidhuvud på alla sidor",
	"common.valueLabel.mainSupervisor.lead": "Huvudvärd",
	"common.label.pageBreakPerRoomBooking": "Sidbryt per lokalbokning",
	"common.message.successMoveExamsToRoomBooking": "Tentamen flyttad till ny lokalbokning",
	"common.message.successMoveSupervisorsToRoomBooking": "Tentamensvärd flyttad till ny lokalbokning",
	"common.label.schedulePastSupervisor": "Du håller på att schemalägga en tentamensvärd för ett datum eller tid som redan har passerat, vill du fortsätta?",
	"pages.examSeatAllocationTab.option.examSelection.removeSelection": "Avmarkera valda",
	"common.label.actions": "Åtgärder",
	"common.label.batchOperations": "Massåtgärder",
	"common.label.bookingsSelected": "Valda bokningar",
	"common.label.calendarOptions": "Kalenderinställningar",
	"common.label.deSelectAll": "Avmarkera alla",
	"common.label.deselectAll": "Avmarkera alla",
	"common.label.move": "Flytta",
	"common.label.personalNumber": "Personnummer",
	"common.label.roombooking": "Lokalbokning",
	"common.label.selectAll": "Välj alla",
	"common.label.studentSchedule": "Studentsida",
	"common.label.templateName": "Mallnamn",
	"common.message.successPublishedExams": "Tentamen publicerad",
	"common.label.addSorting": "Sortera",
	"common.label.selectExam": "Välj tentamen",
	"common.label.selectOne": "Välj",
	"common.label.weekOf": "Vecka",
	"components.moveRoomBookingDialog.alert.examTimeLongerExamSlotTime": "Vänligen observera att tiden för tentamen är längre än den valda slotten.",
	"common.label.logout": "Logga ut",
	"pages.label.attendingStudents": "Deltagande studenter",
	"common.label.relations": "Relationer",
	"pages.exam.label.showRelations": "Visa relationer",
	"common.label.acceptedBookings": "Accepterade bokningar",
	"common.label.availableSupervisors": "Tillgängliga tentamensvärdar",
	"common.label.bookingRequests": "Bokningsförfrågningar",
	"common.label.cancelledBookings": "Avbokade bokningar",
	"common.label.commentToScheduler": "Extern kommentar",
	"common.label.day": "Dag",
	"common.label.declinedBookings": "Avböjda bokningar",
	"common.label.examTime": "Tentamenstid",
	"common.label.expiredBookings": "Förfallna bokningar",
	"common.label.filterBookings": "Filtrera bokningar",
	"common.label.hasBookings": "Har bokningar",
	"common.label.hasNoBookings": "Har inga bokningar",
	"common.label.pendingHours": "Väntande timmar",
	"common.label.schedule": "Schema",
	"common.label.scheduledHours": "Schemalagda timmar",
	"common.label.searchForSupervisor": "Sök efter tentamensvärd",
	"common.label.totalAcceptedHours": "Totalt antal accepterade timmar",
	"common.label.totalRequestedHours": "Totalt antal förfrågade timmar",
	"common.label.workingHours": "Arbetstimmar",
	"common.message.commentToSchedulerNotice": "Den här kommentaren kommer vara synlig i TimeEdit",
	"components.scheduledSupervisorActionsDropdown.button.addRow": "Lägg till rad",
	"components.scheduledSupervisorActionsDropdown.button.removeRow": "Ta bort rad",
	"common.button.secondaryAxis": "Sekundär axel",
	"common.button.selectChartValue": "Välj dataserie",
	"common.button.selectSecondChartValue": "Välj sekundär dataserie",
	"common.button.selectSeries": "Valda serier",
	"common.label.bookedRooms": "Bokade lokaler",
	"common.label.bookingRequestExpires": "Bokningen förfaller",
	"common.label.examRequests": "Tentamensbeställningar",
	"common.label.expiredBookingRequest": "Förfallen bokningsförfrågan",
	"common.label.neededSupervisors": "Behövda tentamensvärdar",
	"common.label.pendingBookings": "Pågående bokningar",
	"common.label.pendingRequests": "Pågående bokningar",
	"common.label.scheduledSupervisors": "Schemalagda tentamensvärdar",
	"common.label.secondaryAxis": "Sekundär axel",
	"common.label.selectedSeries": "Valda serier",
	"common.label.statistics": "Statistik",
	"common.label.unableScheduleSupervisor": "Kan ej schemaläggas",
	"common.label.unableScheduleSupervisorDesc": "Tentamensvärden kan inte schemaläggas",
	"common.message.examInformationCancelledLockedDesc": "Grundläggande information kan inte redigeras efter att en tentamen blivit avbeställd",
	"common.title.common.dashboardOverview": "Dashboard",
	"common.valueLabel.chartOptions.numberOfAcceptedBookings": "Accepterade bokningar",
	"common.valueLabel.chartOptions.numberOfAllocatedStudents": "Allokerade studenter",
	"common.valueLabel.chartOptions.numberOfExamRequests": "Tentamensbeställningar",
	"common.valueLabel.chartOptions.numberOfNeededSupervisors": "Behövda tentamensvärdar",
	"common.valueLabel.chartOptions.numberOfPendingBookings": "Pågående bokningar",
	"common.valueLabel.chartOptions.numberOfPlannedStudents": "Planerade studenter",
	"common.valueLabel.chartOptions.numberOfRegisteredStudents": "Anmälda studenter",
	"common.valueLabel.chartOptions.numberOfRoomsBooked": "Bokade lokaler",
	"common.valueLabel.chartOptions.numberOfScheduledExams": "Schemalagda tentamen",
	"common.valueLabel.chartOptions.numberOfScheduledSupervisors": "Schemalagda tentamensvärdar",
	"common.valueLabel.chartOptions.numberOfSupervisorsAvailable": "Tillgängliga tentamensvärdar",
	"pages.public.examStudentScheduleWrapper.label.yourAnonymizedCode": "Din anonymiseringskod",
	"pages.studentSettings.editMappingList.studentAnonymizedCodeToggleDescription": "(Välj om du önskar att studentens anonymiseringskod skall synas på studentsidan)",
	"pages.supervisorOverview.selections.emailUnsent": "Välj ej skickat",
	"common.label.additionalInfor": "Ytterligare info",
	"common.label.bookedSeats": "Antal bokade platser",
	"common.label.bookingInformation": "Bokningsinfo",
	"common.label.deleteSupervisorGDPR": "Radera tentamensvärd",
	"common.label.examSelecionInstruction": "Välj tentamen",
	"common.label.examsSelected": "Valda tentamen",
	"common.label.multipleRoomsSelectedError": "Flera rum är valda. Vänligen välj ett av rummen för att schemalägga. ",
	"common.label.pleaseConfirmYouWantToReschedule": "Bekräfta ombokning",
	"common.label.roomSelected": "Lokal vald",
	"common.label.scheduledStudents": "Schemalagda studenter",
	"common.label.seatsSelected": "Valda platser",
	"common.label.siblingExamScheduleInSameRoomWarning": "Undertentamen schemalagd i samma lokal",
	"common.label.swithRoomBookingMode": "Boka lokaler",
	"common.label.tag": "Etikett",
	"common.label.toAdministrators": "Till administratörer",
	"common.label.toStudents": "Till studenter",
	"common.label.toSupervisors": "Till tentamensvärdar",
	"common.valueLabel.chartOptions.bookedSeats": "Bokade platser",
	"common.valueLabel.chartOptions.scheduledStudents": "Schemalagda studenter",
	"components.examTagActions.deleteTagConfirmDesription": "Radera etikett",
	"components.examTagActions.deleteTagConfirmTitle": "Radera",
	"components.examTagActions.noEditingNewTagInfo": "Lägg till information",
	"components.examTagActions.renameTagConfirmDesription": "Byt namn",
	"components.examTagActions.renameTagConfirmTitle": "Bekräfta titel",
	"components.moveRoomBookingDialog.alert.supervisorMovingSameDateAndSlot": "Flytta tentamensvärd inom samma dag/slott",
	"pages.examDetail.message.redirectedOnCancelledExam.description": "Avbeställd tentamen",
	"pages.examDetail.message.redirectedOnCancelledExam.message": "Avbeställd tentamen",
	"pages.supervisorOverview.selections.selectAll": "Alla",
	"pages.supervisorOverview.selections.selectNone": "Inga",
	"common.label.plannedStudentsOnSelectedExams": "Planerade studenter på valda tentor",
	"common.label.removeRoom": "Ta bort lokal"
};

var translatedMessages = {
  en: en,
  sv: sv
};

var LANG_KEY = 'language';
var currentLanguage = localStorage.getItem(LANG_KEY);

if (!currentLanguage) {
  currentLanguage = DEFAULT_LANG;
  localStorage.setItem(LANG_KEY, currentLanguage);
}

var intl = createIntl({
  locale: currentLanguage,
  messages: translatedMessages[currentLanguage]
});

var formatMessage = intl.formatMessage;

var messages$a = defineMessages({
  acceptItem: {
    id: 'common.button.acceptItem',
    defaultMessage: 'Accept {item}'
  },
  activateItem: {
    id: 'common.button.activateItem',
    defaultMessage: 'Activate {item}'
  },
  addItem: {
    id: 'common.button.addItem',
    defaultMessage: 'Add {item}'
  },
  addNewItem: {
    id: 'common.button.addNewItem',
    defaultMessage: 'Add new {item}'
  },
  addToCalendar: {
    id: 'common.button.addToCalendar',
    defaultMessage: 'Add to calendar'
  },
  allocate: {
    id: 'common.button.allocate',
    defaultMessage: 'Allocate'
  },
  backToOverview: {
    id: 'common.button.backToOverview',
    defaultMessage: 'Back to overview'
  },
  batchImportExamRequests: {
    id: 'common.button.batchImportExamRequests',
    defaultMessage: 'Batch import exam requests'
  },
  book: {
    id: 'common.button.book',
    defaultMessage: 'Book'
  },
  bookMoreItem: {
    id: 'common.button.bookMoreItem',
    defaultMessage: 'Book more {item}'
  },
  cancel: {
    id: 'common.button.cancel',
    defaultMessage: 'Cancel'
  },
  saveAndClose: {
    id: 'common.button.closeWithSaving',
    defaultMessage: 'Save and close'
  },
  closeWithoutSaving: {
    id: 'common.button.closeWithoutSaving',
    defaultMessage: 'Close without saving'
  },
  configureNow: {
    id: 'common.button.configureNow',
    defaultMessage: 'Configure now'
  },
  confirm: {
    id: 'common.button.confirm',
    defaultMessage: 'Confirm'
  },
  createItem: {
    id: 'common.button.createItem',
    defaultMessage: 'Create {item}'
  },
  createNewItem: {
    id: 'common.button.createNewItem',
    defaultMessage: 'Create new {item}'
  },
  deactivateItem: {
    id: 'common.button.deactivateItem',
    defaultMessage: 'Deactivate {item}'
  },
  decline: {
    id: 'common.button.decline',
    defaultMessage: 'Decline'
  },
  deleteItem: {
    id: 'common.button.deleteItem',
    defaultMessage: 'Delete {item}'
  },
  deleteSelectedItem: {
    id: 'common.button.deleteSelectedItem',
    defaultMessage: 'Delete selected {item}'
  },
  deselectAllItem: {
    id: 'common.button.deselectAllItem',
    defaultMessage: 'Deselect all {item}'
  },
  disable: {
    id: 'common.button.disable',
    defaultMessage: 'Disable'
  },
  discard: {
    id: 'common.button.discard',
    defaultMessage: 'Discard'
  },
  done: {
    id: 'common.button.done',
    defaultMessage: 'Done'
  },
  duplicateExam: {
    id: 'common.button.duplicateExam',
    defaultMessage: 'Duplicate exam'
  },
  editItem: {
    id: 'common.button.editItem',
    defaultMessage: 'Edit {item}'
  },
  editLength: {
    id: 'common.button.editLength',
    defaultMessage: 'Edit length'
  },
  enable: {
    id: 'common.button.enable',
    defaultMessage: 'Enable'
  },
  examScheduling: {
    id: 'common.button.examScheduling',
    defaultMessage: 'Exam scheduling'
  },
  exportItem: {
    id: 'common.button.exportExams',
    defaultMessage: 'Export {item}'
  },
  goBack: {
    id: 'common.button.goBack',
    defaultMessage: 'Go back'
  },
  goToNextWeek: {
    id: 'common.button.goToNextWeek',
    defaultMessage: 'Go to next week'
  },
  goToPreviousWeek: {
    id: 'common.button.goToPreviousWeek',
    defaultMessage: 'Go to previous week'
  },
  help: {
    id: 'common.button.help',
    defaultMessage: 'Help'
  },
  importItem: {
    id: 'common.button.importItem',
    defaultMessage: 'Import {item}'
  },
  matchAll: {
    id: 'common.button.matchAll',
    defaultMessage: 'Match all'
  },
  matchOne: {
    id: 'common.button.matchOne',
    defaultMessage: 'Match one'
  },
  newItem: {
    id: 'common.button.newItem',
    defaultMessage: 'New {item}'
  },
  no: {
    id: 'common.button.no',
    defaultMessage: 'No'
  },
  ok: {
    id: 'common.button.ok',
    defaultMessage: 'OK'
  },
  close: {
    id: 'common.button.close',
    defaultMessage: 'Close'
  },
  options: {
    id: 'common.button.options',
    defaultMessage: 'Options'
  },
  publishExams: {
    id: 'common.button.publishExams',
    defaultMessage: 'Publish Exams'
  },
  cancelExams: {
    id: 'common.button.cancelExams',
    defaultMessage: 'Cancel Exams'
  },
  depublishExams: {
    id: 'common.button.depublishExams',
    defaultMessage: 'Depublish Exams'
  },
  removeFromTEExam: {
    id: 'common.button.removeFromTEExam',
    defaultMessage: 'Remove from TE Exam'
  },
  removeItem: {
    id: 'common.button.removeItem',
    defaultMessage: 'Remove {item}'
  },
  resetConfiguration: {
    id: 'common.button.resetConfiguration',
    defaultMessage: 'Reset configuration'
  },
  roomBooking: {
    id: 'common.button.roomBooking',
    defaultMessage: 'Room booking'
  },
  saveChanges: {
    id: 'common.button.saveChanges',
    defaultMessage: 'Save changes'
  },
  saveItem: {
    id: 'common.button.saveItem',
    defaultMessage: 'Save {item}'
  },
  scheduleHere: {
    id: 'common.button.scheduleHere',
    defaultMessage: 'Schedule here'
  },
  selectAllDay: {
    id: 'common.button.selectAllDay',
    defaultMessage: 'Select all day'
  },
  selectAll: {
    id: 'common.button.selectAll',
    defaultMessage: 'Select all'
  },
  deselectAll: {
    id: 'common.button.deselectAll',
    defaultMessage: 'Deselect all'
  },
  selectOneOffSlots: {
    id: 'common.button.selectOneOffSlots',
    defaultMessage: 'Select one-off slots'
  },
  deselectOneOffSlots: {
    id: 'common.button.deselectOneOffSlots',
    defaultMessage: 'Deselect one-off slots'
  },
  selectAllWithBbookingsThisWeek: {
    id: 'common.button.selectAllWithBbookingsThisWeek',
    defaultMessage: 'Select all with bookings this week'
  },
  selectAllWithBookingsToday: {
    id: 'common.button.selectAllWithBookingsToday',
    defaultMessage: 'Select all with bookings today'
  },
  selectChartValue: {
    id: 'common.button.selectChartValue',
    defaultMessage: 'Select chart series'
  },
  selectSecondChartValue: {
    id: 'common.button.selectSecondChartValue',
    defaultMessage: 'Select second chart series'
  },
  blockAllDay: {
    id: 'common.button.blockAllDay',
    defaultMessage: 'Block all day'
  },
  selectAllItem: {
    id: 'common.button.selectAllItem',
    defaultMessage: 'Select all {item}'
  },
  selectWeek: {
    id: 'common.button.selectWeek',
    defaultMessage: 'Select week'
  },
  send: {
    id: 'common.button.send',
    defaultMessage: 'Send'
  },
  showSelectedRoomBooking: {
    id: 'common.button.showSelectedRoomBooking',
    defaultMessage: 'Show selected room booking'
  },
  supervisorScheduling: {
    id: 'common.button.supervisorScheduling',
    defaultMessage: 'Supervisor scheduling'
  },
  update: {
    id: 'common.button.update',
    defaultMessage: 'Update'
  },
  view: {
    id: 'common.button.view',
    defaultMessage: 'View'
  },
  viewAndEdit: {
    id: 'common.button.viewAndEdit',
    defaultMessage: 'View & edit'
  },
  viewInCalendar: {
    id: 'common.button.viewInCalendar',
    defaultMessage: 'View in calendar'
  },
  viewInExamCalendar: {
    id: 'common.button.viewInExamCalendar',
    defaultMessage: 'View in exam calendar'
  },
  cancelExam: {
    id: 'common.button.cancelExam',
    defaultMessage: 'Cancel exam'
  },
  unCancelExam: {
    id: 'common.button.unCancelExam',
    defaultMessage: 'Uncancel exam'
  },
  viewInSupervisorCalendar: {
    id: 'common.button.viewInSupervisorCalendar',
    defaultMessage: 'View in supervisor calendar'
  },
  viewItem: {
    id: 'common.button.viewItem',
    defaultMessage: 'View {item}'
  },
  viewRoomBooking: {
    id: 'common.button.viewRoomBooking',
    defaultMessage: 'View room booking'
  },
  viewSupervisorsOnBooking: {
    id: 'common.button.viewSupervisorsOnBooking',
    defaultMessage: 'Book supervisors for room booking'
  },
  yes: {
    id: 'common.button.yes',
    defaultMessage: 'Yes'
  },
  previewAsItem: {
    id: 'common.button.previewAsItem',
    defaultMessage: 'Preview as {item}'
  },
  selectItem: {
    id: 'common.button.selectItem',
    defaultMessage: 'Select {item}'
  },
  selectSeries: {
    id: 'common.button.selectSeries',
    defaultMessage: 'Selected series'
  },
  secondaryAxis: {
    id: 'common.button.secondaryAxis',
    defaultMessage: 'Secondary axis'
  }
});
var button = messages$a;

var messages$9 = {
  bootstrapConfigError: defineMessages({
    message: {
      id: 'components.bootstrapConfigError.message',
      defaultMessage: "We're sorry, but it seems like TE Exam is not fully configured yet."
    },
    link: {
      id: 'components.bootstrapConfigError.link',
      defaultMessage: 'Config it'
    }
  }),
  childExamFormDialog: defineMessages({
    editChildExamTitle: {
      id: 'components.childExamFormDialog.title.editChildExam',
      defaultMessage: 'Edit child exams for {id} - {name}'
    },
    addNewChildExamButton: {
      id: 'components.childExamFormDialog.button.addNewChildExam',
      defaultMessage: 'Add new child exam'
    },
    totalChildExamNumberLabel: {
      id: 'components.childExamFormDialog.label.totalChildExamNumber',
      defaultMessage: 'Total number of child exams'
    },
    seatLeftNumberLabel: {
      id: 'components.childExamFormDialog.label.seatLeftNumber',
      defaultMessage: 'Number of seats left'
    },
    copyTheSchedulingFromTheCurrent: {
      id: 'components.childExamFormDialog.message.copyTheSchedulingFromTheCurrent',
      defaultMessage: 'Copy existing scheduling from exam {id} into a new child exam'
    },
    copyTheSchedulingFromTheCurrentNote: {
      id: 'components.childExamFormDialog.message.copyTheSchedulingFromTheCurrentNote',
      defaultMessage: '(If not, the current exam scheduling will be deleted)'
    },
    confirmIncreaseOverbookTitle: {
      id: 'components.childExamFormDialog.message.confirmIncreaseOverbook.title',
      defaultMessage: 'Confirm overbooking of room'
    },
    confirmIncreaseOverbookContent: {
      id: 'components.childExamFormDialog.message.confirmIncreaseOverbook.content',
      defaultMessage: 'By increasing seats of this exam, scheduled room booking and any other exams booked on this room booking will not be able to use seat assignment features for students.'
    },
    confirmIncreaseParentStudentsTitle: {
      id: 'components.childExamFormDialog.message.confirmIncreaseParentStudents.title',
      defaultMessage: 'Planned students to be updated'
    },
    confirmIncreaseParentStudentsContent: {
      id: 'components.childExamFormDialog.message.confirmIncreaseParentStudents.content',
      defaultMessage: 'Total planned students on child exams is now more than planned students on the main exam. Planned students on the main exam will be updated.'
    },
    confirmDecreaseParentStudentsTitle: {
      id: 'components.childExamFormDialog.message.confirmDecreaseParentStudents.title',
      defaultMessage: 'Decrease the number of students'
    },
    confirmDecreaseParentStudentsContent: {
      id: 'components.childExamFormDialog.message.confirmDecreaseParentStudents.content',
      defaultMessage: 'The total number of students in the child exams is lower than in the main exam.'
    },
    confirmDecreaseParentStudentsProceed: {
      id: 'components.childExamFormDialog.message.confirmDecreaseParentStudents.proceed',
      defaultMessage: 'Do you want to decrease the number of students in the main exam to match the number of students in the child exams?'
    },
    confirmDecreaseParentStudentsYesButton: {
      id: 'components.childExamFormDialog.button.confirmDecreaseParentStudents.yes',
      defaultMessage: 'Yes, decrease on main exam'
    },
    confirmDecreaseParentStudentsNoButton: {
      id: 'components.childExamFormDialog.button.confirmDecreaseParentStudents.no',
      defaultMessage: 'No, keep number of students'
    },
    publicationWillBeGone: {
      id: 'components.childExamFormDialog.button.publicationWillBeGone.no',
      defaultMessage: 'If the exam has been published, the publication will be removed'
    }
  }),
  commentChannelSelectorPane: defineMessages({
    label: {
      id: 'components.commentChannelSelectorPane.label',
      defaultMessage: 'Select channel'
    },
    roomBookingGroup: {
      id: 'components.commentChannelSelectorPane.group.roomBooking',
      defaultMessage: 'Room booking'
    },
    examGroupGroup: {
      id: 'components.commentChannelSelectorPane.group.examGroup',
      defaultMessage: 'Exam group'
    },
    examsGroup: {
      id: 'components.commentChannelSelectorPane.group.exams',
      defaultMessage: 'Exams'
    }
  }),
  dynamicTable: defineMessages({
    selectColumnTitle: {
      id: 'components.dynamicTable.selectColumn.title',
      defaultMessage: 'Select columns to display in table'
    }
  }),
  editExternalBookingDialog: defineMessages({
    bookingTitleLabel: {
      id: 'components.editExternalBookingDialog.label.bookingTitle',
      defaultMessage: 'Booking title'
    },
    noLongerNeedMessage: {
      id: 'components.editExternalBookingDialog.message.noLongerNeed',
      defaultMessage: 'No longer need this booking?'
    },
    deleteTitleMessage: {
      id: 'components.editExternalBookingDialog.message.deleteTitle',
      defaultMessage: 'Click here to delete it'
    }
  }),
  examActionsDropdown: defineMessages({
    deleteConfirm: {
      id: 'components.examActionsDropdown.message.deleteConfirm',
      defaultMessage: 'Are you sure want to delete exam {id}?'
    },
    aboutToDeleteWarning: {
      id: 'components.examActionsDropdown.message.aboutToDeleteWarning',
      defaultMessage: 'You are about to delete an exam. This action cannot be undone'
    },
    aboutToDeleteInstruction: {
      id: 'components.examActionsDropdown.message.aboutToDeleteInstruction',
      defaultMessage: 'Press "Delete exam" below to proceed'
    },
    unableToDeleteWarning: {
      id: 'components.examActionsDropdown.message.unableToDeleteWarning',
      defaultMessage: 'Unable to delete exam'
    },
    unableToDeleteDescription: {
      id: 'components.examActionsDropdown.message.unableToDeleteDescription',
      defaultMessage: 'This exam cannot be deleted. Make sure the exam is not schedule, has no child exams, and has not passed yet.'
    },
    deleteButton: {
      id: 'components.examActionsDropdown.button.deleteExam',
      defaultMessage: 'Unable to delete exam'
    }
  }),
  examComment: defineMessages({
    timeAgoText: {
      id: 'components.examComment.text.timeAgo',
      defaultMessage: '{time} ago'
    }
  }),
  examCommentsTab: defineMessages({
    noCommentsPostedMessage: {
      id: 'components.examCommentsTab.message.noCommentsPosted',
      defaultMessage: 'No comments have been posted yet'
    }
  }),
  examCostChart: defineMessages({
    totalRoomCostLabel: {
      id: 'components.examCostChart.label.totalRoomCost',
      defaultMessage: 'Total room cost'
    },
    costForExamLabel: {
      id: 'components.examCostChart.label.costForExam',
      defaultMessage: 'Cost for {examId}'
    },
    costsForOtherExamsLabel: {
      id: 'components.examCostChart.label.costsForOtherExams',
      defaultMessage: 'Costs for other exams'
    },
    costOfUnderUtilizationLabel: {
      id: 'components.examCostChart.label.costOfUnderUtilization',
      defaultMessage: 'Cost of underutilization'
    },
    totalCostForRoomLabel: {
      id: 'components.examCostChart.label.totalCostForRoom',
      defaultMessage: 'Total cost for room'
    },
    costBreakdownLabel: {
      id: 'components.examCostChart.label.costBreakdown',
      defaultMessage: 'Cost breakdown'
    }
  }),
  examLinkagePane: defineMessages({
    linkedToLabel: {
      id: 'components.examLinkagePane.label.linkedTo',
      defaultMessage: 'Linked to'
    },
    verifySchedulingOnTheChildExamsMessage: {
      id: 'components.examLinkagePane.message.verifySchedulingOnTheChildExams',
      defaultMessage: 'Please verify scheduling on the child exams'
    },
    notScheduledMessage: {
      id: 'components.examLinkagePane.message.notScheduled',
      defaultMessage: 'Not scheduled'
    }
  }),
  examPrioritiesColumn: defineMessages({
    noDateMessage: {
      id: 'components.examPrioritiesColumn.message.noDate',
      defaultMessage: 'No date'
    },
    noPrioritiesMessage: {
      id: 'components.examPrioritiesColumn.message.noPriorities',
      defaultMessage: 'No priorities'
    }
  }),
  examTagActions: defineMessages({
    noEditingNewTagInfo: {
      id: 'components.examTagActions.noEditingNewTagInfo',
      defaultMessage: 'This is a new tag. Thus editing is not possible. '
    },
    renameTagConfirmTitle: {
      id: 'components.examTagActions.renameTagConfirmTitle',
      defaultMessage: 'Rename tag {from} in all exams!'
    },
    renameTagConfirmDesription: {
      id: 'components.examTagActions.renameTagConfirmDesription',
      defaultMessage: 'This will rename all tag {from} to {to} in all exams! Are you sure?'
    },
    deleteTagConfirmTitle: {
      id: 'components.examTagActions.deleteTagConfirmTitle',
      defaultMessage: 'Delete tag {name} in all exams!'
    },
    deleteTagConfirmDesription: {
      id: 'components.examTagActions.deleteTagConfirmDesription',
      defaultMessage: 'This will delete all tag {name} in all exams! Are you sure?'
    }
  }),
  examReassignmentModal: defineMessages({
    reassignTitle: {
      id: 'components.examReassignmentModal.message.reassignTitle',
      defaultMessage: 'Reassign exam'
    },
    reassignConfirm: {
      id: 'components.examReassignmentModal.message.reassignConfirm',
      defaultMessage: 'Are you sure you want to reassign this exam?'
    },
    reassignConfirmContent: {
      id: 'components.examReassignmentModal.message.reassignConfirmContent',
      defaultMessage: 'Reassigning the exam will permanently change the ownership. Click OK to proceed.'
    },
    examOwnershipChangedMessage: {
      id: 'components.examReassignmentModal.message.examOwnershipChanged',
      defaultMessage: 'Exam ownership changed'
    },
    examOwnershipChangedMessageDesc: {
      id: 'components.examReassignmentModal.message.examOwnershipChangedMessageDesc',
      defaultMessage: 'You have been redirected since you are no longer the owner of this exam.'
    }
  }),
  examSchedulingRequest: defineMessages({
    invalidSettingsErrorTitle: {
      id: 'pages.examSchedulingRequest.errorTitle.invalidSettings',
      defaultMessage: 'Invalid settings'
    },
    uniqueError: {
      id: 'pages.examSchedulingRequest.error.unique',
      defaultMessage: 'All scheduling priorities need to be unique'
    },
    priorityMinimumError: {
      id: 'pages.examSchedulingRequest.error.priorityMinimum',
      defaultMessage: 'Exam needs to have at least {minRequestNumber, plural, one {# scheduling priority} other {# scheduling priorities}}'
    },
    notSetMessage: {
      id: 'pages.examSchedulingRequest.message.notSetValue',
      defaultMessage: 'Not set'
    }
  }),
  examSchedulingStatusPane: defineMessages({
    studentsScheduledLabel: {
      id: 'components.examSchedulingStatusPane.label.studentsScheduled',
      defaultMessage: 'Students scheduled'
    },
    numberOfChildExamsLabel: {
      id: 'components.examSchedulingStatusPane.label.numberOfChildExams',
      defaultMessage: 'Number of child exams'
    }
  }),
  examSchedulingTab: defineMessages({
    linkedExamNeedsToBeScheduled: {
      id: 'components.examSchedulingTab.message.linkedExamNeedsToBeScheduled',
      defaultMessage: 'The linked exam needs to be scheduled before you can schedule this exam.'
    }
  }),
  examSchedulingTableRow: defineMessages({
    deleteChildExamConfirm: {
      id: 'components.examSchedulingTableRow.message.deleteChildExamConfirm',
      defaultMessage: 'Delete this child exam will deallocate all students registered on this child exam. Are you sure you want to delete this child exam?'
    }
  }),
  examSlotDateContainer: defineMessages({
    freeText: {
      id: 'components.examSlotDateContainer.text.free',
      defaultMessage: '{number}% free'
    },
    childExamHaveToBeScheduleInSameDateMessage: {
      id: 'components.examSlotDateContainer.message.childExamHaveToBeScheduleInSameDate',
      defaultMessage: 'All child exams have to be scheduled on the same date'
    },
    examHasToBeScheduledOnSameDateAsLinkExamMessage: {
      id: 'components.examSlotDateContainer.message.examHasToBeScheduledOnSameDateAsLinkExam',
      defaultMessage: 'The exam has to be scheduled on the same date as its linked exam'
    }
  }),
  examSlotRow: defineMessages({
    examSlotIsTooShortMessage: {
      id: 'components.examSlotRow.message.examSlotIsTooShort',
      defaultMessage: 'The exam slot is too short for the selected exam'
    },
    examNeedsToBeScheduledOnSameExamSlotMessage: {
      id: 'components.examSlotRow.message.examNeedsToBeScheduledOnSameExamSlot',
      defaultMessage: 'The exam needs to be scheduled on the same exam slot as the exam its linked to'
    }
  }),
  filterBar: defineMessages({
    datasetTitle: {
      id: 'components.filterBar.title.dataset',
      defaultMessage: 'Show me all {title}'
    },
    filterModeTitle: {
      id: 'components.filterBar.title.filterMode',
      defaultMessage: 'Matching'
    },
    noFiltersAddedMessage: {
      id: 'components.filterBar.message.noFiltersAdded',
      defaultMessage: 'You have not added any filters yet'
    }
  }),
  filterModeLinkDropdown: defineMessages({
    matchOneButton: {
      id: 'components.filterModeLinkDropdown.button.matchOne',
      defaultMessage: 'One of the filters'
    },
    matchAllButton: {
      id: 'components.filterModeLinkDropdown.button.matchAll',
      defaultMessage: 'All of the filters'
    }
  }),
  initialRoute: defineMessages({
    examSlotEmptyError: {
      id: 'components.initialRoute.error.examSlotEmpty',
      defaultMessage: 'Exam slot list is empty!'
    },
    roomEmptyError: {
      id: 'components.initialRoute.error.roomEmpty',
      defaultMessage: 'Room list is empty!'
    },
    integrationSettingError: {
      id: 'components.initialRoute.error.integrationSettingError',
      defaultMessage: 'Integration setting is not properly set!'
    },
    studentsMappingEmptyError: {
      id: 'components.initialRoute.error.studentsMappingEmpty',
      defaultMessage: 'Sample student mapping is not set!'
    },
    userEmptyError: {
      id: 'components.initialRoute.error.userEmpty',
      defaultMessage: 'User list is empty!'
    }
  }),
  mainMenu: defineMessages({
    logOutLabel: {
      id: 'components.mainMenu.label.logOut',
      defaultMessage: 'Log out'
    },
    organizationLabel: {
      id: 'components.mainMenu.label.organization',
      defaultMessage: 'Organization'
    },
    switchOrganizationTitle: {
      id: 'components.mainMenu.title.switchOrganization',
      defaultMessage: 'Switch Organization'
    }
  }),
  modifyRoomBooking: defineMessages({
    noNonOverlappingExamSlotsMessage: {
      id: 'components.modifyRoomBooking.message.noNonOverlappingExamSlots',
      defaultMessage: 'No non-overlapping exam slots to show'
    },
    unableToModifyAlertMessage: {
      id: 'components.modifyRoomBooking.alert.unableToModifyAlert.message',
      defaultMessage: 'Unable to modify'
    },
    unableToModifyAlertSingleDescription: {
      id: 'components.modifyRoomBooking.alert.unableToModifyAlert.singleDescription',
      defaultMessage: "One or many of the room bookings you have selected contains exams or supervisors, so it can't be edited"
    },
    unableToModifyAlertMultipleDescription: {
      id: 'components.modifyRoomBooking.alert.unableToModifyAlert.multipleDescription',
      defaultMessage: "This room booking contains other exams or supervisors and belongs to a different exam slot, so it can't be moved to the selected exam slot"
    },
    modifyBookingAlertMessage: {
      id: 'components.modifyRoomBooking.alert.modifyBooking.message',
      defaultMessage: 'Modify room booking'
    },
    originLabel: {
      id: 'components.modifyRoomBooking.label.original',
      defaultMessage: 'Original'
    },
    convertIntoLabel: {
      id: 'components.modifyRoomBooking.label.convertInto',
      defaultMessage: 'Convert into'
    },
    addExamSlotsLabel: {
      id: 'components.modifyRoomBooking.label.addExamSlots',
      defaultMessage: 'Add exam slots'
    },
    modifyAndScheduleButton: {
      id: 'components.modifyRoomBooking.button.modifyAndSchedule',
      defaultMessage: 'Modify & schedule'
    }
  }),
  moveRoomBookingDialog: defineMessages({
    title: {
      id: 'components.moveRoomBookingDialog.title',
      defaultMessage: 'Move room booking {room} to {examSlot} slot {date}'
    },
    titleMultiple: {
      id: 'components.moveRoomBookingDialog.titleMultiple',
      defaultMessage: 'Move room bookings to {examSlot} slot {date}'
    },
    titleExams: {
      id: 'components.moveRoomBookingDialog.titleExams',
      defaultMessage: 'Move exams to {room} in slot {examSlot}'
    },
    titleSupervisors: {
      id: 'components.moveRoomBookingDialog.titleSupervisors',
      defaultMessage: 'Move supervisors to {room} in slot {examSlot}'
    },
    description: {
      id: 'components.moveRoomBookingDialog.description',
      defaultMessage: 'You are about to move this room booking to another slot, please confirm you want to proceed?'
    },
    retainRoomBookingCheckbox: {
      id: 'components.moveRoomBookingDialog.retainRoomBookingCheckbox.label',
      defaultMessage: 'Retain current room booking'
    },
    retainRoomBookingCheckboxDesc: {
      id: 'components.moveRoomBookingDialog.retainRoomBookingCheckbox.description',
      defaultMessage: 'This will create a new room booking on the selected slot and retain the current one.'
    },
    noExamAndSupervisorTitle: {
      id: 'components.moveRoomBookingDialog.noExamAndSupervisorTitle',
      defaultMessage: 'You are about to move this room booking to another slot, please confirm you want to proceed?'
    },
    selectExamAndSupervisorTitle: {
      id: 'components.moveRoomBookingDialog.selectExamAndSupervisorTitle',
      defaultMessage: 'Those room bookings contains exam(s) and supervisor(s), please select what you want to move.'
    },
    examTimeLongerExamSlotTimeAlert: {
      id: 'components.moveRoomBookingDialog.alert.examTimeLongerExamSlotTime',
      defaultMessage: 'Please note that the requested exam time is longer than the selected slot time.'
    },
    canBeMovedStatus: {
      id: 'components.moveRoomBookingDialog.status.canBeMoved',
      defaultMessage: 'Can be moved'
    },
    cannotBeMovedStatus: {
      id: 'components.moveRoomBookingDialog.status.cannotBeMoved',
      defaultMessage: 'Cannot be moved'
    },
    associatedExamMustBeInSameRoomBookingAlert: {
      id: 'components.moveRoomBookingDialog.alert.associatedExamMustBeInSameRoomBooking',
      defaultMessage: 'Please note that all associated child or linked exams needs to be schedudeld the same date and time slot, isolated ones can not be moved. These room booking(s) has exams linked with bookings:'
    },
    linkedRoomBookingItem: {
      id: 'components.moveRoomBookingDialog.alert.linkedRoomBooking.item',
      defaultMessage: 'Room {room} in slot "{examSlot}" {date}'
    },
    associatedExamMustBeInSameRoomBookingForExamAlert: {
      id: 'components.moveRoomBookingDialog.alert.associatedExamMustBeInSameRoomBookingForExam',
      defaultMessage: 'Please note that all associated child or linked exams needs to be schedudeld the same date, isolated ones can not be moved to another day. The exam(s) has the following dependencies:'
    },
    linkedExamItem: {
      id: 'components.moveRoomBookingDialog.alert.linkedExam.item',
      defaultMessage: '{exam} in {room} in slot {examSlot}'
    },
    linkedRoomBookingInsertButton: {
      id: 'components.moveRoomBookingDialog.alert.linkedRoomBooking.insertButton',
      defaultMessage: 'Insert'
    },
    supervisorMovingSameDateAndSlot: {
      id: 'components.moveRoomBookingDialog.alert.supervisorMovingSameDateAndSlot',
      defaultMessage: 'Moving within the slot. No actions required.'
    },
    supervisorUnavailableAlert: {
      id: 'components.moveRoomBookingDialog.alert.supervisorUnavailable',
      defaultMessage: 'Please note that one or several supervisors are unavailable in the selected time slot.'
    },
    unableToMoveRoomBookingMessage: {
      id: 'components.moveRoomBookingDialog.unableToMoveRoomBooking.message',
      defaultMessage: 'Unable to move room bookings'
    },
    unableToMoveRoomBookingOccupiedError: {
      id: 'components.moveRoomBookingDialog.unableToMoveRoomBooking.occupiedError',
      defaultMessage: 'The room is already occupied in TE Exam or TE Core'
    },
    unableToMoveRoomBookingRoomsDuplicatedError: {
      id: 'components.moveRoomBookingDialog.unableToMoveRoomBooking.roomsDuplicatedError',
      defaultMessage: 'One room can not have two bookings in the same exam slot'
    },
    confirmActionsAlert: {
      id: 'components.moveRoomBookingDialog.alert.confirmActions',
      defaultMessage: 'This operation will make the following changes, are you sure you want to proceed?'
    },
    linkedExamsInOtherBookingsError: {
      id: 'components.moveRoomBookingDialog.error.linkedExamsInOtherBookings',
      defaultMessage: 'Has linked exams in other room booking'
    },
    childExamsInOtherBookingsError: {
      id: 'components.moveRoomBookingDialog.error.childExamsInOtherBookings',
      defaultMessage: 'Has other child exams in other room booking'
    },
    linkedExamCannotMoveError: {
      id: 'components.moveRoomBookingDialog.error.linkedExamCannotMove',
      defaultMessage: 'Linked exam cannot be moved'
    },
    canBeMovedSuccess: {
      id: 'components.moveRoomBookingDialog.success.canBeMoved',
      defaultMessage: 'Can be moved'
    },
    cannotBeInsertedError: {
      id: 'components.moveRoomBookingDialog.error.cannotBeInserted',
      defaultMessage: 'Cannot be inserted'
    },
    newRoomBookingAction: {
      id: 'components.moveRoomBookingDialog.action.newRoomBooking',
      defaultMessage: 'Create a new room booking for {room} in slot "{examSlot}" {date} containing:'
    },
    newEmptyRoomBookingAction: {
      id: 'components.moveRoomBookingDialog.action.newEmptyRoomBooking',
      defaultMessage: 'Create a new room booking for {room} in slot "{examSlot}" {date}'
    },
    retainRoomBookingAction: {
      id: 'components.moveRoomBookingDialog.action.retainRoomBooking',
      defaultMessage: 'Retain current room booking for {room} in slot "{examSlot}" {date} containing:'
    },
    removeSchedulingAction: {
      id: 'components.moveRoomBookingDialog.action.removeScheduling',
      defaultMessage: 'Remove scheduling in {room} {date} for the following:'
    }
  }),
  publishPane: defineMessages({
    examCannotBePublishedMessage: {
      id: 'components.publishPane.message.examCannotBePublished',
      defaultMessage: "Exam cannot be published since it's not scheduled yet"
    }
  }),
  publicationStatus: defineMessages({
    couldNotBePublishedTitle: {
      id: 'components.publicationStatus.couldNotBePublished.title',
      defaultMessage: 'The exam could not be published because {error}.'
    }
  }),
  removeSpecialNeedsAssignmentButton: defineMessages({
    deleteConfirm: {
      id: 'components.removeSpecialNeedsAssignmentButton.message.deleteConfirm',
      defaultMessage: 'Are you sure you want to remove the special need for this student?'
    }
  }),
  requestedSchedulingListDetailPad: defineMessages({
    title: {
      id: 'components.requestedSchedulingListDetailPad.title',
      defaultMessage: 'Scheduling Priorities'
    },
    prioritiesAddedLabel: {
      id: 'components.requestedSchedulingListDetailPad.label.prioritiesAdded',
      defaultMessage: 'Priorities added'
    },
    prioritiesDisabledWarning: {
      id: 'components.requestedSchedulingListDetailPad.alert.prioritiesDisabled.message',
      defaultMessage: 'Scheduling priorities disabled'
    },
    prioritiesDisabledDescription: {
      id: 'components.requestedSchedulingListDetailPad.alert.prioritiesDisabled.description',
      defaultMessage: "Your organization's configuration does not allow for scheduling prioritization on exam requests"
    },
    prioritiesAddLeastWarning: {
      id: 'components.requestedSchedulingListDetailPad.alert.prioritiesAddLeast.message',
      defaultMessage: 'Please add at lest {minNumber} additional scheduling priorities'
    },
    prioritiesMaximumWarning: {
      id: 'components.requestedSchedulingListDetailPad.alert.prioritiesMaximumWarning.message',
      defaultMessage: 'Please add maximun {maxNumber} additional scheduling priorities'
    },
    prioritiesAddLeastDescription: {
      id: 'components.requestedSchedulingListDetailPad.alert.prioritiesAddLeast.description',
      defaultMessage: 'To save your exam, you have to submit at least {minNumber} scheduling priorities'
    },
    prioritiesInvalidWarning: {
      id: 'components.requestedSchedulingListDetailPad.alert.prioritiesInvalidWarning.message',
      defaultMessage: 'There are invalid priorities'
    },
    prioritiesErrorMessage: {
      id: 'components.requestedSchedulingListDetailPad.alert.prioritiesAddLeast.errorMessage',
      defaultMessage: 'The following errors are stopping you from saving'
    }
  }),
  requestedSchedulingPane: defineMessages({
    notSetMessage: {
      id: 'pages.requestedSchedulingPane.message.notSetValue',
      defaultMessage: 'Not set'
    }
  }),
  resourceScheduler: defineMessages({
    removeSupervisorBookingTitle: {
      id: 'components.resourceScheduler.removeSupervisorBookingModal.title',
      defaultMessage: 'Confirm cancelling this booking'
    },
    removeSupervisorBookingContent: {
      id: 'components.resourceScheduler.removeSupervisorBookingModal.content',
      defaultMessage: "Are you sure you want to cancel this supervisor's booking?"
    },
    removeUnavailableSupervisorBookingTitle: {
      id: 'components.resourceScheduler.removeUnavailableSupervisorBookingModal.title',
      defaultMessage: 'Confirm cancelling this unavailable booking'
    },
    removeUnavailableSupervisorBookingContent: {
      id: 'components.resourceScheduler.removeUnavailableSupervisorBookingModal.content',
      defaultMessage: "Are you sure you want to cancel this supervisor's unavailable booking?"
    },
    declineSupervisorBookingTitle: {
      id: 'components.resourceScheduler.declineSupervisorBookingModal.title',
      defaultMessage: 'Confirm declining this booking'
    },
    declineSupervisorBookingContent: {
      id: 'components.resourceScheduler.declineSupervisorBookingModal.content',
      defaultMessage: "Are you sure you want to decline this supervisor's booking?"
    },
    acceptSupervisorBookingTitle: {
      id: 'components.resourceScheduler.acceptSupervisorBookingModal.title',
      defaultMessage: 'Confirm manually accepting this booking'
    },
    acceptSupervisorBookingContent: {
      id: 'components.resourceScheduler.acceptSupervisorBookingModal.content',
      defaultMessage: 'Are you sure you want to manually accept this booking?'
    },
    resourceFiltersLabel: {
      id: 'components.resourceScheduler.label.resourceFilters',
      defaultMessage: 'Resource filters'
    },
    eventFiltersLabel: {
      id: 'components.resourceScheduler.label.eventFilters',
      defaultMessage: 'Event filters'
    },
    unableToMoveSupervisorBookingMessage: {
      id: 'components.resourceScheduler.unableToMoveSupervisorBooking.message',
      defaultMessage: 'Unable to move supervisor booking'
    },
    unableToMoveSupervisorBookingDescription: {
      id: 'components.resourceScheduler.unableToMoveSupervisorBooking.description',
      defaultMessage: 'The new time collides with another booking'
    }
  }),
  roomBookingActionsDropdown: defineMessages({
    viewInExamCalendarButton: {
      id: 'components.roomBookingActionsDropdown.button.viewInExamCalendar',
      defaultMessage: 'Schedule exams on room booking'
    },
    viewInSupervisorCalendarButton: {
      id: 'components.roomBookingActionsDropdown.button.viewInSupervisorCalendar',
      defaultMessage: 'Book supervisors on room booking'
    }
  }),
  roomBookingBookedObjectsPane: defineMessages({
    noBookObjectsMessage: {
      id: 'components.roomBookingBookedObjectsPane.message.noBookObjects',
      defaultMessage: 'No Booked Objects'
    }
  }),
  roomBookingDetailPad: defineMessages({
    bookingTitle: {
      id: 'components.roomBookingDetailPad.bookingTitle',
      defaultMessage: 'Room booking'
    },
    bookingSelectedTitle: {
      id: 'components.roomBookingDetailPad.bookingSelectedTitle',
      defaultMessage: 'Room booking in {room}, {startTime} - {endTime} ({examSlot})'
    },
    multipleBookingsSelectedTitle: {
      id: 'components.roomBookingDetailPad.multipleBookingsSelectedTitle',
      defaultMessage: 'Viewing {number} room bookings'
    },
    examTitle: {
      id: 'components.roomBookingDetailPad.examTitle',
      defaultMessage: 'Schedule exam'
    },
    examSelectedTitle: {
      id: 'components.roomBookingDetailPad.examSelectedTitle',
      defaultMessage: 'Schedule exam in {room}, {startTime} - {endTime} ({examSlot})'
    },
    modifyRoomBookingMessage: {
      id: 'components.roomBookingDetailPad.modifyRoomBooking.message',
      defaultMessage: 'You have selected a room booking on an exam slot that overlaps your selected exam slot. To complete the scheduling, you have convert the room booking.'
    }
  }),
  roomBookingStatsDetailPad: defineMessages({
    seatsBookedLabel: {
      id: 'components.roomBookingStatsDetailPad.label.seatsBooked',
      defaultMessage: 'Seats booked'
    },
    seatsNeededLabel: {
      id: 'components.roomBookingStatsDetailPad.label.seatsNeeded',
      defaultMessage: 'Seats needed'
    },
    distributionLabel: {
      id: 'components.roomBookingStatsDetailPad.label.distribution',
      defaultMessage: 'Distribution'
    },
    numberOfRoomsLabel: {
      id: 'components.roomBookingStatsDetailPad.label.numberOfRooms',
      defaultMessage: '# of rooms'
    },
    numberOfExamsLabel: {
      id: 'components.roomBookingStatsDetailPad.label.numberOfExams',
      defaultMessage: '# of exams'
    },
    neededLabel: {
      id: 'components.roomBookingStatsDetailPad.label.needed',
      defaultMessage: 'Needed'
    },
    bookedLabel: {
      id: 'components.roomBookingStatsDetailPad.label.booked',
      defaultMessage: 'Booked'
    },
    roomBookingStatisticsTitle: {
      id: 'components.roomBookingStatsDetailPad.title.roomBookingStatistics',
      defaultMessage: 'Room booking statistics'
    }
  }),
  roomBookingTabbedPane: defineMessages({
    timeAndDateTab: {
      id: 'components.roomBookingTabbedPane.tab.timeAndDate',
      defaultMessage: 'Time & date'
    },
    roomInformationTab: {
      id: 'components.roomBookingTabbedPane.tab.roomInformation',
      defaultMessage: 'Room information'
    }
  }),
  roomDetailPad: defineMessages({
    seatsLabel: {
      id: 'components.roomDetailPad.label.seats',
      defaultMessage: 'Seats'
    },
    slotAndTimeLabel: {
      id: 'components.roomDetailPad.label.slotAndTime',
      defaultMessage: 'Slot & time'
    },
    supervisorsNeededLabel: {
      id: 'components.roomDetailPad.label.supervisorsNeeded',
      defaultMessage: 'Supervisors needed'
    },
    bookSelectedRoomsButton: {
      id: 'components.roomDetailPad.button.bookSelectedRooms',
      defaultMessage: 'Book selected rooms'
    },
    noRoomsSelectedMessage: {
      id: 'components.roomDetailPad.message.noRoomsSelected',
      defaultMessage: 'No rooms have been selected'
    }
  }),
  roomSearchDropdown: defineMessages({
    roomFiltersPlaceholder: {
      id: 'components.roomSearchDropdown.placeholder.roomFilters',
      defaultMessage: 'Room filters'
    },
    selectedRoomsLabel: {
      id: 'components.roomSearchDropdown.label.selectedRooms',
      defaultMessage: 'Selected rooms'
    },
    searchForRoomsPlaceholder: {
      id: 'components.roomSearchDropdown.placeholder.searchForRooms',
      defaultMessage: 'Search for rooms...'
    }
  }),
  roomSelectionStatsDetailPad: defineMessages({
    title: {
      id: 'components.roomSelectionStatsDetailPad.title',
      defaultMessage: 'Room selection'
    },
    selectionLabel: {
      id: 'components.roomSelectionStatsDetailPad.label.selection',
      defaultMessage: 'Selection'
    },
    seatsSelectedLabel: {
      id: 'components.roomSelectionStatsDetailPad.label.seatsSelected',
      defaultMessage: 'Seats selected'
    },
    roomsSelectedLabel: {
      id: 'components.roomSelectionStatsDetailPad.label.roomsSelected',
      defaultMessage: 'Rooms selected'
    }
  }),
  saveFiltersButton: defineMessages({
    noFilterMessage: {
      id: 'components.saveFiltersButton.message.noFilter',
      defaultMessage: 'No filter'
    },
    removeConfirm: {
      id: 'components.saveFiltersButton.message.removeConfirm',
      defaultMessage: 'Sure to remove "{name}" filter?'
    },
    saveToCurrentFilterButton: {
      id: 'components.saveFiltersButton.button.saveToCurrentFilter',
      defaultMessage: 'Save to current filter'
    },
    saveAsNewFilterButton: {
      id: 'components.saveFiltersButton.button.saveAsNewFilter',
      defaultMessage: 'Save as new filter'
    },
    savedFiltersText: {
      id: 'components.saveFiltersButton.text.savedFilters',
      defaultMessage: 'Saved filters'
    },
    filterNameLabel: {
      id: 'components.saveFiltersButton.label.filterName',
      defaultMessage: 'Filter name'
    },
    filterNameRequiredError: {
      id: 'components.saveFiltersButton.error.required.filterName',
      defaultMessage: 'Please Input Filter Name!'
    }
  }),
  scheduledSupervisorActionsDropdown: defineMessages({
    removeFromRoomBookingButton: {
      id: 'components.scheduledSupervisorActionsDropdown.button.removeFromRoomBooking',
      defaultMessage: 'Remove from room booking'
    },
    declineRoomBookingForSupervisorButton: {
      id: 'components.scheduledSupervisorActionsDropdown.button.declineRoomBookingForSupervisorButton',
      defaultMessage: 'Decline booking for supervisor'
    },
    cancelRoomBookingForSupervisorButton: {
      id: 'components.scheduledSupervisorActionsDropdown.button.cancelRoomBookingForSupervisorButton',
      defaultMessage: 'Cancel booking for supervisor'
    },
    acceptBookingForSupervisorButton: {
      id: 'components.scheduledSupervisorActionsDropdown.button.acceptBookingForSupervisor',
      defaultMessage: 'Accept booking for supervisor'
    },
    sendEmailToSupervisor: {
      id: 'components.scheduledSupervisorActionsDropdown.button.sendEmailToSupervisor',
      defaultMessage: 'Send email to supervisor'
    },
    scheduleSupervisor: {
      id: 'components.scheduledSupervisorActionsDropdown.button.scheduleSupervisor',
      defaultMessage: 'Schedule supervisor'
    },
    setVisibleForSupervisor: {
      id: 'components.scheduledSupervisorActionsDropdown.button.setVisibleForSupervisor',
      defaultMessage: 'Set visible for supervisor'
    },
    setInvisibleForSupervisor: {
      id: 'components.scheduledSupervisorActionsDropdown.button.setInvisibleForSupervisor',
      defaultMessage: 'Set invisible for supervisor'
    },
    addRow: {
      id: 'components.scheduledSupervisorActionsDropdown.button.addRow',
      defaultMessage: 'Add row'
    },
    removeRow: {
      id: 'components.scheduledSupervisorActionsDropdown.button.removeRow',
      defaultMessage: 'Remove row'
    }
  }),
  schedulingFragment: defineMessages({
    unableToScheduleError: {
      id: 'components.schedulingFragment.error.unableToSchedule',
      defaultMessage: 'Unable to schedule'
    },
    noExamSelectedError: {
      id: 'components.schedulingFragment.error.noExamSelected',
      defaultMessage: 'No exam has been selected'
    },
    examScheduledOnBookingError: {
      id: 'components.schedulingFragment.error.examScheduledOnBooking',
      defaultMessage: 'Exam #{examId} is already scheduled on this room booking'
    },
    examHasChildExamError: {
      id: 'components.schedulingFragment.error.examHasChildExam',
      defaultMessage: 'Exam #{examId} has child exams. Please select one of the children for scheduling'
    },
    schedulingShorterThanExamDurationError: {
      id: 'components.schedulingFragment.error.schedulingShorterThanExamDuration',
      defaultMessage: 'The scheduling is shorter than the requested exam duration'
    },
    schedulingLongerThanExamDurationError: {
      id: 'components.schedulingFragment.error.schedulingLongerThanExamDuration',
      defaultMessage: 'The scheduling is longer than the requested exam duration'
    },
    importantInformationAboutYourScheduling: {
      id: 'components.schedulingFragment.error.importantInformationAboutYourScheduling',
      defaultMessage: 'Important information about your scheduling'
    },
    invalidSchedulingError: {
      id: 'components.schedulingFragment.error.invalidScheduling',
      defaultMessage: 'Invalid scheduling'
    },
    scheduledWithinBoundariesOfExamSlotError: {
      id: 'components.schedulingFragment.error.scheduledWithinBoundariesOfExamSlot',
      defaultMessage: 'The exam must be scheduled within the boundaries of the exam slot'
    },
    rescheduleConfirmTitle: {
      id: 'components.schedulingFragment.message.rescheduleConfirm.title',
      defaultMessage: 'Are you sure you want to reschedule this exam?'
    },
    rescheduleConfirmContent: {
      id: 'components.schedulingFragment.message.rescheduleConfirm.content',
      defaultMessage: 'This exam is already scheduled, are you sure you want to reschedule it?'
    },
    overbookConfirmTitle: {
      id: 'components.schedulingFragment.message.overbookConfirm.title',
      defaultMessage: 'Confirm overbooking of room'
    },
    overbookConfirmContent: {
      id: 'components.schedulingFragment.message.overbookConfirm.content',
      defaultMessage: 'By overbooking the room, this and any other exams booked on this room booking will not be able to use seat assignment features for students.'
    },
    overbookAlertMessage: {
      id: 'components.schedulingFragment.message.overbookAlert.message',
      defaultMessage: 'Overbooking room'
    },
    overbookAlertDescription: {
      id: 'components.schedulingFragment.message.overbookAlert.description',
      defaultMessage: 'By scheduling your exam here, you are overbooking this room.'
    },
    scheduleExamHereButton: {
      id: 'components.schedulingFragment.button.scheduleExamHere',
      defaultMessage: 'Schedule exam here'
    }
  }),
  schedulingPane: defineMessages({
    calendarOptionsLabel: {
      id: 'components.schedulingPane.label.calendarOptions',
      defaultMessage: 'Calendar options'
    },
    showBookedRoomsLabel: {
      id: 'components.schedulingPane.label.showBookedRooms',
      defaultMessage: 'Show booked rooms'
    },
    showCompatibleSlotsLabel: {
      id: 'components.schedulingPane.label.showCompatibleSlots',
      defaultMessage: 'Show compatible slots'
    },
    viewSelectedBookingsButton: {
      id: 'components.schedulingPane.button.viewSelectedBookings',
      defaultMessage: 'View selected bookings'
    },
    showAndBookSelectionButton: {
      id: 'components.schedulingPane.button.showAndBookSelection',
      defaultMessage: 'Show & book selection'
    },
    viewExamButton: {
      id: 'components.schedulingPane.button.viewExams',
      defaultMessage: 'View exams'
    },
    showSchedulingButton: {
      id: 'components.schedulingPane.button.showScheduling',
      defaultMessage: 'Show scheduling'
    }
  }),
  selectedExamDetailPad: defineMessages({
    title: {
      id: 'components.selectedExamDetailPad.title',
      defaultMessage: 'Id: {id}, Name: {name}'
    },
    schedulingStatusAndPrioritiesLabel: {
      id: 'components.selectedExamDetailPad.label.schedulingStatusAndPriorities',
      defaultMessage: 'Scheduling status & priorities'
    }
  }),
  selectedRoomBookingDetailPad: defineMessages({
    roomBookingInfoTab: {
      id: 'components.selectedRoomBookingDetailPad.tab.roomBookingInfo',
      defaultMessage: 'Room booking info'
    },
    roomBookingTitle: {
      id: 'components.selectedRoomBookingDetailPad.title.roomBooking',
      defaultMessage: 'Booking in {room} on {date}'
    }
  }),
  selectionOverlay: defineMessages({
    tryingToMakeASelectionInAnotherExamSlotMessage: {
      id: 'components.selectionOverlay.message.tryingToMakeASelectionInAnotherExamSlot',
      defaultMessage: 'You are trying to make a selection in another exam slot. To do this you need to discard your existing selections.'
    },
    doYouWantToContinueMessage: {
      id: 'components.selectionOverlay.message.doYouWantToContinue',
      defaultMessage: 'Do you want to continue?'
    },
    discardSelectionButton: {
      id: 'components.selectionOverlay.button.discardSelection',
      defaultMessage: 'Discard selection'
    }
  }),
  setSupervisorCount: defineMessages({
    bookingHasPastMessage: {
      id: 'components.setSupervisorCount.message.bookingHasPast',
      defaultMessage: 'This room booking has past, so no edits are allowed'
    }
  }),
  studentScheduleError: defineMessages({
    message: {
      id: 'components.studentScheduleError.message',
      defaultMessage: 'If you think something is wrong or you need help, please contact your administrator.'
    }
  }),
  supervisorAvailabilityCalendar: defineMessages({
    historicalBookingDialogTitle: {
      id: 'components.supervisorAvailabilityCalendar.historicalBooking.title',
      defaultMessage: 'This date and time has already passed'
    },
    historicalBookingDialogContent: {
      id: 'components.supervisorAvailabilityCalendar.historicalBooking.content',
      defaultMessage: 'You cannot create an event for a date and time that has passed'
    },
    overlappingBookingDialogTitle: {
      id: 'components.supervisorAvailabilityCalendar.overlappingBooking.title',
      defaultMessage: 'Overlapping bookings'
    },
    overlappingBookingDialogContent: {
      id: 'components.supervisorAvailabilityCalendar.overlappingBooking.content',
      defaultMessage: 'This booking overlaps with a session you are scheduled on'
    },
    supervisorCalendarHelpTitle: {
      id: 'components.supervisorAvailabilityCalendar.supervisorCalendarHelp.title',
      defaultMessage: 'How to use the calendar'
    },
    supervisorCalendarHelpEnterAvailabilityTitle: {
      id: 'components.supervisorAvailabilityCalendar.supervisorCalendarHelp.enterAvailability.title',
      defaultMessage: 'Enter your availability'
    },
    supervisorCalendarHelpEnterAvailabilityDescription: {
      id: 'components.supervisorAvailabilityCalendar.supervisorCalendarHelp.enterAvailability.description',
      defaultMessage: 'Use the drag and drop interface in the calendar to indicate during which days and times you are not able to work'
    },
    supervisorCalendarHelpEditAvailabilityTitle: {
      id: 'components.supervisorAvailabilityCalendar.supervisorCalendarHelp.editAvailability.title',
      defaultMessage: 'Edit your availability'
    },
    supervisorCalendarHelpEditAvailabilityDescription: {
      id: 'components.supervisorAvailabilityCalendar.supervisorCalendarHelp.editAvailability.description',
      defaultMessage: 'You can edit your availability by dragging and resizing any of the red events, or click on them to change the title or delete them'
    },
    supervisorCalendarHelpConfirmDeclineBookingTitle: {
      id: 'components.supervisorAvailabilityCalendar.supervisorCalendarHelp.confirmDeclineBooking.title',
      defaultMessage: 'View, confirm or decline your bookings'
    },
    supervisorCalendarHelpConfirmDeclineBookingDescription: {
      id: 'components.supervisorAvailabilityCalendar.supervisorCalendarHelp.confirmDeclineBooking.description',
      defaultMessage: "Exam bookings are indicated in green or striped green colors. If you haven't yet accepted a booking (as indicated by its stripes), you can click on it and choose to either accept or decline it"
    },
    selectResponseButton: {
      id: 'components.supervisorAvailabilityCalendar.button.selectResponse',
      defaultMessage: 'Select your response'
    },
    confirmBookingButton: {
      id: 'components.supervisorAvailabilityCalendar.button.confirmBooking',
      defaultMessage: 'I confirm this booking'
    },
    declineBookingButton: {
      id: 'components.supervisorAvailabilityCalendar.button.declineBooking',
      defaultMessage: 'I decline this booking'
    },
    selectResponseForTitle: {
      id: 'components.supervisorAvailabilityCalendar.title.selectResponseFor',
      defaultMessage: 'Select response for {event}'
    },
    selectResponseForAlertTitle: {
      id: 'components.supervisorAvailabilityCalendar.alert.selectResponseFor.title',
      defaultMessage: 'Select your response with the buttons below'
    },
    selectResponseForAlertNote: {
      id: 'components.supervisorAvailabilityCalendar.alert.selectResponseFor.note',
      defaultMessage: 'NOTE'
    },
    selectResponseForAlertContent: {
      id: 'components.supervisorAvailabilityCalendar.alert.selectResponseFor.content',
      defaultMessage: 'to change your response after you have submitted it, you need to contact your administrator'
    },
    myAvailabilityTitle: {
      id: 'components.supervisorAvailabilityCalendar.title.myAvailability',
      defaultMessage: 'My availability and bookings'
    },
    bookAllDayButton: {
      id: 'components.supervisorAvailabilityCalendar.button.bookAllDay',
      defaultMessage: 'Book all day'
    },
    displayingDatesLabel: {
      id: 'components.supervisorAvailabilityCalendar.label.displayingDates',
      defaultMessage: 'Displaying dates'
    },
    weekPickerFormat: {
      id: 'components.supervisorAvailabilityCalendar.weekPicker.format',
      defaultMessage: '{from} - {to} {year} (Week {week})'
    }
  }),
  supervisorFoldout: defineMessages({
    supervisorDetailsTitle: {
      id: 'components.supervisorFoldout.title.supervisorDetails',
      defaultMessage: 'Supervisor details'
    }
  }),
  supervisorPendingActions: defineMessages({
    confirmAcceptMessage: {
      id: 'components.supervisorPendingActions.message.confirmToAccept',
      defaultMessage: 'Are you sure you want to confirm this booking request?'
    },
    confirmToDeclineMessage: {
      id: 'components.supervisorPendingActions.message.confirmToDecline',
      defaultMessage: 'Are you sure you want to decline this booking request?'
    }
  }),
  supervisorsTab: defineMessages({
    scheduledGroup: {
      id: 'components.supervisorsTab.group.scheduled',
      defaultMessage: 'Scheduled'
    },
    availableGroup: {
      id: 'components.supervisorsTab.group.available',
      defaultMessage: 'Available'
    }
  }),
  teExamCalendar: defineMessages({
    timeTooltip: {
      id: 'components.teExamCalendar.tooltip.time',
      defaultMessage: '(Prep time start) - (exam time start) --- (exam time end) - (clean-up time end)'
    },
    supervisorBookingExpirationTitle: {
      id: 'components.teExamCalendar.supervisorBookingExpiration.title',
      defaultMessage: 'Deadline to answer booking request'
    },
    supervisorBookingExpirationContent: {
      id: 'components.teExamCalendar.supervisorBookingExpiration.content',
      defaultMessage: 'Select the number of days the supervisor(s) has to answer to this booking request.'
    },
    supervisorBookingExpirationDateText: {
      id: 'components.teExamCalendar.supervisorBookingExpiration.expirationDate',
      defaultMessage: 'Booking request expires on {expirationDate}'
    }
  }),
  totalExamCostChart: defineMessages({
    seatsUsedLabel: {
      id: 'components.totalExamCostChart.label.seatsUsed',
      defaultMessage: 'Seats used'
    },
    totalRoomCostLabel: {
      id: 'components.totalExamCostChart.label.totalRoomCost',
      defaultMessage: 'Total room cost'
    },
    costForExamLabel: {
      id: 'components.totalExamCostChart.label.costForExam',
      defaultMessage: 'Cost for exam'
    },
    costForExamIdLabel: {
      id: 'components.totalExamCostChart.label.costForExamIdLabel',
      defaultMessage: 'Cost for {examId}'
    },
    costsForOtherExamsLabel: {
      id: 'components.totalExamCostChart.label.costsForOtherExams',
      defaultMessage: 'Costs for other exams'
    },
    costOfUnderUtilizationLabel: {
      id: 'components.totalExamCostChart.label.costOfUnderUtilization',
      defaultMessage: 'Cost of underutilization'
    },
    totalCostForAllRoomsLabel: {
      id: 'components.totalExamCostChart.label.totalCostForAllRooms',
      defaultMessage: 'Total cost for all rooms'
    },
    costBreakdownLabel: {
      id: 'components.totalExamCostChart.label.costBreakdown',
      defaultMessage: 'Cost breakdown'
    }
  }),
  reportingTemplate: defineMessages({
    validationFailed: {
      id: 'components.reportingTemplate.validationFailed',
      defaultMessage: 'Validation Failed'
    },
    adjustedColumnWidthTitle: {
      id: 'components.reportingTemplate.adjustedColumnWidthTitle',
      defaultMessage: 'Adjusted Column Width'
    },
    adjustedColumnWidthContent: {
      id: 'components.reportingTemplate.adjustedColumnWidthContent',
      defaultMessage: 'The column width will be adjusted in order to not line break in the middle of a word.'
    },
    nameIsRequired: {
      id: 'components.reportingTemplate.nameIsRequired',
      defaultMessage: 'Template name is required'
    },
    columnIsMissing: {
      id: 'components.reportingTemplate.columnIsMissing',
      defaultMessage: 'Column {item} is required'
    },
    columnCountInvalid: {
      id: 'components.reportingTemplate.columnCountInvalid',
      defaultMessage: 'Please add at least 1 column'
    }
  })
};
var component = messages$9;

var messages$8 = defineMessages({
  email: {
    id: 'common.error.email',
    defaultMessage: 'The input is not valid email.'
  },
  emailExists: {
    id: 'common.error.emailExists',
    defaultMessage: 'The email is already in use.'
  },
  empty: {
    id: 'common.error.empty',
    defaultMessage: '{item} cannot be empty.'
  },
  findDataSheet: {
    id: 'common.error.findingDataSheet',
    defaultMessage: "The file doesn't contain a sheet called ’data_sheet’, please edit your file and try again."
  },
  outsideOfRoomBooking: {
    id: 'common.error.outsideOfRoomBooking',
    defaultMessage: 'The {denominator} is outside of the room booking'
  },
  theSchedulingDoesNotMatchAnyOfTheSubmittedSchedulingPriorities: {
    id: 'common.error.theSchedulingDoesNotMatchAnyOfTheSubmittedSchedulingPriorities',
    defaultMessage: 'The scheduling does not match any of the submitted scheduling priorities'
  },
  phoneNumber: {
    id: 'common.error.phoneNumber',
    defaultMessage: 'The input is not valid phone number.'
  },
  readFile: {
    id: 'common.error.readFile',
    defaultMessage: 'The file could not be read. Please try again.'
  },
  required: {
    id: 'common.error.required',
    defaultMessage: '{field} is required{item, select, NONE {} other { for the {item}}}.'
  },
  required_short: {
    id: 'common.error.required_short',
    defaultMessage: 'Required'
  },
  unknownUpload: {
    id: 'common.error.unknownUpload',
    defaultMessage: 'An unknown error occured when processing the request. Please try again.'
  },
  uploadFile: {
    id: 'common.error.uploadFile',
    defaultMessage: 'The upload was terminated prematurely, please check your internet connect and try again.'
  },
  uploadDuplicateStudentIds: {
    id: 'common.error.uploadDuplicateStudentIds',
    defaultMessage: 'The file contains duplicate student ids. Please ensure all student ids are unique.'
  }
});
var error = messages$8;

var messages$7 = defineMessages({
  allowExatTimePrioritization: {
    id: 'common.label.allowExatTimePrioritization',
    defaultMessage: 'Allow exat time prioritization'
  },
  allowExatTime: {
    id: 'common.label.allowExatTime',
    defaultMessage: 'Allow exact time'
  },
  allowToLockTime: {
    id: 'common.label.allowToLockTime',
    defaultMessage: 'Allow to lock time'
  },
  allowToLockDate: {
    id: 'common.label.allowToLockDate',
    defaultMessage: 'Allow to lock date'
  },
  allowOnePriorityPerDate: {
    id: 'common.label.allowOnePriorityPerDate',
    defaultMessage: 'Allow one priority per date'
  },
  allowExatTimePrioritizationDesc: {
    id: 'common.label.allowExatTimePrioritizationDesc',
    defaultMessage: 'Should the user be allowed to add an exact time their priorities'
  },
  allowStrictDatePrioritization: {
    id: 'common.label.allowStrictDatePrioritization',
    defaultMessage: 'Allow strict date prioritization '
  },
  allowStrictDatePrioritizationDesc: {
    id: 'common.label.allowExatTimePrioritizationDesc',
    defaultMessage: 'Should the user be allowed to "locked" the date in their priorities'
  },
  allowStrictTimePrioritization: {
    id: 'common.label.allowStrictTimePrioritization',
    defaultMessage: 'Allow strict time prioritization '
  },
  allowStrictTimePrioritizationDesc: {
    id: 'common.label.allowExatTimePrioritizationDesc',
    defaultMessage: 'Should the user be allowed to "locked" the tine in their priorities'
  },
  allowOnlyOneRequestPerDate: {
    id: 'common.label.allowOnlyOneRequestPerDate',
    defaultMessage: 'Allow only one request per date'
  },
  allowOnlyOneRequestPerDateDesc: {
    id: 'common.label.allowOnlyOneRequestPerDateDesc',
    defaultMessage: 'Should the user be allowed to only request one priority per date'
  },
  actions: {
    id: 'common.label.actions',
    defaultMessage: 'Actions'
  },
  acceptedBookings: {
    id: 'common.label.acceptedBookings',
    defaultMessage: 'Accepted bookings'
  },
  attendingStudents: {
    id: 'pages.label.attendingStudents',
    defaultMessage: 'Attending students'
  },
  addSorting: {
    id: 'common.label.addSorting',
    defaultMessage: 'Add sorting'
  },
  availability: {
    id: 'common.label.availability',
    defaultMessage: 'Availability'
  },
  availableSupervisors: {
    id: 'common.label.availableSupervisors',
    defaultMessage: 'Available supervisors'
  },
  removeTagPop: {
    id: 'common.label.removeTagPop',
    defaultMessage: 'Are you sure delete this tag'
  },
  publishExam: {
    id: 'common.label.publishExam',
    defaultMessage: 'Publish exam'
  },
  depublishExam: {
    id: 'common.label.depublishExam',
    defaultMessage: 'Depublish exam'
  },
  cancel: {
    id: 'common.label.cancel',
    defaultMessage: 'Cancel'
  },
  cancelExam: {
    id: 'common.label.cancelExam',
    defaultMessage: 'Cancel exam'
  },
  cancelled: {
    id: 'common.label.cancelled',
    defaultMessage: 'Cancelled'
  },
  action: {
    id: 'common.label.action',
    defaultMessage: 'Actions'
  },
  active: {
    id: 'common.label.active',
    defaultMessage: 'Active'
  },
  unavailable: {
    id: 'common.label.unavailable',
    defaultMessage: 'Unavailable'
  },
  unableToSave: {
    id: 'common.label.unableToSave',
    defaultMessage: 'Unable to save'
  },
  additionalInformation: {
    id: 'common.label.additionalInformation',
    defaultMessage: 'Additional information'
  },
  additionalInfor: {
    id: 'common.label.additionalInfor',
    defaultMessage: 'Additional info'
  },
  address: {
    id: 'common.label.address',
    defaultMessage: 'Address'
  },
  allocated: {
    id: 'common.label.allocated',
    defaultMessage: 'Allocated'
  },
  allocateSelectedStudents: {
    id: 'common.label.allocateSelectedStudents',
    defaultMessage: 'Allocate selected students'
  },
  allowParam: {
    id: 'common.label.allowItem',
    defaultMessage: 'Allow {param}'
  },
  attributes: {
    id: 'common.label.attributes',
    defaultMessage: 'Attributes'
  },
  availableCapacity: {
    id: 'common.label.availableCapacity',
    defaultMessage: 'Available capacity'
  },
  archiveOrDeleteGDPR: {
    id: 'common.label.archiveOrDeleteGDPR',
    defaultMessage: 'Archive or delete personal data from database'
  },
  assignedSpecialNeeds: {
    id: 'common.label.assignedSpecialNeeds',
    defaultMessage: 'Assigned special needs'
  },
  batchOperations: {
    id: 'common.label.batchOperations',
    defaultMessage: 'Batch operations'
  },
  building: {
    id: 'common.label.building',
    defaultMessage: 'Building'
  },
  bookings: {
    id: 'common.label.bookings',
    defaultMessage: 'Bookings'
  },
  bookingsSelected: {
    id: 'common.label.bookingsSelected',
    defaultMessage: 'Bookings selected'
  },
  bookingInfo: {
    id: 'common.label.bookingInfo',
    defaultMessage: 'Booking info'
  },
  bookingTitle: {
    id: 'common.label.bookingTitle',
    defaultMessage: 'Booking title'
  },
  bookedObjects: {
    id: 'common.label.bookedObjects',
    defaultMessage: 'Booked objects'
  },
  bookedSupervisors: {
    id: 'common.label.bookedSupervisors',
    defaultMessage: 'Booked supervisors'
  },
  bookedRooms: {
    id: 'common.label.bookedRooms',
    defaultMessage: 'Booked rooms'
  },
  basicInformation: {
    id: 'common.label.basicInformation',
    defaultMessage: 'Basic information'
  },
  bookingInformation: {
    id: 'common.label.bookingInformation',
    defaultMessage: 'Booking info'
  },
  bulkActions: {
    id: 'common.label.bulkActions',
    defaultMessage: 'Bulk actions'
  },
  campus: {
    id: 'common.label.campus',
    defaultMessage: 'Campus'
  },
  campuses: {
    id: 'common.label.campuses',
    defaultMessage: 'Campuses'
  },
  canBeLead_long: {
    id: 'common.label.canBeLead_long',
    defaultMessage: 'Can be main supervisor'
  },
  cancellationReason: {
    id: 'common.label.cancellationReason',
    defaultMessage: 'Cancellation reason'
  },
  cancelledBookings: {
    id: 'common.label.cancelledBookings',
    defaultMessage: 'Cancelled bookings'
  },
  cancelSupBookingsOk: {
    id: 'common.label.cancelSupBookingsOk',
    defaultMessage: 'Yes cancel booking(s)'
  },
  cancelSupBookingsReason: {
    id: 'common.label.cancelSupBookingsReason',
    defaultMessage: 'Enter cancellation reason:'
  },
  cancelSupBookings: {
    id: 'common.label.cancelSupBookings',
    defaultMessage: 'Cancel supervisor booking(s)'
  },
  cancelSupBookingsDes: {
    id: 'common.label.cancelSupBookingsDes',
    defaultMessage: 'You are about to cancel one or several supervisor bookings, This means the booking will be marked as "Cancelled" but the supervisor(s) will still be available for other bookings. The supervisor(s) will also recieve an email with this information, are you sure you want to proceeed?'
  },
  capacity: {
    id: 'common.label.capacity',
    defaultMessage: 'Capacity'
  },
  capacityOverview: {
    id: 'common.label.capacityOverview',
    defaultMessage: 'Capacity overview'
  },
  checklist: {
    id: 'common.label.checklist',
    defaultMessage: 'Checklist'
  },
  childExams: {
    id: 'common.label.childExams',
    defaultMessage: 'Child exams'
  },
  comment: {
    id: 'common.label.comment',
    defaultMessage: 'Comment'
  },
  comments: {
    id: 'common.label.comments',
    defaultMessage: 'Comments'
  },
  confirmedBooking: {
    id: 'common.label.confirmedBooking',
    defaultMessage: 'Confirmed booking'
  },
  contractType: {
    id: 'common.label.contractType',
    defaultMessage: 'Contract type'
  },
  costCenter: {
    id: 'common.label.costCenter',
    defaultMessage: 'Cost center'
  },
  costCenters: {
    id: 'common.label.costCenters',
    defaultMessage: 'Cost centers'
  },
  course: {
    id: 'common.label.course',
    defaultMessage: 'Course'
  },
  courses: {
    id: 'common.label.courses',
    defaultMessage: 'Courses'
  },
  courseCode: {
    id: 'common.label.courseCode',
    defaultMessage: 'Course code'
  },
  courseName: {
    id: 'common.label.courseName',
    defaultMessage: 'Course name'
  },
  courseEvent: {
    id: 'common.label.courseEvent',
    defaultMessage: 'Course event'
  },
  courseEvents: {
    id: 'common.label.courseEvents',
    defaultMessage: 'Course events'
  },
  credits: {
    id: 'common.label.credits',
    defaultMessage: 'Credits'
  },
  created: {
    id: 'common.label.created',
    defaultMessage: 'Created'
  },
  dataMapping: {
    id: 'common.label.dataMapping',
    defaultMessage: 'Data mapping'
  },
  date: {
    id: 'common.label.date',
    defaultMessage: 'Date'
  },
  day: {
    id: 'common.label.day',
    defaultMessage: 'Day'
  },
  dateAndTime: {
    id: 'common.label.dateAndTime',
    defaultMessage: 'Date & time'
  },
  dateFormat: {
    id: 'common.label.dateFormat',
    defaultMessage: 'Date format'
  },
  dayView: {
    id: 'common.label.dayView',
    defaultMessage: 'Day view'
  },
  declinedBookings: {
    id: 'common.label.declinedBookings',
    defaultMessage: 'Declined bookings'
  },
  declineSupBookingsOk: {
    id: 'common.label.declineSupBookingsOk',
    defaultMessage: 'Yes decline booking(s)'
  },
  declineSupBookings: {
    id: 'common.label.declineSupBookings',
    defaultMessage: 'Decline supervisor booking(s)'
  },
  declineSupBookingsDes: {
    id: 'common.label.declineSupBookingsDes',
    defaultMessage: "You are about to decline one or several supervisor bookings, This means the booking will be marked as \"Declined\" and the supervisor(s) won't be available for other bookings. Are you sure you want to proceeed?"
  },
  deleteAllExams: {
    id: 'common.label.deleteAllExams',
    defaultMessage: 'Delete all exam scheduling'
  },
  deleteAllSupervisors: {
    id: 'common.label.deleteAllSupervisors',
    defaultMessage: 'Delete all supervisor scheduling'
  },
  deleteAllPersonalData: {
    id: 'common.label.deleteAllPersonalData',
    defaultMessage: 'Delete all personal data'
  },
  deleteRoomBooking: {
    id: 'common.label.deleteRoomBooking',
    defaultMessage: 'Delete room booking'
  },
  coordinators: {
    id: 'common.label.coordinators',
    defaultMessage: 'Coordinators'
  },
  configureHowTheStudentScheduleIsDisplayed: {
    id: 'common.label.configureHowTheStudentScheduleIsDisplayed',
    defaultMessage: 'Configure how the student schedule is displayed'
  },
  confirmToDeleteRoomBooking: {
    id: 'common.label.confirmToDeleteRoomBooking',
    defaultMessage: 'Do you want to delete this room booking?'
  },
  confirmToDeleteConfig: {
    id: 'common.label.confirmToDeleteConfig',
    defaultMessage: 'Do you want to delete this config?'
  },
  confirmToDeleteExams: {
    id: 'common.label.confirmToDeleteExams',
    defaultMessage: 'Do you want to delete {multi, select, true {these exams scheduling} false {this exam scheduling}}?'
  },
  confirmToDeleteSupervisors: {
    id: 'common.label.confirmToDeleteSupervisors',
    defaultMessage: 'Do you want to delete {multi, select, true {these supervisors scheduling} false {this supervisor scheduling}}?'
  },
  deleteStudents: {
    id: 'common.label.deleteStudents',
    defaultMessage: 'Delete all students'
  },
  deleteSupervisorGDPR: {
    id: 'common.label.deleteSupervisorGDPR',
    defaultMessage: 'Delete all personal infomation (GDPR)'
  },
  deleteSupervisors: {
    id: 'common.label.deleteSupervisors',
    defaultMessage: 'Delete all supervisors'
  },
  deleteExams: {
    id: 'common.label.deleteExams',
    defaultMessage: 'Delete all exams'
  },
  deleteUsers: {
    id: 'common.label.deleteUsers',
    defaultMessage: 'Delete all users'
  },
  calendarOptions: {
    id: 'common.label.calendarOptions',
    defaultMessage: 'Calendar options'
  },
  customField1: {
    id: 'common.label.customField1',
    defaultMessage: 'Custom field 1'
  },
  customField2: {
    id: 'common.label.customField2',
    defaultMessage: 'Custom field 2'
  },
  customField3: {
    id: 'common.label.customField3',
    defaultMessage: 'Custom field 3'
  },
  customField4: {
    id: 'common.label.customField4',
    defaultMessage: 'Custom field 4'
  },
  customField5: {
    id: 'common.label.customField5',
    defaultMessage: 'Custom field 5'
  },
  deactivationDate: {
    id: 'common.label.deactivationDate',
    defaultMessage: 'Deactivation date'
  },
  description: {
    id: 'common.label.description',
    defaultMessage: 'Description'
  },
  department: {
    id: 'common.label.department',
    defaultMessage: 'Department'
  },
  departments: {
    id: 'common.label.departments',
    defaultMessage: 'Departments'
  },
  departmentCode: {
    id: 'common.label.departmentCode',
    defaultMessage: 'Department code'
  },
  duration: {
    id: 'common.label.duration',
    defaultMessage: 'Duration'
  },
  duplicateAnExamRequest: {
    id: 'common.label.duplicateAnExamRequest',
    defaultMessage: 'Duplicate an exam request'
  },
  editExamAllocation: {
    id: 'common.label.editExamAllocation',
    defaultMessage: 'Edit exam allocation'
  },
  email: {
    id: 'common.label.email',
    defaultMessage: 'Email'
  },
  emailStatus: {
    id: 'common.label.emailStatus',
    defaultMessage: 'Email status'
  },
  empty: {
    id: 'common.label.empty',
    defaultMessage: 'Empty'
  },
  endTime: {
    id: 'common.label.endTime',
    defaultMessage: 'End time'
  },
  endTime_table: {
    id: 'common.label.endTime_long',
    defaultMessage: 'Exam end time'
  },
  enterYourStudentIdToSeeYourSchedule: {
    id: 'common.label.enterYourStudentIdToSeeYourSchedule',
    defaultMessage: 'Enter your student id to see your schedule'
  },
  exam: {
    id: 'common.label.exam',
    defaultMessage: 'Exam'
  },
  examTime: {
    id: 'common.label.examTime',
    defaultMessage: 'Exam time'
  },
  exam_checklist: {
    id: 'common.label.exam_checklist',
    defaultMessage: 'Exam checklist'
  },
  expiredBookings: {
    id: 'common.label.expiredBookings',
    defaultMessage: 'Expired bookings'
  },
  expiredBookingRequest: {
    id: 'common.label.expiredBookingRequest',
    defaultMessage: 'Expired booking request'
  },
  from_until: {
    id: 'common.label.from_until',
    defaultMessage: 'From - until'
  },
  events: {
    id: 'common.label.events',
    defaultMessage: 'Events'
  },
  generateReport: {
    id: 'common.label.generateReport',
    defaultMessage: 'Generate report'
  },
  modified: {
    id: 'common.label.modified',
    defaultMessage: 'Modified'
  },
  deleted: {
    id: 'common.label.deleted',
    defaultMessage: 'Deleted'
  },
  published: {
    id: 'common.label.published',
    defaultMessage: 'Published'
  },
  depublished: {
    id: 'common.label.depublished',
    defaultMessage: 'Depublished'
  },
  depublishedExams: {
    id: 'common.label.depublishedExams',
    defaultMessage: 'Depublished exams'
  },
  cancelledExams: {
    id: 'common.label.cancelledExams',
    defaultMessage: 'Cancelled exams'
  },
  reassigned: {
    id: 'common.label.reassigned',
    defaultMessage: 'Reassigned'
  },
  imported: {
    id: 'common.label.imported',
    defaultMessage: 'Imported'
  },
  deallocated: {
    id: 'common.label.deallocated',
    defaultMessage: 'Deallocated'
  },
  scheduled: {
    id: 'common.label.scheduled',
    defaultMessage: 'Scheduled'
  },
  searchForSupervisor: {
    id: 'common.label.searchForSupervisor',
    defaultMessage: 'Search for supervisor'
  },
  statistics: {
    id: 'common.label.statistics',
    defaultMessage: 'Statistics'
  },
  unscheduled: {
    id: 'common.label.unscheduled',
    defaultMessage: 'Unscheduled'
  },
  children_modified: {
    id: 'common.label.children_modified',
    defaultMessage: 'Children modified'
  },
  exportPersonal: {
    id: 'common.label.exportPersonal',
    defaultMessage: 'Export personal data'
  },
  exam_comment: {
    id: 'common.label.exam_comment',
    defaultMessage: 'Exam comment'
  },
  exam_student: {
    id: 'common.label.exam_student',
    defaultMessage: 'Exam student'
  },
  examCalendar: {
    id: 'common.label.examCalendar',
    defaultMessage: 'Exam calendar'
  },
  exams: {
    id: 'common.label.exams',
    defaultMessage: 'Exams'
  },
  examDetails: {
    id: 'common.label.examDetails',
    defaultMessage: 'Exam details'
  },
  examDuration: {
    id: 'common.label.examDuration',
    defaultMessage: 'Exam duration'
  },
  examId: {
    id: 'common.label.examId',
    defaultMessage: 'Exam Id'
  },
  examInformation: {
    id: 'common.label.examInformation',
    defaultMessage: 'Exam information'
  },
  examSelecionInstruction: {
    id: 'common.label.examSelecionInstruction',
    defaultMessage: 'Select an exam.'
  },
  examHierarchy: {
    id: 'common.label.examHierarchy',
    defaultMessage: 'Exam hierarchy'
  },
  examLanguage: {
    id: 'common.label.examLanguage',
    defaultMessage: 'Exam language'
  },
  examLanguages: {
    id: 'common.label.examLanguages',
    defaultMessage: 'Exam languages'
  },
  examLength: {
    id: 'common.label.examLength',
    defaultMessage: 'Exam length'
  },
  examName: {
    id: 'common.label.examName',
    defaultMessage: 'Exam name'
  },
  examObjects: {
    id: 'common.label.examObjects',
    defaultMessage: 'Exam objects'
  },
  examOwner: {
    id: 'common.label.examOwner',
    defaultMessage: 'Exam owner'
  },
  examOverview: {
    id: 'common.label.examOverview',
    defaultMessage: 'Exam overview'
  },
  examsScheduled: {
    id: 'common.label.examsScheduled',
    defaultMessage: 'Exams scheduled'
  },
  examsSelected: {
    id: 'common.label.examsSelected',
    defaultMessage: 'Exams selected'
  },
  examWasUnsuccessfullyScheduled: {
    id: 'common.label.ExamWasUnsuccessfullyScheduled',
    defaultMessage: 'The exam was unsuccessfully scheduled'
  },
  examWasSuccessfullyScheduled: {
    id: 'common.label.ExamWasSuccessfullyScheduled',
    defaultMessage: 'The exam was successfully scheduled'
  },
  examSlot: {
    id: 'common.label.examSlot',
    defaultMessage: 'Exam slot'
  },
  examSlots: {
    id: 'common.label.examSlots',
    defaultMessage: 'Exam slots'
  },
  examStatus: {
    id: 'common.label.examStatus',
    defaultMessage: 'Exam status'
  },
  examTags: {
    id: 'common.label.examTags',
    defaultMessage: 'Exam tags'
  },
  examTitle: {
    id: 'common.label.examTitle',
    defaultMessage: 'Exam title'
  },
  examType: {
    id: 'common.label.examType',
    defaultMessage: 'Exam type'
  },
  examTypes: {
    id: 'common.label.examTypes',
    defaultMessage: 'Exam types'
  },
  examRequests: {
    id: 'common.label.examRequests',
    defaultMessage: 'Exam requests'
  },
  externalExamName: {
    id: 'common.label.externalExamName',
    defaultMessage: 'External exam name'
  },
  externalReference: {
    id: 'common.label.externalReference',
    defaultMessage: 'External reference'
  },
  tag: {
    id: 'common.label.tag',
    defaultMessage: 'Tag'
  },
  externalSupervisorBooking: {
    id: 'common.label.externalSupervisorBooking',
    defaultMessage: 'External supervisor booking'
  },
  expired: {
    id: 'common.label.expired',
    defaultMessage: 'Expired'
  },
  eventLog: {
    id: 'common.label.eventLog',
    defaultMessage: 'Event log'
  },
  ascending: {
    id: 'common.label.ascending',
    defaultMessage: 'Ascending'
  },
  descending: {
    id: 'common.label.descending',
    defaultMessage: 'Descending'
  },
  filters: {
    id: 'common.label.filters',
    defaultMessage: 'Filters'
  },
  selectDate: {
    id: 'common.label.selectDate',
    defaultMessage: 'Select date'
  },
  filterItem: {
    id: 'common.label.filterItem',
    defaultMessage: 'Filter {item}'
  },
  firstName: {
    id: 'common.label.firstName',
    defaultMessage: 'First name'
  },
  firstPriority: {
    id: 'common.label.firstPriority',
    defaultMessage: 'First priority'
  },
  floor: {
    id: 'common.label.floor',
    defaultMessage: 'Floor'
  },
  freeTextFields: {
    id: 'common.label.freeTextFields',
    defaultMessage: 'Free text fields'
  },
  gdpr: {
    id: 'common.label.gdpr',
    defaultMessage: 'GDPR'
  },
  greeting: {
    id: 'common.label.greeting',
    defaultMessage: 'Greeting'
  },
  greenRed: {
    id: 'common.label.greenRed',
    defaultMessage: 'Green - Red'
  },
  logout: {
    id: 'common.label.logout',
    defaultMessage: 'Log out'
  },
  redGreen: {
    id: 'common.label.redGreen',
    defaultMessage: 'Red - Green'
  },
  hasExams: {
    id: 'common.label.hasExams',
    defaultMessage: 'Has exams'
  },
  hasExpiredRequests: {
    id: 'common.label.hasExpiredRequests',
    defaultMessage: 'Has expired requests'
  },
  hasNoExams: {
    id: 'common.label.hasNoExams',
    defaultMessage: 'Has no exams'
  },
  hasNoBookings: {
    id: 'common.label.hasNoBookings',
    defaultMessage: 'Has no bookings'
  },
  hasSupervisors: {
    id: 'common.label.hasSupervisors',
    defaultMessage: 'Has supervisors'
  },
  hasBookings: {
    id: 'common.label.hasBookings',
    defaultMessage: 'Has bookings'
  },
  hasNoSupervisors: {
    id: 'common.label.hasNoSupervisors',
    defaultMessage: 'Has no supervisors'
  },
  hasTooFew: {
    id: 'common.label.hasTooFew',
    defaultMessage: 'Has too few'
  },
  hasRightNumber: {
    id: 'common.label.hasRightNumber',
    defaultMessage: 'Has right number'
  },
  hasLink: {
    id: 'common.label.hasLink',
    defaultMessage: 'Has link'
  },
  hours: {
    id: 'common.label.hours',
    defaultMessage: 'Hours'
  },
  id: {
    id: 'common.label.id',
    defaultMessage: 'Id'
  },
  idAndName: {
    id: 'common.label.idAndName',
    defaultMessage: 'Id & name'
  },
  importedToExam: {
    id: 'common.label.importedToExam',
    defaultMessage: 'Imported to exam'
  },
  importedSpecialNeeds: {
    id: 'common.label.importedSpecialNeeds',
    defaultMessage: 'Imported special needs'
  },
  neededSupervisors: {
    id: 'common.label.neededSupervisors',
    defaultMessage: 'Needed supervisors'
  },
  importStatus: {
    id: 'common.label.importStatus',
    defaultMessage: 'Import status'
  },
  info: {
    id: 'common.label.info',
    defaultMessage: 'Info'
  },
  infoField: {
    id: 'common.label.infoField',
    defaultMessage: 'Info field'
  },
  informationToStudents: {
    id: 'common.label.informationToStudents',
    defaultMessage: 'Information to the students'
  },
  informationToSupervisors: {
    id: 'common.label.informationToSupervisors',
    defaultMessage: 'Information to the supervisors'
  },
  informationToAdministrators: {
    id: 'common.label.informationToAdministrators',
    defaultMessage: 'Information to the administrators'
  },
  commentToScheduler: {
    id: 'common.label.commentToScheduler',
    defaultMessage: 'External comment'
  },
  integrationOverview: {
    id: 'common.label.integrationOverview',
    defaultMessage: 'Integration overview'
  },
  interval: {
    id: 'common.label.interval',
    defaultMessage: 'Interval'
  },
  isActive: {
    id: 'common.label.isActive',
    defaultMessage: 'Is active'
  },
  isLead: {
    id: 'common.label.isLead',
    defaultMessage: 'Lead'
  },
  isLead_long: {
    id: 'common.label.isLead_long',
    defaultMessage: 'Is lead'
  },
  isOverbooked: {
    id: 'common.label.isOverbooked',
    defaultMessage: 'Is overbooked'
  },
  isReExam: {
    id: 'common.label.isReExam',
    defaultMessage: 'Is re-exam'
  },
  isReExam_short: {
    id: 'common.label.isReExam_short',
    defaultMessage: 'Make-up'
  },
  isReExam_long: {
    id: 'common.label.isReExam_long',
    defaultMessage: 'Regular or make-up exam'
  },
  isReadonly: {
    id: 'common.label.isReadonly',
    defaultMessage: 'Is readonly'
  },
  itemsSelected: {
    id: 'common.label.itemsSelected',
    defaultMessage: 'Items selected'
  },
  key: {
    id: 'common.label.key',
    defaultMessage: 'Key'
  },
  knowledgeAreas: {
    id: 'common.label.knowledgeAreas',
    defaultMessage: 'Knowledge areas'
  },
  label: {
    id: 'common.label.label',
    defaultMessage: 'Label'
  },
  language: {
    id: 'common.label.language',
    defaultMessage: 'Language'
  },
  lastUpdated: {
    id: 'common.label.lastUpdated',
    defaultMessage: 'Last Updated'
  },
  lastName: {
    id: 'common.label.lastName',
    defaultMessage: 'Last name'
  },
  letUsersAccessTheExamScheduleWithoutStudentId: {
    id: 'common.label.letUsersAccessTheExamScheduleWithoutStudentId',
    defaultMessage: 'Let users access the exam schedule without a student id. A student id is only required to see seat assignment'
  },
  linkedExam: {
    id: 'common.label.linkedExam',
    defaultMessage: 'Linked exam'
  },
  linking: {
    id: 'common.label.linking',
    defaultMessage: 'Linking'
  },
  inboundLinks: {
    id: 'common.label.inboundLinks',
    defaultMessage: 'Inbound links'
  },
  mainSupervisor: {
    id: 'common.label.mainSupervisor',
    defaultMessage: 'Main supervisor'
  },
  mainSupervisor_short: {
    id: 'common.label.mainSupervisor_short',
    defaultMessage: 'Can be lead'
  },
  mainSupervisor_long: {
    id: 'common.label.mainSupervisor_long',
    defaultMessage: 'Certified to lead'
  },
  manageSelection: {
    id: 'common.label.manageSelection',
    defaultMessage: 'Manage selection'
  },
  mandatoryObjects: {
    id: 'common.label.mandatoryObjects',
    defaultMessage: 'Mandatory objects'
  },
  mappedValue: {
    id: 'common.label.mappedValue',
    defaultMessage: 'Mapped value'
  },
  mapping: {
    id: 'common.label.mapping',
    defaultMessage: 'Mapping'
  },
  maxRequestNumber: {
    id: 'common.label.maxRequestNumber',
    defaultMessage: 'Max number of requests'
  },
  minRequestNumber: {
    id: 'common.label.minRequestNumber',
    defaultMessage: 'Min number of requests'
  },
  min: {
    id: 'common.label.min',
    defaultMessage: 'Min'
  },
  max: {
    id: 'common.label.max',
    defaultMessage: 'Max'
  },
  minutes: {
    id: 'common.label.minutes',
    defaultMessage: 'Minutes'
  },
  module: {
    id: 'common.label.module',
    defaultMessage: 'Module'
  },
  modules: {
    id: 'common.label.modules',
    defaultMessage: 'Modules'
  },
  moduleId: {
    id: 'common.label.moduleId',
    defaultMessage: 'Module Id'
  },
  move: {
    id: 'common.label.move',
    defaultMessage: 'moved'
  },
  multipleRoomsSelectedError: {
    id: 'common.label.multipleRoomsSelectedError',
    defaultMessage: 'Multiple rooms are selected, please select one'
  },
  noRoomsAndExamsSelectedNote: {
    id: 'common.label.noRoomsSelectedError',
    defaultMessage: 'Please select a room and exam(s)'
  },
  noRoomsSelectedNote: {
    id: 'common.label.noRoomsSelectedError',
    defaultMessage: 'Please select a room'
  },
  noExamsSelectedNote: {
    id: 'common.label.noExamsSelectedError',
    defaultMessage: 'Please select one or more exams'
  },
  siblingExamScheduleInSameRoomWarning: {
    id: 'common.label.siblingExamScheduleInSameRoomWarning',
    defaultMessage: 'Exams {examIds} are scheduled in the same room.'
  },
  name: {
    id: 'common.label.name',
    defaultMessage: 'Name'
  },
  needsSupervisors: {
    id: 'common.label.needsSupervisors',
    defaultMessage: 'Needs supervisors'
  },
  noEvents: {
    id: 'common.label.noEvents',
    defaultMessage: 'No events'
  },
  notes: {
    id: 'common.label.notes',
    defaultMessage: 'Notes'
  },
  numberOfItem: {
    id: 'common.label.numberOfItem',
    defaultMessage: 'Number of {item}'
  },
  owner: {
    id: 'common.label.owner',
    defaultMessage: 'Owner'
  },
  overview: {
    id: 'common.label.overview',
    defaultMessage: 'Overview'
  },
  otherExamsOnRoomBooking: {
    id: 'common.label.otherExamsOnRoomBooking',
    defaultMessage: 'Other exams on room booking'
  },
  otherEventsOnSameDay: {
    id: 'common.label.otherEventsOnSameDay',
    defaultMessage: 'Other events on the same day'
  },
  pastExams: {
    id: 'common.label.pastExams',
    defaultMessage: 'Past exams'
  },
  pendingHours: {
    id: 'common.label.pendingHours',
    defaultMessage: 'Pending hours'
  },
  pendingBooking: {
    id: 'common.label.pendingBooking',
    defaultMessage: 'Pending booking'
  },
  pendingBookings: {
    id: 'common.label.pendingBookings',
    defaultMessage: 'Pending bookings'
  },
  pendingExams: {
    id: 'common.label.pendingExams',
    defaultMessage: 'Pending exams'
  },
  scheduledStudents: {
    id: 'common.label.scheduledStudents',
    defaultMessage: 'Scheduled students'
  },
  bookedSeats: {
    id: 'common.label.bookedSeats',
    defaultMessage: 'Booked seats'
  },
  phoneNumber1: {
    id: 'common.label.phoneNumber1',
    defaultMessage: 'Phone number 1'
  },
  phoneNumber2: {
    id: 'common.label.phoneNumber2',
    defaultMessage: 'Phone number 2'
  },
  planned: {
    id: 'common.label.planned',
    defaultMessage: 'Planned'
  },
  plannedStudents: {
    id: 'common.label.plannedStudents',
    defaultMessage: 'Planned students'
  },
  plannedStudentsOnSelectedExams: {
    id: 'common.label.plannedStudentsOnSelectedExams',
    defaultMessage: 'Planned students on selected exams'
  },
  postEndTime: {
    id: 'common.label.postEndTime',
    defaultMessage: 'Post end time'
  },
  postEndTime_long: {
    id: 'common.label.postEndTime_long',
    defaultMessage: 'Clean-up end'
  },
  postExamManagement: {
    id: 'common.label.postExamManagement',
    defaultMessage: 'Post exam management'
  },
  preStartTime: {
    id: 'common.label.preStartTime',
    defaultMessage: 'Pre start time'
  },
  preStartTime_long: {
    id: 'common.label.preStartTime_long',
    defaultMessage: 'Prep time starts'
  },
  price: {
    id: 'common.label.price',
    defaultMessage: 'Price'
  },
  pricePerSeatPerHour: {
    id: 'common.label.pricePerSeatPerHour',
    defaultMessage: 'Price per seat per hour'
  },
  pricePerSeatPerHour_short: {
    id: 'common.label.pricePerSeatPerHour_short',
    defaultMessage: 'Price'
  },
  pricePerSeatPerHour_long: {
    id: 'common.label.pricePerSeatPerHour_long',
    defaultMessage: 'Price / seat / hour'
  },
  professor: {
    id: 'common.label.professor',
    defaultMessage: 'Professor'
  },
  professors: {
    id: 'common.label.professors',
    defaultMessage: 'Professors'
  },
  professorId: {
    id: 'common.label.professorId',
    defaultMessage: 'Professor Id'
  },
  publicSchedule: {
    id: 'common.label.publicSchedule',
    defaultMessage: 'Public schedule'
  },
  publicStudentSchedule: {
    id: 'common.label.publicStudentSchedule',
    defaultMessage: 'Public student schedule'
  },
  studentPublicSchedule: {
    id: 'common.label.studentPublicSchedule',
    defaultMessage: 'Student public schedule'
  },
  reassignExamOwner: {
    id: 'common.label.reassignExamOwner',
    defaultMessage: 'Reassign exam owner'
  },
  registered: {
    id: 'common.label.registered',
    defaultMessage: 'Registered'
  },
  registeredStudents: {
    id: 'common.label.registeredStudents',
    defaultMessage: 'Registered students'
  },
  registrationDate: {
    id: 'common.label.registrationDate',
    defaultMessage: 'Registration date'
  },
  requestedDate: {
    id: 'common.label.requestedDate',
    defaultMessage: 'Requested date'
  },
  requestedDuration: {
    id: 'common.label.requestedDuration',
    defaultMessage: 'Requested duration'
  },
  requestedScheduling: {
    id: 'common.label.requestedScheduling',
    defaultMessage: 'Requested scheduling'
  },
  reservationSettings: {
    id: 'common.label.reservationSettings',
    defaultMessage: 'Reservation settings'
  },
  reportFormat: {
    id: 'common.label.reportFormat',
    defaultMessage: 'Report format'
  },
  reportInformation: {
    id: 'common.label.reportInformation',
    defaultMessage: 'Report information'
  },
  reportTemplate: {
    id: 'common.label.reportTemplate',
    defaultMessage: 'Report template'
  },
  pageBreakPerRoomBooking: {
    id: 'common.label.pageBreakPerRoomBooking',
    defaultMessage: 'Page break per room booking'
  },
  role: {
    id: 'common.label.role',
    defaultMessage: 'Role'
  },
  room: {
    id: 'common.label.room',
    defaultMessage: 'Room'
  },
  rooms: {
    id: 'common.label.rooms',
    defaultMessage: 'Rooms'
  },
  roomName: {
    id: 'common.label.roomName',
    defaultMessage: 'Room name'
  },
  roomSeats: {
    id: 'common.label.roomSeats',
    defaultMessage: 'Room seats'
  },
  room_booking: {
    id: 'common.label.roombooking',
    defaultMessage: 'Room booking'
  },
  roomBookings: {
    id: 'common.label.roomBookings',
    defaultMessage: 'Room bookings'
  },
  roomBookingOverview: {
    id: 'common.label.roomBookingOverview',
    defaultMessage: 'Room booking overview'
  },
  roomBookingHours: {
    id: 'common.label.roomBookingHours',
    defaultMessage: 'Room booking hours'
  },
  roomInformation: {
    id: 'common.label.roomInformation',
    defaultMessage: 'Room information'
  },
  roomObjects: {
    id: 'common.label.roomObjects',
    defaultMessage: 'Room objects'
  },
  roomOccupation: {
    id: 'common.label.roomOccupation',
    defaultMessage: 'Room occupation'
  },
  roomsSelected: {
    id: 'common.label.roomSelected',
    defaultMessage: 'Rooms selected'
  },
  roomType: {
    id: 'common.label.roomType',
    defaultMessage: 'Room type'
  },
  roomUtilization: {
    id: 'common.label.roomUtilization',
    defaultMessage: 'Room utilization'
  },
  rule: {
    id: 'common.label.rule',
    defaultMessage: 'Rule'
  },
  saveWithoutSendingEmail: {
    id: 'common.label.saveWithoutSendingEmail',
    defaultMessage: 'Save without sending email'
  },
  schedule: {
    id: 'common.label.schedule',
    defaultMessage: 'Schedule'
  },
  scheduleOneOffSlot: {
    id: 'common.label.scheduleOneOffSlot',
    defaultMessage: 'Schedule with one-off slot'
  },
  schedulePastSupervisor: {
    id: 'common.label.schedulePastSupervisor',
    defaultMessage: 'You are about to schedule a supervisor for a date or time that has already passed, are you sure you want to proceed?'
  },
  scheduledDate: {
    id: 'common.label.scheduledDate',
    defaultMessage: 'Scheduled date'
  },
  scheduledSupervisors: {
    id: 'common.label.scheduledSupervisors',
    defaultMessage: 'Scheduled supervisors'
  },
  scheduledExams: {
    id: 'common.label.scheduledExams',
    defaultMessage: 'Scheduled exams'
  },
  scheduledHours: {
    id: 'common.label.scheduledHours',
    defaultMessage: 'Scheduled hours'
  },
  scheduling: {
    id: 'common.label.scheduling',
    defaultMessage: 'Scheduling'
  },
  schedulingResources: {
    id: 'common.label.resources',
    defaultMessage: 'Resources'
  },
  schedulingPriorities: {
    id: 'common.label.schedulingPriorities',
    defaultMessage: 'Scheduling priorities'
  },
  schedulingStatus: {
    id: 'common.label.schedulingStatus',
    defaultMessage: 'Scheduling status'
  },
  seat: {
    id: 'common.label.seat',
    defaultMessage: 'Seat'
  },
  seatAllocation: {
    id: 'common.label.seatAllocation',
    defaultMessage: 'Seat allocation'
  },
  seatsSelected: {
    id: 'common.label.seatsSelected',
    defaultMessage: 'Seats selected'
  },
  source: {
    id: 'common.label.source',
    defaultMessage: 'Source'
  },
  studentSchedule: {
    id: 'common.label.studentSchedule',
    defaultMessage: 'Student Schedule'
  },
  studentSeatAllocation: {
    id: 'common.label.studentSeatAllocation',
    defaultMessage: 'Student seat allocation'
  },
  seatingInformation: {
    id: 'common.label.seatingInformation',
    defaultMessage: 'Seating information'
  },
  seatingNo: {
    id: 'common.label.seatingNo',
    defaultMessage: 'Seating no.'
  },
  studentSeat: {
    id: 'common.label.studentSeat',
    defaultMessage: 'Student Seat'
  },
  seatingStatus: {
    id: 'common.label.seatingStatus',
    defaultMessage: 'Seating status'
  },
  secondaryLabel: {
    id: 'common.label.secondaryLabel',
    defaultMessage: 'Secondary label'
  },
  selectAll: {
    id: 'common.label.selectAll',
    defaultMessage: 'Select all'
  },
  deselectAll: {
    id: 'common.label.deselectAll',
    defaultMessage: 'Deselect all'
  },
  selectOne: {
    id: 'common.label.selectOne',
    defaultMessage: 'Select one'
  },
  selectExam: {
    id: 'common.label.selectExam',
    defaultMessage: 'Select exam'
  },
  selectChildExam: {
    id: 'common.label.selectChildExam',
    defaultMessage: 'Select child exam'
  },
  selection: {
    id: 'common.label.selection',
    defaultMessage: 'Selection'
  },
  selectItem: {
    id: 'common.label.selectItem',
    defaultMessage: 'Select {item}'
  },
  selectRoom: {
    id: 'common.label.selectRoom',
    defaultMessage: 'Select room'
  },
  selected: {
    id: 'common.label.selected',
    defaultMessage: 'Selected'
  },
  selectedSeries: {
    id: 'common.label.selectedSeries',
    defaultMessage: 'Selected series'
  },
  secondaryAxis: {
    id: 'common.label.secondaryAxis',
    defaultMessage: 'Secondary axis'
  },
  selectedCalendar: {
    id: 'common.label.selectedCalendar',
    defaultMessage: 'Selected calendar'
  },
  selectedItem: {
    id: 'common.label.selectedItem',
    defaultMessage: 'Selected {item}'
  },
  selectedObjects: {
    id: 'common.label.selectedObjects',
    defaultMessage: 'Selected objects'
  },
  selectedTEObjects: {
    id: 'common.label.selectedTEObjects',
    defaultMessage: '# of selected TE objects'
  },
  sendBookingRrequestEmailToDupervisor: {
    id: 'common.label.sendBookingRrequestEmailToDupervisor',
    defaultMessage: 'Send booking request email to supervisor'
  },
  sendToUserOn: {
    id: 'common.label.sendToUserOn',
    defaultMessage: 'Sent to user on'
  },
  sendUpdatedBooking: {
    id: 'common.label.sendUpdatedBooking',
    defaultMessage: 'Send updated booking request'
  },
  setMyselfAsOwner: {
    id: 'common.label.setMyselfAsOwner',
    defaultMessage: 'Set myself as owner'
  },
  showAll: {
    id: 'common.label.showAll',
    defaultMessage: 'Show all'
  },
  showCompatibleRoomBookings: {
    id: 'common.label.showCompatibleRoomBookings',
    defaultMessage: 'Show compatible room bookings'
  },
  showPagination: {
    id: 'common.label.showPagination',
    defaultMessage: 'Show pagination'
  },
  showing: {
    id: 'common.label.showing',
    defaultMessage: 'Showing'
  },
  showPageHeaderOnAllPages: {
    id: 'common.label.showPageHeaderOnAllPages',
    defaultMessage: 'Show page header on all pages'
  },
  slotView: {
    id: 'common.label.slotView',
    defaultMessage: 'Slot view'
  },
  specialNeeds: {
    id: 'common.label.specialNeeds',
    defaultMessage: 'Special needs'
  },
  studentSpecialNeeds: {
    id: 'common.label.studentSpecialNeeds',
    defaultMessage: 'Student special needs'
  },
  specialNeedsAssignment: {
    id: 'common.label.specialNeedsAssignment',
    defaultMessage: 'Special needs assignment'
  },
  search: {
    id: 'common.label.search',
    defaultMessage: 'Search'
  },
  searchAmong: {
    id: 'common.label.searchAmong',
    defaultMessage: 'Search among'
  },
  searchForGDPR: {
    id: 'common.label.searchForGDPR',
    defaultMessage: 'Search for email, name or personal number'
  },
  searchResult: {
    id: 'common.label.searchResult',
    defaultMessage: 'Search result'
  },
  seeSchedule: {
    id: 'common.label.seeSchedule',
    defaultMessage: 'See schedule'
  },
  settings: {
    id: 'common.label.settings',
    defaultMessage: 'Settings'
  },
  startTime: {
    id: 'common.label.startTime',
    defaultMessage: 'Start time'
  },
  startTime_table: {
    id: 'common.label.startTime_long',
    defaultMessage: 'Exam start time'
  },
  status: {
    id: 'common.label.status',
    defaultMessage: 'Status'
  },
  students: {
    id: 'common.label.students',
    defaultMessage: 'Students'
  },
  studentsSelected: {
    id: 'common.label.studentsSelected',
    defaultMessage: 'Students selected'
  },
  studentAnonymizedCode: {
    id: 'common.label.studentAnonymizedCode',
    defaultMessage: 'Anonymized student code'
  },
  studentId: {
    id: 'common.label.studentId',
    defaultMessage: 'Student Id'
  },
  studentInformation: {
    id: 'common.label.studentInformation',
    defaultMessage: 'Student information'
  },
  studentDistribution: {
    id: 'common.label.studentDistribution',
    defaultMessage: 'Student distribution'
  },
  studentName: {
    id: 'common.label.studentName',
    defaultMessage: 'Student name'
  },
  studentPersonalIdentificationNumber: {
    id: 'common.label.studentPersonalIdentificationNumber',
    defaultMessage: 'Personal identification number'
  },
  studentsPlanned: {
    id: 'common.label.studentsPlanned',
    defaultMessage: 'Planned number of students'
  },
  studentsRegistered: {
    id: 'common.label.studentsRegistered',
    defaultMessage: 'Students registered'
  },
  studentRegistration: {
    id: 'common.label.studentRegistration',
    defaultMessage: 'Student registration'
  },
  supervisor: {
    id: 'common.label.supervisor',
    defaultMessage: 'Supervisor'
  },
  supervisorBooking: {
    id: 'common.label.supervisorBooking',
    defaultMessage: 'Supervisor booking'
  },
  supervisorCalendar: {
    id: 'common.label.supervisorCalendar',
    defaultMessage: 'Supervisor calendar'
  },
  supervisorHours: {
    id: 'common.label.supervisorHours',
    defaultMessage: 'Supervisor hours'
  },
  scheduleSupervisors: {
    id: 'common.label.scheduleSupervisors',
    defaultMessage: 'Schedule supervisors'
  },
  supervisorInformation: {
    id: 'common.label.supervisorInformation',
    defaultMessage: 'Supervisor information'
  },
  supervisors: {
    id: 'common.label.supervisors',
    defaultMessage: 'Supervisors'
  },
  supervisorsAccepted: {
    id: 'common.label.supervisorsAccepted',
    defaultMessage: 'Supervisors accepted'
  },
  supervisorsScheduled: {
    id: 'common.label.supervisorsScheduled',
    defaultMessage: 'Supervisors scheduled'
  },
  supervisorsSelected: {
    id: 'common.label.supervisorsSelected',
    defaultMessage: 'Supervisors selected'
  },
  supervisorsNeeded: {
    id: 'common.label.supervisorsNeeded',
    defaultMessage: 'Supervisors needed'
  },
  swithRoomBookingMode: {
    id: 'common.label.swithRoomBookingMode',
    defaultMessage: 'Switch to room booking'
  },
  roomBooking: {
    id: 'common.label.roomBooking',
    defaultMessage: 'Room booking'
  },
  roomBookingCalendar: {
    id: 'common.label.roomBookingCalendar',
    defaultMessage: 'Room booking calendar'
  },
  targetDate: {
    id: 'common.label.targetDate',
    defaultMessage: 'Target date'
  },
  templateName: {
    id: 'common.label.templateName',
    defaultMessage: 'Template name'
  },
  teExamRooms: {
    id: 'common.label.teExamRooms',
    defaultMessage: 'TE Exam Rooms'
  },
  teExam: {
    id: 'common.label.teExam',
    defaultMessage: 'TE Exam'
  },
  teCore: {
    id: 'common.label.teCore',
    defaultMessage: 'TE Core'
  },
  teExtId: {
    id: 'common.label.teExtId',
    defaultMessage: 'TE ExtId'
  },
  teExtId_short: {
    id: 'common.label.teExtId_short',
    defaultMessage: 'ExtId'
  },
  theSupervisorWillReceiveAnEmail: {
    id: 'common.label.theSupervisorWillReceiveAnEmail',
    defaultMessage: 'The supervisor(s) will receive an email asking them to confirm the booking. You can choose to send this email now by checking the checkbox below, or later from the booked supervisors table.'
  },
  theWorkingHoursForOneOrSevaralSupervisor: {
    id: 'common.label.theWorkingHoursForOneOrSevaralSupervisor',
    defaultMessage: 'The working hours for one or sevaral supervisor(s) have been updated, do you wish to send an updated booking request to the concerned supervisor(s)?'
  },
  thisExamIsLinkedFrom: {
    id: 'common.label.thisExamIsLinkedFrom',
    defaultMessage: 'This exam is linked from'
  },
  thisExamIsLinkedTo: {
    id: 'common.label.thisExamIsLinkedTo',
    defaultMessage: 'This exam is linked to'
  },
  time: {
    id: 'common.label.time',
    defaultMessage: 'Time'
  },
  timeline: {
    id: 'common.label.timeline',
    defaultMessage: 'Timeline'
  },
  timeEditObjects: {
    id: 'common.label.timeEditObjects',
    defaultMessage: 'TimeEdit Objects'
  },
  timing: {
    id: 'common.label.timing',
    defaultMessage: 'Timing'
  },
  totalCapacity: {
    id: 'common.label.totalCapacity',
    defaultMessage: 'Total capacity'
  },
  totalStudentsAllocated: {
    id: 'common.label.totalStudentsAllocated',
    defaultMessage: 'Total students allocated'
  },
  totalStudentsPlanned: {
    id: 'common.label.totalStudentsPlanned',
    defaultMessage: 'Total students planned'
  },
  totalStudentsRegistered: {
    id: 'common.label.totalStudentsRegistered',
    defaultMessage: 'Total students registered'
  },
  totalRequestedHours: {
    id: 'common.label.totalRequestedHours',
    defaultMessage: 'Total requested hours'
  },
  totalAcceptedHours: {
    id: 'common.label.totalAcceptedHours',
    defaultMessage: 'Total accepted hours'
  },
  toStudents: {
    id: 'common.label.toStudents',
    defaultMessage: 'To students'
  },
  toSupervisors: {
    id: 'common.label.toSupervisors',
    defaultMessage: 'To supervisors'
  },
  toAdministrators: {
    id: 'common.label.toAdministrators',
    defaultMessage: 'To administrators'
  },
  priorities: {
    id: 'common.label.priorities',
    defaultMessage: 'Priorities'
  },
  type: {
    id: 'common.label.type',
    defaultMessage: 'Type'
  },
  typeId: {
    id: 'common.label.typeId',
    defaultMessage: 'Type Id'
  },
  updated: {
    id: 'common.label.updated',
    defaultMessage: 'Updated'
  },
  declineUpdatedRequest: {
    id: 'common.label.updatedRequest',
    defaultMessage: 'Decline updated request'
  },
  confirmUpdatedRequest: {
    id: 'common.label.confirmUpdatedRequest',
    defaultMessage: 'Confirm updated request'
  },
  updatedBookingRequest: {
    id: 'common.label.updatedBookingRequest',
    defaultMessage: 'Updated booking request'
  },
  useIntervals: {
    id: 'common.label.useIntervals',
    defaultMessage: 'Use intervals'
  },
  utilization: {
    id: 'common.label.utilization',
    defaultMessage: 'Utilization'
  },
  value: {
    id: 'common.label.value',
    defaultMessage: 'Value'
  },
  valueFormat: {
    id: 'common.label.valueFormat',
    defaultMessage: 'Value format'
  },
  view: {
    id: 'common.label.view',
    defaultMessage: 'View'
  },
  viewRoomBookingDetails: {
    id: 'common.label.viewRoomBookingDetails',
    defaultMessage: 'View room booking details'
  },
  dueDate: {
    id: 'common.label.dueDate',
    defaultMessage: 'Due date'
  },
  viewIn: {
    id: 'common.label.viewIn',
    defaultMessage: 'View in ...'
  },
  visible: {
    id: 'common.label.visible',
    defaultMessage: 'Visible'
  },
  viewMode: {
    id: 'common.label.viewMode',
    defaultMessage: 'View mode'
  },
  users: {
    id: 'common.label.users',
    defaultMessage: 'Users'
  },
  username: {
    id: 'common.label.username',
    defaultMessage: 'Username'
  },
  isAllocated: {
    id: 'common.label.isAllocated',
    defaultMessage: 'Is allocated'
  },
  allocationStatus: {
    id: 'common.label.allocationStatus',
    defaultMessage: 'Allocation status'
  },
  postExamNotes: {
    id: 'common.label.postExamNotes',
    defaultMessage: 'Post exam notes'
  },
  roomBookingId: {
    id: 'common.label.roomBookingId',
    defaultMessage: 'Room booking id'
  },
  registeredExam: {
    id: 'common.label.registeredExam',
    defaultMessage: 'Registered exam'
  },
  allocatedExam: {
    id: 'common.label.allocatedExam',
    defaultMessage: 'Allocated exam'
  },
  allocatedStudents: {
    id: 'common.label.allocatedStudents',
    defaultMessage: 'Allocated students'
  },
  blank: {
    id: 'common.label.blank',
    defaultMessage: 'Blank'
  },
  bookingRequests: {
    id: 'common.label.bookingRequests',
    defaultMessage: 'Booking requests'
  },
  bookingRequestExpires: {
    id: 'common.label.bookingRequestExpires',
    defaultMessage: 'Booking request expires'
  },
  title: {
    id: 'common.label.title',
    defaultMessage: 'Title'
  },
  width: {
    id: 'common.label.width',
    defaultMessage: 'Width'
  },
  remove: {
    id: 'common.label.remove',
    defaultMessage: 'Remove'
  },
  removeRoom: {
    id: 'common.label.removeRoom',
    defaultMessage: 'Remove room'
  },
  sortBy: {
    id: 'common.label.sortBy',
    defaultMessage: 'Sort by'
  },
  sortByPrimary: {
    id: 'common.label.sortByPrimary',
    defaultMessage: 'Sort by primary'
  },
  sortBySecondary: {
    id: 'common.label.sortBySecondary',
    defaultMessage: 'Sort by secondary'
  },
  reportType: {
    id: 'common.label.reportType',
    defaultMessage: 'Report Type'
  },
  orientation: {
    id: 'common.label.orientation',
    defaultMessage: 'Orientation'
  },
  portrait: {
    id: 'common.label.portrait',
    defaultMessage: 'Portrait'
  },
  landscape: {
    id: 'common.label.landscape',
    defaultMessage: 'Landscape'
  },
  pageBreak: {
    id: 'common.label.pageBreak',
    defaultMessage: 'Page break'
  },
  noPageBreak: {
    id: 'common.label.noPageBreak',
    defaultMessage: 'No page break'
  },
  pendingRequests: {
    id: 'common.label.pendingRequests',
    defaultMessage: 'Pending requests'
  },
  perExam: {
    id: 'common.label.perExam',
    defaultMessage: 'Per exam'
  },
  perRoom: {
    id: 'common.label.perRoom',
    defaultMessage: 'Per room'
  },
  freeText: {
    id: 'common.label.freeText',
    defaultMessage: 'Free text'
  },
  filterBookings: {
    id: 'common.label.filterBookings',
    defaultMessage: 'Filter bookings'
  },
  usePrintDate: {
    id: 'common.label.usePrintDate',
    defaultMessage: 'Use print date'
  },
  relations: {
    id: 'common.label.relations',
    defaultMessage: 'Relations'
  },
  reportTemplateSettings: {
    id: 'common.label.reportTemplateSettings',
    defaultMessage: 'Report template settings'
  },
  pageHeaderSettings: {
    id: 'common.label.pageHeaderSettings',
    defaultMessage: 'Page header settings'
  },
  personalNumber: {
    id: 'common.label.personalNumber',
    defaultMessage: 'Personal number'
  },
  pleaseEnterAStudentId: {
    id: 'common.label.pleaseEnterAStudentId',
    defaultMessage: 'Please enter a student id'
  },
  pleaseConfirmYouWantToReschedule: {
    id: 'common.label.pleaseConfirmYouWantToReschedule',
    defaultMessage: 'Please confirm you want to reschedule'
  },
  itemCompleted: {
    id: 'common.label.itemCompleted',
    defaultMessage: '{item} completed'
  },
  examDateAndStartTime: {
    id: 'common.label.examDateAndStartTime',
    defaultMessage: 'Exam date & start time'
  },
  examDateAndEndTime: {
    id: 'common.label.examDateAndEndTime',
    defaultMessage: 'Exam date & end time'
  },
  workHours: {
    id: 'common.label.workHours',
    defaultMessage: 'Work hours'
  },
  workingHours: {
    id: 'common.label.workingHours',
    defaultMessage: 'Working hours'
  },
  yourWorkHours: {
    id: 'common.label.yourWorkHours',
    defaultMessage: 'Your work hours'
  },
  deSelectAll: {
    id: 'common.label.deSelectAll',
    defaultMessage: 'DeselectAll'
  },
  weekOf: {
    id: 'common.label.weekOf',
    defaultMessage: 'Week of'
  },
  unableScheduleSupervisor: {
    id: 'common.label.unableScheduleSupervisor',
    defaultMessage: 'Unable to schedule supervisor'
  },
  unableScheduleSupervisorDesc: {
    id: 'common.label.unableScheduleSupervisorDesc',
    defaultMessage: 'The supervisor is not available in the selected time and day.'
  },
  ok: {
    id: 'common.label.ok',
    defaultMessage: 'Ok'
  }
});
var label = messages$7;

var messages$6 = defineMessages({
  unscheduled: {
    id: 'common.message.unscheduled',
    defaultMessage: 'unscheduled'
  },
  onlyAvailableForScheduledExam: {
    id: 'common.message.onlyAvailableForScheduledExam',
    defaultMessage: 'Only available for scheduled exam'
  },
  mayNotBeSaved: {
    id: 'common.message.mayNotBeSaved',
    defaultMessage: 'There are changes made to the scheduling priorities which are not saved, are you sure you want to leave the page?'
  },
  atLeastSchedulingPriority: {
    id: 'common.message.atLeastSchedulingPriority',
    defaultMessage: 'To save your exam request, please add at least {priorityNumber, plural, one {# scheduling priority} other {# scheduling priorities}}'
  },
  invalidPriorities: {
    id: 'common.message.invalidPriorities',
    defaultMessage: 'There are invalid priorities'
  },
  prioritiesHaveError: {
    id: 'common.message.prioritiesHaveError',
    defaultMessage: 'The following errors are stopping you from saving'
  },
  actionCannotUndoneWarning: {
    id: 'common.message.actionCannotUndoneWarning',
    defaultMessage: 'This action can not be undone'
  },
  confirmAllocation: {
    id: 'common.message.confirmAllocation',
    defaultMessage: 'Confirm allocation for {number} student'
  },
  confirmDeleteRoomBooking: {
    id: 'common.message.confirmDeleteRoomBooking',
    defaultMessage: 'Are you sure you want to delete room booking on {date} in {room}?'
  },
  confirmDeleteRoomBookings: {
    id: 'common.message.confirmDeleteRoomBookings',
    defaultMessage: 'Are you sure you want to delete selected room bookings?'
  },
  confirmDeleteRoomBookingContent: {
    id: 'common.message.confirmDeleteRoomBookingContent',
    defaultMessage: 'All exams, supervisors and students scheduled and allocated on the room booking will be removed from them.'
  },
  confirmProceed: {
    id: 'common.message.confirmProceed',
    defaultMessage: 'Are you sure you want to proceed?'
  },
  checklistNeedTitle: {
    id: 'common.message.checklistNeedTitle',
    defaultMessage: "You can't mark it as done before you've given it a title"
  },
  deleteItemConfirm: {
    id: 'common.message.deleteItemConfirm',
    defaultMessage: 'Are you sure you want to delete this {item}?'
  },
  examInformationLocked: {
    id: 'common.message.examInformationLocked',
    defaultMessage: 'Exam information is locked'
  },
  examInformationLockedDesc: {
    id: 'common.message.examInformationLockedDesc',
    defaultMessage: 'Editing the basic information is not possible after the exam has been saved'
  },
  examInformationCancelledLockedDesc: {
    id: 'common.message.examInformationCancelledLockedDesc',
    defaultMessage: 'Editing the basic information is not possible after is cancelled'
  },
  examHasPast: {
    id: 'common.message.examHasPast',
    defaultMessage: 'Exam has past'
  },
  examHasPastDesc: {
    id: 'common.message.examHasPastDesc',
    defaultMessage: 'Scheduling or basic information cannot be edited'
  },
  examNamingOptional: {
    id: 'common.message.examNamingOptional',
    defaultMessage: 'Naming your exam is optional, you can always refer to it by its ID'
  },
  infoToAdministratorsNotice: {
    id: 'common.message.infoToAdministratorsNotice',
    defaultMessage: 'Only administrators and the exam owner will see this'
  },
  commentToSchedulerNotice: {
    id: 'common.message.commentToSchedulerNotice',
    defaultMessage: 'This comment will be visible in TimeEdit'
  },
  loadingIndicator: {
    id: 'common.message.loadingIndicator',
    defaultMessage: 'TE Exam loading indicator'
  },
  makeTheBookingVisibleToSupervisor: {
    id: 'common.message.makeTheBookingVisibleToSupervisor',
    defaultMessage: 'Make booking request visible to supervisor'
  },
  noExamScheduled: {
    id: 'common.message.noExamScheduled',
    defaultMessage: 'No exams have been scheduled on this room booking'
  },
  noFilter: {
    id: 'common.message.noFilter',
    defaultMessage: 'You have not added any filters yet'
  },
  noItemSelected: {
    id: 'common.message.noItemSelected',
    defaultMessage: 'No {item} has been selected'
  },
  nothingSelected: {
    id: 'common.message.nothingSelected',
    defaultMessage: 'Nothing has been selected'
  },
  successAdjustItem: {
    id: 'common.message.successAdjustItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} adjusted successfully'
  },
  successActivateItem: {
    id: 'common.message.successActivateItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} activated successfully'
  },
  successAllocateItem: {
    id: 'common.message.successAllocateItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} allocated successfully'
  },
  successAssignItem: {
    id: 'common.message.successAssignItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} assigned successfully'
  },
  successBookRoom: {
    id: 'common.message.successBookRoom',
    defaultMessage: 'Your room was successfully booked'
  },
  successConfirmItem: {
    id: 'common.message.successConfirmItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} confirmed successfully'
  },
  successCreateItem: {
    id: 'common.message.successCreateItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} created successfully'
  },
  successDeactivateItem: {
    id: 'common.message.successDeactivateItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} deactivated successfully'
  },
  successDeallocateItem: {
    id: 'common.message.successDeallocateItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} deallocated successfully'
  },
  successDeleteItem: {
    id: 'common.message.successDeleteItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} deleted successfully'
  },
  successImportItem: {
    id: 'common.message.successImportItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} imported successfully'
  },
  successOperate: {
    id: 'common.message.successOperate',
    defaultMessage: 'Operation was successful'
  },
  successRemoveItem: {
    id: 'common.message.successRemoveItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} removed successfully'
  },
  successCloneItem: {
    id: 'common.message.successCloneItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} cloned successfully'
  },
  successSaveItem: {
    id: 'common.message.successSaveItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} saved successfully'
  },
  successSendEmail: {
    id: 'common.message.successSendEmail',
    defaultMessage: 'The email was sent successfully'
  },
  successCancelBookingForSupervisor: {
    id: 'common.message.successCancelBookingForSupervisor',
    defaultMessage: 'The bookings was cancelled successfully'
  },
  successDeclineBookingForSupervisor: {
    id: 'common.message.successDeclineBookingForSupervisor',
    defaultMessage: 'The bookings was declined successfully'
  },
  successAcceptBookingForSupervisor: {
    id: 'common.message.successAcceptBookingForSupervisor',
    defaultMessage: 'The bookings was accepted successfully'
  },
  successMoveRoomBooking: {
    id: 'common.message.successMoveRoomBooking',
    defaultMessage: 'Your room was successfully moved to another slot'
  },
  successMoveExamsToRoomBooking: {
    id: 'common.message.successMoveExamsToRoomBooking',
    defaultMessage: 'The exams were successfully moved to another room booking'
  },
  successMoveSupervisorsToRoomBooking: {
    id: 'common.message.successMoveSupervisorsToRoomBooking',
    defaultMessage: 'The supervisors were successfully moved to another room booking'
  },
  successPublishedExamsMessage: {
    id: 'common.message.successPublishedExams',
    defaultMessage: 'Published exam successfully'
  },
  successSendEmails: {
    id: 'common.message.successSendEmails',
    defaultMessage: '{number} emails were sent successfully'
  },
  successSendNoEmails: {
    id: 'common.message.successSendNoEmails',
    defaultMessage: 'No emails were sent'
  },
  successSubmitItem: {
    id: 'common.message.successSubmitItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} submitted successfully'
  },
  successUpdateItem: {
    id: 'common.message.successUpdateItem',
    defaultMessage: 'The {item} {multi, select, true {were} false {was}} updated successfully'
  },
  successUpdateSupervisorsNeed: {
    id: 'common.message.successUpdateSupervisorsNeed',
    defaultMessage: 'Supervisors needed was updated'
  },
  errorSendEmails: {
    id: 'common.message.errorSendEmails',
    defaultMessage: '{number} emails were unable to send'
  },
  useThisButtonToSaveChanges: {
    id: 'common.message.useThisButtonToSaveChanges',
    defaultMessage: 'Use this button to save changes to the supervisors work hours and main supervisor'
  },
  sendConfirmationEmailsToSupervisors: {
    id: 'common.message.SendConfirmationEmailsToSupervisors',
    defaultMessage: 'Send confirmation emails to supervisors'
  },
  thisWillSendABookingConfirmationEmail: {
    id: 'common.message.thisWillSendABookingConfirmationEmail',
    defaultMessage: 'This will send a booking confirmation email to all supervisors on the selected room bookings who have not yet received an email and have not yet confirmed the request. Do you wish to proceed?'
  },
  confirmDeleteReportingTemplate: {
    id: 'common.message.confirmDeleteReportingTemplate',
    defaultMessage: 'You are about to delete this report template, are you sure you want to proceed?'
  }
});
var message = messages$6;

var messages$5 = defineMessages({
  availability: {
    id: 'common.model.availability',
    defaultMessage: 'availability'
  },
  booking: {
    id: 'common.model.booking',
    defaultMessage: 'booking'
  },
  bookingRequest: {
    id: 'common.model.bookingRequest',
    defaultMessage: 'booking request'
  },
  campus: {
    id: 'common.model.campus',
    defaultMessage: 'campus'
  },
  checklist: {
    id: 'common.model.checklist',
    defaultMessage: 'checklist'
  },
  childExam: {
    id: 'common.model.childExam',
    defaultMessage: 'child exam'
  },
  column: {
    id: 'common.model.column',
    defaultMessage: 'column'
  },
  comment: {
    id: 'common.model.comment',
    defaultMessage: 'comment'
  },
  costCenters: {
    id: 'common.model.costCenters',
    defaultMessage: 'Cost centers'
  },
  courses: {
    id: 'common.model.courses',
    defaultMessage: 'courses'
  },
  courseEvents: {
    id: 'common.model.courseEvents',
    defaultMessage: 'course events'
  },
  departments: {
    id: 'common.model.departments',
    defaultMessage: 'departments'
  },
  exam: {
    id: 'common.model.exam',
    defaultMessage: 'exam'
  },
  exams: {
    id: 'common.model.exams',
    defaultMessage: 'exams'
  },
  examLanguage: {
    id: 'common.model.examLanguage',
    defaultMessage: 'exam language'
  },
  examRequest: {
    id: 'common.model.examRequest',
    defaultMessage: 'exam request'
  },
  examSlot: {
    id: 'common.model.examSlot',
    defaultMessage: 'exam slot'
  },
  examSlots: {
    id: 'common.model.examSlots',
    defaultMessage: 'exam slots'
  },
  examType: {
    id: 'common.model.examType',
    defaultMessage: 'exam type'
  },
  examTypes: {
    id: 'common.model.examTypes',
    defaultMessage: 'exam types'
  },
  externalBooking: {
    id: 'common.model.externalBooking',
    defaultMessage: 'external booking'
  },
  filter: {
    id: 'common.model.filter',
    defaultMessage: 'filter'
  },
  item: {
    id: 'common.model.item',
    defaultMessage: 'item'
  },
  interval: {
    id: 'common.model.interval',
    defaultMessage: 'interval'
  },
  knowledgeArea: {
    id: 'common.model.knowledgeArea',
    defaultMessage: 'knowledge area'
  },
  knowledgeAreas: {
    id: 'common.model.knowledgeAreas',
    defaultMessage: 'knowledge areas'
  },
  language: {
    id: 'common.model.language',
    defaultMessage: 'language'
  },
  languages: {
    id: 'common.model.languages',
    defaultMessage: 'languages'
  },
  linkedExam: {
    id: 'common.model.linkedExam',
    defaultMessage: 'linked exam'
  },
  modules: {
    id: 'common.model.modules',
    defaultMessage: 'modules'
  },
  postExamNotes: {
    id: 'common.model.postExamNotes',
    defaultMessage: 'post exam notes'
  },
  professors: {
    id: 'common.model.professors',
    defaultMessage: 'professors'
  },
  room: {
    id: 'common.model.room',
    defaultMessage: 'room'
  },
  rooms: {
    id: 'common.model.rooms',
    defaultMessage: 'rooms'
  },
  roomBooking: {
    id: 'common.model.roomBooking',
    defaultMessage: 'room booking'
  },
  objects: {
    id: 'common.model.objects',
    defaultMessage: 'objects'
  },
  scheduling: {
    id: 'common.model.scheduling',
    defaultMessage: 'scheduling'
  },
  schedulingRequest: {
    id: 'common.model.schedulingRequests',
    defaultMessage: 'scheduling request'
  },
  specialNeed: {
    id: 'common.model.specialNeed',
    defaultMessage: 'special need'
  },
  specialNeeds: {
    id: 'common.model.specialNeeds',
    defaultMessage: 'special needs'
  },
  supervisor: {
    id: 'common.model.supervisor',
    defaultMessage: 'supervisor'
  },
  student: {
    id: 'common.model.student',
    defaultMessage: 'student'
  },
  registeredStudents: {
    id: 'common.model.registeredStudents',
    defaultMessage: 'registered students'
  },
  supervisors: {
    id: 'common.model.supervisors',
    defaultMessage: 'supervisors'
  },
  timeInterval: {
    id: 'common.model.timeInterval',
    defaultMessage: 'time interval'
  },
  timeIntervals: {
    id: 'common.model.timeIntervals',
    defaultMessage: 'time intervals'
  },
  user: {
    id: 'common.model.user',
    defaultMessage: 'user'
  },
  users: {
    id: 'common.model.users',
    defaultMessage: 'users'
  },
  value: {
    id: 'common.model.value',
    defaultMessage: 'value'
  },
  template: {
    id: 'common.model.template',
    defaultMessage: 'template'
  },
  row: {
    id: 'common.model.row',
    defaultMessage: 'row'
  }
});
var model = messages$5;

var messages$4 = {
  adjustPlannedStudents: defineMessages({
    adjustPlannedStudentsMessage: {
      id: 'pages.adjustPlannedStudents.alert.adjustPlannedStudents.message',
      defaultMessage: 'Adjust planned students'
    },
    adjustPlannedStudentsDescription1: {
      id: 'pages.adjustPlannedStudents.alert.adjustPlannedStudents.description.1',
      defaultMessage: 'Decrease or increase the number of planned students to free up unused seats or if the exam is over registered.'
    },
    adjustPlannedStudentsDescription2: {
      id: 'pages.adjustPlannedStudents.alert.adjustPlannedStudents.description.2',
      defaultMessage: 'The edited value have to be greater or equal to registered or allocated students respectively.'
    }
  }),
  exam: defineMessages({
    redirectedOnCancelledExamMessage: {
      id: 'pages.examDetail.message.redirectedOnCancelledExam.message',
      defaultMessage: 'Redirected to exam list.'
    },
    redirectedOnCancelledExamDescription: {
      id: 'pages.examDetail.message.redirectedOnCancelledExam.description',
      defaultMessage: 'You can not view nor edit an exam that has been cancelled. Please uncancell it first.'
    },
    redirectedToParentExamMessage: {
      id: 'pages.examDetail.message.redirectedToParentExam.message',
      defaultMessage: 'Redirected to parent exam'
    },
    redirectedToParentExamDescription: {
      id: 'pages.examDetail.message.redirectedToParentExam.description',
      defaultMessage: 'The exam you clicked on is a child exam, you have been redirected to the main exam'
    },
    registeredStudentsText: {
      id: 'pages.examDetailInformationTab.text.registeredStudents',
      defaultMessage: '{studentsRegistered} students'
    },
    publishedExamSuccessMessage: {
      id: 'pages.exam.message.publishedExamSuccess',
      defaultMessage: 'Published exam {examId} successfully'
    },
    publishedExamFailureMessage: {
      id: 'pages.exam.message.publishedExamFailure',
      defaultMessage: 'Published exam {examId} unsuccessfully'
    },
    showRelationsLabel: {
      id: 'pages.exam.label.showRelations',
      defaultMessage: 'Show relations'
    }
  }),
  examOverview: defineMessages({
    selectExamToPublish: {
      id: 'pages.examOverview.selectExamToPublish',
      defaultMessage: 'Select exams to publish'
    },
    selectExamToDepublish: {
      id: 'pages.examOverview.selectExamToDepublish',
      defaultMessage: 'Select exams to depublish'
    },
    selectExamToCancel: {
      id: 'pages.examOverview.selectExamToCancel',
      defaultMessage: 'Select exams to cancel'
    }
  }),
  examBatchImport: defineMessages({
    selectFileTitle: {
      id: 'pages.examBatchImport.title.selectFile',
      defaultMessage: 'Batch import exams: Select file to import (1/3)'
    },
    reviewTitle: {
      id: 'pages.examBatchImport.title.review',
      defaultMessage: 'Batch import exams: Make sure everything looks good (2/3)'
    },
    resultsTitle: {
      id: 'pages.examBatchImport.title.results',
      defaultMessage: 'Batch import exams: Results from the import (3/3)'
    },
    downloadImportTemplateButton: {
      id: 'pages.examBatchImport.button.downloadImportTemplate',
      defaultMessage: 'Download import template'
    },
    saveImportButton: {
      id: 'pages.examBatchImport.button.saveImport',
      defaultMessage: 'Save import'
    },
    clearDataButton: {
      id: 'pages.examBatchImport.button.clearData',
      defaultMessage: 'Clear data'
    },
    importAnotherFileButton: {
      id: 'pages.examBatchImport.button.importAnotherFile',
      defaultMessage: 'Import another file'
    }
  }),
  examExport: defineMessages({
    selectExamToExportLabel: {
      id: 'pages.examExport.label.selectExamToExport',
      defaultMessage: 'Select exams to export'
    },
    examsSelectedLabel: {
      id: 'pages.examExport.label.examsSelected',
      defaultMessage: 'Exams selected'
    }
  }),
  examExportSettings: defineMessages({
    exportSettingsPanel: {
      id: 'pages.examExportSettings.panel.exportSettings',
      defaultMessage: 'Export settings'
    },
    billingReportSettingsCard: {
      id: 'pages.examExportSettings.card.billingReportSettings',
      defaultMessage: 'Billing report settings'
    },
    includeExamOverviewLabel: {
      id: 'pages.examExportSettings.label.includeExamOverview',
      defaultMessage: 'Include exam overview'
    },
    includeSchedulingPrioritiesLabel: {
      id: 'pages.examExportSettings.label.includeSchedulingPrioritiesLabel',
      defaultMessage: 'Include scheduling priorities'
    },
    includeSchedulingInformationLabel: {
      id: 'pages.examExportSettings.label.includeSchedulingInformation',
      defaultMessage: 'Include scheduling information'
    },
    includeBillingInformationLabel: {
      id: 'pages.examExportSettings.label.includeBillingInformation',
      defaultMessage: 'Include billing information'
    },
    selectedStudentMetricLabel: {
      id: 'pages.examExportSettings.label.selectedStudentMetric',
      defaultMessage: 'Selected student metric'
    },
    distributeUnderutilizationLabel: {
      id: 'pages.examExportSettings.label.distributeUnderutilization',
      defaultMessage: 'Distribute underutilization'
    },
    includePrepAndCleanUpTimeLabel: {
      id: 'pages.examExportSettings.label.includePrepAndCleanUpTime',
      defaultMessage: 'Include prep and clean-up time'
    },
    includePostExamNotesLabel: {
      id: 'pages.examExportSettings.label.includePostExamNotes',
      defaultMessage: 'Include post exam notes'
    }
  }),
  examSeatAllocationTab: defineMessages({
    selectionOverflowMessage: {
      id: 'pages.examSeatAllocationTab.alert.selectionOverflow.message',
      defaultMessage: 'Not Enough Available Seats'
    },
    selectionOverflowDescription: {
      id: 'pages.examSeatAllocationTab.alert.selectionOverflow.description',
      defaultMessage: 'You have selected more students than there are available seats, and thus seat assignment is cannot be provided. Select fewer students or reschedule to a room bigger room.'
    },
    overbookedRoomMessage: {
      id: 'pages.examSeatAllocationTab.alert.overbookedRoom.message',
      defaultMessage: 'Overbooked Room'
    },
    overbookedRoomDescription: {
      id: 'pages.examSeatAllocationTab.alert.overbookedRoom.description',
      defaultMessage: 'This exam is scheduled on an overbooked room, and thus seat assignment cannot be provided'
    },
    confirmOverbookTitle: {
      id: 'pages.examSeatAllocationTab.message.confirmOverbook.title',
      defaultMessage: 'Confirm overbooking'
    },
    confirmOverbookContent: {
      id: 'pages.examSeatAllocationTab.message.confirmOverbook.content',
      defaultMessage: 'You are allocating more students than there is capacity on the room. This means seating numbers will not be available. Are you sure you want to continue?'
    },
    seatsLeftLabel: {
      id: 'pages.examSeatAllocationTab.label.seatsLeft',
      defaultMessage: 'Seats left'
    },
    seatingRangeLabel: {
      id: 'pages.examSeatAllocationTab.label.seatingRange',
      defaultMessage: 'Seating range'
    },
    manageSelectionLabel: {
      id: 'pages.examSeatAllocationTab.label.manageSelection',
      defaultMessage: 'Manage selection'
    },
    allocateSelectedStudentsButton: {
      id: 'pages.examSeatAllocationTab.button.allocateSelectedStudents',
      defaultMessage: 'Allocate selected students'
    },
    deallocateSelectedStudentsButton: {
      id: 'pages.examSeatAllocationTab.button.deallocateSelectedStudents',
      defaultMessage: 'Deallocate selected students'
    },
    selectUnallocatedOption: {
      id: 'pages.examSeatAllocationTab.option.examSelection.selectUnallocated',
      defaultMessage: 'Select unallocated'
    },
    selectAllocatedOption: {
      id: 'pages.examSeatAllocationTab.option.examSelection.selectAllocated',
      defaultMessage: 'Select allocated'
    },
    selectFromTopOption: {
      id: 'pages.examSeatAllocationTab.option.examSelection.selectFromTop',
      defaultMessage: 'Select from top'
    },
    selectFromBottomOption: {
      id: 'pages.examSeatAllocationTab.option.examSelection.selectFromBottom',
      defaultMessage: 'Select from bottom'
    },
    selectFromRandomOption: {
      id: 'pages.examSeatAllocationTab.option.examSelection.selectFromRandom',
      defaultMessage: 'Select from random'
    },
    removeSelection: {
      id: 'pages.examSeatAllocationTab.option.examSelection.removeSelection',
      defaultMessage: 'Remove selection'
    },
    examDateHasPassedMessage: {
      id: 'pages.examSeatAllocationTab.alert.examDateHasPassed.message',
      defaultMessage: 'Exam date has passed'
    },
    examDateHasPassedDescription: {
      id: 'pages.examSeatAllocationTab.alert.examDateHasPassed.description',
      defaultMessage: 'The exam date has passed, and registered students cannot be changed'
    },
    registrationOverflowMessage: {
      id: 'pages.examSeatAllocationTab.alert.registrationOverflow.message',
      defaultMessage: 'Too Many Registered Students'
    },
    registrationOverflowDescription: {
      id: 'pages.examSeatAllocationTab.alert.registrationOverflow.description',
      defaultMessage: 'The exam has more registered than planned students. Increase the number of planned students or remove registered students.'
    },
    seatAllocationIncompleteMessage: {
      id: 'pages.examSeatAllocationTab.alert.seatAllocationIncomplete.message',
      defaultMessage: 'Seat allocation incomplete'
    },
    seatAllocationIncompleteDescription: {
      id: 'pages.examSeatAllocationTab.alert.seatAllocationIncomplete.description',
      defaultMessage: 'Not all registered students have been allocated a seat on the exam yet'
    },
    totalRegisterStudentsLabel: {
      id: 'pages.examSeatAllocationTab.label.totalRegisterStudents',
      defaultMessage: 'Total registered students'
    },
    specialNeedsStudentsLabel: {
      id: 'pages.examSeatAllocationTab.label.specialNeedsStudents',
      defaultMessage: 'Number of students with special needs'
    },
    studentsLeftToAllocateLabel: {
      id: 'pages.examSeatAllocationTab.label.studentsLeftToAllocate',
      defaultMessage: 'Students left to allocate'
    },
    studentsToAllocateLabel: {
      id: 'pages.examSeatAllocationTab.label.studentsToAllocate',
      defaultMessage: 'Number of students to allocate'
    },
    allocateStudentsButton: {
      id: 'pages.examSeatAllocationTab.button.allocateStudents',
      defaultMessage: 'Allocate students'
    },
    useStandardAllocationLabel: {
      id: 'pages.examSeatAllocationTab.label.useStandardAllocation',
      defaultMessage: 'Use standard student allocation for this exam'
    },
    useStandardAllocationDesc: {
      id: 'pages.examSeatAllocationTab.label.useStandardAllocation.description',
      defaultMessage: 'This will make it possible to upload a student registration list and allocate individual students, as well as assign special needs.'
    }
  }),
  examSetting: defineMessages({
    listHeader: {
      id: 'pages.examSetting.mandatoryList.header',
      defaultMessage: 'Configure which objects are mandatory in exams'
    },
    departmentDescription: {
      id: 'pages.examSetting.mandatoryList.departmentDescription',
      defaultMessage: 'A value indicating if, and / or which, special need the student is authorized for'
    },
    labelEnabled: {
      id: 'pages.examSetting.mandatoryList.label.enabled',
      defaultMessage: 'Enabled'
    },
    labelIsMandatory: {
      id: 'pages.examSetting.mandatoryList.label.isMandatory',
      defaultMessage: 'Is mandatory'
    },
    labelAllowMultiple: {
      id: 'pages.examSetting.mandatoryList.label.allowMultiple',
      defaultMessage: 'Allow multiple'
    },
    labelShouldPublish: {
      id: 'pages.examSetting.mandatoryList.label.shouldPublish',
      defaultMessage: 'Publish to TE Server'
    },
    minMandatoryObjectToPublishError: {
      id: 'pages.examSetting.mandatoryList.error.minMandatoryObjectToPublish',
      defaultMessage: 'You need at least 1 object designated as mandatory to publish to TE Server'
    },
    otherCustomizationsTab: {
      id: 'pages.examSetting.tab.otherCustomizations',
      defaultMessage: 'Other customizations'
    },
    otherCustomizationsDesc: {
      id: 'pages.examSetting.examCustomizations.description',
      defaultMessage: 'Create certain customizations'
    },
    examTitleInstructionTitle: {
      id: 'pages.examSetting.examCustomizations.examTitleInstruction.title',
      defaultMessage: 'Exam title instruction'
    },
    examTitleInstructionDesc: {
      id: 'pages.examSetting.examCustomizations.examTitleInstruction.description',
      defaultMessage: 'An instruction for what to enter as the exam title on an exam request'
    },
    supervisorBookingExpirationDaysTitle: {
      id: 'pages.examSetting.examCustomizations.supervisorBookingExpirationDays.title',
      defaultMessage: 'Supervisor booking request deadline'
    },
    supervisorBookingExpirationDaysDesc: {
      id: 'pages.examSetting.examCustomizations.supervisorBookingExpirationDays.description',
      defaultMessage: 'Default number of days for the supervisor to answer to a booking request'
    },
    supervisorsNeededsDesc: {
      id: 'pages.examSetting.examCustomizations.supervisorsNeededsDesc.description',
      defaultMessage: 'Set the default number of supervisors needed for any room booking'
    },
    supervisorsNeededsTitle: {
      id: 'pages.examSetting.examCustomizations.supervisorsNeededsTitle.description',
      defaultMessage: 'Number of supervisors needed'
    },
    allowManagerToPublishTitle: {
      id: 'pages.examSetting.examCustomizations.allowManagerToPublishTitle.description',
      defaultMessage: 'Allow Exam Manager to publish exams'
    },
    allowManagerToPublishDesc: {
      id: 'pages.examSetting.examCustomizations.allowManagerToPublishDesc.description',
      defaultMessage: 'Enable this option if you wish to enable feature publish exams to Exam Managers'
    },
    defaultChecklistTitle: {
      id: 'pages.examSetting.examCustomizations.defaultChecklistTitle.description',
      defaultMessage: 'Use default checklist'
    },
    defaultChecklistDesc: {
      id: 'pages.examSetting.examCustomizations.defaultChecklistDesc.description',
      defaultMessage: 'Enable the option if you wish to configure a default checklist for exam requests'
    },
    labelShouldPublishToStudentSchedule: {
      id: 'pages.examSettings.labelShouldPublishToStudentSchedule',
      defaultMessage: 'Publish to student’s schedule'
    }
  }),
  examSlotDetail: defineMessages({
    readonlyMessage: {
      id: 'pages.examSlotDetail.readonly.message',
      defaultMessage: 'Exam Slot Time is Locked'
    },
    readonlyDescription: {
      id: 'pages.examSlotDetail.readonly.description',
      defaultMessage: 'This exam slot has rooms booked on it, and therefore the time cannot be changed'
    },
    deletePopoverTitle: {
      id: 'pages.examSlotDetail.deletePopover.title',
      defaultMessage: 'Are you sure you want to deactivate this exam slot?'
    }
  }),
  examsOnRoomBookingWrapper: defineMessages({
    header: {
      id: 'pages.public.examsOnRoomBookingWrapper.header',
      defaultMessage: 'The following exams are scheduled on the room booking'
    }
  }),
  examSpecialNeedsTab: defineMessages({
    confirmRemovalTitle: {
      id: 'pages.examSpecialNeedsTab.modal.confirmRemoval.title',
      defaultMessage: 'Confirm removal'
    },
    confirmRemovalContent: {
      id: 'pages.examSpecialNeedsTab.modal.confirmRemoval.content',
      defaultMessage: 'Assigned special needs for {selectedNumber} will be removed'
    },
    examDateHasPassedMessage: {
      id: 'pages.examSpecialNeedsTab.alert.examDateHasPassed.message',
      defaultMessage: 'Exam date has passed'
    },
    examDateHasPassedDescription: {
      id: 'pages.examSpecialNeedsTab.alert.examDateHasPassed.description',
      defaultMessage: 'The exam date has passed, and registered students cannot be changed'
    },
    removeSpecialNeedsForSelectionButton: {
      id: 'pages.examSpecialNeedsTab.button.removeSpecialNeedsForSelection',
      defaultMessage: 'Remove special needs for selection'
    }
  }),
  homeSupervisor: defineMessages({
    currentBookings: {
      id: 'pages.homeSupervisor.tab.currentBookings',
      defaultMessage: 'Current bookings'
    },
    pastBookingsTab: {
      id: 'pages.homeSupervisor.tab.pastBookingsTab',
      defaultMessage: 'Past bookings'
    }
  }),
  integrationSettings: defineMessages({
    listHeader: {
      id: 'pages.integrationSettings.integrationList.header',
      defaultMessage: 'Configure which objects are mandatory in exams'
    },
    dangerZoneMessage: {
      id: 'pages.integrationSettings.dangerZoneAlert.message',
      defaultMessage: 'Danger zone'
    },
    dangerZoneDescription: {
      id: 'pages.integrationSettings.dangerZoneAlert.description',
      defaultMessage: 'Editing properties here can break your connection with the TimeEdit server. Proceed with caution'
    },
    baseUrlTitle: {
      id: 'pages.integrationSettings.integrationList.baseUrl.title',
      defaultMessage: 'Base URL'
    },
    baseUrlDescription: {
      id: 'pages.integrationSettings.integrationList.baseUrl.description',
      defaultMessage: 'The URL TE Exam should use to connect to the TimeEdit server'
    },
    usernameTitle: {
      id: 'pages.integrationSettings.integrationList.username.title',
      defaultMessage: 'Username'
    },
    usernameDescription: {
      id: 'pages.integrationSettings.integrationList.username.description',
      defaultMessage: 'The username TE Exam should use to authenticate with the TimeEdit server'
    },
    passwordTitle: {
      id: 'pages.integrationSettings.integrationList.password.title',
      defaultMessage: 'Password'
    },
    passwordDescription: {
      id: 'pages.integrationSettings.integrationList.password.description',
      defaultMessage: 'The password TE Exam should use to authenticate with the TimeEdit server'
    },
    certificateKeyTitle: {
      id: 'pages.integrationSettings.integrationList.certificateKey.title',
      defaultMessage: 'Certificate key'
    },
    certificateKeyDescription: {
      id: 'pages.integrationSettings.integrationList.certificateKey.description',
      defaultMessage: 'The certificate key TE Exam should use to authenticate with the TimeEdit server'
    },
    selectedTEObjectsContent: {
      id: 'pages.integrationSettings.content.selectedTEObjects',
      defaultMessage: '{objectNumber} objects'
    }
  }),
  listStudents: defineMessages({
    removeSelectedStudentsButton: {
      id: 'pages.listStudents.button.removeSelectedStudents',
      defaultMessage: 'Remove selected students'
    },
    adjustPlannedStudentsButton: {
      id: 'pages.listStudents.button.adjustPlannedStudents',
      defaultMessage: 'Adjust planned students'
    },
    confirmRemovalTitle: {
      id: 'pages.listStudents.modal.confirmRemoval.title',
      defaultMessage: 'Confirm removal'
    },
    confirmRemovalContent: {
      id: 'pages.listStudents.modal.confirmRemoval.content',
      defaultMessage: '{selectedNumber} students will be removed'
    },
    examDateHasPassedMessage: {
      id: 'pages.listStudents.alert.examDateHasPassed.message',
      defaultMessage: 'Exam date has passed'
    },
    examDateHasPassedDescription: {
      id: 'pages.listStudents.alert.examDateHasPassed.description',
      defaultMessage: 'The exam date has passed, and registered students cannot be changed'
    },
    registrationOverflowMessage: {
      id: 'pages.listStudents.alert.registrationOverflow.message',
      defaultMessage: 'Registration overflow'
    },
    registrationOverflowDescription: {
      id: 'pages.listStudents.alert.registrationOverflow.description',
      defaultMessage: 'The exam has more registered than planned students, either update planned students or remove registered students'
    },
    studentRegistrationIncompleteMessage: {
      id: 'pages.listStudents.alert.studentRegistrationIncomplete.message',
      defaultMessage: 'Student registration incomplete'
    },
    studentRegistrationIncompleteDescription: {
      id: 'pages.listStudents.alert.studentRegistrationIncomplete.description',
      defaultMessage: 'The exam has fewer registered than planned students, either update planned students or add more registered students'
    },
    studentRegistrationCompleteMessage: {
      id: 'pages.listStudents.alert.studentRegistrationComplete.message',
      defaultMessage: 'Student registration complete'
    },
    studentRegistrationCompleteDescription: {
      id: 'pages.listStudents.alert.studentRegistrationComplete.description',
      defaultMessage: 'Planned and registered students match'
    }
  }),
  postExamManagementTab: defineMessages({
    generalExamNotesPanel: {
      id: 'pages.postExamManagementTab.panel.generalExamNotes',
      defaultMessage: 'General exam notes'
    },
    studentNotesPanel: {
      id: 'pages.postExamManagementTab.panel.studentNotes',
      defaultMessage: 'Student notes'
    },
    billingReportPanel: {
      id: 'pages.postExamManagementTab.panel.billingReport',
      defaultMessage: 'Billing report'
    },
    studentMetricLabel: {
      id: 'pages.postExamManagementTab.label.studentMetric',
      defaultMessage: 'Student metric'
    },
    distributeUnderUtilizationLabel: {
      id: 'pages.postExamManagementTab.label.distributeUnderUtilization',
      defaultMessage: 'Distribute under utilization'
    },
    includePrepAndCleanUpTimeLabel: {
      id: 'pages.postExamManagementTab.label.includePrepAndCleanUpTime',
      defaultMessage: 'Include prep and clean-up time in billing'
    },
    billingViewLabel: {
      id: 'pages.postExamManagementTab.label.billingView',
      defaultMessage: 'Billing view'
    },
    attendingStudentsLabel: {
      id: 'pages.postExamManagementTab.label.attendingStudents',
      defaultMessage: 'Number of students attending the exam'
    },
    overviewGroup: {
      id: 'pages.postExamManagementTab.group.overview',
      defaultMessage: 'Overview'
    },
    examViewGroup: {
      id: 'pages.postExamManagementTab.group.examView',
      defaultMessage: 'Exam view'
    }
  }),
  propertySelectionPane: defineMessages({
    header: {
      id: 'pages.propertySelectionPane.header',
      defaultMessage: 'Edit import mapping settings'
    },
    customizePropertiesMessage: {
      id: 'pages.propertySelectionPane.message.customizeProperties',
      defaultMessage: 'Customize the properties you want to use to parse each object type. The import results will update in realtime'
    }
  }),
  roomBooking: defineMessages({
    alertOverbookedMessage: {
      id: 'pages.roomBooking.alert.overbooked.message',
      defaultMessage: 'Overbooked room'
    },
    alertOverbookedDescription: {
      id: 'pages.roomBooking.alert.overbooked.description',
      defaultMessage: 'This room booking is overbooked, and thus allocated students will not be given seat assignments on the exams.'
    },
    alertOverbookedToChange: {
      id: 'pages.roomBooking.alert.overbooked.toChange',
      defaultMessage: 'To change this, please remove exams or adjust the planned students.'
    },
    selectBookingsToExportLabel: {
      id: 'pages.roomBooking.label.selectBookingsToExport',
      defaultMessage: 'Select room bookings to export'
    },
    selectBookingsToDeleteLabel: {
      id: 'pages.roomBooking.label.selectBookingsToDelete',
      defaultMessage: 'Select room bookings to delete'
    }
  }),
  schedulingPrioritiesSettingList: defineMessages({
    listHeader: {
      id: 'pages.examSettings.schedulingPrioritiesSettingList.header',
      defaultMessage: 'Configure how scheduling priorities are used'
    },
    numberOfRequestTitle: {
      id: 'pages.examSettings.schedulingPrioritiesList.numberOfRequests.title',
      defaultMessage: 'Number of requests'
    },
    numberOfRequestDescription: {
      id: 'pages.examSettings.schedulingPrioritiesList.numberOfRequests.description',
      defaultMessage: 'The number of scheduling priorities a user is allowed to submit'
    },
    intervalsOrExamSlotsTitle: {
      id: 'pages.examSettings.schedulingPrioritiesList.intervalsOrExamSlots.title',
      defaultMessage: 'Intervals or exam slots'
    },
    intervalsOrExamSlotsDescription: {
      id: 'pages.examSettings.schedulingPrioritiesList.intervalsOrExamSlots.description',
      defaultMessage: 'If the user should use exam slots or predefined time intervals to prioritize their time preferences'
    },
    allowParamPrioritizationTitle: {
      id: 'pages.examSettings.schedulingPrioritiesList.allowParamPrioritization.title',
      defaultMessage: 'Allow {param} prioritization'
    },
    allowDatePrioritizationDescription: {
      id: 'pages.examSettings.schedulingPrioritiesList.allowDatePrioritization.description',
      defaultMessage: 'Should the user be allowed to add a date to their priorities'
    },
    allowRoomPrioritizationDescription: {
      id: 'pages.examSettings.schedulingPrioritiesList.allowRoomPrioritization.description',
      defaultMessage: 'Should the user be allowed to add a room to their priorities'
    },
    allowIntervalOrSlotPrioritizationDescription: {
      id: 'pages.examSettings.schedulingPrioritiesList.allowIntervalOrSlotPrioritization.description',
      defaultMessage: 'Should the user be allowed to supply a time preference with their priorities'
    }
  }),
  studentSettings: defineMessages({
    listHeader: {
      id: 'pages.studentSettings.editMappingList.header',
      defaultMessage: 'Configure how TE Exam parses student registration files'
    },
    studentIdDescription: {
      id: 'pages.studentSettings.editMappingList.studentIdDescription',
      defaultMessage: "A unique student identifier used for seat allocation and locating a student's schedule"
    },
    studentNameDescription: {
      id: 'pages.studentSettings.editMappingList.studentNameDescription',
      defaultMessage: 'The name of the student'
    },
    studentSeatDescription: {
      id: 'pages.studentSettings.editMappingList.studentSeatDescription',
      defaultMessage: 'Select if you want the seat to be shown on the student’s schedule'
    },
    studentAnonymizedCodeToggleDescription: {
      id: 'pages.studentSettings.editMappingList.studentAnonymizedCodeToggleDescription',
      defaultMessage: 'Select if you want the anonymized code to be shown on the student’s schedule'
    },
    studentAnonymizedCodeDescription: {
      id: 'pages.studentSettings.editMappingList.studentAnonymizedCodeDescription',
      defaultMessage: 'An anonymous code used to identify students'
    },
    studentPersonalIdentificationNumberDescription: {
      id: 'pages.studentSettings.editMappingList.studentPersonalIdentificationNumberDescription',
      defaultMessage: "A student's personal identification number"
    },
    registrationDateDescription: {
      id: 'pages.studentSettings.editMappingList.registrationDateDescription',
      defaultMessage: 'A timestamp indicating when the student registered for the exam'
    },
    externalExamNameDescription: {
      id: 'pages.studentSettings.editMappingList.externalExamNameDescription',
      defaultMessage: 'A string indicating the name of the exam in Ladok'
    },
    specialNeedsAssignmentDescription: {
      id: 'pages.studentSettings.editMappingList.specialNeedsAssignmentDescription',
      defaultMessage: 'A value indicating if, and / or which, special need the student is authorized for'
    },
    instructionTitle: {
      id: 'pages.studentSettings.registrationMappingInstruction.title',
      defaultMessage: 'Student registration mapping'
    },
    instructionContent: {
      id: 'pages.studentSettings.registrationMappingInstruction.content',
      defaultMessage: 'Adjust how the Ladok files are used in mangaging the registered students for each exam.'
    },
    studentRegistrationMappingHeader: {
      id: 'pages.studentSettings.header.studentRegistrationMapping',
      defaultMessage: 'Student registration mapping'
    },
    dropFilePlaceholder: {
      id: 'pages.studentSettings.upload.dropFilePlaceholder',
      defaultMessage: 'Drop an export file from Ladok here to start the configuration.'
    },
    studentIdLabelDescription: {
      id: 'pages.studentSettings.message.studentIdLabelDescription',
      defaultMessage: '(Seen by students on the student registration page)'
    },
    simpleStudentAllocationLabel: {
      id: 'pages.studentSettings.simpleStudentAllocation.label',
      defaultMessage: 'Enable simple student allocation'
    },
    simpleStudentAllocationDescription: {
      id: 'pages.studentSettings.simpleStudentAllocation.description',
      defaultMessage: 'This will replace the option to upload a student registration list with a number input field to enter the number of students to allocate. It will limit the option to allocate individual students to certain seats and to assign special needs.'
    }
  }),
  studentSeatingInformation: defineMessages({
    studentAvatarLabel: {
      id: 'pages.studentSeatingInformation.label.studentAvatar',
      defaultMessage: 'Student avatar'
    },
    addToCalendarButtonTitle: {
      id: 'pages.studentSeatingInformation.addToCalendarButton.title',
      defaultMessage: 'Exam: {exam}'
    },
    addToCalendarButtonDescription: {
      id: 'pages.studentSeatingInformation.addToCalendarButton.description',
      defaultMessage: 'Seating id: {seatingId}. Seating info: {seatingInfo}'
    }
  }),
  supervisorSchedulingRequest: defineMessages({
    invalidRequestError: {
      id: 'pages.supervisorSchedulingRequest.error.invalidRequest',
      defaultMessage: 'Invalid Request'
    },
    requestNotExistError: {
      id: 'pages.supervisorSchedulingRequest.error.requestNotExist',
      defaultMessage: 'Your request does not exist'
    },
    requestAcceptedError: {
      id: 'pages.supervisorSchedulingRequest.error.requestAccepted',
      defaultMessage: 'Your request has been accepted. You cannot modify it.'
    },
    requestDeclinedError: {
      id: 'pages.supervisorSchedulingRequest.error.requestDeclined',
      defaultMessage: 'Your request has been declined. You cannot change it.'
    },
    requestAcceptedMessage: {
      id: 'pages.supervisorSchedulingRequest.message.requestAccepted',
      defaultMessage: 'Your request has been accepted'
    },
    requestDeclinedMessage: {
      id: 'pages.supervisorSchedulingRequest.message.requestDeclined',
      defaultMessage: 'Your request has been declined'
    }
  }),
  uploadFile: defineMessages({
    dropFileHereMessage: {
      id: 'pages.uploadFile.message.dropFileHere',
      defaultMessage: 'Drop your file here or click to browse your files to start the import.'
    }
  }),
  uploadStudent: defineMessages({
    dropFileMessage: {
      id: 'pages.uploadStudent.message.dropFile',
      defaultMessage: 'Drop your file here to import the registered students.'
    },
    reviewResultMessage: {
      id: 'pages.uploadStudent.message.reviewResult',
      defaultMessage: 'Please review the import results below'
    },
    totalStudentsLabel: {
      id: 'pages.uploadStudent.label.totalStudents',
      defaultMessage: 'Total students'
    },
    studentsEligibleForImportLabel: {
      id: 'pages.uploadStudent.label.studentsEligibleForImport',
      defaultMessage: 'Students eligible for import'
    },
    removeDuplicateStudentsButton: {
      id: 'pages.uploadStudent.button.removeDuplicateStudents',
      defaultMessage: 'Remove duplicate students'
    },
    importRegisteredStudentsButton: {
      id: 'pages.uploadStudent.button.importRegisteredStudents',
      defaultMessage: 'Import registered students'
    }
  }),
  validationSummary: defineMessages({
    errorMessage: {
      id: 'pages.validationSummary.message.error.message',
      defaultMessage: 'Heads up!'
    },
    errorDescription: {
      id: 'pages.validationSummary.message.error.description',
      defaultMessage: 'We found {errorNumber} errors and {warningNumber} warnings with your import'
    },
    successMessage: {
      id: 'pages.validationSummary.message.success.message',
      defaultMessage: 'All good!'
    },
    successDescription: {
      id: 'pages.validationSummary.message.success.description',
      defaultMessage: 'Your import has no errors or warnings'
    }
  }),
  teIntegration: defineMessages({
    applyChangesWarning: {
      id: 'pages.teIntegration.message.applyChangesWarning',
      defaultMessage: 'Click here to update the TEX room objects with new values from TE Server, e.g., if the data has been changed in TE Server, or if the mapping has been updated'
    },
    applyChangesButton: {
      id: 'pages.teIntegration.button.applyChanges',
      defaultMessage: 'Apply changes'
    }
  }),
  publicExamStudentScheduleWrapper: defineMessages({
    initialLoadingErrorTitle: {
      id: 'pages.public.examStudentScheduleWrapper.error.initialLoading.title',
      defaultMessage: 'Ooops! Something looks off with your link.'
    },
    initialLoadingErrorDescription: {
      id: 'pages.public.examStudentScheduleWrapper.error.initialLoading.description',
      defaultMessage: "We tried our best, but we weren't able to find the organization or the exam."
    },
    examNotScheduledErrorTitle: {
      id: 'pages.public.examStudentScheduleWrapper.error.examNotScheduled.title',
      defaultMessage: "You're fast! Too fast, almost."
    },
    examNotScheduledErrorDescription: {
      id: 'pages.public.examStudentScheduleWrapper.error.examNotScheduled.description',
      defaultMessage: "This exam has not scheduled yet, so we can't give you your schedule right now. Please check back in later."
    },
    notYourScheduleErrorTitle: {
      id: 'pages.public.examStudentScheduleWrapper.error.notYourSchedule.title',
      defaultMessage: 'Found you! But not your schedule :('
    },
    notYourScheduleErrorDescription: {
      id: 'pages.public.examStudentScheduleWrapper.error.notYourSchedule.description',
      defaultMessage: 'Your schedule and seating information has not been determined yet. Please check back later.'
    },
    pastExamErrorTitle: {
      id: 'pages.public.examStudentScheduleWrapper.error.pastExam.title',
      defaultMessage: 'This is a past exam'
    },
    pastExamErrorDescription: {
      id: 'pages.public.examStudentScheduleWrapper.error.pastExam.description',
      defaultMessage: 'Please note that this exam has already taken place.'
    },
    yourAnonymizedCodeLabel: {
      id: 'pages.public.examStudentScheduleWrapper.label.yourAnonymizedCode',
      defaultMessage: 'Your Anonymized Code'
    },
    yourScheduleLabel: {
      id: 'pages.public.examStudentScheduleWrapper.label.yourSchedule',
      defaultMessage: 'Your schedule'
    },
    notesToStudentsLabel: {
      id: 'pages.public.examStudentScheduleWrapper.label.notesToStudents',
      defaultMessage: 'Notes to students'
    },
    noNotesAddedMessage: {
      id: 'pages.public.examStudentScheduleWrapper.message.noNotesAdded',
      defaultMessage: 'No notes have been added'
    }
  }),
  publicReadOnlyExamObjects: defineMessages({
    typeDescription: {
      id: 'pages.public.readOnlyExamObjects.description.type',
      defaultMessage: 'How the exam is given'
    },
    languageDescription: {
      id: 'pages.public.readOnlyExamObjects.description.language',
      defaultMessage: 'Language the exam is given in'
    },
    courseDescription: {
      id: 'pages.public.readOnlyExamObjects.description.courses',
      defaultMessage: 'Courses the exam is offered for'
    },
    courseEventDescription: {
      id: 'pages.public.readOnlyExamObjects.description.courseEvents',
      defaultMessage: 'Course events the exam is offered for'
    },
    moduleDescription: {
      id: 'pages.public.readOnlyExamObjects.description.modules',
      defaultMessage: 'Modules the exam is offered for'
    },
    departmentDescription: {
      id: 'pages.public.readOnlyExamObjects.description.departments',
      defaultMessage: 'Departments offering the exam'
    },
    professorDescription: {
      id: 'pages.public.readOnlyExamObjects.description.professors',
      defaultMessage: 'Professors responsible for the exam'
    }
  }),
  publicStudentSignIn: defineMessages({
    logoAlt: {
      id: 'pages.public.studentSignIn.alt.logoAlt',
      defaultMessage: 'Student login'
    },
    holaText: {
      id: 'pages.public.studentSignIn.text.hola',
      defaultMessage: 'Hola, friend!'
    },
    enterStudentIdText: {
      id: 'pages.public.studentSignIn.text.enterStudentId',
      defaultMessage: 'Enter your student id to locate your exam schedule.'
    },
    unableLocateStudentIdOnExamError: {
      id: 'pages.public.studentSignIn.error.unableLocateStudentIdOnExam',
      defaultMessage: 'We were unable to locate your student id on the exam. Please try again.'
    },
    studentIdRequiredError: {
      id: 'pages.public.studentSignIn.error.studentIdRequired',
      defaultMessage: 'Please input your student id to view your schedule.'
    },
    studentIdPlaceholder: {
      id: 'pages.public.studentSignIn.placeholder.studentId',
      defaultMessage: 'Enter your student id'
    },
    viewYourExamScheduleButton: {
      id: 'pages.public.studentSignIn.button.viewYourExamSchedule',
      defaultMessage: 'View your exam schedule'
    }
  }),
  supervisorOverview: defineMessages({
    selectAll: {
      id: 'pages.supervisorOverview.selections.selectAll',
      defaultMessage: 'Select all'
    },
    selectNone: {
      id: 'pages.supervisorOverview.selections.selectNone',
      defaultMessage: 'Remove selection'
    },
    emailUnsent: {
      id: 'pages.supervisorOverview.selections.emailUnsent',
      defaultMessage: 'Select email "not sent"'
    }
  }),
  supervisorSettings: defineMessages({
    title: {
      id: 'pages.settings.supervisorSettings.title',
      defaultMessage: 'Configure the information visible in the supervisor interface'
    },
    informationAboutOtherSupervisorsTitle: {
      id: 'pages.settings.supervisorSettings.informationAboutOtherSupervisors.title',
      defaultMessage: 'Information about other supervisors'
    },
    informationAboutOtherSupervisorsDescription: {
      id: 'pages.settings.supervisorSettings.informationAboutOtherSupervisors.description',
      defaultMessage: 'Enable if you want the supervisor to see information regarding  other supervisors working in the same room and day'
    }
  })
};
var page = messages$4;

var messages$3 = defineMessages({
  addItem: {
    id: 'common.placeholder.addItem',
    defaultMessage: 'Add {item}...'
  },
  comment: {
    id: 'common.placeholder.comment',
    defaultMessage: 'Type your comment here...'
  },
  untitledExam: {
    id: 'common.placeholder.untitledExam',
    defaultMessage: 'Untitled exam'
  },
  durationHours: {
    id: 'common.placeholder.durationHours',
    defaultMessage: 'Duration hours'
  },
  durationMinutes: {
    id: 'common.placeholder.durationMinutes',
    defaultMessage: 'Duration minutes'
  },
  externalExamReference: {
    id: 'common.placeholder.externalExamReference',
    defaultMessage: 'External exam reference'
  },
  filterItem: {
    id: 'common.placeholder.filterItem',
    defaultMessage: 'Filter {item}'
  },
  filterProperties: {
    id: 'common.placeholder.filterProperties',
    defaultMessage: 'Filter properties...'
  },
  information: {
    id: 'common.placeholder.information',
    defaultMessage: 'Comments, permitted resources, ..'
  },
  notAssigned: {
    id: 'common.placeholder.notAssigned',
    defaultMessage: 'Not assigned'
  },
  noItem: {
    id: 'common.placeholder.noItem',
    defaultMessage: 'No {item}'
  },
  pleaseSelectItem: {
    id: 'common.placeholder.pleaseSelectItem',
    defaultMessage: 'Please select {item}'
  },
  search: {
    id: 'common.placeholder.search',
    defaultMessage: 'Search...'
  },
  searchItem: {
    id: 'common.placeholder.searchItem',
    defaultMessage: 'Search {item}'
  },
  select: {
    id: 'common.placeholder.select',
    defaultMessage: 'Select...'
  },
  selectItem: {
    id: 'common.placeholder.selectItem',
    defaultMessage: 'Select {item}'
  },
  selectCategory: {
    id: 'common.placeholder.selectCategory',
    defaultMessage: 'Select a category'
  },
  selectProperty: {
    id: 'common.placeholder.selectProperty',
    defaultMessage: 'Select a property'
  },
  selectFilterRule: {
    id: 'common.placeholder.selectFilterRule',
    defaultMessage: 'Select a filter rule'
  },
  typeToEdit: {
    id: 'common.placeholder.typeToEdit',
    defaultMessage: 'Type to edit me...'
  }
});
var placeholder = messages$3;

var messages$2 = defineMessages({
  confirm: {
    id: 'common.title.common.confirm',
    defaultMessage: 'Confirm'
  },
  confirmation: {
    id: 'common.title.common.confirmation',
    defaultMessage: 'Confirmation'
  },
  overview: {
    id: 'common.title.common.overview',
    defaultMessage: 'Overview'
  },
  publish: {
    id: 'common.title.common.publish',
    defaultMessage: 'Publish Exams'
  },
  overviewOfItem: {
    id: 'common.title.common.overviewOfItem',
    defaultMessage: 'Overview of {item}'
  },
  itemOverview: {
    id: 'common.title.common.itemOverview',
    defaultMessage: '{item} overview'
  },
  dashboardOverview: {
    id: 'common.title.common.dashboardOverview',
    defaultMessage: 'Dashboard overview'
  },
  addNewItem: {
    id: 'common.title.common.addNewItem',
    defaultMessage: 'Add new {item}'
  },
  newItem: {
    id: 'common.title.common.newItem',
    defaultMessage: 'New {item}'
  },
  editItem: {
    id: 'common.title.common.editItem',
    defaultMessage: 'Edit {item}'
  },
  myAvailability: {
    id: 'common.title.myAvailability',
    defaultMessage: 'My availability'
  },
  availability: {
    id: 'common.title.availability',
    defaultMessage: 'Availability'
  },
  home: {
    id: 'common.title.home',
    defaultMessage: 'Home'
  },
  examSlots: {
    id: 'common.title.examSlots',
    defaultMessage: 'Exam slots'
  },
  createExamSlot: {
    id: 'common.title.examSlots.create',
    defaultMessage: 'New exam slot'
  },
  bookings: {
    id: 'common.title.bookings',
    defaultMessage: 'Room bookings'
  },
  bookingDetail: {
    id: 'common.title.bookings.detail',
    defaultMessage: 'Booking on {date} in {room}'
  },
  createExam: {
    id: 'common.title.exams.create',
    defaultMessage: 'New exam'
  },
  updateExam: {
    id: 'common.title.exams.update',
    defaultMessage: 'Id #{id}'
  },
  exportExam: {
    id: 'common.title.exams.export',
    defaultMessage: 'Export Exams'
  },
  batchImportExam: {
    id: 'common.title.exams.batchImport',
    defaultMessage: 'Batch import'
  },
  allRooms: {
    id: 'common.title.allRooms',
    defaultMessage: 'All rooms'
  },
  scheduling: {
    id: 'common.menu.scheduling',
    defaultMessage: 'Scheduling'
  },
  teIntegration: {
    id: 'common.menu.teIntegration',
    defaultMessage: 'TE Integration'
  },
  examScheduling: {
    id: 'common.title.scheduling',
    defaultMessage: 'Scheduling {exam, select, NONE {} other {for {exam}}}'
  },
  requestedScheduling: {
    id: 'common.title.scheduling.requested',
    defaultMessage: 'Requested scheduling for {exam}'
  },
  settings: {
    id: 'common.title.settings',
    defaultMessage: 'Settings'
  },
  integrationSettings: {
    id: 'common.title.settings.teIntegration',
    defaultMessage: 'TimeEdit integration'
  },
  userSettings: {
    id: 'common.title.settings.users',
    defaultMessage: 'Users'
  },
  profile: {
    id: 'common.title.settings.profile',
    defaultMessage: 'Profile'
  },
  examSettings: {
    id: 'common.title.settings.exams',
    defaultMessage: 'Exam settings'
  },
  timeIntervalsSettings: {
    id: 'common.title.settings.time-intervals',
    defaultMessage: 'Time intervals'
  },
  studentRegistrationSettings: {
    id: 'common.menu.settings.students',
    defaultMessage: 'Student registration'
  },
  studentSettings: {
    id: 'common.title.settings.students',
    defaultMessage: 'Student registration mapping'
  },
  languageSettings: {
    id: 'common.title.settings.languages',
    defaultMessage: 'Languages'
  },
  publicStudentSchedule: {
    id: 'common.title.public.studentSchedule',
    defaultMessage: 'Student schedule'
  },
  roomBooking: {
    id: 'common.title.roomBooking',
    defaultMessage: 'Room booking in {room} on {date} between {startTime} and {endTime}'
  },
  roomBookingInRoom: {
    id: 'common.title.roomBookingInRoom',
    defaultMessage: 'Room booking in {room}'
  },
  supervisorBookingInRoom: {
    id: 'common.title.supervisorBookingInRoom',
    defaultMessage: 'Booking of {supervisor} in {room}'
  },
  supervisorExternalBookingInRoom: {
    id: 'common.title.supervisorExternalBookingInRoom',
    defaultMessage: 'External booking by {supervisor}'
  },
  leavePage: {
    id: 'common.title.leavePage',
    defaultMessage: 'Leave page?'
  },
  reportingTemplates: {
    id: 'common.title.reportingTemplates',
    defaultMessage: 'Reporting templates'
  },
  newReportingTemplate: {
    id: 'common.title.newReportingTemplate',
    defaultMessage: 'New reporting template'
  }
});
var title = messages$2;

var messages$1 = {
  allocationStatus: defineMessages({
    allocated: {
      id: 'common.valueLabel.allocationStatus.allocated',
      defaultMessage: 'Allocated'
    },
    notAllocated: {
      id: 'common.valueLabel.allocationStatus.notAllocated',
      defaultMessage: 'Not allocated'
    }
  }),
  allowIntervalOrSlotParam: defineMessages({
    interval: {
      id: 'common.valueLabel.allowIntervalOrSlotParam.interval',
      defaultMessage: 'Interval'
    },
    slot: {
      id: 'common.valueLabel.allowIntervalOrSlotParam.slot',
      defaultMessage: 'Slot'
    }
  }),
  bookingStatus: defineMessages({
    pending: {
      id: 'common.valueLabel.bookingStatus.pending',
      defaultMessage: 'Pending'
    },
    accepted: {
      id: 'common.valueLabel.bookingStatus.accepted',
      defaultMessage: 'Accepted'
    },
    declined: {
      id: 'common.valueLabel.bookingStatus.declined',
      defaultMessage: 'Declined'
    },
    scheduled: {
      id: 'common.valueLabel.bookingStatus.scheduled',
      defaultMessage: 'Scheduled'
    },
    expired: {
      id: 'common.valueLabel.bookingStatus.expired',
      defaultMessage: 'Expired'
    },
    cancelled: {
      id: 'common.valueLabel.bookingStatus.cancelled',
      defaultMessage: 'Cancelled'
    }
  }),
  boolean: defineMessages({
    yes: {
      id: 'common.valueLabel.boolean.yes',
      defaultMessage: 'Yes'
    },
    no: {
      id: 'common.valueLabel.boolean.no',
      defaultMessage: 'No'
    },
    notYet: {
      id: 'common.valueLabel.boolean.notYet',
      defaultMessage: 'Not yet'
    }
  }),
  emailStatus: defineMessages({
    sent: {
      id: 'common.valueLabel.emailStatus.sent',
      defaultMessage: 'Sent'
    },
    notSent: {
      id: 'common.valueLabel.emailStatus.notSent',
      defaultMessage: 'Not sent'
    }
  }),
  examSchedulingStatus: defineMessages({
    pending: {
      id: 'common.valueLabel.examSchedulingStatus.pending',
      defaultMessage: 'Pending'
    },
    past: {
      id: 'common.valueLabel.examSchedulingStatus.past',
      defaultMessage: 'Past'
    },
    scheduled: {
      id: 'common.valueLabel.examSchedulingStatus.scheduled',
      defaultMessage: 'Scheduled'
    },
    depublished: {
      id: 'common.valueLabel.examSchedulingStatus.depublished',
      defaultMessage: 'Depublished'
    },
    cancelled: {
      id: 'common.valueLabel.examSchedulingStatus.cancelled',
      defaultMessage: 'Cancelled'
    }
  }),
  chartOptions: defineMessages({
    numberOfNeededSupervisors: {
      id: 'common.valueLabel.chartOptions.numberOfNeededSupervisors',
      defaultMessage: 'Needed supervisors'
    },
    numberOfScheduledSupervisors: {
      id: 'common.valueLabel.chartOptions.numberOfScheduledSupervisors',
      defaultMessage: 'Scheduled supervisors'
    },
    numberOfPendingBookings: {
      id: 'common.valueLabel.chartOptions.numberOfPendingBookings',
      defaultMessage: 'Pending bookings'
    },
    numberOfAcceptedBookings: {
      id: 'common.valueLabel.chartOptions.numberOfAcceptedBookings',
      defaultMessage: 'Accepted bookings'
    },
    numberOfSupervisorsAvailable: {
      id: 'common.valueLabel.chartOptions.numberOfSupervisorsAvailable',
      defaultMessage: 'Supervisors available'
    },
    numberOfRoomsBooked: {
      id: 'common.valueLabel.chartOptions.numberOfRoomsBooked',
      defaultMessage: 'Rooms booked'
    },
    numberOfExamRequests: {
      id: 'common.valueLabel.chartOptions.numberOfExamRequests',
      defaultMessage: 'Exam requests'
    },
    numberOfScheduledExams: {
      id: 'common.valueLabel.chartOptions.numberOfScheduledExams',
      defaultMessage: 'Scheduled exams'
    },
    numberOfPlannedStudents: {
      id: 'common.valueLabel.chartOptions.numberOfPlannedStudents',
      defaultMessage: 'Planned students'
    },
    numberOfRegisteredStudents: {
      id: 'common.valueLabel.chartOptions.numberOfRegisteredStudents',
      defaultMessage: 'Registered students'
    },
    numberOfAllocatedStudents: {
      id: 'common.valueLabel.chartOptions.numberOfAllocatedStudents',
      defaultMessage: 'Allocated students'
    },
    scheduledStudents: {
      id: 'common.valueLabel.chartOptions.scheduledStudents',
      defaultMessage: 'Scheduled students'
    },
    bookedSeats: {
      id: 'common.valueLabel.chartOptions.bookedSeats',
      defaultMessage: 'Booked seats'
    }
  }),
  commentScope: defineMessages({
    admin: {
      id: 'common.valueLabel.commentScope.admin',
      defaultMessage: 'Admin'
    },
    administrator: {
      id: 'common.valueLabel.commentScope.administrator',
      defaultMessage: 'Administrator'
    },
    all: {
      id: 'common.valueLabel.commentScope.all',
      defaultMessage: 'All'
    }
  }),
  contractType: defineMessages({
    employee: {
      id: 'common.valueLabel.contractType.employee',
      defaultMessage: 'Employee'
    },
    consultant: {
      id: 'common.valueLabel.contractType.consultant',
      defaultMessage: 'Consultant'
    }
  }),
  dateRange: defineMessages({
    today: {
      id: 'components.dateRange.today',
      defaultMessage: 'Today'
    },
    thisWeek: {
      id: 'components.dateRange.thisWeek',
      defaultMessage: 'This week'
    },
    nextWeek: {
      id: 'components.dateRange.nextWeek',
      defaultMessage: 'Next week'
    },
    thisMonth: {
      id: 'components.dateRange.thisMonth',
      defaultMessage: 'This month'
    },
    nextMonth: {
      id: 'components.dateRange.nextMonth',
      defaultMessage: 'Next month'
    }
  }),
  examStatus: defineMessages({
    notScheduled: {
      id: 'common.valueLabel.examStatus.notScheduled',
      defaultMessage: 'Not scheduled'
    },
    pastExam: {
      id: 'common.valueLabel.examStatus.pastExam',
      defaultMessage: 'Past exam'
    },
    upcoming: {
      id: 'common.valueLabel.examStatus.upcoming',
      defaultMessage: 'Upcoming'
    }
  }),
  importStatus: defineMessages({
    imported: {
      id: 'common.valueLabel.importStatus.imported',
      defaultMessage: 'Imported'
    },
    couldNotBeImported: {
      id: 'common.valueLabel.importStatus.couldNotBeImported',
      defaultMessage: 'Could not be imported'
    },
    ok: {
      id: 'common.valueLabel.importStatus.ok',
      defaultMessage: 'OK'
    },
    duplicate: {
      id: 'common.valueLabel.importStatus.duplicate',
      defaultMessage: 'Duplicate'
    }
  }),
  isActive: defineMessages({
    active: {
      id: 'common.valueLabel.isActive.active',
      defaultMessage: 'Active'
    },
    inactive: {
      id: 'common.valueLabel.isActive.inactive',
      defaultMessage: 'Inactive'
    },
    deactivated: {
      id: 'common.valueLabel.isActive.deactivated',
      defaultMessage: 'Deactivated'
    },
    pending: {
      id: 'common.valueLabel.isActive.pending',
      defaultMessage: 'Pending'
    }
  }),
  itemCount: defineMessages({
    exams: {
      id: 'common.valueLabel.itemCount.exams',
      defaultMessage: '{number} exams'
    },
    students: {
      id: 'common.valueLabel.itemCount.students',
      defaultMessage: '{number} students'
    },
    allocatedPlannedstudents: {
      id: 'common.valueLabel.itemCount.allocatedPlannedstudents',
      defaultMessage: '{allocated}/{planned} students'
    },
    confirmedScheduledNeededSupervisors: {
      id: 'common.valueLabel.itemCount.confirmedScheduledNeededSupervisors',
      defaultMessage: '{confirmed}/{scheduled}/{needed} supervisors'
    },
    pricePerSeatPerHour: {
      id: 'common.valueLabel.itemCount.pricePerSeatPerHour',
      defaultMessage: '{price} / seat / hour'
    }
  }),
  isReExam: defineMessages({
    regular: {
      id: 'common.valueLabel.isReExam.regular',
      defaultMessage: 'Regular exam'
    },
    makeUp: {
      id: 'common.valueLabel.isReExam.makeUp',
      defaultMessage: 'Make-up exam'
    },
    reExam: {
      id: 'common.valueLabel.isReExam.reExam',
      defaultMessage: 'Re-exam'
    }
  }),
  isScheduled: defineMessages({
    completed: {
      id: 'common.valueLabel.isScheduled.completed',
      defaultMessage: 'Scheduling completed'
    },
    incomplete: {
      id: 'common.valueLabel.isScheduled.incomplete',
      defaultMessage: 'Scheduling incomplete'
    }
  }),
  isMyExams: defineMessages({
    myExams: {
      id: 'common.valueLabel.filter.myExams',
      defaultMessage: 'My exams'
    }
  }),
  filter: defineMessages({
    contains: {
      id: 'common.valueLabel.filter.contains',
      defaultMessage: 'Contains'
    },
    category: {
      id: 'common.valueLabel.filter.category',
      defaultMessage: 'Category'
    },
    lessThan: {
      id: 'common.valueLabel.filter.lessThan',
      defaultMessage: 'Is less than'
    },
    greaterThan: {
      id: 'common.valueLabel.filter.greaterThan',
      defaultMessage: 'Is greater than'
    },
    equalTo: {
      id: 'common.valueLabel.filter.equalTo',
      defaultMessage: 'Is equal to'
    },
    true: {
      id: 'common.valueLabel.filter.true',
      defaultMessage: 'Is true'
    },
    false: {
      id: 'common.valueLabel.filter.false',
      defaultMessage: 'Is false'
    },
    greaterThanOrEqualTo: {
      id: 'common.valueLabel.filter.greaterThanOrEqualTo',
      defaultMessage: 'Is greater than or equal to'
    },
    isLessThanOrEqualTo: {
      id: 'common.valueLabel.filter.isLessThanOrEqualTo',
      defaultMessage: 'Is less than or equal to'
    },
    between: {
      id: 'common.valueLabel.filter.between',
      defaultMessage: 'Between'
    }
  }),
  mainSupervisor: defineMessages({
    certified: {
      id: 'common.valueLabel.mainSupervisor.certified',
      defaultMessage: 'Certified'
    },
    notCertified: {
      id: 'common.valueLabel.mainSupervisor.notCertified',
      defaultMessage: 'Not certified'
    },
    isLead: {
      id: 'common.valueLabel.mainSupervisor.isLead',
      defaultMessage: 'Is lead supervisor'
    },
    lead: {
      id: 'common.valueLabel.mainSupervisor.lead',
      defaultMessage: 'Lead'
    }
  }),
  moveRoomBookingAction: defineMessages({
    moveScheduling: {
      id: 'common.valueLabel.moveRoomBookingAction.moveScheduling',
      defaultMessage: 'Move to new slot'
    },
    moveExamToNewRoomBooking: {
      id: 'common.valueLabel.moveRoomBookingAction.moveExamToNewRoomBooking',
      defaultMessage: 'Move exam to new room booking'
    },
    retainScheduling: {
      id: 'common.valueLabel.moveRoomBookingAction.retainScheduling',
      defaultMessage: 'Retain on current room booking'
    },
    removeScheduling: {
      id: 'common.valueLabel.moveRoomBookingAction.removeScheduling',
      defaultMessage: 'Remove scheduling'
    },
    moveAndSendBooking: {
      id: 'common.valueLabel.moveRoomBookingAction.moveAndSendBooking',
      defaultMessage: 'Move and send new booking request'
    },
    moveWithoutSendBooking: {
      id: 'common.valueLabel.moveRoomBookingAction.moveWithoutSendBooking',
      defaultMessage: 'Move without sending new booking request'
    },
    retainBooking: {
      id: 'common.valueLabel.moveRoomBookingAction.retainBooking',
      defaultMessage: 'Retain on current room booking'
    },
    cancelBooking: {
      id: 'common.valueLabel.moveRoomBookingAction.cancelBooking',
      defaultMessage: 'Cancel supervisor booking'
    },
    removeBooking: {
      id: 'common.valueLabel.moveRoomBookingAction.removeBooking',
      defaultMessage: 'Remove supervisor booking'
    }
  }),
  overbooked: defineMessages({
    overbooked: {
      id: 'common.valueLabel.overbooked.overbooked',
      defaultMessage: 'Overbooked'
    },
    notOverbooked: {
      id: 'common.valueLabel.overbooked.notOverbooked',
      defaultMessage: 'Not overbooked'
    }
  }),
  publicationStatus: defineMessages({
    notPublished: {
      id: 'common.valueLabel.publicationStatus.notPublished',
      defaultMessage: 'Not published'
    },
    published: {
      id: 'common.valueLabel.publicationStatus.published',
      defaultMessage: 'Published{date, select, NONE {} other { on {date}}}'
    },
    publishedWithChanges: {
      id: 'common.valueLabel.publicationStatus.publishedWithChanges',
      defaultMessage: 'Published{date, select, NONE {} other { on {date}}}, but there are changes'
    },
    modified: {
      id: 'common.valueLabel.publicationStatus.modified',
      defaultMessage: 'Modified'
    },
    depublished: {
      id: 'common.valueLabel.publicationStatus.depublished',
      defaultMessage: 'Depublished'
    }
  }),
  role: defineMessages({
    admin: {
      id: 'common.valueLabel.role.admin',
      defaultMessage: 'Admin'
    },
    cea: {
      id: 'common.valueLabel.role.cea',
      defaultMessage: 'Central Exam Administrator'
    },
    dec: {
      id: 'common.valueLabel.role.dec',
      defaultMessage: 'Departemental Exam Coordinator'
    },
    // old: CEA
    examAdministrator: {
      id: 'common.valueLabel.role.examAdministrator',
      defaultMessage: 'Exam Administrator'
    },
    // old: DEC
    examManager: {
      id: 'common.valueLabel.role.examManager',
      defaultMessage: 'Exam Manager'
    },
    examCoordinator: {
      id: 'common.valueLabel.role.examCoordinator',
      defaultMessage: 'Exam Coordinator'
    },
    supervisor: {
      id: 'common.valueLabel.role.supervisor',
      defaultMessage: 'Supervisor'
    },
    supervisorCoordinator: {
      id: 'common.valueLabel.role.supervisorCoordinator',
      defaultMessage: 'Supervisor Coordinator'
    },
    student: {
      id: 'common.valueLabel.role.student',
      defaultMessage: 'Student'
    }
  }),
  savingStatus: defineMessages({
    saved: {
      id: 'common.valueLabel.savingStatus.saved',
      defaultMessage: 'Saved'
    },
    unsaved: {
      id: 'common.valueLabel.savingStatus.unsaved',
      defaultMessage: 'Unsaved changes'
    }
  }),
  studentCount: defineMessages({
    allocated: {
      id: 'common.valueLabel.studentCount.allocated',
      defaultMessage: '{number} students allocated'
    },
    registered: {
      id: 'common.valueLabel.studentCount.registered',
      defaultMessage: '{number} students registered'
    },
    planned: {
      id: 'common.valueLabel.studentCount.planned',
      defaultMessage: '{number} students planned'
    },
    scheduled: {
      id: 'common.valueLabel.studentCount.scheduled',
      defaultMessage: '{number} students scheduled'
    },
    capacity: {
      id: 'common.valueLabel.studentCount.capacity',
      defaultMessage: '{number} students capacity'
    }
  }),
  supervisorCount: defineMessages({
    accepted: {
      id: 'common.valueLabel.supervisorCount.accepted',
      defaultMessage: '{number} accepted'
    },
    scheduled: {
      id: 'common.valueLabel.supervisorCount.scheduled',
      defaultMessage: '{number} scheduled'
    },
    required: {
      id: 'common.valueLabel.supervisorCount.required',
      defaultMessage: '{number} required'
    }
  }),
  usePlannedStudents: defineMessages({
    planned: {
      id: 'common.valueLabel.usePlannedStudents.planned',
      defaultMessage: 'Planned students'
    },
    allocated: {
      id: 'common.valueLabel.usePlannedStudents.allocated',
      defaultMessage: 'Allocated students'
    }
  })
};
var valueLabel = messages$1;

var definedMessages = {
  button: button,
  component: component,
  error: error,
  label: label,
  message: message,
  model: model,
  page: page,
  placeholder: placeholder,
  title: title,
  valueLabel: valueLabel
}; // common messages

var messages = definedMessages;

var getOrgFeatureFromRedux = function getOrgFeatureFromRedux() {
  var lockedFeatures = window.localStorage.getItem('lockedFeatures') || '[]';

  if (isEmpty(lockedFeatures)) {
    return [];
  }

  return JSON.parse(lockedFeatures);
};

var isLockedFeature = function isLockedFeature(feature) {
  return getOrgFeatureFromRedux().includes(feature);
};

var FeatureFlag;

(function (FeatureFlag) {
  FeatureFlag["EXAM_PLUGIN_BULK_EDIT"] = "EXAM_PLUGIN_BULK_EDIT";
  FeatureFlag["EXAM_TYPE_EXAM_LANGUAGE"] = "EXAM_TYPE_EXAM_LANGUAGE";
})(FeatureFlag || (FeatureFlag = {}));

var commonProperties = {
  labelKey: 'name',
  idKey: 'teExtId',
  importParseMap: ['name', 'teExtId', 'id']
};
var DEFAULT_EXAM_PROPERTY_OBJECTS = [{
  name: 'campus',
  key: 'campus',
  field: 'campus',
  labelKey: 'name',
  idKey: 'name',
  columnConfig: [{
    value: 'name',
    label: formatMessage(messages.label.name)
  }],
  labelPath: 'room.fields.campus.fieldLabel',
  objectName: 'room',
  defaultLabel: 'Campus'
}, _objectSpread2({
  name: 'professor',
  key: 'professorIds',
  field: 'extObjectProfessors',
  defaultLabel: 'Professor'
}, commonProperties), _objectSpread2({
  name: 'coordinator',
  key: 'coordinatorIds',
  field: 'extObjectCoordinators',
  defaultLabel: 'Coordinator'
}, commonProperties), _objectSpread2(_objectSpread2({
  name: 'course',
  label: formatMessage(messages.label.course),
  key: 'courseIds',
  field: 'extObjectCourses',
  defaultLabel: formatMessage(messages.label.course)
}, commonProperties), {}, {
  importParseMap: [].concat(_toConsumableArray(commonProperties.importParseMap), ['courseCode'])
}), _objectSpread2({
  name: 'courseEvent',
  label: formatMessage(messages.label.courseEvent),
  key: 'courseEventIds',
  field: 'extObjectCourseEvents',
  defaultLabel: formatMessage(messages.label.courseEvent)
}, commonProperties), _objectSpread2({
  name: 'module',
  label: formatMessage(messages.label.module),
  key: 'moduleIds',
  field: 'extObjectModules',
  defaultLabel: formatMessage(messages.label.module)
}, commonProperties), _objectSpread2({
  name: 'coursePart',
  key: 'coursePartIds',
  field: 'extObjectCourseParts',
  defaultLabel: 'Course part'
}, commonProperties), _objectSpread2({
  name: 'program',
  key: 'programIds',
  field: 'extObjectPrograms',
  defaultLabel: 'Program'
}, commonProperties), _objectSpread2({
  name: 'studentGroup',
  key: 'studentGroupIds',
  field: 'extObjectStudentGroups',
  defaultLabel: 'Student group'
}, commonProperties), _objectSpread2({
  name: 'costCenter',
  label: formatMessage(messages.label.costCenter),
  key: 'costCenterIds',
  field: 'extObjectCostCenters',
  defaultLabel: 'Cost center'
}, commonProperties), _objectSpread2({
  name: 'department',
  label: formatMessage(messages.label.department),
  key: 'departmentIds',
  field: 'extObjectDepartments',
  defaultLabel: 'Department'
}, commonProperties), _objectSpread2({
  name: 'externalCustomer',
  key: 'externalCustomerIds',
  field: 'extObjectExternalCustomers',
  defaultLabel: 'External customer'
}, commonProperties)];
var OLD_EXAM_PROPERTY_OBJECTS = [_objectSpread2(_objectSpread2({}, commonProperties), {}, {
  name: 'examType',
  label: formatMessage(messages.label.examType),
  key: 'examType',
  labelKey: 'label',
  field: 'examType',
  idKey: 'id',
  defaultLabel: 'Exam Type'
}), _objectSpread2(_objectSpread2({}, commonProperties), {}, {
  name: 'language',
  label: formatMessage(messages.label.examLanguage),
  key: 'language',
  labelKey: 'label',
  field: 'language',
  idKey: 'id',
  defaultLabel: formatMessage(messages.label.examLanguage)
})].concat(DEFAULT_EXAM_PROPERTY_OBJECTS);
var NEW_EXAM_PROPERTY_OBJECTS = [_objectSpread2(_objectSpread2({}, commonProperties), {}, {
  name: 'examType',
  label: formatMessage(messages.label.examType),
  key: 'examTypeIds',
  labelKey: 'label',
  field: 'extObjectExamType',
  idKey: 'teExtId',
  defaultLabel: 'Exam Type'
}), _objectSpread2(_objectSpread2({}, commonProperties), {}, {
  name: 'examLanguage',
  label: formatMessage(messages.label.examLanguage),
  key: 'examLanguageIds',
  labelKey: 'label',
  field: 'extObjectExamLanguage',
  idKey: 'teExtId',
  defaultLabel: formatMessage(messages.label.examLanguage)
})].concat(DEFAULT_EXAM_PROPERTY_OBJECTS);
var getExamCommonPropertyObject = function getExamCommonPropertyObject() {
  if (isLockedFeature(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE)) {
    return OLD_EXAM_PROPERTY_OBJECTS.filter(function (_ref) {
      var name = _ref.name;
      return !['campus', 'examType', 'language'].includes(name);
    });
  }

  return NEW_EXAM_PROPERTY_OBJECTS.filter(function (_ref2) {
    var name = _ref2.name;
    return !['campus'].includes(name);
  });
};
var getExamPropertyObject = function getExamPropertyObject(isLockedLanguageAndType) {
  if (isLockedLanguageAndType) {
    return OLD_EXAM_PROPERTY_OBJECTS;
  }

  return NEW_EXAM_PROPERTY_OBJECTS;
};
var getExamPropertyName = function getExamPropertyName() {
  var isLockedLanguageAndType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _isLockedLanguageAndType = isLockedLanguageAndType !== null && isLockedLanguageAndType !== void 0 ? isLockedLanguageAndType : isLockedFeature(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE);

  if (_isLockedLanguageAndType) {
    return OLD_EXAM_PROPERTY_OBJECTS.map(function (_ref3) {
      var name = _ref3.name;
      return name;
    });
  }

  return NEW_EXAM_PROPERTY_OBJECTS.map(function (_ref4) {
    var name = _ref4.name;
    return name;
  });
};
var getExamPropertyNameForInitialState = function getExamPropertyNameForInitialState() {
  return [].concat(_toConsumableArray(OLD_EXAM_PROPERTY_OBJECTS), _toConsumableArray(NEW_EXAM_PROPERTY_OBJECTS)).map(function (_ref5) {
    var name = _ref5.name;
    return name;
  });
};

/**
 * Used by Ant Design to constrain tooltips and popups to the Exam Plugin container
 */
var getPluginContainer = function getPluginContainer() {
  return document.getElementById('exam-plugin');
};

var validateDraftExam = function validateDraftExam(exam, mandatoryObjects, isLockedLanguageAndType) {
  var _exam$studentsPlanned, _exam$durationHours, _exam$durationMinutes;

  var output = {};

  if (isEmpty(exam.name)) {
    output['name'] = {
      invalid: "Can't be empty"
    };
  }

  if (((_exam$studentsPlanned = exam === null || exam === void 0 ? void 0 : exam.studentsPlanned) !== null && _exam$studentsPlanned !== void 0 ? _exam$studentsPlanned : 0) <= 0) {
    output['studentsPlanned'] = {
      invalid: 'Must be greater than 0'
    };
  }

  var hours = (_exam$durationHours = exam === null || exam === void 0 ? void 0 : exam.durationHours) !== null && _exam$durationHours !== void 0 ? _exam$durationHours : 0;
  var minutes = (_exam$durationMinutes = exam === null || exam === void 0 ? void 0 : exam.durationMinutes) !== null && _exam$durationMinutes !== void 0 ? _exam$durationMinutes : 0;
  var duration = hours * 60 + minutes;

  if (duration <= 0) {
    output['examDuration'] = {
      invalid: 'Must be greater than 0'
    };
  }

  for (var i = 0; i < (exam === null || exam === void 0 ? void 0 : (_exam$priorities = exam.priorities) === null || _exam$priorities === void 0 ? void 0 : _exam$priorities.length); i++) {
    var _exam$priorities;

    var _exam$priorities$i = exam === null || exam === void 0 ? void 0 : exam.priorities[i],
        _exam$priorities$i$ex = _exam$priorities$i.exactStartTime,
        exactStartTime = _exam$priorities$i$ex === void 0 ? 0 : _exam$priorities$i$ex,
        _exam$priorities$i$ex2 = _exam$priorities$i.exactEndTime,
        exactEndTime = _exam$priorities$i$ex2 === void 0 ? 0 : _exam$priorities$i$ex2;

    if (exactStartTime >= exactEndTime) {
      output["priority ".concat(i + 1)] = {
        invalid: 'Start time must be before end time'
      };
    }
  }

  var _iterator = _createForOfIteratorHelper(getExamPropertyObject(isLockedLanguageAndType)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          name = _step$value.name,
          key = _step$value.key;
      var mandatoryObject = mandatoryObjects[name];

      if (!mandatoryObject || mandatoryObject.disabled) {
        continue;
      }

      var missingMandatory = mandatoryObject.mandatory && (!exam[key] || isEmpty(exam[key] + ''));
      var tooMany = !mandatoryObject.multiple && Array.isArray(exam[key]) && exam[key].length > 1;
      output[name] = {
        missingMandatory: missingMandatory,
        tooMany: tooMany
      };
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return output;
};
var draftIsValid = function draftIsValid(exam, mandatoryObjects, isLockedLanguageAndType) {
  var validation = validateDraftExam(exam, mandatoryObjects, isLockedLanguageAndType);
  return !Object.values(validation).some(function (obj) {
    return obj.missingMandatory || obj.tooMany || obj.invalid;
  });
};
var notifyValidation = function notifyValidation(validation) {
  var hadErrors = false;
  Object.entries(validation).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        status = _ref2[1];

    if (status.invalid) {
      hadErrors = true;
      notification.error({
        getContainer: getPluginContainer,
        message: "Invalid ".concat(key, ": ").concat(status.invalid)
      });
    }

    if (status.missingMandatory) {
      hadErrors = true;
      notification.error({
        getContainer: getPluginContainer,
        message: "".concat(key, " is mandatory")
      });
    }

    if (status.tooMany) {
      hadErrors = true;
      notification.error({
        getContainer: getPluginContainer,
        message: "Too many ".concat(key)
      });
    }
  });
  return hadErrors;
};

var getMillisecondsFromHoursAndMinutes = function getMillisecondsFromHoursAndMinutes(hours, minutes) {
  if (hours == null || Number.isNaN(hours) || minutes == null || Number.isNaN(minutes)) return 0;
  return hours * (1000 * 60 * 60) + minutes * (1000 * 60);
};
var getHoursFromMilliseconds = function getHoursFromMilliseconds(milliseconds) {
  if (milliseconds == null || Number.isNaN(milliseconds)) return 0;
  return Math.floor(milliseconds / (1000 * 60 * 60));
};
var getMinutesFromMilliseconds = function getMinutesFromMilliseconds(milliseconds) {
  if (milliseconds == null || Number.isNaN(milliseconds)) return 0;
  var residualMilliseconds = milliseconds - Math.floor(milliseconds / (1000 * 60 * 60)) * (1000 * 60 * 60);
  return Math.floor(residualMilliseconds / (1000 * 60));
};

var extractSpecificValues = function extractSpecificValues(entity, mapValues) {
  return castArray(entity).map(function (item) {
    return mapValues[item];
  }).filter(Boolean);
};

var draftToExam = function draftToExam(_ref6) {
  var teObjects = _ref6.teObjects,
      oldDataSource = _ref6.oldDataSource,
      mandatoryObjects = _ref6.mandatoryObjects,
      _ref6$isLockExamTypeL = _ref6.isLockExamTypeLanguage,
      isLockExamTypeLanguage = _ref6$isLockExamTypeL === void 0 ? false : _ref6$isLockExamTypeL,
      errors = _ref6.errors;
  var courseMap = keyBy(teObjects.course, 'teExtId');
  var courseEventMap = keyBy(teObjects.courseEvent, 'teExtId');
  var professorMap = keyBy(teObjects.professor, 'teExtId');
  var costCenterMap = keyBy(teObjects.costCenter, 'teExtId');
  var coordinatorMap = keyBy(teObjects.coordinator, 'teExtId');
  var examTypeMap = !isLockExamTypeLanguage ? keyBy(teObjects.examType, 'teExtId') : oldDataSource.examType;
  var examLanguageMap = !isLockExamTypeLanguage ? keyBy(teObjects.examLanguage, 'teExtId') : oldDataSource.examLanguage;
  var examTypeField = 'examTypeIds';
  var examLanguageField = 'examLanguageIds';

  if (isLockExamTypeLanguage) {
    examTypeField = 'examType';
    examLanguageField = 'language';
  }

  return function (exam) {
    var _errors$find, _exam$examTypeField, _exam$examLanguageFie;

    var validation = validateDraftExam(exam, mandatoryObjects, isLockExamTypeLanguage);
    var error = (_errors$find = errors.find(function (e) {
      return e.reservationId === exam.reservationId;
    })) === null || _errors$find === void 0 ? void 0 : _errors$find.error;
    return _objectSpread2(_objectSpread2({}, exam), {}, {
      courses: extractSpecificValues(exam.courseIds, courseMap),
      professors: extractSpecificValues(exam.professorIds, professorMap),
      courseEvents: extractSpecificValues(exam.courseEventIds, courseEventMap),
      costCenters: extractSpecificValues(exam.costCenterIds, costCenterMap),
      coordinators: extractSpecificValues(exam.coordinatorIds, coordinatorMap),
      examTypes: extractSpecificValues((_exam$examTypeField = exam === null || exam === void 0 ? void 0 : exam[examTypeField]) !== null && _exam$examTypeField !== void 0 ? _exam$examTypeField : [], examTypeMap),
      examLanguages: extractSpecificValues((_exam$examLanguageFie = exam === null || exam === void 0 ? void 0 : exam[examLanguageField]) !== null && _exam$examLanguageFie !== void 0 ? _exam$examLanguageFie : [], examLanguageMap),
      validation: validation,
      error: error
    });
  };
};

var toArray = function toArray(val) {
  return compact(castArray(val));
};

var toCreateExamsPayload = function toCreateExamsPayload(exams, ownerId) {
  return exams.map(function (exam) {
    return toCreateExamPayload(exam, ownerId);
  });
};
var toCreateExamPayload = function toCreateExamPayload(exam, ownerId) {
  var _exam$priorities;

  return {
    reservationId: exam.reservationId,
    ownerId: ownerId,
    studentsPlanned: exam.studentsPlanned,
    name: exam.name,
    externalReference: exam.externalReference,
    informationToStudents: exam.informationToStudents,
    informationToSupervisors: exam.informationToSupervisors,
    informationToAdministrators: exam.informationToAdministrators,
    commentToScheduler: exam.commentToScheduler,
    extObjectProfessors: toArray(exam.professorIds),
    extObjectCoordinators: toArray(exam.coordinatorIds),
    extObjectCourses: toArray(exam.courseIds),
    extObjectCourseEvents: toArray(exam.courseEventIds),
    extObjectModules: toArray(exam.moduleIds),
    extObjectCourseParts: toArray(exam.coursePartIds),
    extObjectPrograms: toArray(exam.programIds),
    extObjectStudentGroups: toArray(exam.studentGroupIds),
    extObjectCostCenters: toArray(exam.costCenterIds),
    extObjectDepartments: toArray(exam.departmentIds),
    extObjectExternalCustomers: toArray(exam.externalCustomerIds),
    extObjectExamType: toArray(exam.examTypeIds),
    extObjectExamLanguage: toArray(exam.examLanguageIds),
    examTime: getMillisecondsFromHoursAndMinutes(exam.durationHours, exam.durationMinutes) || 0,
    linkedExam: exam.linkedExamId || null,
    linkedFromExamIds: exam.linkedFromExamIds,
    campus: exam.campus,
    isReExam: exam.isReExam,
    isSimpleAllocation: exam.isSimpleAllocation,
    source: exam.source,
    examType: exam.examType,
    language: exam.language,
    priorities: (_exam$priorities = exam.priorities) === null || _exam$priorities === void 0 ? void 0 : _exam$priorities.map(transformPriority)
  };
};

var transformPriority = function transformPriority(priority) {
  var _priority$room$id, _priority$room;

  return _objectSpread2(_objectSpread2({}, priority), {}, {
    room: (_priority$room$id = priority === null || priority === void 0 ? void 0 : (_priority$room = priority.room) === null || _priority$room === void 0 ? void 0 : _priority$room.id) !== null && _priority$room$id !== void 0 ? _priority$room$id : undefined
  });
};

var examApi = baseApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      createExam: build.mutation({
        query: function query(_ref) {
          var exam = _ref.exam,
              ownerId = _ref.ownerId;
          return {
            method: 'POST',
            url: '/exams',
            body: toCreateExamPayload(exam, ownerId)
          };
        }
      }),
      createExamsInBatch: build.mutation({
        query: function query(_ref2) {
          var exams = _ref2.exams,
              ownerId = _ref2.ownerId;
          return {
            method: 'POST',
            url: '/exams/multiple',
            body: toCreateExamsPayload(exams, ownerId)
          };
        }
      }),
      updateExam: build.mutation({
        query: function query(_ref3) {
          var exam = _ref3.exam,
              ownerId = _ref3.ownerId;
          return {
            method: 'PATCH',
            url: "/exams/".concat(exam.id),
            body: toCreateExamPayload(exam, ownerId)
          };
        }
      })
    };
  }
});
var useCreateExamMutation = examApi.useCreateExamMutation,
    useCreateExamsInBatchMutation = examApi.useCreateExamsInBatchMutation,
    useUpdateExamMutation = examApi.useUpdateExamMutation;

var PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
var DEFAULT_PAGE_SIZE = 10;
var DEFAULT_TABLE_CONFIG = {
  page: 1,
  limit: DEFAULT_PAGE_SIZE
};
var DEFAULT_POPULATE = JSON.stringify(['examType', 'language', 'children', {
  path: 'priorities',
  populate: ['room', 'examSlot', 'requestInterval']
}, 'linkedExam', 'linkedFromExams']);

var _EXAM_STATUS_LABELS;
var DATE_FORMAT_DEFAULT = 'YYYY-MM-DD';
var USER_STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING'
};
var EXAM_STATUSES = {
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
  PAST: 'past',
  DEPUBLISHED: 'depublished',
  CANCELLED: 'cancelled'
};
(_EXAM_STATUS_LABELS = {}, _defineProperty(_EXAM_STATUS_LABELS, EXAM_STATUSES.PENDING, formatMessage(messages.valueLabel.examSchedulingStatus.pending)), _defineProperty(_EXAM_STATUS_LABELS, EXAM_STATUSES.SCHEDULED, formatMessage(messages.valueLabel.examSchedulingStatus.scheduled)), _defineProperty(_EXAM_STATUS_LABELS, EXAM_STATUSES.PAST, formatMessage(messages.valueLabel.examSchedulingStatus.past)), _defineProperty(_EXAM_STATUS_LABELS, EXAM_STATUSES.DEPUBLISHED, formatMessage(messages.valueLabel.examSchedulingStatus.depublished)), _defineProperty(_EXAM_STATUS_LABELS, EXAM_STATUSES.CANCELLED, formatMessage(messages.valueLabel.examSchedulingStatus.cancelled)), _EXAM_STATUS_LABELS);
var VALIDATION_STATUS = {
  READY_TO_SUBMIT: 'Ready to submit',
  TOO_MANY_OBJECTS: 'Too many objects',
  MISSING_OBJECTS: 'Missing objects',
  INVALID: 'Invalid value'
};
var TOOLTIP_DELAY = 1.1;

// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function () {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);

var integrationSettingsSelector = function integrationSettingsSelector(state) {
  return state.integrationSettings;
};
var selectReservationSettingsLoading = createSelector(integrationSettingsSelector, function (integration) {
  return integration.reservationSettingsLoading;
});
var selectObjectFieldsLoading = function selectObjectFieldsLoading() {
  return createSelector(integrationSettingsSelector, function (integration) {
    return Object.values(integration.teObjectFieldsLoading).some(function (a) {
      return a;
    });
  });
};
var selectObjectFieldLoading = function selectObjectFieldLoading(field) {
  return createSelector(integrationSettingsSelector, function (integration) {
    return integration.teObjectFieldsLoading[field];
  });
};
createSelector(integrationSettingsSelector, function (integrationSettings) {
  return integrationSettings.teObjectTypes;
});
var selectTeObjects = createSelector(integrationSettingsSelector, function (integrationSettings) {
  var objects = {};
  Object.keys(integrationSettings.teObjectIds).map(function (key) {
    objects[key] = integrationSettings.teObjectIds[key].map(function (te_extid) {
      return window.teObjects[key][te_extid];
    });
  });
  return objects;
});
var selectProfessors = createSelector(selectTeObjects, function (teObjects) {
  return teObjects.professor || [];
});
var selectProfessorFilters = createSelector(selectProfessors, function (professors) {
  return professors.map(function (_ref) {
    var name = _ref.name,
        teExtId = _ref.teExtId;
    return {
      text: name,
      value: teExtId
    };
  });
});

var appAxios = axios.create({});

var responseBody = function responseBody(response) {
  return response.data;
};

var RETRY_DELAY_MS = 3000;
var MAX_RETRY_COUNT = 3;
var requestsMap = new Map();
appAxios.interceptors.request.use(function (config) {
  var token = getAccessToken();

  if (token) {
    config.headers.Authorization = "Bearer ".concat(token);
  }

  var key = "".concat(config.method, "-").concat(config.url, "-").concat(JSON.stringify(config.data));

  if (!requestsMap.has(key)) {
    requestsMap.set(key, {
      config: config,
      retryCount: 0
    });
  }

  return config;
});

function onFulfilled(_x) {
  return _onFulfilled.apply(this, arguments);
}

function _onFulfilled() {
  _onFulfilled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(res) {
    var config, key;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            config = res.config;
            key = "".concat(config.method, "-").concat(config.url, "-").concat(JSON.stringify(config.data));
            requestsMap.delete(key);
            return _context2.abrupt("return", res);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _onFulfilled.apply(this, arguments);
}

appAxios.interceptors.response.use(onFulfilled, /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(error) {
    var _ref2, status, token, _config, _key, requestInfo, config, key;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = error.response, status = _ref2.status;
            token = getAccessToken();

            if (!(status === 400 || status === 401)) {
              _context.next = 13;
              break;
            }

            _config = error.config;
            _key = "".concat(_config.method, "-").concat(_config.url, "-").concat(JSON.stringify(_config.data));
            requestInfo = requestsMap.get(_key);

            if (!(requestInfo && requestInfo.retryCount < MAX_RETRY_COUNT)) {
              _context.next = 13;
              break;
            }

            requestInfo.retryCount++;
            _context.next = 10;
            return new Promise(function (resolve) {
              return setTimeout(resolve, RETRY_DELAY_MS);
            });

          case 10:
            _config.headers.Authorization = "Bearer ".concat(token);
            _config.baseURL = undefined;
            return _context.abrupt("return", appAxios.request(_config));

          case 13:
            _context.t0 = status;
            _context.next = _context.t0 === 400 ? 16 : _context.t0 === 403 ? 17 : _context.t0 === 500 ? 18 : 19;
            break;

          case 16:
            return _context.abrupt("break", 20);

          case 17:
            return _context.abrupt("break", 20);

          case 18:
            return _context.abrupt("break", 20);

          case 19:
            return _context.abrupt("break", 20);

          case 20:
            config = error.config;
            key = "".concat(config.method, "-").concat(config.url, "-").concat(JSON.stringify(config.data));
            requestsMap.delete(key);
            return _context.abrupt("return", Promise.reject(error));

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x2) {
    return _ref.apply(this, arguments);
  };
}());
var requests = {
  get: function get(url, params) {
    return appAxios.get(url, {
      params: params
    }).then(responseBody);
  },
  post: function post(url, body) {
    return appAxios.post(url, body).then(responseBody);
  },
  put: function put(url, body) {
    return appAxios.put(url, body).then(responseBody);
  },
  patch: function patch(url, body) {
    return appAxios.patch(url, body).then(responseBody);
  },
  delete: function _delete(url) {
    return appAxios.delete(url).then(responseBody);
  }
};
var Account = {
  login: function login(values) {
    return requests.post("".concat(getEnvParams().AUTH_URL, "/auth/validate-login"), values);
  },
  fetchProfile: function fetchProfile() {
    return requests.get("".concat(getEnvParams().API_URL, "/account"));
  },
  changeOrg: function changeOrg(values) {
    return requests.post("".concat(getEnvParams().AUTH_URL, "/auth/change-organization"), values);
  }
};
var Org = {
  fetchReqIntervals: function fetchReqIntervals() {
    return requests.get("".concat(getEnvParams().API_URL, "/request-intervals"));
  },
  fetchReqSetting: function fetchReqSetting() {
    return requests.get("".concat(getEnvParams().API_URL, "/request-settings"));
  },
  fetchMandatoryObjects: function fetchMandatoryObjects() {
    return requests.get("".concat(getEnvParams().API_URL, "/mandatory-objects"));
  },
  saveMandatoryObjects: function saveMandatoryObjects(values) {
    return requests.post("".concat(getEnvParams().API_URL, "/mandatory-objects"), values);
  },
  fetchIntegrationSettings: function fetchIntegrationSettings(orgId) {
    return requests.get("".concat(getEnvParams().API_URL, "/organizations/").concat(orgId, "/integration-settings"));
  },
  fetchOrgs: function fetchOrgs() {
    return requests.get("".concat(getEnvParams().AUTH_URL, "/apps/").concat(getEnvParams().APP_ID, "/organizations/"));
  },
  fetchExamSettings: function fetchExamSettings() {
    return requests.get("".concat(getEnvParams().API_URL, "/exam-settings"));
  },
  fetchAppSettings: function fetchAppSettings() {
    return requests.get("".concat(getEnvParams().API_URL, "/app-service/exam-in-core"));
  },
  fetchObjectTypeMapping: function fetchObjectTypeMapping() {
    return requests.get("".concat(getEnvParams().API_URL, "/app-service/mapping"));
  },
  fetchFeatureFlags: function fetchFeatureFlags() {
    return requests.get("".concat(getEnvParams().API_URL, "/feature-flag"));
  }
};
var Exam = {
  searchExamsOfTeCoreType: function searchExamsOfTeCoreType(payload) {
    var payloadWithFilter = _objectSpread2(_objectSpread2({}, payload), {
      source: 'te_core'
    });

    return requests.get("".concat(getEnvParams().API_URL, "/exams"), payloadWithFilter);
  },
  // searchExamsByIds: (examIds: number[]): Promise<any> =>
  //   requests.get(`${getEnvParams().API_URL}/exams`),
  getExamById: function getExamById(examId, payload) {
    return requests.get("".concat(getEnvParams().API_URL, "/exams/").concat(examId), payload);
  },
  fetchExamTypes: function fetchExamTypes() {
    return requests.get("".concat(getEnvParams().API_URL, "/exam-types"));
  }
};
var Priority = {
  fetchPrioritiesByExamIds: function fetchPrioritiesByExamIds(examIds) {
    return requests.post("".concat(getEnvParams().API_URL, "/exams/scheduling-priorities/exams"), {
      examIds: examIds
    });
  },
  create: function create(examId, values) {
    return requests.post("".concat(getEnvParams().API_URL, "/exams/scheduling-priorities/exam/").concat(examId), values);
  },
  update: function update(priorityId, values) {
    return requests.put("".concat(getEnvParams().API_URL, "/exams/scheduling-priorities/").concat(priorityId), values);
  }
};
var Language = {
  fetchAll: function fetchAll() {
    return requests.get("".concat(getEnvParams().API_URL, "/languages"));
  }
};
var ExamType = {
  fetchAll: function fetchAll() {
    return requests.get("".concat(getEnvParams().API_URL, "/exam-types"));
  }
};
var Room = {
  fetchAll: function fetchAll() {
    return requests.get("".concat(getEnvParams().API_URL, "/rooms"));
  }
};
var Users$1 = {
  fetchAll: function fetchAll() {
    return requests.get("".concat(getEnvParams().API_URL, "/users"));
  },
  fetchExtraUser: function fetchExtraUser(userIds) {
    return requests.post("".concat(getEnvParams().API_URL, "/users/findByIds"), {
      userIds: userIds
    });
  }
};
var IntegrationService = {
  fetchObjectsOfType: function fetchObjectsOfType(type) {
    return requests.get("".concat(getEnvParams().API_URL, "/integration-service/objects/types/").concat(type));
  },
  fetchObjectField: function fetchObjectField(values) {
    return requests.post("".concat(getEnvParams().API_URL, "/integration-service/objects/search/"), values);
  },
  fetchField: function fetchField(organizationId, values) {
    return requests.post("".concat(getEnvParams().API_URL, "/integration-service/service/teExam/integration/").concat(organizationId, "/object/search"), values);
  }
};
var agent = {
  Account: Account,
  Org: Org,
  Exam: Exam,
  Language: Language,
  ExamType: ExamType,
  Room: Room,
  Priority: Priority,
  Users: Users$1,
  IntegrationService: IntegrationService
};
var agent$1 = agent;

var ls = localStorage;
var getToken = function getToken() {
  return ls.getItem(TOKEN_NAME);
};
var setToken = function setToken(accessToken) {
  return ls.setItem(TOKEN_NAME, accessToken);
};
var deleteToken = function deleteToken() {
  return ls.removeItem(TOKEN_NAME);
};

var AuthStatus;

(function (AuthStatus) {
  AuthStatus["NOT_AUTHENTICATED"] = "NOT_AUTHENTICATED";
  AuthStatus["MULTIPLE_ORGS"] = "MULTIPLE_ORGS";
  AuthStatus["AUTHENTICATED"] = "AUTHENTICATED";
})(AuthStatus || (AuthStatus = {}));

var _TEX_ROLES;
var ROLES = {
  ExamAdministrator: 'teExam:teExamCEA',
  // old role: CEA
  ExamManager: 'teExam:teExamDEC',
  // old role: DEC
  ExamCoordinator: 'teExam:teExamDEC_COORDINATOR',
  // new role
  Supervisor: 'teExam:teExamSUPE',
  // old role
  SupervisorCoordinator: 'teExam:teExamSUPE_COORDINATOR',
  // new role
  // Root: 'teAdmin:TE_Admin', // admin of TimeEdit role
  // OLD_Root: 'teAdmin:Timeedit Admin', // todo: remove when update role name in production
  // Student: 'teExam:stu',
  TeRootUser: 'TE_ROOT_USER'
};
var ROLES_V3 = {
  ExamAdministrator: 'TE_EXAM::cea',
  // old role: CEA
  ExamManager: 'TE_EXAM::dec',
  // old role: DEC
  ExamCoordinator: 'TE_EXAM::decCoordinator',
  // new role
  Supervisor: 'TE_EXAM::supervisor',
  // old role
  SupervisorCoordinator: 'TE_EXAM::supervisorCoordinator',
  // new role
  // Root: 'TE_EXAM::Admin', // admin of TimeEdit role
  // Student: 'TE_EXAM::Student',
  TeRootUser: 'TE_ROOT_USER'
};
(_TEX_ROLES = {}, _defineProperty(_TEX_ROLES, ROLES.ExamAdministrator, formatMessage(messages.valueLabel.role.examAdministrator)), _defineProperty(_TEX_ROLES, ROLES_V3.ExamAdministrator, formatMessage(messages.valueLabel.role.examAdministrator)), _defineProperty(_TEX_ROLES, ROLES.ExamManager, formatMessage(messages.valueLabel.role.examManager)), _defineProperty(_TEX_ROLES, ROLES_V3.ExamManager, formatMessage(messages.valueLabel.role.examManager)), _defineProperty(_TEX_ROLES, ROLES.ExamCoordinator, formatMessage(messages.valueLabel.role.examCoordinator)), _defineProperty(_TEX_ROLES, ROLES_V3.ExamCoordinator, formatMessage(messages.valueLabel.role.examCoordinator)), _defineProperty(_TEX_ROLES, ROLES.Supervisor, formatMessage(messages.valueLabel.role.supervisor)), _defineProperty(_TEX_ROLES, ROLES_V3.Supervisor, formatMessage(messages.valueLabel.role.supervisor)), _defineProperty(_TEX_ROLES, ROLES.SupervisorCoordinator, formatMessage(messages.valueLabel.role.supervisorCoordinator)), _defineProperty(_TEX_ROLES, ROLES_V3.SupervisorCoordinator, formatMessage(messages.valueLabel.role.supervisorCoordinator)), _TEX_ROLES); // list of CEA role, can see all menus

var CEA_ROLES = [ROLES.ExamAdministrator, // ROLES.Root,
// ROLES.OLD_Root,
ROLES_V3.ExamAdministrator, ROLES_V3.TeRootUser]; // list of DEC role, can see DEC menus

var DEC_ROLES = [ROLES.ExamManager, ROLES.ExamCoordinator, ROLES_V3.ExamManager, ROLES_V3.ExamCoordinator];

var SUPERVISOR_ROLES = [ROLES.Supervisor, ROLES.SupervisorCoordinator, ROLES_V3.Supervisor, ROLES_V3.SupervisorCoordinator];

var UserSchema = new schema.Entity('users', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var _organizationGroups$;

    var user = {};
    user = pick(e, ['id', 'organizationIds', 'organizationId', 'firstName', 'lastName', 'name', 'email', 'language', 'status', 'roleName', 'permissions', 'isActive']);
    var userToken = getAccessToken();
    var decoded = jwt.decode(userToken);

    var _ref = decoded || {},
        _ref$organizationId = _ref.organizationId,
        organizationId = _ref$organizationId === void 0 ? null : _ref$organizationId,
        _ref$organizationIds = _ref.organizationIds,
        organizationIds = _ref$organizationIds === void 0 ? null : _ref$organizationIds,
        _ref$organizationGrou = _ref.organizationGroups,
        organizationGroups = _ref$organizationGrou === void 0 ? null : _ref$organizationGrou;

    user.organizationId = organizationId;
    user.organizationIds = organizationIds;
    user.organizationGroups = organizationGroups;
    user.roleName = null;

    if (organizationGroups) {
      var foundGroup = organizationGroups.find(function (_ref2) {
        var app = _ref2.app;
        return app === 'teExam' || app === 'teAdmin';
      });
      user.roleName = (foundGroup === null || foundGroup === void 0 ? void 0 : foundGroup.permissionGroup) || null;
    }

    user.isCEA = CEA_ROLES.includes(user.roleName);
    user.isDEC = DEC_ROLES.includes(user.roleName);
    user.isSupervisor = SUPERVISOR_ROLES.includes(user.roleName);
    user.isSupervisorCoordinator = user.roleName === ROLES.SupervisorCoordinator;
    user.supervisorId = e.supervisor_id;

    if ((organizationGroups === null || organizationGroups === void 0 ? void 0 : (_organizationGroups$ = organizationGroups[0]) === null || _organizationGroups$ === void 0 ? void 0 : _organizationGroups$.isActive) === false) {
      user.status = USER_STATUSES.INACTIVE;
    } else if (!e.password) {
      user.status = USER_STATUSES.PENDING;
    } else {
      user.status = user.isActive ? USER_STATUSES.ACTIVE : USER_STATUSES.INACTIVE;
    }

    return user;
  }
});
var UserSchema$1 = UserSchema;

var ApiStatus;

(function (ApiStatus) {
  ApiStatus["IDLE"] = "idle";
  ApiStatus["LOADING"] = "loading";
  ApiStatus["SUCCEEDED"] = "succeeded";
  ApiStatus["FAILED"] = "failed";
})(ApiStatus || (ApiStatus = {}));

var login = createAsyncThunk('authentication/login', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", agent$1.Account.login(values));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
var changeOrg = createAsyncThunk('authentication/changeOrg', function (values) {
  return agent$1.Account.changeOrg(values);
});
var fetchOrgs = createAsyncThunk('authentication/fetchOrgs', function () {
  return agent$1.Org.fetchOrgs();
});
createAsyncThunk('authentication/fetchIntegrationSettings', function (orgId) {
  return agent$1.Org.fetchIntegrationSettings(orgId);
});
var fetchProfile = createAsyncThunk('authentication/fetchProfile', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_, thunkApi) {
    var response, _error$data, _error$data2;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return agent$1.Account.fetchProfile();

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);

            if (!(((_error$data = _context2.t0.data) === null || _error$data === void 0 ? void 0 : _error$data.code) !== 400 && ((_error$data2 = _context2.t0.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.code) !== 401)) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", thunkApi.rejectWithValue(_context2.t0.data));

          case 11:
            return _context2.abrupt("return", agent$1.Account.fetchProfile());

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function (_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());
var authentication = createSlice({
  name: 'authentication',
  initialState: {
    authenticationStatus: AuthStatus.NOT_AUTHENTICATED,
    availableOrgs: [],
    user: null,
    org: null,
    integrationSettings: null,
    env: 'production',
    coreUserId: '',
    loginReqStatus: ApiStatus.IDLE,
    accessToken: ''
  },
  reducers: {
    logout: function logout(state) {
      deleteToken();
      state.authenticationStatus = AuthStatus.NOT_AUTHENTICATED;
    },
    checkAuthLocal: function checkAuthLocal(state) {
      var token = getToken();

      if (token) {
        try {
          var decoded = jwt.decode(token);
          if (!decoded) throw new Error('Token invalid');
          state.accessToken = token;
          state.authenticationStatus = AuthStatus.AUTHENTICATED;
        } catch (e) {
          console.error(e);
          state.authenticationStatus = AuthStatus.NOT_AUTHENTICATED;
        }
      }
    }
  },
  extraReducers: function extraReducers(builder) {
    /* LOGIN */
    builder.addCase(login.fulfilled, function (state, action) {
      var _loginPayload$token;

      var loginPayload = action.payload;

      if (!loginPayload.user) {
        state.authenticationStatus = AuthStatus.NOT_AUTHENTICATED;
        return;
      }

      var accessToken = loginPayload === null || loginPayload === void 0 ? void 0 : (_loginPayload$token = loginPayload.token) === null || _loginPayload$token === void 0 ? void 0 : _loginPayload$token.accessToken;

      if (accessToken) {
        setToken(accessToken);
        state.accessToken = accessToken;
        state.authenticationStatus = AuthStatus.AUTHENTICATED;
        state.loginReqStatus = ApiStatus.SUCCEEDED;
      } else {
        state.loginReqStatus = ApiStatus.FAILED;
      }

      if (!loginPayload.user.organizationId) {
        state.authenticationStatus = AuthStatus.MULTIPLE_ORGS;
        return;
      }
    });
    builder.addCase(login.rejected, function (state) {
      state.authenticationStatus = AuthStatus.NOT_AUTHENTICATED;
      state.loginReqStatus = ApiStatus.FAILED;
    });
    builder.addCase(login.pending, function (state) {
      state.loginReqStatus = ApiStatus.LOADING;
    });
    /* FETCH ORGS */

    builder.addCase(fetchOrgs.fulfilled, function (state, action) {
      var fetchOrgsPayload = action.payload;
      state.availableOrgs = fetchOrgsPayload.data.organizations;
    });
    /* CHANGE ORG */

    builder.addCase(changeOrg.fulfilled, function (state, action) {
      var _ref3 = action.payload,
          accessToken = _ref3.accessToken;

      if (accessToken) {
        setToken(accessToken);
        state.accessToken = accessToken;
        var payload = jwt.decode(accessToken);

        if (payload.userData) {
          var _normalize = normalize(payload.userData, UserSchema$1),
              entities = _normalize.entities,
              result = _normalize.result;

          state.user = entities.users[result];
          state.authenticationStatus = AuthStatus.AUTHENTICATED;
        }
      }
    });
    /* FETCH PROFILES */

    builder.addCase(fetchProfile.fulfilled, function (state, action) {
      var fetchProfilePayload = action.payload;

      var _normalize2 = normalize(fetchProfilePayload === null || fetchProfilePayload === void 0 ? void 0 : fetchProfilePayload.data, UserSchema$1),
          entities = _normalize2.entities,
          result = _normalize2.result;

      state.user = entities.users[result];
      state.authenticationStatus = !state.user.organizationId ? AuthStatus.MULTIPLE_ORGS : AuthStatus.AUTHENTICATED;
    });
  }
});
var _authentication$actio = authentication.actions;
    _authentication$actio.logout;
    _authentication$actio.checkAuthLocal;
var authentication$1 = authentication;

var _EXAM_GROUPING_STATUS;

var EXAM_GROUPING_STATUS_MAIN = 'EXAM_GROUPING_STATUS_MAIN';
var EXAM_GROUPING_STATUS_SINGLE = 'EXAM_GROUPING_STATUS_SINGLE';
var EXAM_GROUPING_STATUS_CHILD = 'EXAM_GROUPING_STATUS_CHILD';
var EXAM_GROUPING_STATUS_LETTER = (_EXAM_GROUPING_STATUS = {}, _defineProperty(_EXAM_GROUPING_STATUS, EXAM_GROUPING_STATUS_MAIN, 'G'), _defineProperty(_EXAM_GROUPING_STATUS, EXAM_GROUPING_STATUS_SINGLE, 'S'), _defineProperty(_EXAM_GROUPING_STATUS, EXAM_GROUPING_STATUS_CHILD, 'C'), _EXAM_GROUPING_STATUS);

var scheduled = function scheduled(e) {
  if (e.isScheduled) {
    if (e.groupingStatus !== EXAM_GROUPING_STATUS_MAIN) {
      return e.scheduled;
    }

    var _e$children = _slicedToArray(e.children, 1),
        firstChild = _e$children[0];

    if (!firstChild) {
      return e.scheduled;
    }

    return firstChild.scheduled;
  }

  return null;
};

var ExamSchema = new schema.Entity('exams', {}, {
  idAttribute: 'examId',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var exam = {};
    exam.id = e.id;
    exam.reservationId = e.reservationId; // exam.organizationId = e.organizationId;

    exam.ownerId = e.ownerId;
    exam.parent = e.parent; // exam.hasSchedulingPriorities = e.hasSchedulingPriorities;

    exam.childExams = e.children;
    exam.groupingStatus = exam.parent ? EXAM_GROUPING_STATUS_CHILD : exam.childExams.length > 0 ? EXAM_GROUPING_STATUS_MAIN : EXAM_GROUPING_STATUS_SINGLE; // exam.isRequested = e.isRequested;

    var _isScheduled = scheduled(e);

    exam.isScheduled = _isScheduled ? _isScheduled.roomBooking : false;
    exam.isCancelled = !!e.cancelledAt;
    exam.linkedExam = e.linkedExam;
    exam.linkedExamId = e.linkedExam ? e.linkedExam.id : undefined;
    exam.linkedFromExamIds = e.linkedFromExamIds || [];
    exam.createdAt = e.createdAt;
    exam.updatedAt = e.updatedAt;
    exam.examId = e.examId;
    /** ***************************************************************************
     * EXAM INFO
     *************************************************************************** */

    exam.name = e.name;

    if (isLockedFeature(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE)) {
      exam.language = e.language;
      exam.languageId = e.language ? e.language.id : e.languageId;
      exam.examType = e.examType;
      exam.examTypeId = e.examType ? e.examType.id : undefined;
    }

    exam.studentsPlanned = e.studentsPlanned || 0;
    exam.studentsRegistered = e.studentsRegistered || 0;
    exam.StudentsAllocated = e.studentsAllocated || 0;
    exam.studentsWithSpecialNeeds = e.studentsWithSpecialNeeds || 0;
    exam.studentsAttended = e.studentsAttended;
    exam.isReExam = !!e.isReExam;
    exam.isSimpleAllocation = !!e.isSimpleAllocation;
    exam.externalReference = e.externalReference;
    exam.informationToStudents = e.informationToStudents;
    exam.informationToSupervisors = e.informationToSupervisors;
    exam.informationToAdministrators = e.informationToAdministrators;
    exam.commentToScheduler = e.commentToScheduler;
    exam.scheduledExamDate = e.examTargetDate ? moment.unix(e.examTargetDate).utc() : null;
    exam.source = e.source;
    /** ***************************************************************************
     * EXAM TIME
     *************************************************************************** */

    exam.examDuration = e.examTime || 0;
    exam.durationHours = getHoursFromMilliseconds(exam.examDuration);
    exam.durationMinutes = getMinutesFromMilliseconds(exam.examDuration);
    /** ***************************************************************************
     * EXAM PROPERTIES
     *************************************************************************** */

    exam.campus = e.campus;

    var _iterator = _createForOfIteratorHelper(getExamCommonPropertyObject()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _step.value,
            key = _step$value.key,
            field = _step$value.field;
        exam[key] = e[field] ? _toConsumableArray(e[field]) : [];
      }
      /** ***************************************************************************
       * SCHEDULING INFORMATION
       *************************************************************************** */

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    exam.scheduledExamSlotId = e.scheduledExamSlotId;
    exam.scheduledRoomId = e.scheduledRoomId;
    exam.scheduledRoomBookingId = e.scheduledRoomBookingId;
    exam.scheduledStartTime = e.scheduledStartTime;
    exam.scheduledEndTime = e.scheduledEndTime;
    exam.scheduledStartSeatNumber = e.scheduledStartSeatNo;
    exam.scheduledEndSeatNumber = e.scheduledEndSeatNo;

    if (e.isOverbooked !== undefined) {
      exam.isOverbooked = e.isOverbooked;
    } else if (e.studentsAllocated !== undefined && e.studentsPlanned !== undefined) {
      exam.isOverbooked = e.studentsAllocated > e.studentsPlanned;
    }

    exam.publicationDate = e.publicationDate ? moment.unix(e.publicationDate).utc() : undefined; // exam.publicationBookingId = e.publicationBookingId;
    // exam.publicationUserId = e.publication_userId;
    // exam.publicationResult = e.publicationResult || null;

    exam.commentToScheduler = e.commentToScheduler;
    /** ***************************************************************************
     * SCHEDULING INFORMATION
     *************************************************************************** */

    exam.postExamNotes = e.postExamNotes || '';
    var priorities = (e.priorities || []).map(function (item) {
      if (item.targetDate) {
        item.targetDate = moment(item.targetDate).utc(true);
      }

      return item;
    });
    exam.priorities = priorities;
    return exam;
  }
});
var ExamSchema$1 = ExamSchema;

new schema.Entity('users', {}, {
  idAttribute: '_id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var user = {};
    user.id = e._id;
    user.name = e === null || e === void 0 ? void 0 : e.name;
    user.email = e.email;
    return user;
  }
});
var ExtraUserSchema = new schema.Entity('extra_users', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var user = {};
    user.id = e.id;
    user.name = "".concat(e.firstName, " ").concat(e.lastName);
    return user;
  }
});

var initialState$9 = {
  ids: [],
  entities: {},
  loading: false
};
var fetchExtraUser = createAsyncThunk('User/fetchExtrauser', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(userIds) {
    var res, _normalize, entities, result;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!userIds || !userIds.length)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", {
              entities: {},
              ids: []
            });

          case 2:
            _context.next = 4;
            return agent$1.Users.fetchExtraUser(userIds);

          case 4:
            res = _context.sent;
            _normalize = normalize(res, [ExtraUserSchema]), entities = _normalize.entities, result = _normalize.result;
            return _context.abrupt("return", {
              entities: entities.extra_users,
              ids: result
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
var Users = createSlice({
  name: 'user',
  initialState: initialState$9,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    // FETCH EXTRA USER
    builder.addCase(fetchExtraUser.fulfilled, function (state, action) {
      state.entities = _objectSpread2(_objectSpread2({}, action.payload.entities), state.entities);
      state.ids = [].concat(_toConsumableArray(action.payload.ids), _toConsumableArray(state.ids));
      state.loading = false;
    });
    builder.addCase(fetchExtraUser.pending, function (state) {
      state.loading = true;
    });
    builder.addCase(fetchExtraUser.rejected, function (state) {
      state.loading = false;
    });
  }
});
var users = Users;

var newExamInitialState = {
  id: null,
  name: '',
  language: null,
  examType: '',
  examDuration: 0,
  studentsPlanned: 0,
  studentsRegistered: 0,
  isReExam: false,
  externalReference: '',
  informationToStudents: '',
  informationToSupervisors: '',
  informationToAdministrators: '',
  commentToScheduler: '',
  professorIds: [],
  costCenterIds: [],
  campus: null,
  courseIds: [],
  courseEventIds: [],
  moduleIds: [],
  departmentIds: [],
  linkedExamId: '',
  examSetting: []
};
var initialState$8 = {
  entities: {},
  linkedExams: {},
  edit: {},
  selectedLinkedExam: [],
  examDetail: {},
  linkedExam: {},
  selectedExam: {},
  currentExam: {},
  totalResults: 0,
  page: 1,
  isSelectedLinkExams: false,
  totalLinkedExamsResults: 0,
  new: newExamInitialState,
  publicationStatus: {},
  ids: [],
  apiStatus: {
    searchExamsOfTeCoreType: ApiStatus.IDLE,
    searchLinkedExams: ApiStatus.IDLE
  },
  examSetting: []
}; // const booksAdapter = createEntityAdapter<Book>({
//   // Assume IDs are stored in a field other than `book.id`
//   selectId: (book) => book.bookId,
//   // Keep the "all IDs" array sorted based on book titles
//   sortComparer: (a, b) => a.title.localeCompare(b.title),
// })

var searchExamsOfTeCoreType = createAsyncThunk('exams/searchExamsOfTeCoreType', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, thunkApi) {
    var _children$entities$ex, _exams, children, childrenNomalize, parentExam, ownerIds, _normalize, ids, entities;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (payload && payload.sort_by === '') delete payload.sort_by;
            if (payload && payload.except_exam_id === '') delete payload.except_exam_id;
            _context.next = 5;
            return agent$1.Exam.searchExamsOfTeCoreType(payload);

          case 5:
            _exams = _context.sent;
            children = normalize(_exams.results.flatMap(function (exam) {
              return exam.children;
            }), [ExamSchema$1]);
            childrenNomalize = groupBy(Object.values((_children$entities$ex = children.entities.exams) !== null && _children$entities$ex !== void 0 ? _children$entities$ex : {}), 'parent');
            parentExam = _exams.results.map(function (exam) {
              if (childrenNomalize[exam.examId]) {
                exam.children = childrenNomalize[exam.examId];
              }

              return exam;
            });
            ownerIds = parentExam.map(function (exam) {
              return exam.ownerId;
            });
            _context.next = 12;
            return thunkApi.dispatch(fetchExtraUser(ownerIds));

          case 12:
            _normalize = normalize(parentExam, [ExamSchema$1]), ids = _normalize.result, entities = _normalize.entities;
            return _context.abrupt("return", {
              ids: ids,
              entities: entities.exams,
              totalResults: _exams.totalResults || 0,
              page: payload.page
            });

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", thunkApi.rejectWithValue(_context.t0.data));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var fetchExamSettingField = createAsyncThunk('exams/fetchExamSettingField', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(payload, thunkApi) {
    var res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return agent$1.IntegrationService.fetchObjectField(payload);

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", {
              examSetting: res.data
            });

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", thunkApi.rejectWithValue(_context2.t0.data));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
var searchLinkedExams = createAsyncThunk('exams/searchLinkedExams', /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(payload, thunkApi) {
    var res, _normalize2, ids, entities;

    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            if (payload && payload.sort_by === '') delete payload.sort_by;
            if (payload && payload.except_exam_id === '') delete payload.except_exam_id;
            _context3.next = 5;
            return agent$1.Exam.searchExamsOfTeCoreType(payload);

          case 5:
            res = _context3.sent;
            _normalize2 = normalize(res.results, [ExamSchema$1]), ids = _normalize2.result, entities = _normalize2.entities;
            return _context3.abrupt("return", {
              ids: ids,
              linkedExams: entities.exams,
              totalLinkedExamsResults: res.totalResults || 0
            });

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", thunkApi.rejectWithValue(_context3.t0.data));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 10]]);
  }));

  return function (_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}());
var updateExamProperty = createAsyncThunk('exams/updateExamProperty', /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(payload, thunkApi) {
    var examId, newExam;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            examId = payload.examId, newExam = payload.newExam;
            return _context4.abrupt("return", {
              newExam: newExam,
              examId: examId
            });

          case 5:
            _context4.prev = 5;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", thunkApi.rejectWithValue(_context4.t0.data));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 5]]);
  }));

  return function (_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}());
var getExamDetail = createAsyncThunk('exams/getExamDetail', /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(requestId, thunkApi) {
    var exam, linkedExam, _normalize3, ids, entities;

    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;

            if (!requestId) {
              _context5.next = 8;
              break;
            }

            _context5.next = 4;
            return agent$1.Exam.getExamById(requestId, {
              populate: DEFAULT_POPULATE
            });

          case 4:
            exam = _context5.sent;
            linkedExam = exam.linkedExam;
            _normalize3 = normalize([exam], [ExamSchema$1]), ids = _normalize3.result, entities = _normalize3.entities;
            return _context5.abrupt("return", {
              ids: ids,
              examDetail: entities.exams || {},
              linkedExam: linkedExam
            });

          case 8:
            _context5.next = 13;
            break;

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", thunkApi.rejectWithValue(_context5.t0.data));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 10]]);
  }));

  return function (_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}());
var setSelectedLinkedExam = createAsyncThunk('exams/setSelectedLinkedExam', /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(examData, thunkApi) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            return _context6.abrupt("return", examData);

          case 4:
            _context6.prev = 4;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", thunkApi.rejectWithValue(_context6.t0.data));

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 4]]);
  }));

  return function (_x11, _x12) {
    return _ref6.apply(this, arguments);
  };
}());
var setSelectedLinkExams = createAsyncThunk('exams/isSelectedLinkExams', /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(payload, thunkApi) {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            return _context7.abrupt("return", {
              isSelectedLinkExams: payload
            });

          case 4:
            _context7.prev = 4;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", thunkApi.rejectWithValue(_context7.t0.data));

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 4]]);
  }));

  return function (_x13, _x14) {
    return _ref7.apply(this, arguments);
  };
}());
var exams = createSlice({
  name: 'exams',
  initialState: initialState$8,
  reducers: {
    editExam: function editExam(state, action) {
      state.edit = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(setSelectedLinkedExam.fulfilled, function (state, action) {
      state.selectedLinkedExam = [action.payload];
    });
    builder.addCase(getExamDetail.fulfilled, function (state, action) {
      if (action.payload) {
        var _action$payload = action.payload,
            examDetail = _action$payload.examDetail,
            linkedExam = _action$payload.linkedExam;
        state.examDetail = examDetail;
        state.linkedExam = linkedExam;
      }
    });
    builder.addCase(setSelectedLinkExams.fulfilled, function (state, action) {
      var isSelectedLinkExams = action.payload.isSelectedLinkExams;
      state.isSelectedLinkExams = !isSelectedLinkExams;
    });
    builder.addCase(fetchExamSettingField.fulfilled, function (state, action) {
      var examSetting = action.payload.examSetting;
      state.examSetting = examSetting;
    });
    builder.addCase(updateExamProperty.fulfilled, function (state, action) {
      var _action$payload2 = action.payload,
          examId = _action$payload2.examId,
          newExam = _action$payload2.newExam;
      state.entities[examId] = newExam;
    });
    /* FETCH ALL FROM CORE */

    builder.addCase(searchExamsOfTeCoreType.fulfilled, function (state, action) {
      var _action$payload3 = action.payload,
          entities = _action$payload3.entities,
          totalResults = _action$payload3.totalResults,
          page = _action$payload3.page;
      state.entities = entities;
      state.totalResults = totalResults;
      state.page = page;

      if (isEmpty(state.linkedExams)) {
        state.linkedExams = entities;
      }

      state.totalLinkedExamsResults = totalResults;
      state.apiStatus.searchExamsOfTeCoreType = ApiStatus.SUCCEEDED;
    });
    builder.addCase(searchExamsOfTeCoreType.pending, function (state) {
      state.apiStatus.searchExamsOfTeCoreType = ApiStatus.LOADING;
    });
    builder.addCase(searchExamsOfTeCoreType.rejected, function (state) {
      state.apiStatus.searchExamsOfTeCoreType = ApiStatus.FAILED;
    });
    /* FETCH ALL FROM LINKED EXAMS */

    builder.addCase(searchLinkedExams.fulfilled, function (state, action) {
      var _action$payload4 = action.payload,
          ids = _action$payload4.ids,
          linkedExams = _action$payload4.linkedExams,
          totalLinkedExamsResults = _action$payload4.totalLinkedExamsResults;
      state.ids = uniq(concat(state.ids, ids));
      state.linkedExams = linkedExams;
      state.totalLinkedExamsResults = totalLinkedExamsResults;
      state.apiStatus.searchLinkedExams = ApiStatus.SUCCEEDED;
    });
    builder.addCase(searchLinkedExams.pending, function (state) {
      state.apiStatus.searchLinkedExams = ApiStatus.LOADING;
    });
    builder.addCase(searchLinkedExams.rejected, function (state) {
      state.apiStatus.searchLinkedExams = ApiStatus.FAILED;
    }); // /* SEARCH BY IDS */
    // builder.addCase(searchExamsByIds.fulfilled, (state, action) => {
    //   const { ids, entities } = action.payload;
    //   state.ids = uniq(concat(state.ids, ids));
    //   ids.map((id: any) => {
    //     state.entities[id] = entities[id];
    //   });
    // });
  }
});
var exams$1 = exams;

var PrioritySchema = new schema.Entity('priorities', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var priority = {};
    priority.id = e.id;
    priority.targetDate = moment.unix(e.targetDate).utc() || moment.utc();
    priority.targetDate.startOf('days'); // priority.TargetDate = e.priority.targetDate.unix();

    priority.examSlotId = e.examSlotId || null;
    priority.intervalId = e.requestIntervalId || null;
    priority.roomId = e.roomId || null;
    priority.examId = e.examId || null;
    priority.order = e.order;
    priority.exactEndTime = e.exactEndTime || null;
    priority.exactStartTime = e.exactStartTime || null;
    priority.strictDate = Boolean(Number(e.strictDate || 0));
    priority.strictTime = Boolean(Number(e.strictTime || 0));
    return priority;
  }
});
var PrioritySchema$1 = PrioritySchema;

var _excluded$9 = ["exam_id"],
    _excluded2 = ["id"],
    _excluded3 = ["id"],
    _excluded4 = ["exam_id"],
    _excluded5 = ["id"];
//   builder.addCase(
//     asyncThunk.pending,
//     (state: any) => (state.apiStatus[asyncThunk.name] = 'pending')
//   );
//   builder.addCase(
//     asyncThunk.fulfilled,
//     (state: any) => (state.apiStatus[asyncThunk.name] = 'fulfilled')
//   );
//   builder.addCase(
//     asyncThunk.rejected,
//     (state: any) => (state.apiStatus[asyncThunk.name] = 'rejected')
//   );
// }

var initialState$7 = {
  ids: [],
  entities: {},
  groupByExamId: {},
  apiStatus: {}
};
var fetchPrioritiesByExamIds = createAsyncThunk('priorities/fetchByExamIds', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(examIds, thunkApi) {
    var res, _normalize, entities, result;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return agent$1.Priority.fetchPrioritiesByExamIds(examIds);

          case 3:
            res = _context.sent;
            _normalize = normalize(res.data, [PrioritySchema$1]), entities = _normalize.entities, result = _normalize.result;
            return _context.abrupt("return", {
              entities: entities.priorities,
              ids: result,
              groupByExamId: mapValues(groupBy(entities.priorities, 'examId'), function (a) {
                return sortBy(a, 'order');
              })
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", thunkApi.rejectWithValue(_context.t0.data));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
createAsyncThunk('priorities/create', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, thunkApi) {
    var exam_id, props, res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            exam_id = values.exam_id, props = _objectWithoutProperties(values, _excluded$9);
            _context2.next = 4;
            return agent$1.Priority.create(exam_id, props);

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", thunkApi.rejectWithValue(_context2.t0.data));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
createAsyncThunk('priorities/updateOne', /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values, thunkApi) {
    var id, props, res;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            id = values.id, props = _objectWithoutProperties(values, _excluded2);
            _context3.next = 4;
            return agent$1.Priority.update(id, props);

          case 4:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", thunkApi.rejectWithValue(_context3.t0.data));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function (_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}());
createAsyncThunk('priorities/updateMultiple', /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(valuesList, thunkApi) {
    var promises, _iterator, _step, values, id, props;

    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            promises = [];
            _iterator = _createForOfIteratorHelper(valuesList);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                values = _step.value;
                id = values.id, props = _objectWithoutProperties(values, _excluded3);
                promises.push(agent$1.Priority.update(id, props));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return _context4.abrupt("return", Promise.all(promises));

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", thunkApi.rejectWithValue(_context4.t0.data));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function (_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}());
createAsyncThunk('priorities/createMultiple', /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(valuesList, thunkApi) {
    var promises, _iterator2, _step2, values, exam_id, others;

    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            promises = [];
            _iterator2 = _createForOfIteratorHelper(valuesList);

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                values = _step2.value;
                exam_id = values.exam_id, others = _objectWithoutProperties(values, _excluded4);
                promises.push(agent$1.Priority.create(exam_id, others));
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            return _context5.abrupt("return", Promise.all(promises));

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", thunkApi.rejectWithValue(_context5.t0.data));

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function (_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}());
createAsyncThunk('priorities/createOrUpdateMultiple', /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(valuesList, thunkApi) {
    var promises, _iterator3, _step3, values, id, props;

    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            promises = [];
            _iterator3 = _createForOfIteratorHelper(valuesList);

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                values = _step3.value;
                id = values.id, props = _objectWithoutProperties(values, _excluded5);

                if (id) {
                  promises.push(agent$1.Priority.update(id, props));
                } else if (props.exam_id) {
                  promises.push(agent$1.Priority.create(props.exam_id, props));
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            return _context6.abrupt("return", Promise.all(promises));

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", thunkApi.rejectWithValue(_context6.t0.data));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));

  return function (_x11, _x12) {
    return _ref6.apply(this, arguments);
  };
}());
var priorities = createSlice({
  name: 'priorities',
  initialState: initialState$7,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    /* FETCH EXAM TYPES */
    builder.addCase(fetchPrioritiesByExamIds.fulfilled, function (state, action) {
      var _action$payload = action.payload,
          ids = _action$payload.ids,
          entities = _action$payload.entities,
          groupByExamId = _action$payload.groupByExamId;
      state.ids = uniq(concat(state.ids, ids));
      merge(state.entities, entities);
      merge(state.groupByExamId, groupByExamId);
    });
  }
});
var priorities$1 = priorities;

var ExamTypeSchema = new schema.Entity('examTypes', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var examType = {};
    examType.id = e.id;
    examType.value = e.value;
    examType.label = e.label;
    examType.deletedAt = e.deletedAt;
    return examType;
  }
});
var ExamTypeSchema$1 = ExamTypeSchema;

var initialState$6 = {
  ids: [],
  entities: {},
  apiStatus: {
    fetchExamTypes: ApiStatus.IDLE
  }
};
var fetchExamTypes = createAsyncThunk('examTypes/fetchExamTypes', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, thunkApi) {
    var res, _normalize, entities, result;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return agent$1.Exam.fetchExamTypes();

          case 3:
            res = _context.sent;
            _normalize = normalize(res.results, [ExamTypeSchema$1]), entities = _normalize.entities, result = _normalize.result;
            return _context.abrupt("return", {
              entities: entities.examTypes,
              ids: result
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", thunkApi.rejectWithValue(_context.t0.data));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var examTypes = createSlice({
  name: 'examTypes',
  initialState: initialState$6,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    /* FETCH EXAM TYPES */
    builder.addCase(fetchExamTypes.fulfilled, function (state, action) {
      state.entities = action.payload.entities;
      state.ids = action.payload.ids;
      state.apiStatus.fetchExamTypes = ApiStatus.SUCCEEDED;
    });
    builder.addCase(fetchExamTypes.pending, function (state) {
      state.apiStatus.fetchExamTypes = ApiStatus.LOADING;
    });
    builder.addCase(fetchExamTypes.rejected, function (state) {
      state.apiStatus.fetchExamTypes = ApiStatus.FAILED;
    });
  }
});
var examTypes$1 = examTypes;

var TERoomObjectSchema = new schema.Entity('teRoomObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.description = e.description;
    obj.capacity = e.capacity;
    obj.floor = e.floor;
    obj.building = e.building;
    obj.campus = e.campus;
    obj.address = e.address;
    obj.pricePerSeatPerHour = e.pricePerSeatPerHour;
    obj.roomType = e.roomType;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TERoomObjectSchema$1 = TERoomObjectSchema;

var TEProfessorObjectSchema = new schema.Entity('teProfessorObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.id = e.id;
    obj.email = e.email;
    obj.department = e.department;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TEProfessorObjectSchema$1 = TEProfessorObjectSchema;

var TECoordinatorObjectSchema = new schema.Entity('teCoordinatorObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.id = e.id;
    obj.email = e.email;
    obj.department = e.department;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TECoordinatorObjectSchema$1 = TECoordinatorObjectSchema;

var TECourseObjectSchema = new schema.Entity('teCourseObject', {}, {
  idAttribute: 'teExtId',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.code = e.code;
    obj.credits = e.credits;
    obj.department = e.department;
    obj.courseCode = e.courseCode;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TECourseObjectSchema$1 = TECourseObjectSchema;

var TECourseEventObjectSchema = new schema.Entity('teCourseEventObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.id = e.id;
    obj.number = e.number;
    obj.courseName = e.courseName;
    obj.courseCode = e.courseCode;
    obj.department = e.department;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TECourseEventObjectSchema$1 = TECourseEventObjectSchema;

var TEModuleObjectSchema = new schema.Entity('teModuleObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid;
    obj.name = e.name;
    obj.id = e.id;
    obj.credits = e.credits;
    obj.code = e.code;
    obj.courseCode = e.courseCode;
    obj.department = e.department;
    obj.moduleId = e.moduleId;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TEModuleObjectSchema$1 = TEModuleObjectSchema;

var TECoursePartObjectSchema = new schema.Entity('teCoursePartObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid;
    obj.name = e.name;
    obj.id = e.id;
    obj.credits = e.credits;
    obj.code = e.code;
    obj.courseCode = e.courseCode;
    obj.department = e.department;
    obj.moduleId = e.moduleId;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TECoursePartObjectSchema$1 = TECoursePartObjectSchema;

var TEProgramObjectSchema = new schema.Entity('teProgramObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.id = e.id;
    obj.number = e.number;
    obj.credits = e.credits;
    obj.code = e.code;
    obj.courseCode = e.courseCode;
    obj.department = e.department;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TEProgramObjectSchema$1 = TEProgramObjectSchema;

var TEStudentGroupObjectSchema = new schema.Entity('teStudentGroupObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.id = e.id;
    obj.number = e.number;
    obj.courseName = e.courseName;
    obj.courseCode = e.courseCode;
    obj.department = e.department;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TEStudentGroupObjectSchema$1 = TEStudentGroupObjectSchema;

var TECostCenterObjectSchema = new schema.Entity('teCostCenterObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.id = e.id;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TECostCenterObjectSchema$1 = TECostCenterObjectSchema;

var TEDepartmentObjectSchema = new schema.Entity('teExtId', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.code = e.code;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TEDepartmentObjectSchema$1 = TEDepartmentObjectSchema;

var TEExternalCustomerObjectSchema = new schema.Entity('teExternalCustomerObject', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.teExtId = e.te_extid || '';
    obj.name = e.name;
    obj.id = e.id;
    obj.customField1 = e.customField1;
    obj.customField2 = e.customField2;
    obj.customField3 = e.customField3;
    obj.customField4 = e.customField4;
    obj.customField5 = e.customField5;
    obj.secondaryLabel = e.secondaryLabel;
    return obj;
  }
});
var TEExternalCustomerObjectSchema$1 = TEExternalCustomerObjectSchema;

var TEExamLanguageObjectSchema = new schema.Entity('teExtId', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var _e$te_extid, _e$secondaryLabel;

    var obj = {};
    obj.teExtId = (_e$te_extid = e === null || e === void 0 ? void 0 : e.te_extid) !== null && _e$te_extid !== void 0 ? _e$te_extid : '';
    obj.id = e.id || '';
    obj.value = e.value;
    obj.title = e.name;
    obj.name = e.name;
    obj.secondaryLabel = (_e$secondaryLabel = e === null || e === void 0 ? void 0 : e.secondaryLabel) !== null && _e$secondaryLabel !== void 0 ? _e$secondaryLabel : '';
    return obj;
  }
});
var TEExamLanguageObjectSchema$1 = TEExamLanguageObjectSchema;

var TEExamTypeObjectSchema = new schema.Entity('teExtId', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var _e$te_extid, _e$secondaryLabel;

    var obj = {};
    obj.teExtId = (_e$te_extid = e === null || e === void 0 ? void 0 : e.te_extid) !== null && _e$te_extid !== void 0 ? _e$te_extid : '';
    obj.id = e.id || '';
    obj.value = e.value;
    obj.title = e.name;
    obj.name = e.name;
    obj.secondaryLabel = (_e$secondaryLabel = e === null || e === void 0 ? void 0 : e.secondaryLabel) !== null && _e$secondaryLabel !== void 0 ? _e$secondaryLabel : '';
    return obj;
  }
});
var TEExamTypeObjectSchema$1 = TEExamTypeObjectSchema;

var initialState$5 = {
  TEObjectTypesHasError: false,
  teObjectIds: {},
  teObjectTypes: getExamPropertyName().reduce(function (rs, name) {
    return _objectSpread2(_objectSpread2({}, rs), {}, _defineProperty({}, name, {}));
  }, {}),
  relatedExtIds: getExamPropertyName().reduce(function (rs, name) {
    return _objectSpread2(_objectSpread2({}, rs), {}, _defineProperty({}, name, {}));
  }, {}),
  typeIdentified: {},
  reservationSettings: {},
  reservationSettingsLoading: true,
  relations: [],
  relationMap: {},
  loading: true,
  teObjectFieldsLoading: {},
  teObjects: {}
};
createAsyncThunk('authentication/login', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(orgId) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", agent$1.Org.fetchIntegrationSettings(orgId));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
var fetchObjectsOfType = createAsyncThunk('integration/fetchObjectsOfType', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(type) {
    var res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return agent$1.IntegrationService.fetchObjectsOfType(type);

          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", {
              type: type,
              objects: (res.data || []).map(function (obj) {
                return obj.fields || {};
              })
            });

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}());
var schemaMapping = {
  room: TERoomObjectSchema$1,
  professor: TEProfessorObjectSchema$1,
  coordinator: TECoordinatorObjectSchema$1,
  course: TECourseObjectSchema$1,
  courseEvent: TECourseEventObjectSchema$1,
  module: TEModuleObjectSchema$1,
  coursePart: TECoursePartObjectSchema$1,
  program: TEProgramObjectSchema$1,
  studentGroup: TEStudentGroupObjectSchema$1,
  costCenter: TECostCenterObjectSchema$1,
  department: TEDepartmentObjectSchema$1,
  externalCustomer: TEExternalCustomerObjectSchema$1,
  examType: TEExamTypeObjectSchema$1,
  examLanguage: TEExamLanguageObjectSchema$1
};
var integrationSettings = createSlice({
  name: 'integrationSettings',
  initialState: initialState$5,
  reducers: {
    storeReservationSettings: function storeReservationSettings(state, action) {
      state.reservationSettingsLoading = false;
      state.reservationSettings = keyBy(action.payload.paramMappings, 'appFieldId');
    },
    initTeObjectLoadingState: function initTeObjectLoadingState(state, action) {
      var _action$payload;

      state.teObjectFieldsLoading = ((_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : []).reduce(function (acc, item) {
        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, item, false));
      }, {});
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchObjectsOfType.pending, function (state, action) {
      state.teObjectFieldsLoading[action.meta.arg] = true;
    });
    builder.addCase(fetchObjectsOfType.fulfilled, function (state, action) {
      state.teObjectFieldsLoading[action.meta.arg] = false;
      var _action$payload2 = action.payload,
          type = _action$payload2.type,
          objects = _action$payload2.objects;
      if (!objects || !objects.length) return;

      var normalizedObjs = _.chain(objects).map(function (obj) {
        var schema = schemaMapping[type];
        if (!schema) return null;

        var _normalize = normalize(obj, schema),
            result = _normalize.result,
            entities = _normalize.entities;

        return entities[schema.key][result];
      }).compact().value();

      state.teObjects[type] = normalizedObjs;
      state.teObjectIds[type] = normalizedObjs.map(function (obj) {
        return obj.teExtId;
      });
      var teObjectsMapping = window.teObjects || {};
      teObjectsMapping[type] = _.keyBy(normalizedObjs, 'teExtId');
      window.teObjects = teObjectsMapping;
    });
    builder.addCase(fetchObjectsOfType.rejected, function (state, action) {
      state.teObjectFieldsLoading[action.meta.arg] = false;
    });
  }
});
var _integrationSettings$ = integrationSettings.actions,
    storeReservationSettings = _integrationSettings$.storeReservationSettings,
    initTeObjectLoadingState = _integrationSettings$.initTeObjectLoadingState;
var integrationSettings$1 = integrationSettings;

var LanguageSchema = new schema.Entity('languages', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var language = {};
    language.id = e.id;
    language.value = e.value;
    language.label = e.label;
    language.deleted_at = e.deleted_at;
    return language;
  }
});
var LanguageSchema$1 = LanguageSchema;

var initialState$4 = {
  ids: [],
  entities: {},
  apiStatus: {
    fetchLanguages: ApiStatus.IDLE
  }
};
var fetchLanguages = createAsyncThunk('languages/fetchAll', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, thunkApi) {
    var res, _normalize, entities, result;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return agent$1.Language.fetchAll();

          case 3:
            res = _context.sent;
            _normalize = normalize(res.results, [LanguageSchema$1]), entities = _normalize.entities, result = _normalize.result;
            return _context.abrupt("return", {
              entities: entities.languages,
              ids: result
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", thunkApi.rejectWithValue(_context.t0.data));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var languages = createSlice({
  name: 'languages',
  initialState: initialState$4,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    /* FETCH LANGUAGES */
    builder.addCase(fetchLanguages.fulfilled, function (state, action) {
      state.entities = action.payload.entities;
      state.ids = action.payload.ids;
      state.apiStatus.fetchLanguages = ApiStatus.SUCCEEDED;
    });
    builder.addCase(fetchLanguages.pending, function (state) {
      state.apiStatus.fetchLanguages = ApiStatus.LOADING;
    });
    builder.addCase(fetchLanguages.rejected, function (state) {
      state.apiStatus.fetchLanguages = ApiStatus.FAILED;
    });
  }
});
var languages$1 = languages;

var ExamMandatoryObjectsSchema = new schema.Entity('examMandatoryObjects', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: buildMandatoryObjects
});

function buildMandatoryObjects() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    isInitialState: false
  };
  var obj = {};
  var isLockedLanguageAndType = isLockedFeature(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE);
  var examPropertyName = options.isInitialState ? getExamPropertyNameForInitialState() : getExamPropertyName(isLockedLanguageAndType);

  var _iterator = _createForOfIteratorHelper(examPropertyName),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var name = _step.value;
      obj[name] = {
        disabled: defaultTo(e["".concat(name, "Disabled")], true),
        mandatory: defaultTo(e["".concat(name, "Mandatory")], true),
        multiple: name !== 'campus' ? defaultTo(e["".concat(name, "Multiple")], false) : false,
        shouldPublish: name !== 'campus' ? defaultTo(e["".concat(name, "ShouldPublish")], false) : false,
        showToStudent: name !== 'campus' ? defaultTo(e["".concat(name, "ShowToStudent")], false) : false
      };
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  obj.linkedExam = {
    disabled: defaultTo(e.linkExamDisabled, true)
  };
  return obj;
}

var RequestSettingsSchema = new schema.Entity('requestSettings', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var obj = {};
    obj.id = e.id;
    obj.useIntervals = !!e.useIntervals;
    obj.allowDateParam = !!e.allowDateRequest;
    obj.allowRoomParam = !!e.allowRoomRequest;
    obj.allowIntervalOrSlotParam = !!e.allowIntervalRequest;
    obj.maxRequestNumber = e.requestNumber || 0;
    obj.minRequestNumber = e.minRequestNumber || 0;
    obj.maxOnePerDay = !!e.maxOnePerDay;
    obj.useTeCoreIntervals = !!e.teCoreUseIntervals;
    obj.allowTeCoreDateParam = !!e.teCoreAllowDateRequest;
    obj.allowTeCoreRoomParam = !!e.teCoreAllowRoomRequest;
    obj.allowTeCoreIntervalOrSlotParam = !!e.teCoreAllowIntervalRequest;
    obj.teCoreMaxRequestNumber = e.teCoreRequestNumber || 0;
    obj.teCoreMinRequestNumber = e.teCoreMinRequestNumber || 0;
    obj.teCoreAllowExactTime = !!e.teCoreAllowExactTimeRequest;
    obj.teCoreAllowStrictDate = !!e.teCoreAllowStrictDateRequest;
    obj.teCoreAllowStrictTime = !!e.teCoreAllowStrictTimeRequest;
    obj.teCoreMaxOnePerDay = !!e.teCoreMaxOnePerDay;
    return obj;
  }
});
var RequestSettingsSchema$1 = RequestSettingsSchema;

var ExamSettingsSchema = new schema.Entity('examSettings', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: buildExamSettings
});

function buildExamSettings() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var obj = {};
  var id = e.id,
      exam_title_instruction = e.exam_title_instruction,
      booking_request_expired_day = e.booking_request_expired_day,
      room_booking_supervisor_count = e.room_booking_supervisor_count,
      _e$allow_simple_alloc = e.allow_simple_allocation,
      allow_simple_allocation = _e$allow_simple_alloc === void 0 ? false : _e$allow_simple_alloc,
      _e$allow_manager_to_p = e.allow_manager_to_publish,
      allow_manager_to_publish = _e$allow_manager_to_p === void 0 ? true : _e$allow_manager_to_p;
  obj.id = id;
  obj.examTitleInstruction = exam_title_instruction;
  obj.supervisorBookingExpirationDays = booking_request_expired_day;
  obj.roomBookingSupervisorCount = room_booking_supervisor_count;
  obj.allowSimpleAllocation = !!allow_simple_allocation;
  obj.allowManagerToPublish = !!allow_manager_to_publish;
  return obj;
}
var ExamSettingsSchema$1 = ExamSettingsSchema;

var initialState$3 = {
  organization: {},
  lockedFeatures: [],
  integrationSettings: {},
  registeredStudentsMapping: {},
  requestIntervals: {},
  requestSetting: {},
  mandatoryObjects: buildMandatoryObjects({}, {
    isInitialState: true
  }),
  examSettings: buildExamSettings(),
  isRegisteredStudentsMappingSet: false,
  apiStatus: {
    fetchMandatoryObjects: ApiStatus.IDLE,
    fetchExamSettings: ApiStatus.IDLE,
    fetchAppSettings: ApiStatus.IDLE,
    fetchIntegrationSettings: ApiStatus.IDLE,
    fetchObjectTypeMapping: ApiStatus.IDLE,
    fetchFeatureFlags: ApiStatus.IDLE
  },
  examInCore: {},
  teObjectTypes: {}
};
var fetchIntegrationSettings = createAsyncThunk('organization/fetchIntegrationSettings', function (orgId) {
  return agent$1.Org.fetchIntegrationSettings(orgId);
});
var fetchMandatoryObjects = createAsyncThunk('organization/fetchMandatoryObjects', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var res, _normalize, result, entities;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return agent$1.Org.fetchMandatoryObjects();

        case 2:
          res = _context.sent;
          _normalize = normalize(res, ExamMandatoryObjectsSchema), result = _normalize.result, entities = _normalize.entities;
          return _context.abrupt("return", entities.examMandatoryObjects[result]);

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
var fetchRequestSettings = createAsyncThunk('organization/fetchRequestSettings', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var res, _normalize2, result, entities;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return agent$1.Org.fetchReqSetting();

        case 2:
          res = _context2.sent;
          _normalize2 = normalize(res, RequestSettingsSchema$1), result = _normalize2.result, entities = _normalize2.entities;
          return _context2.abrupt("return", entities.requestSettings[result]);

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
})));
var fetchExamSettings = createAsyncThunk('organization/fetchExamSettings', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var res, _normalize3, entities, result;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return agent$1.Org.fetchExamSettings();

        case 2:
          res = _context3.sent;
          _normalize3 = normalize(res, ExamSettingsSchema$1), entities = _normalize3.entities, result = _normalize3.result;
          return _context3.abrupt("return", entities.examSettings[result]);

        case 5:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3);
})));
var fetchIntervals = createAsyncThunk('organization/fetchIntervals', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var res;
  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return agent$1.Org.fetchReqIntervals();

        case 2:
          res = _context4.sent;
          return _context4.abrupt("return", res);

        case 4:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4);
})));
var fetchAppSettings = createAsyncThunk('organization/fetchAppSettings', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var res;
  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return agent$1.Org.fetchAppSettings();

        case 2:
          res = _context5.sent;
          return _context5.abrupt("return", res);

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5);
})));
var fetchObjectTypeMapping = createAsyncThunk('organization/fetchObjectTypeMapping', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var res;
  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return agent$1.Org.fetchObjectTypeMapping();

        case 2:
          res = _context6.sent;
          return _context6.abrupt("return", res.objectTypes);

        case 4:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6);
})));
var fetchFeatureFlags = createAsyncThunk('organization/fetchFeatureFlag', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var _res$lockedFeatures;

  var res, lockedFeatures;
  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return agent$1.Org.fetchFeatureFlags();

        case 2:
          res = _context7.sent;
          lockedFeatures = (_res$lockedFeatures = res === null || res === void 0 ? void 0 : res.lockedFeatures) !== null && _res$lockedFeatures !== void 0 ? _res$lockedFeatures : [];
          window.localStorage.setItem('lockedFeatures', JSON.stringify(lockedFeatures));
          return _context7.abrupt("return", lockedFeatures);

        case 6:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7);
})));
var organization = createSlice({
  name: 'organization',
  initialState: initialState$3,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    /* FETCH INTEGRATION SETTINGS */
    builder.addCase(fetchIntegrationSettings.fulfilled, function (state, action) {
      var _action$payload;

      state.integrationSettings = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data;
      state.apiStatus.fetchIntegrationSettings = ApiStatus.SUCCEEDED;
    });
    builder.addCase(fetchIntegrationSettings.pending, function (state) {
      state.apiStatus.fetchIntegrationSettings = ApiStatus.LOADING;
    });
    builder.addCase(fetchIntegrationSettings.rejected, function (state) {
      state.apiStatus.fetchIntegrationSettings = ApiStatus.FAILED;
    });
    /* FETCH MANDATORY OBJECTS */

    builder.addCase(fetchMandatoryObjects.fulfilled, function (state, action) {
      state.mandatoryObjects = action.payload;
      state.apiStatus.fetchMandatoryObjects = ApiStatus.SUCCEEDED;
    });
    /* FETCH REQUEST SETTINGS */

    builder.addCase(fetchRequestSettings.fulfilled, function (state, action) {
      state.requestSetting = action.payload;
    });
    /* FETCH EXAM SETTINGS */

    builder.addCase(fetchExamSettings.fulfilled, function (state, action) {
      state.examSettings = action.payload;
      state.apiStatus.fetchExamSettings = ApiStatus.SUCCEEDED;
    });
    builder.addCase(fetchExamSettings.pending, function (state) {
      state.apiStatus.fetchExamSettings = ApiStatus.LOADING;
    });
    builder.addCase(fetchExamSettings.rejected, function (state) {
      state.apiStatus.fetchExamSettings = ApiStatus.FAILED;
    });
    /* FETCH APP SETTINGS */

    builder.addCase(fetchAppSettings.fulfilled, function (state, action) {
      state.examInCore = action.payload;
      state.apiStatus.fetchAppSettings = ApiStatus.SUCCEEDED;
    });
    builder.addCase(fetchAppSettings.pending, function (state) {
      state.apiStatus.fetchAppSettings = ApiStatus.LOADING;
    });
    builder.addCase(fetchAppSettings.rejected, function (state) {
      state.apiStatus.fetchAppSettings = ApiStatus.FAILED;
    });
    /* FETCH OBJECT TYPE MAPPING */

    builder.addCase(fetchObjectTypeMapping.fulfilled, function (state, action) {
      var teObjectTypes = {};
      action.payload.forEach(function (type) {
        teObjectTypes[type.applicationObjectTypeName] = _objectSpread2(_objectSpread2({}, type), {}, {
          fields: type.fields.reduce(function (rs, field) {
            return _objectSpread2(_objectSpread2({}, rs), {}, _defineProperty({}, field.appFieldName, field));
          }, {})
        });
      });
      state.teObjectTypes = teObjectTypes;
      state.apiStatus.fetchObjectTypeMapping = ApiStatus.SUCCEEDED;
    });
    builder.addCase(fetchObjectTypeMapping.pending, function (state) {
      state.apiStatus.fetchObjectTypeMapping = ApiStatus.LOADING;
    });
    builder.addCase(fetchObjectTypeMapping.rejected, function (state) {
      state.apiStatus.fetchObjectTypeMapping = ApiStatus.FAILED;
    });
    /* FETCH FEATURE FLAGS */

    builder.addCase(fetchFeatureFlags.fulfilled, function (state, action) {
      state.lockedFeatures = action.payload || [];
      state.apiStatus.fetchFeatureFlags = ApiStatus.SUCCEEDED;
    });
    builder.addCase(fetchFeatureFlags.pending, function (state) {
      state.apiStatus.fetchFeatureFlags = ApiStatus.LOADING;
    });
    builder.addCase(fetchFeatureFlags.rejected, function (state) {
      state.apiStatus.fetchFeatureFlags = ApiStatus.FAILED;
    });
  }
});
var organization$1 = organization;

var RoomSchema = new schema.Entity('rooms', {}, {
  idAttribute: 'id',
  mergeStrategy: function mergeStrategy(a, b) {
    return _objectSpread2(_objectSpread2({}, a), b);
  },
  processStrategy: function processStrategy(e) {
    var room = {
      id: e.id,
      teExtId: e.teExtid,
      name: e.name,
      description: e.description,
      capacity: e.capacity,
      floor: e.floor,
      building: e.building,
      campus: e.campus,
      address: e.address,
      pricePerSeatPerHour: e.pricePerSeatPerHour,
      roomType: e.roomType,
      deleted: !!e.deletedAt,
      customField1: e.customField1,
      customField2: e.customField2,
      customField3: e.customField3,
      customField4: e.customField4,
      customField5: e.customField5,
      secondaryLabel: e.secondaryLabel
    };
    return room;
  }
});
var RoomSchema$1 = RoomSchema;

var initialState$2 = {
  ids: [],
  entities: {},
  apiStatus: {
    fetchRooms: ApiStatus.IDLE
  }
};
var fetchRooms = createAsyncThunk('rooms/fetchAll', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var res, normalized;
  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return agent$1.Room.fetchAll();

        case 2:
          res = _context.sent;
          normalized = normalize(res.results, [RoomSchema$1]);
          return _context.abrupt("return", {
            entities: normalized.entities.rooms,
            ids: normalized.result
          });

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
var rooms = createSlice({
  name: 'rooms',
  initialState: initialState$2,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    /* FETCH LANGUAGES */
    builder.addCase(fetchRooms.fulfilled, function (state, action) {
      state.entities = action.payload.entities;
      state.ids = action.payload.ids;
      state.apiStatus.fetchRooms = ApiStatus.SUCCEEDED;
    });
    builder.addCase(fetchRooms.pending, function (state) {
      state.apiStatus.fetchRooms = ApiStatus.LOADING;
    });
    builder.addCase(fetchRooms.rejected, function (state) {
      state.apiStatus.fetchRooms = ApiStatus.FAILED;
    });
  }
});
var rooms$1 = rooms;

var initialState$1 = {
  reservations: undefined,
  drafts: undefined
};
var draftSlice = createSlice({
  name: 'draft',
  initialState: initialState$1,
  reducers: {
    initializeDrafts: function initializeDrafts(state, action) {
      var _action$payload = action.payload,
          reservations = _action$payload.reservations,
          drafts = _action$payload.drafts;
      return {
        reservations: reservations,
        drafts: drafts
      };
    },
    removeDrafts: function removeDrafts(state, action) {
      var _state$drafts;

      var idsToRemove = action.payload;
      return _objectSpread2(_objectSpread2({}, state), {}, {
        drafts: (_state$drafts = state.drafts) === null || _state$drafts === void 0 ? void 0 : _state$drafts.filter(function (draft) {
          return !idsToRemove.includes(draft.reservationId);
        })
      });
    },
    saveExamDraft: function saveExamDraft(state, action) {
      if (!state.drafts) {
        notification.error({
          message: 'Unable to save, drafts have not been initialized'
        });
        return;
      }

      var index = state.drafts.findIndex(function (exam) {
        return exam.reservationId === action.payload.reservationId;
      });

      if (index === -1) {
        notification.error({
          message: "Unable to save, reservation doesn't exist"
        });
        return;
      }

      state.drafts[index] = action.payload;
    }
  }
});
var _draftSlice$actions = draftSlice.actions,
    initializeDrafts = _draftSlice$actions.initializeDrafts,
    removeDrafts = _draftSlice$actions.removeDrafts,
    saveExamDraft = _draftSlice$actions.saveExamDraft;
var draftSlice$1 = draftSlice;

var initialState = {
  curReservations: null,
  selectedExamId: null,
  selectedReservation: null,
  originalExamId: null,
  mode: 'ALL',
  originalMode: 'ALL'
};
var selectionSlice = createSlice({
  name: 'navigation',
  initialState: initialState,
  reducers: {
    setInitialNavigation: function setInitialNavigation(state, action) {
      state.mode = action.payload.mode;
      state.originalMode = action.payload.mode;
      state.curReservations = normalizeReservations(action.payload.reservations);
    },
    clearCurReservations: function clearCurReservations(state) {
      state.curReservations = null;
    },
    setSelectedReservation: function setSelectedReservation(state, action) {
      state.selectedReservation = action.payload;
    },
    doGotoEditExam: function doGotoEditExam(state, action) {
      state.selectedExamId = action.payload;
      state.mode = 'EDIT';
    },
    setMode: function setMode(state, action) {
      state.mode = action.payload;
    },
    gotoAllExams: function gotoAllExams(state) {
      state.mode = 'ALL';
    },
    gotoCreateNewExam: function gotoCreateNewExam(state, action) {
      state.mode = 'CREATE';
      state.selectedExamId = null;

      if (action.payload) {
        state.curReservations = [action.payload];
      }
    }
  }
});

var normalizeReservations = function normalizeReservations(reservations) {
  return reservations ? reservations.map(normalizeReservation) : [];
};

var normalizeReservation = function normalizeReservation(reservation) {
  return {
    objects: reservation.objects,
    begin: moment.unix(reservation.begin).startOf('m').unix(),
    end: moment.unix(reservation.end).startOf('m').unix(),
    id: reservation.id,
    mode: reservation.mode,
    fields: reservation.fields
  };
};

var _selectionSlice$actio = selectionSlice.actions,
    setMode = _selectionSlice$actio.setMode,
    gotoCreateNewExam = _selectionSlice$actio.gotoCreateNewExam,
    gotoAllExams = _selectionSlice$actio.gotoAllExams,
    setSelectedReservation = _selectionSlice$actio.setSelectedReservation,
    setInitialNavigation = _selectionSlice$actio.setInitialNavigation,
    clearCurReservations = _selectionSlice$actio.clearCurReservations,
    doGotoEditExam = _selectionSlice$actio.doGotoEditExam;
var selectionSlice$1 = selectionSlice;

var _reducer;
var store = configureStore({
  reducer: (_reducer = {
    auth: authentication$1.reducer,
    organization: organization$1.reducer,
    examTypes: examTypes$1.reducer,
    languages: languages$1.reducer,
    integrationSettings: integrationSettings$1.reducer,
    rooms: rooms$1.reducer,
    exams: exams$1.reducer,
    priorities: priorities$1.reducer,
    users: users.reducer
  }, _defineProperty(_reducer, baseApi.reducerPath, baseApi.reducer), _defineProperty(_reducer, "draft", draftSlice$1.reducer), _defineProperty(_reducer, "selection", selectionSlice$1.reducer), _reducer),
  middleware: function middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      serializableCheck: false
    }).concat(baseApi.middleware);
  }
});
var useAppDispatch = function useAppDispatch() {
  return useDispatch();
};
var useAppSelector = useSelector;

var featureFlagApi = baseApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getFeatureFlags: build.query({
        query: function query(organizationId) {
          return "/feature-flag/organization/".concat(organizationId);
        }
      })
    };
  }
});
var useGetFeatureFlagsQuery = featureFlagApi.useGetFeatureFlagsQuery;

var useIsLockedFeature = function useIsLockedFeature(feature) {
  var _data$lockedFeatures$, _data$lockedFeatures;

  var organizationId = useAppSelector(function (state) {
    var _state$auth$user;

    return (_state$auth$user = state.auth.user) === null || _state$auth$user === void 0 ? void 0 : _state$auth$user.organizationId;
  });

  var _useGetFeatureFlagsQu = useGetFeatureFlagsQuery(organizationId !== null && organizationId !== void 0 ? organizationId : skipToken),
      data = _useGetFeatureFlagsQu.data;

  return (_data$lockedFeatures$ = data === null || data === void 0 ? void 0 : (_data$lockedFeatures = data.lockedFeatures) === null || _data$lockedFeatures === void 0 ? void 0 : _data$lockedFeatures.includes(feature)) !== null && _data$lockedFeatures$ !== void 0 ? _data$lockedFeatures$ : true;
};

var getExamStatus = function getExamStatus(exam) {
  var _exam$childExams, _exam$childExams$;

  if (!exam) {
    return EXAM_STATUSES.PENDING;
  } // Single


  if (!((_exam$childExams = exam.childExams) !== null && _exam$childExams !== void 0 && _exam$childExams.length)) {
    if (!exam.isScheduled) {
      return EXAM_STATUSES.PENDING;
    }

    if (moment.utc(exam.scheduledExamDate).isBefore(moment.utc().startOf('day'))) {
      return EXAM_STATUSES.PAST;
    }

    return EXAM_STATUSES.SCHEDULED;
  } // Group


  var isAllChildrenScheduled = exam.childExams.every(function (childExam) {
    return childExam.isScheduled;
  });
  var studentsPlannedChildren = exam.childExams.reduce(function (tot, childExam) {
    return tot + ((childExam === null || childExam === void 0 ? void 0 : childExam.studentsPlanned) || 0);
  }, 0);
  var isPast = exam.childExams[0] && moment.utc((_exam$childExams$ = exam.childExams[0]) === null || _exam$childExams$ === void 0 ? void 0 : _exam$childExams$.scheduledExamDate).isBefore(moment.utc().startOf('day'));

  if (isAllChildrenScheduled) {
    if (studentsPlannedChildren === ((exam === null || exam === void 0 ? void 0 : exam.studentsPlanned) || 0)) {
      return isPast ? EXAM_STATUSES.PAST : EXAM_STATUSES.SCHEDULED;
    }
  }

  return EXAM_STATUSES.PENDING;
};

var mapIdsToObjects = function mapIdsToObjects(ids, objectMap) {
  return castArray(ids).map(function (id) {
    return objectMap[id];
  }).filter(Boolean);
};

var useExams = function useExams() {
  var examMap = useSelector(function (state) {
    var _state$exams;

    return ((_state$exams = state.exams) === null || _state$exams === void 0 ? void 0 : _state$exams.entities) || {};
  });
  var teObjects = useAppSelector(selectTeObjects);
  var courseMap = keyBy(teObjects.course, 'teExtId');
  var courseEventMap = keyBy(teObjects.courseEvent, 'teExtId');
  var professorMap = keyBy(teObjects.professor, 'teExtId');
  var costCenterMap = keyBy(teObjects.costCenter, 'teExtId');
  var coordinatorMap = keyBy(teObjects.coordinator, 'teExtId');
  var examTypeMap = keyBy(teObjects.examType, 'teExtId');
  var examLanguageMap = keyBy(teObjects.examLanguage, 'teExtId');
  var isLockedExamTypeExamLanguage = useIsLockedFeature(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE);
  var userMap = useSelector(function (state) {
    var _state$users;

    return ((_state$users = state.users) === null || _state$users === void 0 ? void 0 : _state$users.entities) || {};
  });
  var getStatus = useCallback(getExamStatus, [examMap]);
  var getExamHierarchy = useCallback(function (exam) {
    if (!exam.parent) {
      return {
        parent: exam,
        children: exam.childExams || []
      };
    }

    var parentExam = (examMap === null || examMap === void 0 ? void 0 : examMap[exam.parent]) || {};
    return {
      parent: parentExam,
      children: []
    };
  }, [examMap]);
  var exams = useMemo(function () {
    var examIds = Object.keys(examMap);
    var examObjectMap = examIds.reduce(function (map, id) {
      var _exam$priorities;

      var exam = examMap[id];
      map[id] = {
        status: getStatus(exam),
        examHierarchy: getExamHierarchy(exam),
        priorities: (_exam$priorities = exam.priorities) !== null && _exam$priorities !== void 0 ? _exam$priorities : [],
        courses: mapIdsToObjects(exam.courseIds, courseMap),
        professors: mapIdsToObjects(exam.professorIds, professorMap),
        courseEvents: mapIdsToObjects(exam.courseEventIds, courseEventMap),
        costCenters: mapIdsToObjects(exam.costCenterIds, costCenterMap),
        coordinators: mapIdsToObjects(exam.coordinatorIds, coordinatorMap),
        owner: userMap[exam.ownerId],
        examTypes: isLockedExamTypeExamLanguage ? exam.examType : mapIdsToObjects(exam.examTypeIds, examTypeMap),
        examLanguages: isLockedExamTypeExamLanguage ? exam.language : mapIdsToObjects(exam.examLanguageIds, examLanguageMap)
      };
      return map;
    }, {});
    return examIds.reduce(function (acu, id) {
      acu[id] = _objectSpread2(_objectSpread2({}, examMap[id]), examObjectMap[id]);
      return acu;
    }, {});
  }, [examMap, courseMap, professorMap, courseEventMap, costCenterMap, coordinatorMap, userMap, getStatus, getExamHierarchy, isLockedExamTypeExamLanguage]);
  return exams;
};
var sanitizeExtId = function sanitizeExtId(extId) {
  // Replace all non-alphanumeric and non-underscore characters with underscores
  return extId.replace(/[^a-zA-Z0-9_]/g, '_');
};
function convertFieldsToObject(data) {
  if (!data) {
    return undefined;
  }

  return data.reduce(function (acc, item) {
    if (!item.fields) {
      return acc;
    }

    var key = sanitizeExtId(item.extid);
    acc[key] = item.fields.reduce(function (fieldAcc, field) {
      var _field$values;

      var fieldKey = "".concat(sanitizeExtId(item.typeextid), ".").concat(sanitizeExtId(field.extid));
      fieldAcc[fieldKey] = ((_field$values = field === null || field === void 0 ? void 0 : field.values) !== null && _field$values !== void 0 ? _field$values : []).join(',');
      return fieldAcc;
    }, {});
    return acc;
  }, {});
}

var EPReservationFieldPrefix = 'EPreservationField';

var selectCurrentOrganization = function selectCurrentOrganization(state) {
  return state.organization.organization;
};

var selectReqIntervalsMap = function selectReqIntervalsMap(state) {
  return state.organization.requestIntervals;
};

var selectReqSettings = function selectReqSettings(state) {
  return state.organization.requestSetting;
};
var selectMandatoryObjects = function selectMandatoryObjects(state) {
  return state.organization.mandatoryObjects;
};
var selectExamInCoreSettings = function selectExamInCoreSettings(state) {
  return state.organization.examInCore;
};
var selectTeObjectTypes = function selectTeObjectTypes(state) {
  return state.organization.teObjectTypes;
};
var selectLockedFeature = function selectLockedFeature(state) {
  return state.organization.lockedFeatures;
};
createSelector(selectReqIntervalsMap, function (timeIntervalMap) {
  return Object.values(timeIntervalMap || {});
});
var isExamObjectEnabled = createSelector([selectMandatoryObjects, function (_, name) {
  return name;
}], function (mandatoryObjects, name) {
  if (![].concat(_toConsumableArray(getExamPropertyName()), ['linkedExam']).includes(name)) return null;
  return !mandatoryObjects[name].disabled;
});

var getConfigurableFieldsGetter = function getConfigurableFieldsGetter(settingFields) {
  if (!settingFields) {
    return function () {
      return {
        title: '',
        studentsPlanned: 0,
        adminInfo: '',
        studentInfo: '',
        supervisorInfo: '',
        externalRef: ''
      };
    };
  }

  var lookupObject = function lookupObject(examObject, transformed) {
    var _ref, _matchingObject$field;

    if (!transformed) return null;
    var key = sanitizeExtId("".concat(examObject === null || examObject === void 0 ? void 0 : examObject.field));
    var mode = sanitizeExtId("".concat(examObject === null || examObject === void 0 ? void 0 : examObject.mode));
    var field = "".concat(mode, ".").concat(key);
    var matchingObject = Object.values(transformed).find(function (obj) {
      var _obj$field;

      return (_obj$field = obj === null || obj === void 0 ? void 0 : obj[field]) !== null && _obj$field !== void 0 ? _obj$field : obj === null || obj === void 0 ? void 0 : obj["".concat(EPReservationFieldPrefix, ".").concat(key)];
    });
    return (_ref = (_matchingObject$field = matchingObject === null || matchingObject === void 0 ? void 0 : matchingObject[field]) !== null && _matchingObject$field !== void 0 ? _matchingObject$field : matchingObject === null || matchingObject === void 0 ? void 0 : matchingObject["".concat(EPReservationFieldPrefix, ".").concat(key)]) !== null && _ref !== void 0 ? _ref : null;
  };

  var getField = function getField(field, transformed) {
    if (!field) return '';
    var value = lookupObject(field, transformed);
    return field === settingFields.student ? Number(value) || 0 : value !== null && value !== void 0 ? value : '';
  };

  return function (transformed) {
    return {
      title: getField(settingFields.examTitle, transformed),
      studentsPlanned: getField(settingFields.student, transformed),
      adminInfo: getField(settingFields.adminInfo, transformed),
      studentInfo: getField(settingFields.studentInfo, transformed),
      supervisorInfo: getField(settingFields.supervisorInfo, transformed),
      externalRef: getField(settingFields.externalRef, transformed)
    };
  };
};
var useConfigurableFieldsGetter = function useConfigurableFieldsGetter() {
  var examInCoreSettings = useAppSelector(selectExamInCoreSettings);
  return useMemo(function () {
    var _examInCoreSettings$c;

    return getConfigurableFieldsGetter((_examInCoreSettings$c = examInCoreSettings === null || examInCoreSettings === void 0 ? void 0 : examInCoreSettings.configureFields) !== null && _examInCoreSettings$c !== void 0 ? _examInCoreSettings$c : {});
  }, [examInCoreSettings]);
};

var integrationServiceApi = baseApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getObjectsSearch: build.query({
        query: function query(_ref) {
          var objectIds = _ref.objectIds;
          return {
            method: 'POST',
            url: "/integration-service/objects/search",
            body: {
              objectIds: objectIds
            }
          };
        }
      })
    };
  }
});
var useGetObjectsSearchQuery = integrationServiceApi.useGetObjectsSearchQuery;

var _excluded$8 = ["te_extid"];

/**
 * Fetch extra fields that were not sent by core
 * Used when mapping fields
 */
var useReservationObjectFields = function useReservationObjectFields(reservations) {
  var _useAppSelector, _uniq$filter;

  var typesUsedByFields = uniq(Object.values((_useAppSelector = useAppSelector(function (state) {
    var _state$organization$e;

    return (_state$organization$e = state.organization.examInCore) === null || _state$organization$e === void 0 ? void 0 : _state$organization$e.configureFields;
  })) !== null && _useAppSelector !== void 0 ? _useAppSelector : {}).map(function (f) {
    return f.mode;
  }));
  var objectIds = (_uniq$filter = uniq(reservations === null || reservations === void 0 ? void 0 : reservations.flatMap(function (r) {
    var _filter$map, _r$objects;

    return (_filter$map = ((_r$objects = r === null || r === void 0 ? void 0 : r.objects) !== null && _r$objects !== void 0 ? _r$objects : []).filter(function (o) {
      return typesUsedByFields.includes(o.typeextid);
    }).map(function (o) {
      return o.extid;
    })) !== null && _filter$map !== void 0 ? _filter$map : [];
  })).filter(function (objectId) {
    return !isEmpty(objectId);
  })) !== null && _uniq$filter !== void 0 ? _uniq$filter : [];
  var params = objectIds && objectIds.length > 0 ? {
    objectIds: objectIds
  } : undefined;

  var _useGetObjectsSearchQ = useGetObjectsSearchQuery(params !== null && params !== void 0 ? params : skipToken$1),
      data = _useGetObjectsSearchQ.currentData,
      isLoading = _useGetObjectsSearchQ.isFetching;

  return useMemo(function () {
    var _data$data;

    if (!data) {
      return {
        data: undefined,
        isLoading: isLoading
      };
    }

    var result = {};

    var _iterator = _createForOfIteratorHelper((_data$data = data === null || data === void 0 ? void 0 : data.data) !== null && _data$data !== void 0 ? _data$data : []),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var object = _step.value;

        var _object$fields = object.fields,
            te_extid = _object$fields.te_extid,
            fields = _objectWithoutProperties(_object$fields, _excluded$8);

        if (te_extid) {
          result[te_extid] = fields;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return {
      data: result,
      isLoading: isLoading
    };
  }, [data, isLoading]);
};

var _shouldUsePrimaryLanguage;

var shouldUsePrimaryLanguage = function shouldUsePrimaryLanguage() {
  if (_shouldUsePrimaryLanguage === undefined) {
    var storeState = store.getState();

    var userLanguage = _.get(storeState, 'auth.user.language');

    var primaryLanguage = _.get(storeState, 'organization.organization.primaryLanguage');

    var secondaryLanguage = _.get(storeState, 'organization.organization.secondaryLanguage');

    if (!userLanguage || !primaryLanguage || !secondaryLanguage) {
      _shouldUsePrimaryLanguage = true;
    } else {
      _shouldUsePrimaryLanguage = userLanguage === primaryLanguage || userLanguage !== secondaryLanguage;
    }
  }

  return _shouldUsePrimaryLanguage;
};

var createColumnsFromConstant = function createColumnsFromConstant(constant) {
  return (Object.keys(constant) || []).filter(function (key) {
    return constant[key].hide !== true;
  }).map(function (key) {
    return {
      title: constant[key].label,
      dataIndex: constant[key].value,
      key: key,
      render: constant[key].render ? function (value) {
        return constant[key].render(value);
      } : undefined
    };
  });
};
var createDataSourceForTable = function createDataSourceForTable(constant, dataArray) {
  var dataSrc = dataArray.map(function (el, idx) {
    var retEl = {};
    (Object.keys(constant) || []).forEach(function (key) {
      retEl[constant[key].value] = el[constant[key].value];
    });
    return _objectSpread2(_objectSpread2({}, retEl), {}, {
      rowKey: "row-idx-".concat(idx)
    });
  });
  return dataSrc;
};
var createColumnsFromObjectType = function createColumnsFromObjectType() {
  var objectType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var labelFieldToRemove = null;

  if (objectType.labelField !== objectType.secondaryLabelField) {
    labelFieldToRemove = shouldUsePrimaryLanguage() ? objectType.secondaryLabelField : objectType.labelField;
  }

  return Object.values(objectType.fields || {}).reduce(function (rs, _ref) {
    var appFieldName = _ref.appFieldName,
        fieldLabel = _ref.fieldLabel;
    return appFieldName === labelFieldToRemove ? rs : [].concat(_toConsumableArray(rs), [{
      value: appFieldName,
      label: fieldLabel
    }]);
  }, [{
    value: 'teExtId',
    label: formatMessage(messages.label.teExtId_short),
    hide: true
  }]);
};
var getValidationStatus = function getValidationStatus(status) {
  if (!status) return {
    missingMandatory: [],
    tooMany: [],
    invalid: []
  };
  var missingMandatory = [];
  var tooMany = [];
  var invalid = [];
  Object.entries(status !== null && status !== void 0 ? status : {}).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        object = _ref3[0],
        objectStatus = _ref3[1];

    if (objectStatus.missingMandatory) {
      missingMandatory.push(object);
    }

    if (objectStatus.tooMany) {
      tooMany.push(object);
    }

    if (objectStatus.invalid) {
      invalid.push("".concat(object, ": ").concat(objectStatus.invalid));
    }
  });
  return {
    missingMandatory: missingMandatory,
    tooMany: tooMany,
    invalid: invalid
  };
};
var isValidationComplete = function isValidationComplete(validation) {
  var _getValidationStatus = getValidationStatus(validation),
      missingMandatory = _getValidationStatus.missingMandatory,
      tooMany = _getValidationStatus.tooMany,
      invalid = _getValidationStatus.invalid;

  return tooMany.length === 0 && missingMandatory.length === 0 && invalid.length === 0;
};
var hasExcessObjects = function hasExcessObjects(validation) {
  var _getValidationStatus2 = getValidationStatus(validation),
      tooMany = _getValidationStatus2.tooMany;

  return tooMany.length > 0;
};
var hasMissingObjects = function hasMissingObjects(validation) {
  var _getValidationStatus3 = getValidationStatus(validation),
      missingMandatory = _getValidationStatus3.missingMandatory;

  return missingMandatory.length > 0;
};
var hasInvalidValues = function hasInvalidValues(validation) {
  var _getValidationStatus4 = getValidationStatus(validation),
      invalid = _getValidationStatus4.invalid;

  return invalid.length > 0;
};

var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};

var usePrevious$1 = usePrevious;

var deepSeaGreen = '#0e5c67';
var jungleGreen = '#29b68f';
var bittersweet = '#ff6357';
var swedishSkies = '#f4f5f7';
var darkBlack = '#2c3741';
var black = 'rgba(0, 0, 0, 0.85)';
var white = '#ffffff';
var darkGrey = '#888e99';
var lightGrey = '#e5e6eb';
var defaultFontSize = '0.75rem';

var ModifiedAntdInput = styled(Input$2).withConfig({
  displayName: "Input__ModifiedAntdInput",
  componentId: "sc-1gyebp9-0"
})(["&&&{&.ant-input,.ant-input{color:", ";}", ":hover,:focus-visible{outline:none;}:hover .ant-input:not(.ant-input-disabled){border-color:", ";}.ant-input{::selection{background-color:", ";}:focus,:hover{border-color:", ";}:focus{box-shadow:0 0 0 2px rgb(41 182 143 / 20%);}}.ant-input-group-addon{background:", ";color:", ";}}"], darkGrey, function (props) {
  return !props.prefix && !props.suffix ? "\n          ::selection {\n            background-color: ".concat(jungleGreen, ";\n          }\n\n          :focus, :hover {\n            border-color: ").concat(jungleGreen, ";\n          }\n      \n          :focus {\n            box-shadow: 0 0 0 2px rgb(41 182 143 / 20%);\n          }\n        ") : '';
}, jungleGreen, jungleGreen, jungleGreen, lightGrey, darkGrey);

var Input = function Input(props) {
  return /*#__PURE__*/React__default.createElement(ModifiedAntdInput, props);
};

Input.defaultProps = {
  size: 'small'
};
var Input$1 = Input;

var Table = styled(Table$2).withConfig({
  displayName: "Table",
  componentId: "sc-afbhdj-0"
})(["&&&{.ant-pagination-item-active{border-color:", ";a{color:", ";}}.ant-pagination-item:not(.ant-pagination-disabled):focus a,.ant-pagination-item:not(.ant-pagination-disabled):hover a{color:", ";}.ant-pagination-prev:not(.ant-pagination-disabled):focus .ant-pagination-item-link,.ant-pagination-next:not(.ant-pagination-disabled):focus .ant-pagination-item-link,.ant-pagination-prev:not(.ant-pagination-disabled):hover .ant-pagination-item-link,.ant-pagination-next:not(.ant-pagination-disabled):hover .ant-pagination-item-link{color:", ";}.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon{color:", ";}.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on,.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on{color:", ";}}.ant-spin.ant-spin-spinning.ant-table-with-pagination.ant-table-spin-holder span.ant-spin-dot.ant-spin-dot-spin{font-size:20px !important;.ant-spin-dot-item{background-color:", ";}}"], jungleGreen, jungleGreen, jungleGreen, jungleGreen, jungleGreen, jungleGreen, jungleGreen);
var Table$1 = Table;

var PropertyTable = function PropertyTable(_ref) {
  var path = _ref.path,
      exam = _ref.exam,
      selectedProperty = _ref.selectedProperty,
      selectableProperties = _ref.selectableProperties,
      showRelations = _ref.showRelations,
      setShowRelations = _ref.setShowRelations,
      onSelectProperty = _ref.onSelectProperty,
      onEditExamValue = _ref.onEditExamValue,
      onAddMultipleExamValue = _ref.onAddMultipleExamValue,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchString = _useState2[0],
      setSearchString = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedTypes = _useState4[0],
      setSelectedTypes = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      relatedObjects = _useState6[0],
      setRelatedObjects = _useState6[1];

  var _useState7 = useState(loading),
      _useState8 = _slicedToArray(_useState7, 2),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var isSelectedLinkExams = useSelector(function (state) {
    return state.exams.isSelectedLinkExams;
  });

  var _useState9 = useState(_objectSpread2(_objectSpread2({}, DEFAULT_TABLE_CONFIG), {}, {
    populate: DEFAULT_POPULATE // except_id: '',

  })),
      _useState10 = _slicedToArray(_useState9, 2),
      tableConfig = _useState10[0],
      setTableConfig = _useState10[1];

  var totalResults = useSelector(function (state) {
    return state.exams.totalLinkedExamsResults;
  });
  var linkedExams = useSelector(function (state) {
    return state.exams.linkedExams;
  });
  var currentPage = useSelector(function (state) {
    return state.exams.page;
  });
  var prevExam = usePrevious$1(exam);
  var preTableConfig = usePrevious$1(tableConfig);
  var dispatch = useDispatch();
  useEffect(function () {
    if (selectedTypes && selectedTypes.length > 0) {
      var relatedProperties = selectableProperties.filter(function (_ref2) {
        var name = _ref2.name;
        return selectedTypes.includes(name);
      });
      var isChanged = relatedProperties.some(function (_ref3) {
        var key = _ref3.key;
        var prevValue = prevExam === null || prevExam === void 0 ? void 0 : prevExam[key];
        var curValue = exam === null || exam === void 0 ? void 0 : exam[key];
        return !isEqual(curValue, prevValue);
      });

      if (isChanged) {
        var _relatedObjects = {};
        relatedProperties.forEach(function (_ref4) {
          var key = _ref4.key,
              relations = _ref4.relations,
              relatedExtIds = _ref4.relatedExtIds;
          relations.forEach(function (type) {
            if (!isEmpty(exam === null || exam === void 0 ? void 0 : exam[key])) {
              var values = Array.isArray(exam === null || exam === void 0 ? void 0 : exam[key]) ? exam === null || exam === void 0 ? void 0 : exam[key] : [exam === null || exam === void 0 ? void 0 : exam[key]];
              values.forEach(function (value) {
                if (relatedExtIds[value]) {
                  var _relatedObjects$type;

                  if (!_relatedObjects[type]) {
                    _relatedObjects[type] = [];
                  }

                  (_relatedObjects$type = _relatedObjects[type]).push.apply(_relatedObjects$type, _toConsumableArray(relatedExtIds[value]));
                }
              });
            }
          });
        });
        setRelatedObjects(_relatedObjects);
      }
    }
  }, [exam, prevExam, selectedTypes, selectableProperties, setRelatedObjects]);
  useEffect(function () {
    if (searchString) {
      setSearchString(null);
    }
  }, [selectedProperty]); // Find the selected property's data source

  var sP = useMemo(function () {
    var _selectableProperties;

    return (_selectableProperties = selectableProperties.find(function (p) {
      return p.key === selectedProperty;
    })) !== null && _selectableProperties !== void 0 ? _selectableProperties : {};
  }, [selectableProperties, selectedProperty]);
  useEffect(function () {
    if (sP.key === 'linkedExamId') {
      setIsLoading(false);
    }
  }, [linkedExams, sP]);
  var selectedValues = useMemo(function () {
    var valuePath = [sP.key];
    if (sP.isObject) valuePath.push(sP.idKey);

    var _selectedValues = get(exam, valuePath);

    if (_selectedValues) {
      // make sure values always is array for includes run properly
      if (!Array.isArray(_selectedValues)) {
        _selectedValues = [_selectedValues];
      } else {
        _selectedValues = uniq(_selectedValues);
      } // in case user change from allow multiple to not allow, cut off values after first value


      if (!sP.allowMultiple && size(_selectedValues) > 0) {
        _selectedValues = slice(_selectedValues, 0, 1);
      }
    } else {
      _selectedValues = [];
    }

    return _selectedValues;
  }, [sP, exam]);
  useEffect(function () {
    if (sP.key === 'linkedExamId' && !isEmpty(tableConfig) && !isEqual(preTableConfig, tableConfig)) {
      setIsLoading(true);
      dispatch(searchLinkedExams(tableConfig));
    }
  }, [tableConfig]);
  var dataSource = useMemo(function () {
    if (!sP || !sP.columnConfig || !sP.dataSource) return [];

    var _searchString = size(searchString) >= 3 ? searchString.toLowerCase() : '';

    var shouldFilterRelations = showRelations && !_searchString && relatedObjects[sP.name] && (sP.dataSource || []).some(function (item) {
      return relatedObjects[sP.name].includes(item.teExtId);
    });
    var filteredDataSource;

    if (!isEmpty(selectedValues) || _searchString || shouldFilterRelations) {
      filteredDataSource = (sP.dataSource || []).filter(function (item) {
        // remove data which is selected
        if (includes(selectedValues, item[sP.idKey])) return false; // remove data which is not match search string

        if (_searchString) {
          return some(item, function (value) {
            return includes(toLower(value), _searchString);
          });
        } // if relations existing, remove not match items


        if (shouldFilterRelations) {
          return relatedObjects[sP.name].includes(item.teExtId);
        }

        return true;
      });
    } else {
      filteredDataSource = sP.dataSource;
    }

    return createDataSourceForTable(sP.columnConfig, filteredDataSource);
  }, [sP, selectedValues, searchString, showRelations, relatedObjects, linkedExams]);
  var pagination = useMemo(function () {
    if (sP.key === 'linkedExamId') {
      return {
        current: tableConfig.page,
        onChange: function onChange(page) {
          return onChangeProperty(page);
        },
        size: 'small',
        total: totalResults
      };
    } else {
      return {
        pageSize: 10,
        size: 'small',
        onChange: function onChange(page) {
          return onChangeProperty(page);
        },
        total: dataSource.length,
        current: tableConfig.page
      };
    }
  }, [isSelectedLinkExams, tableConfig, dataSource, currentPage, totalResults, sP]);
  var columns = useMemo(function () {
    if (!sP || !sP.columnConfig || !sP.dataSource) return [];
    var columnConfig = pickBy(sP.columnConfig, function (p) {
      return some(sP.dataSource, function (data) {
        return data[p.value] && data[p.value] !== 'N/A';
      });
    });
    return createColumnsFromConstant(columnConfig);
  }, [sP]);
  var handleObjectSelection = useCallback(function (rowIndex, record) {
    if (sP && sP.key === 'linkedExamId') {
      dispatch(setSelectedLinkedExam(record));
    }

    if (!sP || !sP.columnConfig || !sP.dataSource) return null;

    if (sP.relations && sP.relatedExtIds[record.teExtId]) {
      setSelectedTypes(function (prevSelectedTypes) {
        if (sP.relations.some(function (type) {
          return !prevSelectedTypes.includes(type);
        }) && !prevSelectedTypes.includes(sP.name)) {
          return [].concat(_toConsumableArray(prevSelectedTypes), [sP.name]);
        }

        return prevSelectedTypes;
      });
    }

    if (sP.allowMultiple === false) {
      if (!sP.isObject) {
        onEditExamValue({
          examId: path,
          target: sP.key,
          value: record[sP.idKey]
        });
      } else {
        var obj = sP.dataSource.find(function (o) {
          return o[sP.idKey] === record[sP.idKey];
        });
        if (!obj) return null;
        onEditExamValue({
          examId: path,
          target: sP.key,
          value: obj.value
        });
      }
    } else {
      // Get the object from the datasource
      var selObj = sP.dataSource.find(function (el) {
        return el[sP.idKey] === record[sP.idKey];
      });

      if (selObj) {
        onAddMultipleExamValue({
          examId: path,
          target: {
            name: sP.key,
            value: selObj[sP.idKey]
          }
        });
      }
    }

    if (!sP.allowMultiple) {
      // Find the index of the currently selected sP
      var idx = selectableProperties.findIndex(function (p) {
        return p.key === sP.key;
      });
      var nextSelectableProperties = selectableProperties.find(function (_ref5, index) {
        var isDisabled = _ref5.isDisabled;
        return !isDisabled && index > idx;
      });

      if (nextSelectableProperties) {
        onSelectProperty(nextSelectableProperties.key);
      }
    }
  }, [selectableProperties, sP, tableConfig]);
  var prevDataSource = usePrevious$1(dataSource);
  useEffect(function () {
    if (!isEqual(prevDataSource, dataSource) && isLoading === true) {
      setIsLoading(false);
    }
  }, [isLoading, dataSource]);
  if (!sP || !sP.columnConfig || !sP.dataSource) return null;

  var onChangeProperty = function onChangeProperty(currentPage) {
    setTableConfig(function (prevTableConfig) {
      var newTableConfig = _objectSpread2(_objectSpread2({}, prevTableConfig), {}, {
        page: currentPage
      });

      if (exam.id !== undefined) {
        newTableConfig.except_id = exam.id;
      }

      return newTableConfig;
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SearchBarWrapper, null, /*#__PURE__*/React__default.createElement(Input$1, {
    prefix: /*#__PURE__*/React__default.createElement(Icon, {
      type: "search",
      style: {
        color: 'rgba(0,0,0,.25)'
      }
    }),
    placeholder: formatMessage(messages.placeholder.filterProperties),
    value: searchString,
    onChange: function onChange(e) {
      return setSearchString(e.target.value.toLowerCase());
    }
  })), /*#__PURE__*/React__default.createElement(SelectionTableHeader, null, /*#__PURE__*/React__default.createElement(MdAdd, null), formatMessage(messages.label.selectItem, {
    item: sP.label
  })), /*#__PURE__*/React__default.createElement(Table$1, {
    loading: isLoading,
    columns: columns,
    dataSource: dataSource,
    onRow: function onRow(record, rowIndex) {
      return {
        onClick: function onClick() {
          return handleObjectSelection(rowIndex, record);
        }
      };
    },
    scroll: {
      x: true
    },
    rowKey: "rowKey",
    pagination: pagination // rowClassName="exam-property-selection-table-row"

  }), /*#__PURE__*/React__default.createElement(Checkbox$1, {
    checked: showRelations,
    onChange: function onChange(_ref6) {
      var checked = _ref6.target.checked;
      return setShowRelations(checked);
    },
    style: {
      padding: '0 6px',
      position: 'absolute',
      bottom: 4
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, formatMessage(messages.page.exam.showRelationsLabel))));
};

var SearchBarWrapper = styled.div.withConfig({
  displayName: "PropertyTable__SearchBarWrapper",
  componentId: "sc-1rluhu0-0"
})(["background:", ";padding:0.2rem 2px 0.2rem 6px;"], swedishSkies);
var SelectionTableHeader = styled.div.withConfig({
  displayName: "PropertyTable__SelectionTableHeader",
  componentId: "sc-1rluhu0-1"
})(["background:", ";border-top:1px solid ", ";border-bottom:1px solid ", ";display:flex;align-items:center;padding:0.2rem 2px 0.2rem 6px;font-weight:700;"], swedishSkies, darken(0.05, swedishSkies), darken(0.05, swedishSkies));
var PropertyTable$1 = PropertyTable;

var classnames$1 = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames$1));

var classnames = classnames$1.exports;

var SelectedObjectWrapper = styled.div.withConfig({
  displayName: "SelectedObject__SelectedObjectWrapper",
  componentId: "sc-1bj6r84-0"
})(["padding:0 2px;display:flex;background:", ";border-radius:0.4rem;align-items:center;position:relative;cursor:pointer;white-space:nowrap;&:hover{text-decoration:underline dotted;}& + &{margin-left:2px;}"], darken(0.05, swedishSkies));
var InfoObject = styled.div.withConfig({
  displayName: "SelectedObject__InfoObject",
  componentId: "sc-1bj6r84-1"
})(["height:14px;transition:0.2s;border-top-left-radius:0.4rem;border-bottom-left-radius:0.4rem;display:flex;align-items:center;justify-content:center;cursor:pointer;"]);
var RemoveObject = styled.div.withConfig({
  displayName: "SelectedObject__RemoveObject",
  componentId: "sc-1bj6r84-2"
})(["height:14px;transition:0.2s;border-top-right-radius:0.4rem;border-bottom-right-radius:0.4rem;display:flex;align-items:center;justify-content:center;cursor:pointer;padding-left:2px;padding-right:2px;&:hover{color:#fff;background:", ";}"], bittersweet);

var SelectedObject = function SelectedObject(_ref) {
  var label = _ref.label,
      availabilityStatus = _ref.availabilityStatus,
      objId = _ref.objId,
      readonly = _ref.readonly,
      onDelete = _ref.onDelete,
      field = _ref.field;
  var loading = useAppSelector(selectObjectFieldLoading(field));
  return /*#__PURE__*/React__default.createElement(SelectedObjectWrapper, null, loading && /*#__PURE__*/React__default.createElement("div", {
    className: "skeleton-loading"
  }), availabilityStatus && availabilityStatus === 'missing' && /*#__PURE__*/React__default.createElement(InfoObject, null, /*#__PURE__*/React__default.createElement(MdPriorityHigh, null)), label || objId, !readonly && /*#__PURE__*/React__default.createElement(RemoveObject, {
    onClick: function onClick() {
      return onDelete(objId);
    }
  }, /*#__PURE__*/React__default.createElement(MdHighlightOff, null)));
};

var SelectedObject$1 = SelectedObject;

var RULE_LABEL_MAPPING = {
  '*': {
    isMandatory: true
  },
  '': {
    isMandatory: false
  }
};

var PropertyRow = function PropertyRow(_ref) {
  var path = _ref.path,
      exam = _ref.exam,
      selectedProperty = _ref.selectedProperty,
      selectableProperty = _ref.selectableProperty,
      readonly = _ref.readonly,
      onSelectProperty = _ref.onSelectProperty,
      onEditExamValue = _ref.onEditExamValue,
      onRemoveMultipleExamValue = _ref.onRemoveMultipleExamValue,
      miniMode = _ref.miniMode;
  var key = selectableProperty.key,
      label = selectableProperty.label,
      idKey = selectableProperty.idKey,
      labelKey = selectableProperty.labelKey,
      isObject = selectableProperty.isObject,
      columnConfig = selectableProperty.columnConfig,
      dataSource = selectableProperty.dataSource,
      isMandatory = selectableProperty.isMandatory,
      allowMultiple = selectableProperty.allowMultiple;
  var loading = useAppSelector(selectObjectFieldLoading(selectableProperty === null || selectableProperty === void 0 ? void 0 : selectableProperty.name));

  var _useFormContext = useFormContext(),
      watch = _useFormContext.watch;

  watch(key);
  var linkedExam = useSelector(function (state) {
    var _state$exams;

    if (!isEmpty(state === null || state === void 0 ? void 0 : (_state$exams = state.exams) === null || _state$exams === void 0 ? void 0 : _state$exams.linkedExam)) {
      var _state$exams2;

      var _state$exams$linkedEx = state === null || state === void 0 ? void 0 : (_state$exams2 = state.exams) === null || _state$exams2 === void 0 ? void 0 : _state$exams2.linkedExam,
          id = _state$exams$linkedEx.id,
          name = _state$exams$linkedEx.name,
          examId = _state$exams$linkedEx.examId;

      return {
        id: id,
        examId: examId,
        name: name,
        nameDisplay: size(name) ? "".concat(examId, " - ").concat(name) : examId
      };
    }
  });
  var ruleLabel = useMemo(function () {
    return _.findKey(RULE_LABEL_MAPPING, {
      isMandatory: isMandatory
    });
  }, [isMandatory]);
  var selectedObjects = useMemo(function () {
    var valuePath = [key];
    if (isObject) valuePath.push(idKey);

    var selectedValues = _.get(exam, valuePath);

    if (!selectedValues) return []; // make sure values always is array for _.includes run properly

    if (!_.isArray(selectedValues)) {
      selectedValues = [selectedValues]; // eslint-disable-next-line brace-style
    } // somehow data is duplicated
    else {
      selectedValues = _.uniq(selectedValues);
    } // in case user change from allow multiple to not allow, cut off values after first value


    if (!allowMultiple && _.size(selectedValues) > 0) {
      selectedValues = _.slice(selectedValues, 0, 1);
    }

    return selectedValues.reduce(function (tot, value) {
      var obj = _.find(dataSource, _defineProperty({}, idKey, value));

      if (!obj && key === 'linkedExamId') {
        obj = linkedExam;
      }

      if (obj) {
        tot.push(obj);
      } else {
        var _tot$push;

        tot.push((_tot$push = {}, _defineProperty(_tot$push, idKey, value), _defineProperty(_tot$push, "availabilityStatus", 'missing'), _tot$push));
      }

      return tot;
    }, []);
  }, [exam, key, idKey, allowMultiple, dataSource, linkedExam, isObject]);
  var handleObjectRemoval = useCallback(function (objId) {
    if (allowMultiple) return onRemoveMultipleExamValue({
      examId: path,
      target: key,
      value: objId
    });
    return onEditExamValue({
      examId: path,
      target: key,
      value: ''
    });
  }, [path, key, allowMultiple]);

  if (miniMode && !selectedObjects.length) {
    return null;
  }

  var nameDisplay = function nameDisplay(obj) {
    if (obj && (obj.examId || obj.id)) {
      return obj.nameDisplay;
    }

    return obj.name;
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames('selection-row', {
      'is-selected': selectedProperty === key
    }),
    onClick: function onClick() {
      return onSelectProperty(key);
    }
  }, !miniMode ? /*#__PURE__*/React__default.createElement("div", {
    className: "selection-property"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "selection-property-label"
  }, label), ruleLabel ? /*#__PURE__*/React__default.createElement("span", {
    className: "selection-property-rule"
  }, ruleLabel) : null) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "selected-objects"
  }, miniMode ? /*#__PURE__*/React__default.createElement("div", {
    className: "selection-property-label",
    style: {
      marginRight: 10
    }
  }, label) : null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: miniMode ? 'block' : 'flex'
    }
  }, loading && selectedObjects.length === 0 ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '200px',
      position: 'relative',
      margin: '1px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "skeleton-loading"
  })) : null, selectedObjects.map(function (obj, index) {
    var object = _typeof(obj[idKey]) === 'object' ? obj[idKey] : obj;
    return /*#__PURE__*/React__default.createElement(Popover, {
      key: "selected-object-".concat(index),
      title: "".concat(label).concat(object[labelKey] ? ": ".concat(object[labelKey]) : ''),
      content: /*#__PURE__*/React__default.createElement(Descriptions, {
        size: "small",
        layout: "horizontal",
        column: 1,
        style: {
          maxWidth: 400
        }
      }, Object.values(columnConfig || {}).filter(function (col) {
        return object[col.value] && !col.hide;
      }).map(function (col) {
        return /*#__PURE__*/React__default.createElement(Descriptions.Item, {
          label: col.label,
          key: col.value
        }, col.render ? col.render(object[col.value]) : object[col.value]);
      })),
      trigger: "click"
    }, /*#__PURE__*/React__default.createElement(SelectedObject$1, {
      key: object[idKey],
      label: object[labelKey] || nameDisplay(obj),
      objId: object[idKey],
      availabilityStatus: (object || obj || {}).availabilityStatus,
      onDelete: handleObjectRemoval,
      readonly: readonly,
      field: selectableProperty.name
    }));
  }))));
};

PropertyRow.propTypes = {
  path: PropTypes.string,
  exam: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedProperty: PropTypes.string.isRequired,
  selectableProperty: PropTypes.objectOf(PropTypes.any).isRequired,
  readonly: PropTypes.bool,
  onSelectProperty: PropTypes.func.isRequired,
  onEditExamValue: PropTypes.func.isRequired,
  onRemoveMultipleExamValue: PropTypes.func.isRequired,
  miniMode: PropTypes.bool.isRequired
};
PropertyRow.defaultProps = {
  readonly: false
};
var PropertyRow$1 = PropertyRow;

var ExamPropertySelection = function ExamPropertySelection(_ref) {
  var exam = _ref.exam,
      selectableProperties = _ref.selectableProperties,
      path = _ref.path,
      readonly = _ref.readonly,
      eventHandlers = _ref.eventHandlers,
      miniMode = _ref.miniMode,
      style = _ref.style;

  var _useFormContext = useFormContext(),
      getValues = _useFormContext.getValues,
      setValue = _useFormContext.setValue;

  var dispatch = useDispatch();

  var _useState = useState(selectableProperties[0].key),
      _useState2 = _slicedToArray(_useState, 2),
      selectedProperty = _useState2[0],
      setSelectedProperty = _useState2[1];

  var _useState3 = useState(selectableProperties[0].key),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedPropertyName = _useState4[0],
      setSelectedPropertyName = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      showRelations = _useState6[0],
      setShowRelations = _useState6[1];

  var onSelectProperty = useCallback(function (property) {
    if (property && property === 'linkedExamId') {
      dispatch(setSelectedLinkExams(true));
    } else {
      dispatch(setSelectedLinkExams(false));
    }

    setSelectedProperty(property);
    var foundProperty = selectableProperties.find(function (_ref2) {
      var key = _ref2.key;
      return key === property;
    });

    if (foundProperty) {
      setSelectedPropertyName(foundProperty.name);
    }
  }, []);

  var onEditExamValue = function onEditExamValue(_ref3) {
    _ref3.examId;
        var target = _ref3.target,
        value = _ref3.value;

    var newExamProperty = _objectSpread2(_objectSpread2({}, getValues()), {}, _defineProperty({}, target, value));

    if (exam && exam.examId) {
      var properties = cloneDeep(newExamProperty);

      var _iterator = _createForOfIteratorHelper(getExamCommonPropertyObject()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value.key;
          properties[key] = newExamProperty[key] ? castArray(newExamProperty[key]) : [];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      dispatch(updateExamProperty({
        examId: exam.examId || exam.id,
        newExam: properties
      }));
    }

    setValue(target, value);
  };

  var onAddMultipleExamValue = function onAddMultipleExamValue(_ref4) {
    var examId = _ref4.examId,
        target = _ref4.target,
        value = _ref4.value;
    if (eventHandlers && eventHandlers.addMultipleExamValue && typeof eventHandlers.addMultipleExamValue === 'function') return eventHandlers.addMultipleExamValue({
      examId: examId,
      target: target,
      value: value
    });
    var newValues = chain(getValues(target.name)).concat(target.value).uniq().value();

    var newExamProperty = _objectSpread2(_objectSpread2({}, getValues()), {}, _defineProperty({}, target.name, newValues));

    if (exam && exam.examId) {
      var properties = cloneDeep(newExamProperty);

      var _iterator2 = _createForOfIteratorHelper(getExamCommonPropertyObject()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value.key;
          properties[key] = newExamProperty[key] ? castArray(newExamProperty[key]) : [];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      dispatch(updateExamProperty({
        examId: exam.examId,
        newExam: properties
      }));
    }

    setValue(target.name, newValues);
  };

  var onRemoveMultipleExamValue = function onRemoveMultipleExamValue(_ref5) {
    var examId = _ref5.examId,
        target = _ref5.target,
        value = _ref5.value;
    if (eventHandlers && eventHandlers.removeMultipleExamValue && typeof eventHandlers.removeMultipleExamValue === 'function') return eventHandlers.removeMultipleExamValue({
      examId: examId,
      target: target,
      value: value
    });
    var newValues = pull(getValues(target), value);

    var newExamProperty = _objectSpread2(_objectSpread2({}, getValues()), {}, _defineProperty({}, target, newValues));

    if (exam && exam.examId) {
      var properties = cloneDeep(newExamProperty);

      var _iterator3 = _createForOfIteratorHelper(getExamCommonPropertyObject()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var key = _step3.value.key;
          properties[key] = newExamProperty[key] ? castArray(newExamProperty[key]) : [];
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      dispatch(updateExamProperty({
        examId: exam.examId,
        newExam: properties
      }));
    }

    setValue(target, newValues);
  };

  var _selectableProperties = useMemo(function () {
    return selectableProperties.filter(function (sP) {
      return !sP.isDisabled;
    });
  }, [selectableProperties]);

  return /*#__PURE__*/React__default.createElement(Container, {
    style: style
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "exam-property-selection-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "exam-property-selection-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "selection-header"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "selection-header-property"
  }, formatMessage(messages.label.type)), /*#__PURE__*/React__default.createElement("div", {
    className: "selection-header-objects"
  }, formatMessage(messages.label.selectedObjects))), _selectableProperties.map(function (selectableProperty, index) {
    return /*#__PURE__*/React__default.createElement(PropertyRow$1, {
      key: index,
      path: path,
      exam: exam,
      selectableProperty: selectableProperty,
      selectedProperty: selectedProperty,
      readonly: readonly,
      onSelectProperty: onSelectProperty,
      onEditExamValue: onEditExamValue,
      onRemoveMultipleExamValue: onRemoveMultipleExamValue,
      miniMode: miniMode
    });
  })), !readonly && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PropertyTable$1, {
    path: path,
    exam: exam,
    selectedProperty: selectedProperty,
    selectableProperties: selectableProperties,
    showRelations: showRelations,
    setShowRelations: setShowRelations,
    onSelectProperty: onSelectProperty,
    onEditExamValue: onEditExamValue,
    onAddMultipleExamValue: onAddMultipleExamValue,
    selectedPropertyName: selectedPropertyName
  }))));
};

var selectionPropertyWidth = '150px';
var Container = styled.div.withConfig({
  displayName: "ExamPropertySelection__Container",
  componentId: "sc-1t6ww5o-0"
})(["&&&{position:relative;.exam-property-selection-wrapper{border:1px solid ", ";.selection-header{display:flex;height:28px;background:", ";color:#fff;font-weight:700;.selection-header-property{width:", ";display:flex;align-items:center;padding:2px;padding-left:6px;}.selection-header-objects{width:calc(100% - ", ");display:flex;align-items:center;padding:2px;}}.selection-row{background:", ";min-height:1.3rem;display:flex;.selection-property{width:", ";background:", ";padding:2px;display:flex;align-items:center;padding-left:6px;span.selection-property-rule{color:", ";}}.selected-objects{padding:0;width:calc(100% - ", ");display:flex;min-height:1.3rem;flex-wrap:wrap;padding:2px;overflow-x:auto;}&.is-selected{.selection-property{background:", ";color:#fff;span.selection-property-rule{color:", ";}}.selected-objects{background:", ";}}}.exam-property-selection-table-header{height:3rem;background:", ";border-top:1px solid ", ";border-bottom:1px solid ", ";display:flex;align-items:center;padding:0 0.4rem;font-weight:700;}.ant-table-pagination.ant-pagination{margin:0;}.ant-pagination-item-link,.ant-pagination-item{border-color:transparent;}.ant-table-thead > tr > th{padding:0 2px;background:", ";white-space:nowrap;}.ant-table-thead > tr > th:first-child{padding-left:6px;}.ant-table-tbody > tr > td{padding:0 2px;white-space:nowrap;}.ant-table-tbody > tr > td:first-child{padding-left:6px;}}.exam-property-selection-table-row > td{padding-top:0.4rem !important;padding-bottom:0.4rem !important;cursor:pointer;}}"], darken(0.05, swedishSkies), deepSeaGreen, selectionPropertyWidth, selectionPropertyWidth, swedishSkies, selectionPropertyWidth, darken(0.05, swedishSkies), rgba(darkBlack, 0.8), selectionPropertyWidth, deepSeaGreen, rgba('#fff', 0.8), rgba(deepSeaGreen, 0.5), swedishSkies, darken(0.05, swedishSkies), darken(0.05, swedishSkies), darken(0.02, '#fff'));
ExamPropertySelection.propTypes = {
  path: PropTypes.string,
  readonly: PropTypes.bool,
  miniMode: PropTypes.bool,
  exam: PropTypes.objectOf(PropTypes.any),
  selectableProperties: PropTypes.arrayOf(PropTypes.object).isRequired,
  editExamValue: PropTypes.func,
  addMultipleExamValue: PropTypes.func,
  removeMultipleExamValue: PropTypes.func,
  eventHandlers: PropTypes.object
};
ExamPropertySelection.defaultProps = {
  readonly: false,
  exam: {},
  eventHandlers: null,
  miniMode: false
};
var ExamPropertySelection$1 = ExamPropertySelection;

// I18N
var TE_TYPE_DATA_MODEL_FIELD_CATEGORIES = {
  id: {
    label: formatMessage(messages.label.typeId),
    value: 'id',
    hide: true
  },
  name: {
    value: 'label',
    label: formatMessage(messages.label.name)
  }
};

var PriorityColumnWrapper = styled.div.withConfig({
  displayName: "ExamPriorities__PriorityColumnWrapper",
  componentId: "sc-m1w7jv-0"
})(["color:", ";"], darkBlack);

var PriorityRoom = function PriorityRoom(_ref) {
  var room = _ref.room;
  if (!(room !== null && room !== void 0 && room.name)) return null;
  return /*#__PURE__*/React__default.createElement(PriorityColumnWrapper, null, /*#__PURE__*/React__default.createElement("span", null, room.name));
};

var ExamPrioritiesColumn = function ExamPrioritiesColumn(_ref2) {
  var examId = _ref2.examId;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPriorityIndex = _useState2[0],
      setSelectedPriorityIndex = _useState2[1];

  var examMapped = useAppSelector(function (state) {
    return state.exams.linkedExams;
  });
  var priorities = useMemo(function () {
    var _examMapped$examId$pr, _examMapped$examId;

    return (_examMapped$examId$pr = (_examMapped$examId = examMapped[examId]) === null || _examMapped$examId === void 0 ? void 0 : _examMapped$examId.priorities) !== null && _examMapped$examId$pr !== void 0 ? _examMapped$examId$pr : [];
  }, [examMapped, examId]);
  var incrementPriorityIndex = useCallback(function () {
    if (priorities !== null && priorities !== void 0 && priorities[selectedPriorityIndex + 1]) {
      setSelectedPriorityIndex(selectedPriorityIndex + 1);
    }
  }, [priorities, selectedPriorityIndex]);
  var decrementPriorityIndex = useCallback(function () {
    if (selectedPriorityIndex - 1 >= 0 && priorities !== null && priorities !== void 0 && priorities[selectedPriorityIndex - 1]) {
      setSelectedPriorityIndex(selectedPriorityIndex - 1);
    }
  }, [priorities, selectedPriorityIndex]);
  var priority = useMemo(function () {
    return priorities === null || priorities === void 0 ? void 0 : priorities[selectedPriorityIndex];
  }, [priorities, selectedPriorityIndex]);
  var priorityDate = useMemo(function () {
    if (!priority || !priority.targetDate) return null;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "priorities-column__priority--date"
    }, /*#__PURE__*/React__default.createElement("span", null, moment.utc(priority.targetDate).format(DATE_FORMAT_DEFAULT)));
  }, [priority]);
  var priorityRoom = useMemo(function () {
    return /*#__PURE__*/React__default.createElement(PriorityRoom, {
      room: priority === null || priority === void 0 ? void 0 : priority.room
    });
  }, [priority]);
  var delimiter = useMemo(function () {
    var _nextPriority$room;

    if (!priorityRoom) return null;
    var nextPriority = priorities === null || priorities === void 0 ? void 0 : priorities[selectedPriorityIndex];

    if (!nextPriority || !nextPriority.targetDate || !((_nextPriority$room = nextPriority.room) !== null && _nextPriority$room !== void 0 && _nextPriority$room.name)) {
      return null;
    }

    return /*#__PURE__*/React__default.createElement("span", {
      className: "delimiter"
    }, "\xA0\xA0/\xA0\xA0");
  }, [priorityRoom, priorities, selectedPriorityIndex]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "priorities-column--wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "priorities-column--toggler"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    icon: "caret-left",
    onClick: decrementPriorityIndex,
    disabled: selectedPriorityIndex <= 0
  }), /*#__PURE__*/React__default.createElement("span", null, "".concat(selectedPriorityIndex + 1, "/").concat(priorities.length)), /*#__PURE__*/React__default.createElement(Button$2, {
    icon: "caret-right",
    onClick: incrementPriorityIndex,
    disabled: selectedPriorityIndex + 1 >= priorities.length
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "priorities-column__priority--wrapper"
  }, priorityDate, delimiter, priorityRoom));
};

var ExamPrioritiesColumn$1 = ExamPrioritiesColumn;

var TE_LINKED_EXAM_DATA_MODEL_FIELD_CATEGORIES = {
  examId: {
    value: 'examId',
    label: formatMessage(messages.label.examId)
  },
  name: {
    value: 'name',
    label: formatMessage(messages.label.name)
  },
  id: {
    value: 'id',
    label: formatMessage(messages.label.id),
    hide: true
  },
  priorities: {
    value: 'examId',
    label: formatMessage(messages.label.priorities),
    render: function render(examId) {
      return /*#__PURE__*/React__default.createElement(ExamPrioritiesColumn$1, {
        examId: examId
      });
    }
  }
};

var selectLanguages = function selectLanguages(state) {
  return state.languages;
};

var selectLanguagesMap = function selectLanguagesMap(state) {
  return state.languages.entities;
};
var selectActiveLanguages = createSelector(selectLanguages, function (languages) {
  if (!languages || !languages.entities) return [];
  return Object.values(languages.entities).filter(function (_ref) {
    var deletedAt = _ref.deletedAt;
    return !deletedAt;
  });
});

var selectRoomMap = function selectRoomMap(state) {
  return state.rooms.entities;
};
var selectRoomId = function selectRoomId(state, roomId) {
  return roomId;
};
createSelector([selectRoomMap, selectRoomId], function (entities, roomId) {
  return entities[roomId];
});
createSelector(selectRoomMap, function (entities) {
  return Object.values(entities || {}).filter(function (_ref) {
    var deleted = _ref.deleted;
    return !deleted;
  });
});
var selectCampuses = createSelector(selectRoomMap, function (entities) {
  return chain(entities).filter(function (_ref2) {
    var deleted = _ref2.deleted,
        campus = _ref2.campus;
    return !deleted && campus;
  }).map(function (_ref3) {
    var campus = _ref3.campus;
    return {
      name: campus,
      label: campus
    };
  }).uniqBy('name').value();
});
var selectCampusFilters = createSelector(selectRoomMap, function (entities) {
  return chain(entities).filter(function (_ref4) {
    var deleted = _ref4.deleted,
        campus = _ref4.campus;
    return !deleted && campus;
  }).map(function (_ref5) {
    var campus = _ref5.campus;
    return {
      text: campus,
      value: campus
    };
  }).uniqBy('value').value();
});
var selectRoomLabel = createSelector([selectTeObjectTypes, function (_, room) {
  return room;
}], function (teObjectTypes, room) {
  var _teObjectTypes$room = teObjectTypes.room,
      labelField = _teObjectTypes$room.labelField,
      secondaryLabelField = _teObjectTypes$room.secondaryLabelField;
  var label = shouldUsePrimaryLanguage() ? room === null || room === void 0 ? void 0 : room[labelField] : room === null || room === void 0 ? void 0 : room[secondaryLabelField];
  return label || 'N/A';
});

var selectExamTypeMap = function selectExamTypeMap(state) {
  return state.examTypes.entities;
};
var selectActiveExamTypes = createSelector(selectExamTypeMap, function (examTypeMap) {
  if (!examTypeMap) {
    return [];
  }

  return Object.values(examTypeMap).filter(function (_ref) {
    var deletedAt = _ref.deletedAt;
    return !deletedAt;
  });
});

var _EXAM_PUBLICATION_STA;
var EXAM_PUBLICATION_STATUS_NOT_PUBLISHED = 'not_published';
var EXAM_PUBLICATION_STATUS_PUBLISHED = 'published';
var EXAM_PUBLICATION_STATUS_PUBLISHED_WITH_CHANGES = 'published_with_changes';
var EXAM_PUBLICATION_STATUS_DEPUBLISHED = 'depublished';
(_EXAM_PUBLICATION_STA = {}, _defineProperty(_EXAM_PUBLICATION_STA, EXAM_PUBLICATION_STATUS_NOT_PUBLISHED, formatMessage(messages.valueLabel.publicationStatus.notPublished)), _defineProperty(_EXAM_PUBLICATION_STA, EXAM_PUBLICATION_STATUS_PUBLISHED, formatMessage(messages.valueLabel.publicationStatus.published, {
  date: 'NONE'
})), _defineProperty(_EXAM_PUBLICATION_STA, EXAM_PUBLICATION_STATUS_PUBLISHED_WITH_CHANGES, formatMessage(messages.valueLabel.publicationStatus.modified)), _defineProperty(_EXAM_PUBLICATION_STA, EXAM_PUBLICATION_STATUS_DEPUBLISHED, formatMessage(messages.valueLabel.publicationStatus.depublished)), _EXAM_PUBLICATION_STA);

var _excluded$7 = ["te_extid"];
var statusAllowedToPublish = [EXAM_PUBLICATION_STATUS_NOT_PUBLISHED, EXAM_PUBLICATION_STATUS_PUBLISHED_WITH_CHANGES, EXAM_PUBLICATION_STATUS_DEPUBLISHED];
var statusAllowedToDepublish = [EXAM_PUBLICATION_STATUS_PUBLISHED];

var filterForAction = function filterForAction(exam, action) {
  switch (action) {
    case 'publish':
      return statusAllowedToPublish.includes(exam.publicationStatus);

    case 'depublish':
      return statusAllowedToDepublish.includes(exam.publicationStatus);

    default:
      return true;
  }
};

var examMapSelector = function examMapSelector(state) {
  return state.exams.entities;
};

var examObjectSelector = function examObjectSelector(state) {
  return state.exams.examSetting;
};

createSelector(examMapSelector, function (examMap) {
  return Object.values(examMap || {}).filter(function (e) {
    return e.groupingStatus !== EXAM_GROUPING_STATUS_CHILD;
  });
});
createSelector(examObjectSelector, function (objects) {
  if (!objects) {
    return {};
  }

  var result = {};

  var _iterator = _createForOfIteratorHelper(objects !== null && objects !== void 0 ? objects : []),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var object = _step.value;

      var _object$fields = object.fields,
          te_extid = _object$fields.te_extid,
          fields = _objectWithoutProperties(_object$fields, _excluded$7);

      if (te_extid) {
        result[te_extid] = fields;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
});
var selectLinkedExams = createSelector([examMapSelector, function (_, examId) {
  return examId;
}], function (examMap, examId) {
  return (examMap ? Object.values(examMap) : []).filter(function (_ref) {
    var id = _ref.id,
        groupingStatus = _ref.groupingStatus;
    return !examId || examId !== id && groupingStatus !== EXAM_GROUPING_STATUS_CHILD;
  }).map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        examId = _ref2.examId;
    return {
      id: id,
      examId: examId,
      name: name,
      nameDisplay: size(name) ? "".concat(examId, " - ").concat(name) : examId
    };
  });
});
createSelector(examMapSelector, function (_, examIds) {
  return examIds;
}, function (examMap, examIds) {
  return (examIds || []).map(function (id) {
    return examMap[id];
  }).filter(function (exam) {
    return exam;
  });
});
createSelector(examMapSelector, function (exams) {
  return Object.values(exams || {});
});
var selectAllParentExams = createSelector(examMapSelector, function (exams) {
  return _.filter(exams, function (exam) {
    return !exam.parentId;
  });
});
createSelector(examMapSelector, function (exams) {
  return _.filter(exams, function (exam) {
    return !!exam.parentId;
  });
});
createSelector(selectAllParentExams, function (exams) {
  return (exams || []).filter(function (e) {
    return e.examStatus === EXAM_STATUSES.PENDING;
  });
});
var selectScheduledParentExams = createSelector(selectAllParentExams, function (exams) {
  return (exams || []).filter(function (e) {
    return e.examStatus === EXAM_STATUSES.SCHEDULED;
  });
});
createSelector(selectScheduledParentExams, function (_, props) {
  return props || {};
}, function (exams, _ref3) {
  var action = _ref3.action;
  return (exams || []).filter(function (e) {
    return filterForAction(e, action);
  });
});
var selectPastParentExams = createSelector(selectAllParentExams, function (exams) {
  return (exams || []).filter(function (exam) {
    return exam.examStatus === EXAM_STATUSES.PAST;
  });
});
createSelector(selectPastParentExams, function (_, props) {
  return props || {};
}, function (exams, _ref4) {
  var action = _ref4.action;
  return (exams || []).filter(function (e) {
    return filterForAction(e, action);
  });
});
createSelector(selectAllParentExams, function (exams) {
  return (exams || []).filter(function (e) {
    return e.examStatus === EXAM_STATUSES.CANCELLED;
  });
});
createSelector(selectAllParentExams, function (exams) {
  return (exams || []).filter(function (e) {
    return ![EXAM_STATUSES.PAST, EXAM_STATUSES.CANCELLED].includes(e.examStatus);
  });
});
createSelector(selectAllParentExams, function (exams) {
  return (exams || []).filter(function (exam) {
    return exam.examStatus === EXAM_STATUSES.PENDING || exam.examStatus === EXAM_STATUSES.DEPUBLISHED || exam.examStatus === EXAM_STATUSES.SCHEDULED;
  }).sort(function (a, b) {
    var firstPritorityA = _.get(a, 'priorities.0._targetDate', 0);

    var firstPritorityB = _.get(b, 'priorities.0._targetDate', 0);

    return firstPritorityA - firstPritorityB;
  });
});
createSelector(selectScheduledParentExams, function (scheduledExams) {
  if (!scheduledExams || !scheduledExams.length) {
    return [];
  }

  var examDates = scheduledExams.map(function (exam) {
    return moment(exam.scheduledExamDate).toDate();
  });
  return [moment.utc(new Date(Math.min.apply(null, examDates))).startOf('day'), moment.utc(new Date(Math.max.apply(null, examDates))).endOf('day')];
});

var useFeatureFlag = function useFeatureFlag(flag) {
  var lockedFeatures = useAppSelector(selectLockedFeature);
  return lockedFeatures.includes(flag);
};

var ExamPropertySelectionContainer = function ExamPropertySelectionContainer(_ref) {
  var examId = _ref.examId,
      path = _ref.path,
      readonly = _ref.readonly,
      eventHandlers = _ref.eventHandlers,
      miniMode = _ref.miniMode,
      exam = _ref.exam,
      style = _ref.style;

  var _useAppSelector = useAppSelector(function (state) {
    return {
      examTypeDataSource: selectActiveExamTypes(state),
      mandatoryObjects: state.organization.mandatoryObjects,
      languageDataSource: selectActiveLanguages(state),
      teObjects: selectTeObjects(state),
      relatedExtIds: state.integrationSettings.relatedExtIds,
      relationMap: state.integrationSettings.relationMap,
      teObjectTypes: state.organization.teObjectTypes,
      campus: selectCampuses(state),
      isLinkedExamEnabled: isExamObjectEnabled(state, 'linkedExam'),
      linkedExamDataSource: selectLinkedExams(state, examId)
    };
  }),
      mandatoryObjects = _useAppSelector.mandatoryObjects,
      languageDataSource = _useAppSelector.languageDataSource,
      teObjects = _useAppSelector.teObjects,
      relatedExtIds = _useAppSelector.relatedExtIds,
      relationMap = _useAppSelector.relationMap,
      teObjectTypes = _useAppSelector.teObjectTypes,
      campus = _useAppSelector.campus,
      examTypeDataSource = _useAppSelector.examTypeDataSource,
      isLinkedExamEnabled = _useAppSelector.isLinkedExamEnabled;

  var isLockedExamTypeExamLanguage = useFeatureFlag(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE);
  var selectedLinkedExam = useSelector(function (state) {
    var _state$exams;

    return Object.values((_state$exams = state.exams) === null || _state$exams === void 0 ? void 0 : _state$exams.selectedLinkedExam).map(function (_ref2) {
      var id = _ref2.id,
          name = _ref2.name,
          examId = _ref2.examId;
      return {
        id: id,
        examId: examId,
        name: name,
        nameDisplay: size(name) ? "".concat(examId, " - ").concat(name) : examId
      };
    });
  });
  var storeLinkedExams = useSelector(function (state) {
    var _state$exams2;

    var linkedExams = state === null || state === void 0 ? void 0 : (_state$exams2 = state.exams) === null || _state$exams2 === void 0 ? void 0 : _state$exams2.linkedExams;

    if (!isEmpty(linkedExams)) {
      return (Object.values(linkedExams) || []).map(function (_ref3) {
        var id = _ref3.id,
            name = _ref3.name,
            examId = _ref3.examId;
        return {
          id: id,
          examId: examId,
          name: name,
          nameDisplay: size(name) ? "".concat(examId, " - ").concat(name) : examId
        };
      });
    }
  });

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      linkedExams = _useState2[0],
      setLinkedExams = _useState2[1];

  var prevStoreLinkedExams = usePrevious$1(storeLinkedExams);
  var examProperties = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, teObjects), {}, {
      campus: campus
    });
  }, [teObjects, campus]);
  useEffect(function () {
    if (storeLinkedExams && !isEqual(prevStoreLinkedExams, storeLinkedExams)) {
      var examList = [];

      if (storeLinkedExams && selectedLinkedExam) {
        examList = uniqBy(concat(storeLinkedExams, selectedLinkedExam), 'examId');
      } else {
        examList = storeLinkedExams;
      }

      if (examList.length > 0) {
        examList = examList.filter(function (item) {
          return item.examId;
        });
      }

      setLinkedExams(examList);
    }
  }, [storeLinkedExams, selectedLinkedExam, prevStoreLinkedExams]);

  var getKey = function getKey(name, isLocked) {
    return isLocked ? name : "".concat(name, "Id");
  };

  var selectableProperties = useMemo(function () {
    var properties = _toConsumableArray(getExamPropertyObject(isLockedExamTypeExamLanguage).map(function (_ref4) {
      var _mandatoryObjects$nam9, _mandatoryObjects$nam10, _mandatoryObjects$nam11, _mandatoryObjects$nam12, _mandatoryObjects$nam13, _mandatoryObjects$nam14;

      var name = _ref4.name,
          key = _ref4.key,
          idKey = _ref4.idKey,
          labelPath = _ref4.labelPath,
          columnConfig = _ref4.columnConfig;

      if (name === 'examType' && isLockedExamTypeExamLanguage) {
        var _mandatoryObjects$nam, _mandatoryObjects$nam2, _mandatoryObjects$nam3;

        return {
          name: formatMessage(messages.label.examType),
          label: formatMessage(messages.label.examType),
          key: getKey(name, isLockedExamTypeExamLanguage),
          columnConfig: TE_TYPE_DATA_MODEL_FIELD_CATEGORIES,
          dataSource: examTypeDataSource,
          labelKey: 'label',
          idKey: 'id',
          isMandatory: mandatoryObjects === null || mandatoryObjects === void 0 ? void 0 : (_mandatoryObjects$nam = mandatoryObjects[name]) === null || _mandatoryObjects$nam === void 0 ? void 0 : _mandatoryObjects$nam.mandatory,
          allowMultiple: mandatoryObjects === null || mandatoryObjects === void 0 ? void 0 : (_mandatoryObjects$nam2 = mandatoryObjects[name]) === null || _mandatoryObjects$nam2 === void 0 ? void 0 : _mandatoryObjects$nam2.multiple,
          isDisabled: mandatoryObjects === null || mandatoryObjects === void 0 ? void 0 : (_mandatoryObjects$nam3 = mandatoryObjects[name]) === null || _mandatoryObjects$nam3 === void 0 ? void 0 : _mandatoryObjects$nam3.disabled
        };
      }

      if (name === 'language' && isLockedExamTypeExamLanguage) {
        var _mandatoryObjects$nam4, _mandatoryObjects$nam5, _mandatoryObjects$nam6, _mandatoryObjects$nam7, _mandatoryObjects$nam8;

        return {
          name: formatMessage(messages.label.examLanguage),
          label: formatMessage(messages.label.examLanguage),
          key: getKey(name, isLockedExamTypeExamLanguage),
          columnConfig: TE_TYPE_DATA_MODEL_FIELD_CATEGORIES,
          dataSource: languageDataSource,
          labelKey: 'label',
          idKey: 'id',
          isMandatory: (_mandatoryObjects$nam4 = mandatoryObjects === null || mandatoryObjects === void 0 ? void 0 : (_mandatoryObjects$nam5 = mandatoryObjects[name]) === null || _mandatoryObjects$nam5 === void 0 ? void 0 : _mandatoryObjects$nam5.mandatory) !== null && _mandatoryObjects$nam4 !== void 0 ? _mandatoryObjects$nam4 : false,
          allowMultiple: mandatoryObjects === null || mandatoryObjects === void 0 ? void 0 : (_mandatoryObjects$nam6 = mandatoryObjects[name]) === null || _mandatoryObjects$nam6 === void 0 ? void 0 : _mandatoryObjects$nam6.multiple,
          isDisabled: (_mandatoryObjects$nam7 = mandatoryObjects === null || mandatoryObjects === void 0 ? void 0 : (_mandatoryObjects$nam8 = mandatoryObjects[name]) === null || _mandatoryObjects$nam8 === void 0 ? void 0 : _mandatoryObjects$nam8.disabled) !== null && _mandatoryObjects$nam7 !== void 0 ? _mandatoryObjects$nam7 : true
        };
      }

      return {
        name: name,
        label: get(teObjectTypes, labelPath || "".concat(name, ".applicationObjectTypeLabel")),
        columnConfig: columnConfig || createColumnsFromObjectType(teObjectTypes[name]),
        dataSource: examProperties[name],
        relations: relationMap === null || relationMap === void 0 ? void 0 : relationMap[name],
        relatedExtIds: relatedExtIds[name],
        key: key,
        labelKey: name === 'campus' ? 'name' : 'label',
        idKey: idKey,
        isMandatory: (_mandatoryObjects$nam9 = mandatoryObjects === null || mandatoryObjects === void 0 ? void 0 : (_mandatoryObjects$nam10 = mandatoryObjects[name]) === null || _mandatoryObjects$nam10 === void 0 ? void 0 : _mandatoryObjects$nam10.mandatory) !== null && _mandatoryObjects$nam9 !== void 0 ? _mandatoryObjects$nam9 : false,
        allowMultiple: (_mandatoryObjects$nam11 = mandatoryObjects === null || mandatoryObjects === void 0 ? void 0 : (_mandatoryObjects$nam12 = mandatoryObjects[name]) === null || _mandatoryObjects$nam12 === void 0 ? void 0 : _mandatoryObjects$nam12.multiple) !== null && _mandatoryObjects$nam11 !== void 0 ? _mandatoryObjects$nam11 : false,
        isDisabled: (_mandatoryObjects$nam13 = mandatoryObjects === null || mandatoryObjects === void 0 ? void 0 : (_mandatoryObjects$nam14 = mandatoryObjects[name]) === null || _mandatoryObjects$nam14 === void 0 ? void 0 : _mandatoryObjects$nam14.disabled) !== null && _mandatoryObjects$nam13 !== void 0 ? _mandatoryObjects$nam13 : true
      };
    }));

    if (isLinkedExamEnabled) {
      properties.push({
        label: formatMessage(messages.label.linkedExam),
        key: 'linkedExamId',
        columnConfig: TE_LINKED_EXAM_DATA_MODEL_FIELD_CATEGORIES,
        dataSource: linkedExams,
        labelKey: 'nameDisplay',
        idKey: 'examId',
        primitiveKey: 'id',
        isMandatory: false,
        allowMultiple: false,
        isDisabled: false
      });
    }

    return orderBy(properties, ['isMandatory'], ['desc']);
  }, [isLinkedExamEnabled, isLockedExamTypeExamLanguage, teObjectTypes, examProperties, relationMap, relatedExtIds, mandatoryObjects, examTypeDataSource, languageDataSource, linkedExams]);
  return /*#__PURE__*/React__default.createElement(ExamPropertySelection$1, {
    exam: exam,
    selectableProperties: selectableProperties,
    path: path,
    readonly: readonly,
    eventHandlers: eventHandlers,
    miniMode: miniMode,
    style: style
  });
};

var ExamPropertySelectionContainer$1 = ExamPropertySelectionContainer;

var isDuplicated = function isDuplicated(priority, priorityIndex, priorities) {
  if (!priority.targetDate) return false;

  var _priorities = [].concat(_toConsumableArray(priorities.slice(0, priorityIndex)), _toConsumableArray(priorities.slice(priorityIndex + 1)));

  var existsSame = _priorities.some(function (cf) {
    var sameRoom = cf.roomId === priority.roomId;
    var sameSlot = cf.examSlotId === priority.examSlotId;
    var sameInterval = cf.intervalId === priority.intervalId;
    var sameDate = moment(cf.targetDate).isSame(moment(priority.targetDate), 'day');
    return sameRoom && sameSlot && sameInterval && sameDate;
  });

  return existsSame;
};
var hasDuplicated = function hasDuplicated(priorities) {
  if (!Array.isArray(priorities) || !priorities.length) return false;
  return !!priorities.find(function (priority, priorityIndex) {
    return isDuplicated(priority, priorityIndex, priorities);
  });
};

var selectState = function selectState(state) {
  return state.priorities;
};

var selectOrganiationState = function selectOrganiationState(state) {
  return state.organization;
};

var selectGroupByExamId = createSelector(selectState, function (priorities) {
  return priorities.groupByExamId;
});
createSelector([selectGroupByExamId, function (_, examId) {
  return examId;
}], function (groupByExamId, examId) {
  return groupByExamId[examId] || [];
});
var requestedSchedulingValidations = [function (_ref) {
  var priorities = _ref.priorities,
      minRequestNumber = _ref.minRequestNumber;
  return priorities.length < minRequestNumber ? formatMessage(messages.component.requestedSchedulingListDetailPad.prioritiesAddLeastWarning, {
    minNumber: minRequestNumber
  }) : null;
}, function (_ref2) {
  var priorities = _ref2.priorities,
      maxRequestNumber = _ref2.maxRequestNumber;
  return priorities.length > maxRequestNumber ? formatMessage(messages.component.requestedSchedulingListDetailPad.prioritiesMaximumWarning, {
    maxNumber: maxRequestNumber
  }) : null;
}, function (_ref3) {
  var priorities = _ref3.priorities;
  return priorities.find(function (item) {
    return !item.targetDate;
  }) ? formatMessage(messages.component.requestedSchedulingListDetailPad.prioritiesInvalidWarning) : null;
}, function (_ref4) {
  var priorities = _ref4.priorities;
  return hasDuplicated(priorities) ? formatMessage(messages.component.examSchedulingRequest.uniqueError) : null;
}];
var selectRequestedSchedulingErrorMessage = function selectRequestedSchedulingErrorMessage(priorities) {
  return createSelector(selectState, selectOrganiationState, function (requestedScheduling, organization) {
    var requestSetting = organization.requestSetting;
    var teCoreMinRequestNumber = requestSetting.teCoreMinRequestNumber,
        teCoreMaxRequestNumber = requestSetting.teCoreMaxRequestNumber;

    var _iterator = _createForOfIteratorHelper(requestedSchedulingValidations),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var validationFn = _step.value;
        var hasError = validationFn({
          priorities: priorities,
          teCoreMinRequestNumber: teCoreMinRequestNumber,
          teCoreMaxRequestNumber: teCoreMaxRequestNumber
        });

        if (hasError) {
          return hasError;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  });
};

var usePrioritiesSettings = function usePrioritiesSettings() {
  return useSelector(function (state) {
    return state.organization.requestSetting;
  });
};
var useRequestedSchedulingErrorMessage = function useRequestedSchedulingErrorMessage(priorities) {
  return useSelector(function (state) {
    return selectRequestedSchedulingErrorMessage(priorities)(state);
  });
};

var useRooms = function useRooms() {
  return useSelector(function (state) {
    return Object.values(state.rooms.entities || {});
  });
};

var FormItem = styled(Form$2.Item).withConfig({
  displayName: "FormItem",
  componentId: "sc-1io00rc-0"
})(["&&&{margin:0;.ant-form-item-label,.ant-form-item-control{", "}.ant-form-item-label > label.ant-form-item-no-colon::after{display:none;}.ant-form-item-label label{color:", ";}}"], function (props) {
  return props.lineHeight !== undefined ? "line-height: ".concat(isNaN$1(props.lineHeight) ? props.lineHeight : "".concat(props.lineHeight, "px"), ";") : null;
}, darkGrey);
var FormItem$1 = FormItem;

var Form = styled(Form$2).withConfig({
  displayName: "Form",
  componentId: "sc-7ctqjc-0"
})(["&&&{padding:0;&.ant-form-vertical .ant-form-item-label{padding:0 0 3px;}}"]);
var Form$1 = Form;

var _excluded$6 = ["children", "dropdownClassName"];

var BaseSelect = function BaseSelect(_ref) {
  var children = _ref.children,
      dropdownClassName = _ref.dropdownClassName,
      props = _objectWithoutProperties(_ref, _excluded$6);

  return /*#__PURE__*/React__default.createElement(Select$2, _extends({
    dropdownClassName: "exam-plugin-select-dropdown ".concat(dropdownClassName)
  }, props), children);
};

BaseSelect.defaultProps = {
  dropdownClassName: ''
};
var Select = styled(BaseSelect).withConfig({
  displayName: "Select",
  componentId: "sc-qprrwv-0"
})(["&&&{&.ant-select-focused,&.ant-select-open{.ant-select-selection{border-color:", ";box-shadow:0 0 0 2px rgb(41 182 143 / 20%);}}.ant-select-selection{:focus,:hover{border-color:", ";}:focus{box-shadow:0 0 0 2px rgb(41 182 143 / 20%);}}.ant-select-selection-selected-value,.ant-select-search__field{color:", ";}}"], jungleGreen, jungleGreen, darkGrey);
var Select$1 = Select;

var SelectOption = styled(Select$2.Option).withConfig({
  displayName: "SelectOption",
  componentId: "sc-ieq7yt-0"
})([""]);
var SelectOption$1 = SelectOption;

var Card = styled(Card$2).withConfig({
  displayName: "Card",
  componentId: "sc-li3saa-0"
})(["&&&{margin-bottom:15px;.ant-card-body{padding:0;}}"]);
var Card$1 = Card;

var sizeToClassSuffix = function sizeToClassSuffix(size) {
  switch (size) {
    case 'sm':
      return '-sm';

    case 'lg':
      return '-lg';

    default:
      return '';
  }
};

var _excluded$5 = ["addonBefore", "size", "style", "inputStyle", "popupClassName"];

var TimePicker = function TimePicker(_ref) {
  var addonBefore = _ref.addonBefore,
      size = _ref.size,
      style = _ref.style,
      inputStyle = _ref.inputStyle,
      popupClassName = _ref.popupClassName,
      props = _objectWithoutProperties(_ref, _excluded$5);

  return /*#__PURE__*/React__default.createElement(TimePickerWraper, {
    style: style
  }, addonBefore && /*#__PURE__*/React__default.createElement("span", {
    className: "ant-input-group-wrapper ant-input-group-wrapper".concat(sizeToClassSuffix(size))
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "ant-input-wrapper ant-input-group"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "ant-input-group-addon"
  }, addonBefore), /*#__PURE__*/React__default.createElement(TimePicker$2, _extends({
    size: size,
    popupClassName: "exam-plugin-time-picker-popup ".concat(popupClassName),
    style: inputStyle
  }, props)))), !addonBefore && /*#__PURE__*/React__default.createElement(TimePicker$2, _extends({
    size: size,
    style: inputStyle,
    popupClassName: "exam-plugin-time-picker-popup ".concat(popupClassName)
  }, props)));
};

TimePicker.defaultProps = {
  popupClassName: ''
};
var TimePickerWraper = styled.span.withConfig({
  displayName: "TimePicker__TimePickerWraper",
  componentId: "sc-1qv9p0c-0"
})(["&&&{.ant-time-picker-input{color:", ";}.ant-input-group-addon + .ant-time-picker{.ant-time-picker-input{border-radius:0 4px 4px 0;}}:hover .ant-time-picker-input:not(.ant-input-disabled){border-color:", ";}:hover,:focus-visible{outline:none;}.ant-time-picker-input{::selection{background-color:", ";}:focus,:hover{border-color:", ";}:focus{box-shadow:0 0 0 2px rgb(41 182 143 / 20%);}}.ant-input-group-wrapper{width:auto;.ant-input-group{display:inline-table;width:auto;}}.anticon.anticon-close-circle.ant-time-picker-clear,.anticon.anticon-clock-circle.ant-time-picker-clock-icon,.ant-time-picker-icon{display:flex;align-items:center;justify-content:flex-end;}.ant-input-group-addon{background:", ";color:", ";}}"], darkGrey, jungleGreen, jungleGreen, jungleGreen, lightGrey, darkGrey);
var TimePicker$1 = TimePicker;

var _excluded$4 = ["addonBefore", "size", "style", "inputStyle", "dropdownClassName"];

var DatePicker = function DatePicker(_ref) {
  var addonBefore = _ref.addonBefore,
      size = _ref.size,
      style = _ref.style,
      inputStyle = _ref.inputStyle,
      dropdownClassName = _ref.dropdownClassName,
      props = _objectWithoutProperties(_ref, _excluded$4);

  return /*#__PURE__*/React__default.createElement(DatePickerWrapper, {
    style: style
  }, addonBefore && /*#__PURE__*/React__default.createElement("span", {
    className: "ant-input-group-wrapper ant-input-group-wrapper".concat(sizeToClassSuffix(size))
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "ant-input-wrapper ant-input-group"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "ant-input-group-addon"
  }, addonBefore), /*#__PURE__*/React__default.createElement(DatePicker$2, _extends({
    size: size,
    style: inputStyle,
    dropdownClassName: "exam-plugin-date-picker-dropdown ".concat(dropdownClassName)
  }, props)))), !addonBefore && /*#__PURE__*/React__default.createElement(DatePicker$2, _extends({
    size: size,
    style: inputStyle,
    dropdownClassName: "exam-plugin-date-picker-dropdown ".concat(dropdownClassName)
  }, props)));
};

DatePicker.defaultProps = {
  dropdownClassName: ''
};
var DatePickerWrapper = styled.span.withConfig({
  displayName: "DatePicker__DatePickerWrapper",
  componentId: "sc-14xb7pj-0"
})(["&&&{.ant-calendar-picker-input{color:", ";}.ant-input-group-addon + .ant-calendar-picker{.ant-input{border-radius:0 4px 4px 0;}}:hover .ant-input:not(.ant-input-disabled){border-color:", ";}:hover,:focus-visible{outline:none;}.ant-input{::selection{background-color:", ";}:focus,:hover{border-color:", ";}:focus{box-shadow:0 0 0 2px rgb(41 182 143 / 20%);}}.ant-input-group-wrapper{width:auto;.ant-input-group{display:inline-table;width:auto;line-height:0.5;vertical-align:middle;}}.anticon.anticon-calendar.ant-calendar-picker-icon{display:flex;align-items:center;justify-content:flex-end;}}"], darkGrey, jungleGreen, jungleGreen, jungleGreen);
var DatePicker$1 = DatePicker;

var commonStyles = css(["&[disabled]{opacity:0.5;:focus,:hover{background-color:", ";border-color:", ";}}:focus,:hover{color:", ";background-color:", ";border-color:", ";}"], jungleGreen, jungleGreen, white, darken(0.05, jungleGreen), darken(0.05, jungleGreen));
var ModifiedAntdButton = styled(Button$2).withConfig({
  displayName: "Button__ModifiedAntdButton",
  componentId: "sc-soh9pv-0"
})(["&&&{&.ant-btn-primary{background-color:", ";border-color:", ";color:", ";", "}&.ant-btn-default{", "}&.ant-btn-link{color:", ";:hover,:focus,:active{color:", ";}}}"], jungleGreen, jungleGreen, white, commonStyles, commonStyles, jungleGreen, lighten(0.05, jungleGreen));

var Button = function Button(props) {
  return /*#__PURE__*/React__default.createElement(ModifiedAntdButton, props);
};

Button.defaultProps = {
  size: 'small',
  type: 'primary'
};
var Button$1 = Button;

var dateToHourFormatter = new Intl.DateTimeFormat('sv', {
  hour: 'numeric',
  minute: 'numeric',
  hour12: false,
  timeZone: 'UTC'
}).format;
new Intl.DateTimeFormat('sv', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  timeZone: 'UTC'
}).format;
var unixTimestampToHourFormatter = function unixTimestampToHourFormatter(val) {
  if (Number.isNaN(val * 1000)) return '';
  return dateToHourFormatter(new Date(val * 1000));
};
var hourTimestampToMoment = function hourTimestampToMoment(timestamp) {
  return moment(timestamp ? unixTimestampToHourFormatter(timestamp) : '00:00', 'HH:mm');
};

var RoomLabelText = function RoomLabelText(_ref) {
  var room = _ref.room;
  var label = useAppSelector(function (state) {
    return selectRoomLabel(state, room);
  });
  return label;
};

var ExamSchedulingRequest = function ExamSchedulingRequest(_ref2) {
  var clearSchedulingPriorities = _ref2.clearSchedulingPriorities,
      setRequestedSchedulings = _ref2.setRequestedSchedulings,
      _ref2$priority = _ref2.priority,
      targetDate = _ref2$priority.targetDate,
      exactStartTime = _ref2$priority.exactStartTime;
      _ref2$priority.exactEndTime;
      var strictTime = _ref2$priority.strictTime,
      strictDate = _ref2$priority.strictDate,
      isShown = _ref2$priority.isShown,
      priorityIndex = _ref2.priorityIndex,
      isScheduled = _ref2.isScheduled,
      style = _ref2.style;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      getValues = _useFormContext.getValues,
      setValue = _useFormContext.setValue;

  var _usePrioritiesSetting = usePrioritiesSettings(),
      allowTeCoreRoomParam = _usePrioritiesSetting.allowTeCoreRoomParam,
      allowTeCoreDateParam = _usePrioritiesSetting.allowTeCoreDateParam,
      teCoreAllowExactTime = _usePrioritiesSetting.teCoreAllowExactTime,
      teCoreAllowStrictDate = _usePrioritiesSetting.teCoreAllowStrictDate,
      teCoreAllowStrictTime = _usePrioritiesSetting.teCoreAllowStrictTime;

  var rooms = useRooms();

  var getUpdatingDateTime = function getUpdatingDateTime() {
    var exactEndTime = getValues("priorities.".concat(priorityIndex, ".exactEndTime"));
    var exactStartTime = getValues("priorities.".concat(priorityIndex, ".exactStartTime"));
    var targetDate = getValues("priorities.".concat(priorityIndex, ".targetDate"));
    return {
      exactStartTime: exactStartTime,
      exactEndTime: exactEndTime,
      targetDate: targetDate
    };
  };

  var toggleStrictTime = function toggleStrictTime() {
    setRequestedSchedulings(_objectSpread2({
      strictTime: !strictTime,
      strictDate: strictDate,
      isShown: strictDate && !strictTime
    }, getUpdatingDateTime()), priorityIndex);
  };

  var toggleStrictDate = function toggleStrictDate() {
    setRequestedSchedulings(_objectSpread2({
      strictDate: !strictDate,
      strictTime: strictTime,
      isShown: strictTime && !strictDate
    }, getUpdatingDateTime()), priorityIndex);
  };

  var formatTime = function formatTime(time) {
    return moment.utc().startOf('day').add(time, 'seconds');
  };

  return /*#__PURE__*/React__default.createElement(Card$1, {
    style: _objectSpread2({
      display: isShown ? 'block' : 'none'
    }, style !== null && style !== void 0 ? style : {}),
    className: classnames('exam-schedule-request--wrapper', {
      invalid: !targetDate
    }),
    size: "small"
  }, /*#__PURE__*/React__default.createElement(Form$1, {
    labelCol: {
      span: 3
    },
    layout: "horizontal",
    labelAlign: "left"
  }, allowTeCoreDateParam && /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: formatMessage(messages.label.date),
    lineHeight: "30"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "priorities.".concat(priorityIndex, ".targetDate"),
    control: control,
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DatePicker$1, _extends({}, field, {
        disabledDate: function disabledDate(current) {
          return current && current.isBefore(moment(), 'day');
        },
        getCalendarContainer: getPluginContainer,
        size: "small",
        allowClear: false,
        disabled: isScheduled,
        inputStyle: {
          maxWidth: 120
        }
      })), teCoreAllowStrictDate ? strictDate ? /*#__PURE__*/React__default.createElement(Button$1, {
        type: "danger",
        ghost: true,
        icon: "lock",
        onClick: toggleStrictDate,
        style: {
          borderColor: 'transparent',
          boxShadow: 'none'
        }
      }) : /*#__PURE__*/React__default.createElement(Button$1, {
        type: "link",
        icon: "unlock",
        onClick: toggleStrictDate
      }) : undefined);
    }
  })), teCoreAllowExactTime && /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: "Time",
    lineHeight: "30"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "priorities.".concat(priorityIndex, ".exactStartTime"),
    control: control,
    render: function render(_ref4) {
      var _ref4$field = _ref4.field,
          _onChange = _ref4$field.onChange,
          value = _ref4$field.value;
      return /*#__PURE__*/React__default.createElement(TimePicker$1, {
        addonBefore: "From",
        getPopupContainer: getPluginContainer,
        onChange: function onChange(time) {
          var value = time ? time.startOf('m').unix() - time.startOf('day').unix() : 0;

          _onChange(value);

          var startOfDay = moment.utc(exactStartTime).startOf('day');
          var endOfTime = moment.unix(getValues("priorities.".concat(priorityIndex, ".exactStartTime"))).add(getValues('durationHours'), 'hours').add(getValues('durationMinutes'), 'minutes').diff(startOfDay, 'seconds');
          setValue("priorities.".concat(priorityIndex, ".exactEndTime"), endOfTime);
        },
        allowClear: false,
        size: "small",
        value: formatTime(value),
        format: "HH:mm",
        disabled: isScheduled,
        style: {
          marginRight: 6
        },
        inputStyle: {
          maxWidth: 70
        }
      });
    }
  }), /*#__PURE__*/React__default.createElement(Controller, {
    name: "priorities.".concat(priorityIndex, ".exactEndTime"),
    control: control,
    render: function render(_ref5) {
      var _ref5$field = _ref5.field,
          _onChange2 = _ref5$field.onChange,
          value = _ref5$field.value;
      return /*#__PURE__*/React__default.createElement(TimePicker$1, {
        addonBefore: "To",
        getPopupContainer: getPluginContainer,
        onChange: function onChange(time) {
          var value = time ? time.startOf('m').unix() - time.startOf('day').unix() : 0;
          var startTime = hourTimestampToMoment(getValues("priorities.".concat(priorityIndex, ".exactStartTime")));
          var endTime = hourTimestampToMoment(value);
          var duration = moment.duration(endTime.diff(startTime));
          var hours = duration.hours();
          var minutes = duration.minutes();

          if (hours) {
            setValue('durationHours', hours);
          }

          if (minutes) {
            setValue('durationMinutes', minutes);
          }

          _onChange2(value);
        },
        allowClear: false,
        size: "small",
        value: formatTime(value),
        format: "HH:mm",
        disabled: isScheduled,
        inputStyle: {
          maxWidth: 70
        }
      });
    }
  }), teCoreAllowStrictTime ? strictTime ? /*#__PURE__*/React__default.createElement(Button$1, {
    type: "danger",
    ghost: true,
    icon: "lock",
    onClick: toggleStrictTime,
    style: {
      borderColor: 'transparent',
      boxShadow: 'none'
    }
  }) : /*#__PURE__*/React__default.createElement(Button$1, {
    type: "link",
    icon: "unlock",
    onClick: toggleStrictTime
  }) : undefined), allowTeCoreRoomParam && /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: formatMessage(messages.label.room),
    lineHeight: "30"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "priorities.".concat(priorityIndex, ".room.id"),
    control: control,
    render: function render(_ref6) {
      var _ref6$field = _ref6.field,
          value = _ref6$field.value,
          _onChange3 = _ref6$field.onChange;
      return /*#__PURE__*/React__default.createElement(Select$1, {
        style: {
          maxWidth: 160
        },
        getPopupContainer: getPluginContainer,
        dropdownMatchSelectWidth: false,
        size: "small",
        placeholder: formatMessage(messages.placeholder.selectItem, {
          item: formatMessage(messages.model.room)
        }),
        allowClear: true,
        value: value || 'N/A',
        onChange: function onChange(val) {
          return _onChange3(val);
        },
        disabled: isScheduled,
        showSearch: true,
        optionFilterProp: "children",
        filterOption: function filterOption(input, option) {
          return "".concat(get(option.props.children, 'props.room.name', '')).toLowerCase().includes(input.toLowerCase());
        }
      }, (rooms || []).map(function (el) {
        return /*#__PURE__*/React__default.createElement(SelectOption$1, {
          key: el.id,
          value: el.id
        }, /*#__PURE__*/React__default.createElement(RoomLabelText, {
          room: el
        }));
      }));
    }
  }))), !isScheduled ? /*#__PURE__*/React__default.createElement(Button$1, {
    shape: "circle",
    icon: "delete",
    type: "danger",
    style: {
      position: 'absolute',
      top: 6,
      right: 6
    },
    size: "small",
    onClick: function onClick(e) {
      e.stopPropagation();
      return clearSchedulingPriorities(priorityIndex);
    }
  }) : null);
};

var ExamSchedulingRequest$1 = ExamSchedulingRequest;

var ExamSchedulingRequests = function ExamSchedulingRequests(_ref) {
  var _ref$priorities = _ref.priorities,
      priorities = _ref$priorities === void 0 ? [] : _ref$priorities,
      saveButtonClicked = _ref.saveButtonClicked,
      isScheduled = _ref.isScheduled,
      setRequestedSchedulings = _ref.setRequestedSchedulings,
      clearSchedulingPriorities = _ref.clearSchedulingPriorities,
      itemStyle = _ref.itemStyle;
  // const isLoading = useLoadingTillAllCompleted([
  //   'FETCH_REQUESTED_SCHEDULINGS_FOR_EXAM',
  //   'FETCH_REQUESTED_SCHEDULINGS_FOR_EXAMS',
  //   'SAVE_REQUESTED_SCHEDULINGS_FOR_EXAM',
  //   'FETCH_TIME_INTERVALS_FOR_USER',
  // ]);
  var requestedSchedulingErrorMessage = useRequestedSchedulingErrorMessage(priorities); // if (isLoading) return <TELoadingIndicator isLoading={isLoading} />;
  // const onCheckDuplicated = (priority: any, priorityIndex: number) =>
  //   isDuplicated(priority, priorityIndex, priorities);

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isScheduled && saveButtonClicked && requestedSchedulingErrorMessage ? /*#__PURE__*/React__default.createElement(Alert, {
    style: {
      marginBottom: '1.2rem'
    },
    type: "error",
    message: "".concat(formatMessage(messages.message.prioritiesHaveError), ":"),
    description: requestedSchedulingErrorMessage
  }) : null, priorities.map(function (priority, priorityIndex) {
    return /*#__PURE__*/React__default.createElement(ExamSchedulingRequest$1, {
      clearSchedulingPriorities: clearSchedulingPriorities,
      setRequestedSchedulings: setRequestedSchedulings,
      priority: priority,
      key: "rs-".concat(priorityIndex),
      priorityIndex: priorityIndex,
      isScheduled: isScheduled,
      style: itemStyle
    });
  }));
};

var ExamSchedulingRequests$1 = ExamSchedulingRequests;

var ExamRequestedSchedulingPane = function ExamRequestedSchedulingPane(_ref) {
  var _ref$priorities = _ref.priorities,
      priorities = _ref$priorities === void 0 ? [] : _ref$priorities,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$saveButtonClicke = _ref.saveButtonClicked,
      saveButtonClicked = _ref$saveButtonClicke === void 0 ? false : _ref$saveButtonClicke,
      removePriority = _ref.removePriority,
      setRequestedSchedulings = _ref.setRequestedSchedulings,
      itemStyle = _ref.itemStyle;
  var dispatch = useDispatch();
  var prioritiesSettings = usePrioritiesSettings();
  priorities = priorities.filter(function (item) {
    return !item.isDeleted;
  });
  useEffect(function () {
    dispatch(fetchRequestSettings());
    dispatch(fetchIntervals());
  }, []); // Make sure use is allowed to prioritize on at least 1 parameter

  var userCanPrioritize = useMemo(function () {
    var allowTeCoreDateParam = prioritiesSettings.allowTeCoreDateParam,
        allowTeCoreRoomParam = prioritiesSettings.allowTeCoreRoomParam,
        teCoreAllowExactTime = prioritiesSettings.teCoreAllowExactTime,
        teCoreMaxRequestNumber = prioritiesSettings.teCoreMaxRequestNumber;
    if (!allowTeCoreDateParam && !allowTeCoreRoomParam && !teCoreAllowExactTime || !teCoreMaxRequestNumber || teCoreMaxRequestNumber === 0) return false;
    return true;
  }, [prioritiesSettings]);
  return /*#__PURE__*/React__default.createElement("div", null, !userCanPrioritize ? /*#__PURE__*/React__default.createElement(Alert, {
    type: "warning",
    message: formatMessage(messages.component.requestedSchedulingListDetailPad.prioritiesDisabledWarning),
    description: formatMessage(messages.component.requestedSchedulingListDetailPad.prioritiesDisabledDescription),
    style: {
      marginBottom: 10
    }
  }) : /*#__PURE__*/React__default.createElement(ExamSchedulingRequests$1, {
    isScheduled: readOnly,
    priorities: priorities,
    saveButtonClicked: saveButtonClicked,
    clearSchedulingPriorities: removePriority,
    setRequestedSchedulings: setRequestedSchedulings,
    itemStyle: itemStyle
  }));
};

var ExamRequestedSchedulingPane$1 = ExamRequestedSchedulingPane;

var Collapse = styled(Collapse$2).withConfig({
  displayName: "Collapse",
  componentId: "sc-jx1xmz-0"
})(["&&&{margin:0;.ant-collapse-item{background:#fff;border-radius:0;box-shadow:none;margin:0;border-top:1px solid #d9d9d9;border-bottom:none;&:last-child{border-bottom:1px solid #d9d9d9;}.ant-collapse-header{color:", ";border-bottom:none;font-size:inherit;padding:3px 6px;padding-left:20px;}.ant-collapse-header .anticon-right{left:6px;}.ant-collapse-content{padding:0 6px;}.ant-collapse-content-box{padding:0;}}}"], jungleGreen);
var Collapse$1 = Collapse;

var CollapsePanel = styled(Collapse$2.Panel).withConfig({
  displayName: "CollapsePanel",
  componentId: "sc-1xjdmjb-0"
})([""]);
var CollapsePanel$1 = CollapsePanel;

var FormItemLabel = function FormItemLabel(_ref) {
  var iconPosition = _ref.iconPosition,
      icon = _ref.icon,
      text = _ref.text;
  return /*#__PURE__*/React__default.createElement(FormItemLabelWrapper, null, iconPosition == 'before' && icon, text, iconPosition == 'after' && icon);
};

var FormItemLabelWrapper = styled.label.withConfig({
  displayName: "FormItemLabel__FormItemLabelWrapper",
  componentId: "sc-1g2bqsn-0"
})(["&&&{display:flex;color:", ";.anticon{display:flex;align-items:center;}}"], darkGrey);
var FormItemLabel$1 = FormItemLabel;

function AdditionalInfo(_ref) {
  _ref.style;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: "External ref",
    lineHeight: "30"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "externalReference",
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field;
      return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, field, {
        size: "small",
        placeholder: "External reference"
      }));
    }
  })), /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: "Student info",
    lineHeight: "30"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "informationToStudents",
    control: control,
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, field, {
        size: "small",
        placeholder: "Student information"
      }));
    }
  })), /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: "Supervisor info",
    lineHeight: "30"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "informationToSupervisors",
    control: control,
    render: function render(_ref4) {
      var field = _ref4.field;
      return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, field, {
        size: "small",
        placeholder: "Supervisor information"
      }));
    }
  })), /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: "Admin info",
    lineHeight: "30"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "informationToAdministrators",
    control: control,
    render: function render(_ref5) {
      var field = _ref5.field;
      return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, field, {
        size: "small",
        placeholder: "Administrator information"
      }));
    }
  })));
}

var RadioGroup = styled(Radio$2.Group).withConfig({
  displayName: "RadioGroup",
  componentId: "sc-d1krxk-0"
})([""]);
var RadioGroup$1 = RadioGroup;

var Radio = styled(Radio$2).withConfig({
  displayName: "Radio",
  componentId: "sc-1srkrdc-0"
})(["&&&{.ant-radio-wrapper:hover .ant-radio,.ant-radio:hover .ant-radio-inner,.ant-radio-input:focus+.ant-radio-inner{border-color:", ";}.ant-radio-checked .ant-radio-inner{border-color:", ";}.ant-radio-inner::after{background-color:", ";}input:focus{outline:none;}span{color:", ";}}"], jungleGreen, jungleGreen, jungleGreen, darkGrey);
var Radio$1 = Radio;

var _excluded$3 = ["addonAfter", "style", "size", "inputStyle"];

var InputNumber = function InputNumber(_ref) {
  var addonAfter = _ref.addonAfter,
      style = _ref.style,
      size = _ref.size,
      inputStyle = _ref.inputStyle,
      props = _objectWithoutProperties(_ref, _excluded$3);

  return /*#__PURE__*/React__default.createElement(InputNumberWrapper, {
    style: style
  }, addonAfter && /*#__PURE__*/React__default.createElement("span", {
    className: "ant-input-group-wrapper ant-input-group-wrapper".concat(sizeToClassSuffix(size))
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "ant-input-wrapper ant-input-group"
  }, /*#__PURE__*/React__default.createElement(InputNumber$2, _extends({
    size: size,
    style: inputStyle
  }, props)), /*#__PURE__*/React__default.createElement("span", {
    className: "ant-input-group-addon"
  }, addonAfter))), !addonAfter && /*#__PURE__*/React__default.createElement(InputNumber$2, _extends({
    size: size,
    style: inputStyle
  }, props)));
};

var InputNumberWrapper = styled.div.withConfig({
  displayName: "InputNumber__InputNumberWrapper",
  componentId: "sc-1l0ccow-0"
})(["&&&{display:flex;.ant-input-number{color:", ";}> .ant-input-number{display:flex;flex:1;}.ant-input-wrapper.ant-input-group{display:flex;.ant-input-number{display:flex;flex:1;border-radius:4px 0 0 4px;.ant-input-number-input{border-radius:4px 0 0 4px;}}.ant-input-group-addon{display:flex;align-items:center;justify-content:center;}}.ant-input-number{:hover{border-color:", ";}&.ant-input-number-focused{border-color:", ";box-shadow:0 0 0 2px rgb(41 182 143 / 20%) !important;}.ant-input-number-handler:hover .ant-input-number-handler-up-inner,.ant-input-number-handler:hover .ant-input-number-handler-down-inner{color:", "}}.ant-input-group-addon{background:", ";color:", ";}}"], darkGrey, jungleGreen, jungleGreen, jungleGreen, lightGrey, darkGrey);
InputNumber.defaultProps = {
  size: 'small'
};
var InputNumber$1 = InputNumber;

function BasicInfo(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$priorities = _ref.priorities,
      priorities = _ref$priorities === void 0 ? [] : _ref$priorities;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      getValues = _useFormContext.getValues,
      setValue = _useFormContext.setValue;

  var handleChangeDuration = function handleChangeDuration() {
    priorities.map(function (item, index) {
      var endOfTime = getValues("priorities.".concat(index, ".exactStartTime")) + getValues('durationHours') * 3600 + getValues('durationMinutes') * 60;
      setValue("priorities.".concat(index, ".exactEndTime"), endOfTime);
    });
  };

  return /*#__PURE__*/React__default.createElement(Row, {
    gutter: 12
  }, /*#__PURE__*/React__default.createElement(Form$1, {
    layout: "vertical",
    labelAlign: "left"
  }, /*#__PURE__*/React__default.createElement(Col, {
    span: 7
  }, /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: "Number of students:"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "studentsPlanned",
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field;
      return /*#__PURE__*/React__default.createElement(InputNumber$1, _extends({}, field, {
        min: 0,
        placeholder: "Number of students",
        disabled: isDisabled
      }));
    }
  }))), /*#__PURE__*/React__default.createElement(Col, {
    span: 8
  }, /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: "Duration:"
  }, /*#__PURE__*/React__default.createElement(Row, {
    gutter: 12
  }, /*#__PURE__*/React__default.createElement(Col, {
    span: "12"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "durationHours",
    control: control,
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/React__default.createElement(InputNumber$1, _extends({}, field, {
        min: 0,
        placeholder: "Hours",
        addonAfter: "h",
        disabled: isDisabled,
        onChange: function onChange(e) {
          field.onChange(e);
          handleChangeDuration();
        }
      }));
    }
  })), /*#__PURE__*/React__default.createElement(Col, {
    span: 12
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "durationMinutes",
    control: control,
    render: function render(_ref4) {
      var field = _ref4.field;
      return /*#__PURE__*/React__default.createElement(InputNumber$1, _extends({}, field, {
        min: 0,
        placeholder: "Minutes",
        addonAfter: "m",
        disabled: isDisabled,
        onChange: function onChange(e) {
          field.onChange(e);
          handleChangeDuration();
        }
      }));
    }
  }))))), /*#__PURE__*/React__default.createElement(Col, {
    span: 9
  }, /*#__PURE__*/React__default.createElement(FormItem$1, {
    label: "Regular or make up exam:"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "isReExam",
    control: control,
    render: function render(_ref5) {
      var field = _ref5.field;
      return /*#__PURE__*/React__default.createElement(RadioGroup$1, _extends({}, field, {
        defaultValue: getValues('isReExam') ? true : false,
        size: "small",
        disabled: isDisabled,
        style: {
          marginTop: 4
        }
      }), /*#__PURE__*/React__default.createElement(Radio$1, {
        value: false
      }, "Regular"), /*#__PURE__*/React__default.createElement(Radio$1, {
        value: true
      }, "Make up"));
    }
  })))));
}

var DraftExamDetail = function DraftExamDetail(_ref) {
  var _examForm$getValues;

  var exam = _ref.exam,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      isDisabled = _ref.isDisabled;
  var examForm = useForm({
    defaultValues: exam
  });
  useEffect(function () {
    examForm.reset(exam);
  }, [exam, examForm]);

  var _useFieldArray = useFieldArray({
    keyName: 'formId',
    // prevent auto generated key from colliding with object schema
    control: examForm.control,
    name: 'priorities'
  }),
      priorities = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove,
      update = _useFieldArray.update;

  var mandatoryObjectsLoaded = useAppSelector(function (state) {
    return state.organization.apiStatus.fetchMandatoryObjects === ApiStatus.SUCCEEDED;
  });
  var examTypesLoaded = useAppSelector(function (state) {
    return state.examTypes.apiStatus.fetchExamTypes === ApiStatus.SUCCEEDED;
  });
  var languagesLoaded = useAppSelector(function (state) {
    return state.languages.apiStatus.fetchLanguages === ApiStatus.SUCCEEDED;
  });
  var roomsLoaded = useAppSelector(function (state) {
    return state.rooms.apiStatus.fetchRooms === ApiStatus.SUCCEEDED;
  });
  var examSettingsLoaded = useAppSelector(function (state) {
    return state.organization.apiStatus.fetchExamSettings === ApiStatus.SUCCEEDED;
  });
  var appSettingsLoaded = useAppSelector(function (state) {
    return state.organization.apiStatus.fetchAppSettings === ApiStatus.SUCCEEDED;
  });
  var userLoaded = useAppSelector(function (state) {
    return !state.users.loading;
  });
  var selectedLinkedExam = useAppSelector(function (state) {
    return state.exams.selectedLinkedExam;
  });
  var examPropertyTableReadonly = !(mandatoryObjectsLoaded && examTypesLoaded && languagesLoaded && roomsLoaded && examSettingsLoaded && appSettingsLoaded && userLoaded);
  var requestSetting = useAppSelector(function (state) {
    return selectReqSettings(state);
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var canAddMorePriority = useMemo(function () {
    return priorities.length < requestSetting.teCoreMaxRequestNumber;
  }, [requestSetting, priorities]);

  var addPriority = function addPriority() {
    if (!canAddMorePriority) return;
    append(buildNewPriority());
  };

  var removePriority = function removePriority(idx) {
    return remove(idx);
  };

  var handleLockPriority = function handleLockPriority(priority, updated) {
    var strictDate = false;
    var strictTime = false;
    strictDate = updated.strictDate ? updated.strictDate : false;
    strictTime = updated.strictTime ? updated.strictTime : false;
    return _objectSpread2(_objectSpread2({}, priority), {}, {
      strictDate: strictDate,
      strictTime: strictTime,
      isShown: updated.isShown ? updated.isShown : true
    });
  };

  var handleChangeRequestedSchedulings = function handleChangeRequestedSchedulings(updatedField, idx) {
    var updatedPriority = examForm.getValues('priorities').find(function (_priority, curIdx) {
      return curIdx === idx;
    });

    if (updatedPriority) {
      var newPriority = handleLockPriority(updatedPriority, updatedField);
      update(idx, newPriority);
    }
  };

  var buildNewPriority = useCallback(function () {
    var startOfDay = moment.unix(exam.begin).utc().startOf('day');
    var newEndOfTime = moment.unix(exam.end).diff(startOfDay, 'seconds');

    if (examForm.getValues('durationHours') && examForm.getValues('durationMinutes')) {
      newEndOfTime = moment.unix(exam.begin).add(examForm.getValues('durationHours'), 'hours').add(examForm.getValues('durationMinutes'), 'minutes').diff(startOfDay, 'seconds');
    }

    return {
      targetDate: moment.unix(exam.begin).utc().startOf('day'),
      roomId: undefined,
      isShown: true,
      exactStartTime: moment.unix(exam.begin).diff(startOfDay, 'seconds'),
      exactEndTime: newEndOfTime
    };
  }, [exam, examForm]);

  var handleSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(exam) {
      var _exam$priorities, _find$id, _find;

      var formPriorities, priorities, linkedExamId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formPriorities = (_exam$priorities = exam.priorities) !== null && _exam$priorities !== void 0 ? _exam$priorities : [];
              priorities = formPriorities.map(function (p) {
                return omit(p, 'formId');
              }); // convert linkedExamId as incrementing id to objectId
              // I'm so sorry that we have to do this
              // I prmoise I will fix this when we reevaluate the exam object

              linkedExamId = (_find$id = (_find = (selectedLinkedExam !== null && selectedLinkedExam !== void 0 ? selectedLinkedExam : []).find(function (selectedExam) {
                return (selectedExam === null || selectedExam === void 0 ? void 0 : selectedExam.examId) === (exam === null || exam === void 0 ? void 0 : exam.linkedExamId);
              })) === null || _find === void 0 ? void 0 : _find.id) !== null && _find$id !== void 0 ? _find$id : null;
              setLoading(true);
              _context.prev = 4;
              _context.next = 7;
              return onSave(_objectSpread2(_objectSpread2({}, exam), {}, {
                linkedExamId: linkedExamId,
                priorities: priorities
              }));

            case 7:
              _context.prev = 7;
              setLoading(false);
              return _context.finish(7);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4,, 7, 10]]);
    }));

    return function handleSave(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var prioritiesSettings = usePrioritiesSettings();
  var userCanPrioritize = useMemo(function () {
    var allowTeCoreDateParam = prioritiesSettings.allowTeCoreDateParam,
        allowTeCoreRoomParam = prioritiesSettings.allowTeCoreRoomParam,
        teCoreAllowExactTime = prioritiesSettings.teCoreAllowExactTime,
        teCoreMaxRequestNumber = prioritiesSettings.teCoreMaxRequestNumber;
    if (!allowTeCoreDateParam && !allowTeCoreRoomParam && !teCoreAllowExactTime || !teCoreMaxRequestNumber || teCoreMaxRequestNumber === 0) return false;
    return true;
  }, [prioritiesSettings]);
  return /*#__PURE__*/React__default.createElement(FormProvider, examForm, /*#__PURE__*/React__default.createElement(Form$1, {
    labelCol: {
      span: 3
    },
    wrapperCol: {
      span: 21
    },
    layout: "horizontal",
    labelAlign: "left"
  }, /*#__PURE__*/React__default.createElement(FormItem$1, {
    style: {
      padding: '0 6px'
    },
    label: /*#__PURE__*/React__default.createElement(FormItemLabel$1, {
      text: "Title:",
      iconPosition: "after",
      icon: /*#__PURE__*/React__default.createElement(InfoCircleOutlined, {
        style: {
          marginLeft: 3
        }
      })
    }),
    colon: false
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "name",
    control: examForm.control,
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, field, {
        placeholder: "Enter your exam title"
      }));
    }
  }))), /*#__PURE__*/React__default.createElement(Collapse$1, {
    bordered: false,
    defaultActiveKey: ['1', '2', '3', '4']
  }, /*#__PURE__*/React__default.createElement(CollapsePanel$1, {
    header: "Basic information",
    key: "1"
  }, /*#__PURE__*/React__default.createElement(BasicInfo, {
    isDisabled: isDisabled,
    priorities: examForm.getValues('priorities')
  })), /*#__PURE__*/React__default.createElement(CollapsePanel$1, {
    header: /*#__PURE__*/React__default.createElement(SPCollapsePanelHeader, {
      priorityQty: ((_examForm$getValues = examForm.getValues('priorities')) !== null && _examForm$getValues !== void 0 ? _examForm$getValues : []).length,
      onClickAddBtn: addPriority,
      disableAddBtn: isDisabled || !userCanPrioritize || !canAddMorePriority,
      showAddBtn: !isDisabled
    }),
    key: "2"
  }, /*#__PURE__*/React__default.createElement(ExamRequestedSchedulingPane$1, {
    removePriority: removePriority,
    priorities: examForm.getValues('priorities'),
    setRequestedSchedulings: handleChangeRequestedSchedulings,
    itemStyle: {
      padding: '3px 6px'
    },
    readOnly: isDisabled
  })), /*#__PURE__*/React__default.createElement(CollapsePanel$1, {
    header: "Exam objects",
    key: "3"
  }, /*#__PURE__*/React__default.createElement(ExamPropertySelectionContainer$1, {
    readonly: examPropertyTableReadonly,
    style: {
      margin: '0 -6px'
    },
    exam: examForm.getValues()
  })), /*#__PURE__*/React__default.createElement(CollapsePanel$1, {
    header: "Additional information",
    key: "4"
  }, /*#__PURE__*/React__default.createElement(AdditionalInfo, {
    style: {
      paddingBottom: 10
    }
  }))), /*#__PURE__*/React__default.createElement(SaveBtnWrapper, null, onCancel && /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: onCancel,
    disabled: loading,
    type: "link"
  }, "Back"), /*#__PURE__*/React__default.createElement(Button$1, {
    disabled: loading,
    loading: loading,
    onClick: examForm.handleSubmit(handleSave)
  }, "Save exam request")));
};

var SaveBtnWrapper = styled.div.withConfig({
  displayName: "DraftExamDetail__SaveBtnWrapper",
  componentId: "sc-n0gxuv-0"
})(["padding:6px;display:flex;flex-direction:row;justify-content:space-between;& >:only-child{margin-left:auto;}"]);

var SPCollapsePanelHeader = function SPCollapsePanelHeader(_ref4) {
  var priorityQty = _ref4.priorityQty,
      onClickAddBtn = _ref4.onClickAddBtn,
      disableAddBtn = _ref4.disableAddBtn,
      showAddBtn = _ref4.showAddBtn;
  return /*#__PURE__*/React__default.createElement(PanelHeaderContainer, null, /*#__PURE__*/React__default.createElement("div", null, "Scheduling Priorities"), /*#__PURE__*/React__default.createElement("div", null, "Priorities added: ", /*#__PURE__*/React__default.createElement("span", null, priorityQty), showAddBtn && /*#__PURE__*/React__default.createElement(Button$1, {
    disabled: disableAddBtn,
    onClick: function onClick(e) {
      e.stopPropagation();
      onClickAddBtn();
    }
  }, "Add new")));
};

var PanelHeaderContainer = styled.div.withConfig({
  displayName: "DraftExamDetail__PanelHeaderContainer",
  componentId: "sc-n0gxuv-1"
})(["&{display:flex;flex-direction:row;> div:first-child{display:flex;flex:1;}> div:last-child{color:", ";> span{margin-left:5px;margin-right:30px;border-radius:4px;background-color:", ";padding:0 4px;color:#8a909c;}}}"], black, lightGrey);
var DraftExamDetail$1 = DraftExamDetail;

var useUserId = function useUserId() {
  return useAppSelector(function (state) {
    return state.auth.user ? state.auth.user.id : undefined;
  });
};

var getId = function getId(teExtId) {
  // _te_2500 => te_2500
  if (teExtId[0] == '_') {
    return teExtId.slice(1);
  }

  return teExtId;
};

var extractReservationObjects = function extractReservationObjects(reservationObjects, teObjectTypes, teObjects, mandatoryObjects, isLockedLanguageAndType) {
  if (!reservationObjects) return {};
  var teObjectTypesGroupedByObjectTypeName = groupBy(teObjectTypes, 'objectTypeExtId');
  var objects = reservationObjects.reduce(function (tot, _ref) {
    var _teObjectTypesGrouped;

    var typeextid = _ref.typeextid,
        extid = _ref.extid;
    var matchedObjectType = (_teObjectTypesGrouped = teObjectTypesGroupedByObjectTypeName === null || teObjectTypesGroupedByObjectTypeName === void 0 ? void 0 : teObjectTypesGroupedByObjectTypeName[typeextid]) !== null && _teObjectTypesGrouped !== void 0 ? _teObjectTypesGrouped : [];
    matchedObjectType.forEach(function (objectType) {
      var _tot$objectType$appli;

      tot[objectType.applicationObjectTypeName] = (_tot$objectType$appli = tot[objectType.applicationObjectTypeName]) !== null && _tot$objectType$appli !== void 0 ? _tot$objectType$appli : [];
      var foundObjectType = teObjects[objectType.applicationObjectTypeName];

      if (foundObjectType) {
        var foundObject = foundObjectType.find(function (_ref2) {
          var teExtId = _ref2.teExtId;
          return getId(teExtId) === getId(extid);
        });

        if (foundObject) {
          tot[objectType.applicationObjectTypeName].push(foundObject);
        }
      }
    });
    return tot;
  }, {}); // In case user change from allow multiple to not allow, cut off values after first value

  var _iterator = _createForOfIteratorHelper(getExamPropertyObject(isLockedLanguageAndType)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _objects$name;

      var name = _step.value.name;
      var mandatoryObject = mandatoryObjects[name];

      if (mandatoryObject && !(mandatoryObject !== null && mandatoryObject !== void 0 && mandatoryObject.multiple) && objects[name] && Array.isArray(objects[name]) && ((_objects$name = objects[name]) === null || _objects$name === void 0 ? void 0 : _objects$name.length) > 1) {
        objects[name] = slice(objects[name], 0, 1);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return getExamCommonPropertyObject().filter(function (_ref3) {
    var name = _ref3.name;
    return objects[name];
  }).reduce(function (acc, _ref4) {
    var name = _ref4.name,
        key = _ref4.key;

    if (Array.isArray(objects[name])) {
      var teObjectsList = objects[name].map(function (item) {
        return item.teExtId;
      });
      acc[key] = teObjectsList.length > 0 ? teObjectsList : [];
    } else {
      acc[key] = objects[name] ? [objects[name].teExtId] : [];
    }

    return acc;
  }, {});
};

var _templateObject;

var isFetchBaseQueryError = function isFetchBaseQueryError(error) {
  return error != null && _typeof(error) === 'object' && 'status' in error;
};

var isBackendError = function isBackendError(error) {
  return error != null && _typeof(error) === 'object' && 'message' in error;
};
/**
 * Gets the error message from {@link Error} or {@link FetchBaseQueryError}
 */


var getErrorMessage = function getErrorMessage(error) {
  if (error == null) {
    return null;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (isFetchBaseQueryError(error)) {
    if ('error' in error) {
      return error.error;
    } else if (isBackendError(error.data)) {
      var _error$data$message;

      return (_error$data$message = error.data.message) !== null && _error$data$message !== void 0 ? _error$data$message : null;
    } else {
      return "HTTP error ".concat(error.status); // all we have is a status code
    }
  }

  return null;
};
/**
 * From `errorHandler()` middleware in te-exam-be
 */

var classifyReservationsWithExamId = function classifyReservationsWithExamId(reservations, examIdProp) {
  return partition(reservations, function (reservation) {
    var _reservation$fields$f;

    return ((_reservation$fields$f = reservation.fields.find(function (field) {
      return field.extid === examIdProp;
    })) === null || _reservation$fields$f === void 0 ? void 0 : _reservation$fields$f.values[0]) != undefined;
  });
};
var classifyReservationsWithRoom = function classifyReservationsWithRoom(reservations, roomObjectType) {
  return partition(reservations, function (reservation) {
    var _reservation$objects;

    return !!(reservation !== null && reservation !== void 0 && (_reservation$objects = reservation.objects) !== null && _reservation$objects !== void 0 && _reservation$objects.find(function (object) {
      return object.typeextid === roomObjectType && !!object.extid;
    }));
  });
};
var errorMessageGenerator = {
  HAD_ROOM: function HAD_ROOM() {
    return 'Can not create exams containing a room';
  },
  SKIP_EXAM_ID: function SKIP_EXAM_ID(skipReservationWithExam) {
    console.warn("Skipped ".concat(skipReservationWithExam.map(function (r) {
      return r.id;
    }), " reservation(s) because they already have an associated exam"));
    return "Skipped ".concat(skipReservationWithExam.length, " reservation(s) because they already have an associated exam.");
  },
  SKIP_ROOM: function SKIP_ROOM(skipReservationWithRoom) {
    console.warn(_templateObject || (_templateObject = _taggedTemplateLiteral(["Skipped reservations: ", " because they have assigned rooms."])), skipReservationWithRoom.map(function (r) {
      return r.id;
    }));
    return "Skipped ".concat(skipReservationWithRoom.length, " reservation(s) because they already have an associated room.");
  }
};

var emptyExam = {
  name: '',
  source: 'te_core',
  examDuration: 0,
  durationHours: 0,
  durationMinutes: 0,
  studentsPlanned: 0,
  studentsRegistered: 0,
  isReExam: false,
  externalReference: '',
  informationToStudents: '',
  informationToSupervisors: '',
  informationToAdministrators: '',
  commentToScheduler: '',
  professorIds: [],
  programIds: [],
  externalCustomerIds: [],
  studentGroupIds: [],
  costCenterIds: [],
  coursePartIds: [],
  courseIds: [],
  courseEventIds: [],
  moduleIds: [],
  departmentIds: [],
  coordinatorIds: [],
  examTypeIds: [],
  examLanguageIds: [],
  linkedExamId: '',
  examTypeId: null,
  languageId: null,
  reservationId: null
};
/**
 * Takes a list of reservations, converts them to exam drafts and stores them
 */

var setReservationDrafts = function setReservationDrafts(reservations, extraFields, disableRedirection) {
  return function (dispatch, getState) {
    try {
      var _examInCoreSettings$c, _state$integrationSet, _state$integrationSet2, _context$teObjectType, _context$teObjectType2;

      var state = getState();

      if (reservations === undefined || reservations.length === 0 || ['CREATE', 'EDIT'].includes(state.selection.originalMode)) {
        dispatch(initializeDrafts({
          reservations: reservations,
          drafts: []
        }));
        return;
      }

      var examInCoreSettings = selectExamInCoreSettings(state);
      var mandatoryObjects = state.organization.mandatoryObjects;
      var context = {
        extraFields: extraFields,
        teObjects: selectTeObjects(state),
        teObjectTypes: selectTeObjectTypes(state),
        configurableFieldsGetter: getConfigurableFieldsGetter((_examInCoreSettings$c = examInCoreSettings === null || examInCoreSettings === void 0 ? void 0 : examInCoreSettings.configureFields) !== null && _examInCoreSettings$c !== void 0 ? _examInCoreSettings$c : {}),
        mandatoryObjects: mandatoryObjects
      };
      var examIdProp = state === null || state === void 0 ? void 0 : (_state$integrationSet = state.integrationSettings) === null || _state$integrationSet === void 0 ? void 0 : (_state$integrationSet2 = _state$integrationSet.reservationSettings) === null || _state$integrationSet2 === void 0 ? void 0 : _state$integrationSet2.exam_id;
      var roomObjectType = context === null || context === void 0 ? void 0 : (_context$teObjectType = context.teObjectTypes) === null || _context$teObjectType === void 0 ? void 0 : (_context$teObjectType2 = _context$teObjectType.room) === null || _context$teObjectType2 === void 0 ? void 0 : _context$teObjectType2.objectTypeExtId;

      var _classifyReservations = classifyReservationsWithExamId(reservations, examIdProp),
          _classifyReservations2 = _slicedToArray(_classifyReservations, 2),
          skippedReservations = _classifyReservations2[0],
          reservationsWithoutExamId = _classifyReservations2[1];

      var _classifyReservations3 = classifyReservationsWithRoom(reservationsWithoutExamId, roomObjectType),
          _classifyReservations4 = _slicedToArray(_classifyReservations3, 2),
          skippedReservationsBecauseRoom = _classifyReservations4[0],
          reservationsWithoutRoomsOrExamId = _classifyReservations4[1];

      var message = []; // if (reservationsWithoutRoomsOrExamId.length === 0) {
      //   message.push(errorMessageGenerator.HAD_ROOM());
      // } else {

      if (skippedReservations.length > 0) {
        message.push(errorMessageGenerator.SKIP_EXAM_ID(skippedReservations));
      }

      if (skippedReservationsBecauseRoom.length > 0) {
        message.push(errorMessageGenerator.SKIP_ROOM(skippedReservationsBecauseRoom));
      } // }


      if (message.length > 0) {
        notification.warn({
          getContainer: getPluginContainer,
          message: message.join(', ')
        });
      }

      var isLockedLanguageAndType = state.organization.lockedFeatures.includes(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE);
      var drafts = reservationsWithoutRoomsOrExamId.map(function (reservation) {
        return reservationToExamDraft(reservation, context, isLockedLanguageAndType);
      });
      dispatch(initializeDrafts({
        reservations: reservations,
        drafts: drafts
      }));

      if (!disableRedirection && reservationsWithoutRoomsOrExamId.length === 0) {
        dispatch(gotoAllExams());
      } else if (!disableRedirection && reservationsWithoutRoomsOrExamId.length === 1 && skippedReservations.length > 0) {
        dispatch(setMode('CREATE_MULTI'));
      }

      return true;
    } catch (e) {
      notification.error({
        getContainer: getPluginContainer,
        message: 'Failed to load reservations'
      });
      console.error('Failed to convert reservations to exam drafts', e);
      dispatch(initializeDrafts({
        reservations: reservations,
        drafts: []
      }));
    }
  };
};
var markReservationAsCompleted = function markReservationAsCompleted(reservationIds) {
  return function (dispatch, getState) {
    var _state$draft$drafts$l, _state$draft$drafts;

    dispatch(removeDrafts(reservationIds));
    var state = getState();
    var draftsLeft = (_state$draft$drafts$l = (_state$draft$drafts = state.draft.drafts) === null || _state$draft$drafts === void 0 ? void 0 : _state$draft$drafts.length) !== null && _state$draft$drafts$l !== void 0 ? _state$draft$drafts$l : -1;
    return {
      finishedAll: draftsLeft === 0
    };
  };
};
var createObjectsWithExtraFields = function createObjectsWithExtraFields(reservation) {
  var extraFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = reservation || {},
      _ref$objects = _ref.objects,
      objects = _ref$objects === void 0 ? [] : _ref$objects,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields;

  var transformObject = objects.map(function (obj) {
    var _extraFields$obj$exti;

    var extra = Object.entries((_extraFields$obj$exti = extraFields[obj.extid]) !== null && _extraFields$obj$exti !== void 0 ? _extraFields$obj$exti : {}).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      return {
        extid: key,
        values: [value.toString()]
      };
    });
    return _objectSpread2(_objectSpread2({}, obj), {}, {
      fields: obj.fields ? obj.fields.concat(extra) : extra
    });
  });
  var transformReservationFields = fields.map(function (obj) {
    return {
      extid: obj.extid,
      typeextid: EPReservationFieldPrefix,
      fields: [{
        extid: obj.extid,
        values: obj.values
      }]
    };
  });
  return [].concat(_toConsumableArray(transformObject), _toConsumableArray(transformReservationFields));
};
var reservationToExamDraft = function reservationToExamDraft(reservation, context, isLockedLanguageAndType) {
  var objects = extractReservationObjects(reservation.objects, context.teObjectTypes, context.teObjects, context.mandatoryObjects, isLockedLanguageAndType);
  var startOfDay = moment.unix(reservation.begin).utc().startOf('day');
  var priority = {
    isShown: true,
    targetDate: moment.unix(reservation.begin).utc().startOf('day'),
    exactStartTime: moment.unix(reservation.begin).diff(startOfDay, 'seconds'),
    exactEndTime: moment.unix(reservation.end).diff(startOfDay, 'seconds')
  };
  var objectsWithExtraFields = createObjectsWithExtraFields(reservation, context.extraFields);
  var fields = context.configurableFieldsGetter(convertFieldsToObject(objectsWithExtraFields));
  var examDuration = (reservation.end - reservation.begin) * 1000;
  return _objectSpread2(_objectSpread2({}, emptyExam), {}, {
    begin: reservation.begin,
    end: reservation.end,
    id: null,
    name: fields.title,
    reservationId: reservation.id,
    priorities: [priority],
    studentsPlanned: fields.studentsPlanned,
    informationToAdministrators: fields.adminInfo,
    informationToSupervisors: fields.supervisorInfo,
    informationToStudents: fields.studentInfo,
    externalReference: fields.externalRef,
    durationHours: getHoursFromMilliseconds(examDuration),
    durationMinutes: getMinutesFromMilliseconds(examDuration),
    examDuration: examDuration
  }, objects);
};

/* eslint-disable react-hooks/rules-of-hooks */
var useTeObjects = function useTeObjects() {
  return {
    teObjectTypes: useAppSelector(selectTeObjectTypes),
    teObjectIds: useAppSelector(function (state) {
      return state.integrationSettings.teObjectIds;
    }),
    teObjects: useAppSelector(selectTeObjects),
    mandatoryObjects: useAppSelector(function (state) {
      return state.organization.mandatoryObjects;
    })
  };
};

var NewExam = function NewExam(_ref) {
  var reservation = _ref.reservation,
      setMode = _ref.setMode,
      onCreateExam = _ref.onCreateExam;

  var _useTeObjects = useTeObjects(),
      teObjects = _useTeObjects.teObjects,
      teObjectTypes = _useTeObjects.teObjectTypes,
      mandatoryObjects = _useTeObjects.mandatoryObjects;

  var configurableFieldsGetter = useConfigurableFieldsGetter();
  var isLockedExamTypeExamLanguage = useFeatureFlag(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE);

  var _useReservationObject = useReservationObjectFields([reservation]),
      extraFields = _useReservationObject.data,
      isLoading = _useReservationObject.isLoading;

  var _useCreateExamMutatio = useCreateExamMutation(),
      _useCreateExamMutatio2 = _slicedToArray(_useCreateExamMutatio, 1),
      createExam = _useCreateExamMutatio2[0];

  var currentPage = useAppSelector(function (state) {
    return state.exams.page;
  });
  var dispatch = useAppDispatch();
  var ownerId = useUserId();
  var exam = useMemo(function () {
    if (isLoading) {
      return null;
    }

    return reservationToExamDraft(reservation, {
      teObjects: teObjects,
      extraFields: extraFields !== null && extraFields !== void 0 ? extraFields : {},
      teObjectTypes: teObjectTypes,
      configurableFieldsGetter: configurableFieldsGetter,
      mandatoryObjects: mandatoryObjects
    }, isLockedExamTypeExamLanguage);
  }, [configurableFieldsGetter, mandatoryObjects, reservation, teObjectTypes, teObjects, extraFields, isLoading, isLockedExamTypeExamLanguage]);
  var onSubmit = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(exam) {
      var tableConfig, errors, result, _getErrorMessage;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              notification.destroy();
              tableConfig = _objectSpread2(_objectSpread2({}, DEFAULT_TABLE_CONFIG), {}, {
                page: currentPage,
                populate: DEFAULT_POPULATE
              });
              errors = validateDraftExam(exam, mandatoryObjects, isLockedExamTypeExamLanguage);

              if (!notifyValidation(errors)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              _context.prev = 5;
              _context.next = 8;
              return createExam({
                exam: exam,
                ownerId: ownerId
              });

            case 8:
              result = _context.sent;

              if (!('error' in result)) {
                _context.next = 11;
                break;
              }

              throw result.error;

            case 11:
              notification.success({
                getContainer: getPluginContainer,
                message: 'New exam has been created.'
              });
              onCreateExam(result.data.examId, result.data.reservationId);
              dispatch(searchExamsOfTeCoreType(tableConfig));
              setMode('ALL');
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](5);
              notification.error({
                getContainer: getPluginContainer,
                message: 'Failed to create new exam.',
                description: (_getErrorMessage = getErrorMessage(_context.t0)) !== null && _getErrorMessage !== void 0 ? _getErrorMessage : 'Something went wrong.'
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 17]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [createExam, currentPage, dispatch, mandatoryObjects, onCreateExam, ownerId, setMode]);

  if (!exam) {
    return /*#__PURE__*/React__default.createElement(Spin, null);
  }

  return /*#__PURE__*/React__default.createElement(DraftExamDetail$1, {
    exam: exam,
    onSave: onSubmit
  });
};

var NewExam$1 = NewExam;

var StatusLabel = function StatusLabel(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      style = _ref.style,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "container-status-label ".concat(color, " ").concat(size),
    style: style
  }, children);
};

var ExamSchedulingStatusIndicator = function ExamSchedulingStatusIndicator(_ref) {
  var isScheduled = _ref.isScheduled;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: classnames('exam-scheduling-status-indicator', {
      'scheduling-complete': isScheduled,
      'scheduling-incomplete': !isScheduled
    })
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "exam-scheduling-exam-message"
  }, isScheduled ? formatMessage(messages.valueLabel.isScheduled.completed) : formatMessage(messages.valueLabel.isScheduled.incomplete)));
};

var ExamSchedulingStatusPane = function ExamSchedulingStatusPane(_ref) {
  var exam = _ref.exam;
  var isScheduled = exam.isScheduled,
      groupingStatus = exam.groupingStatus,
      childExams = exam.childExams,
      studentsPlanned = exam.studentsPlanned,
      examHierarchy = exam.examHierarchy;

  var _useMemo = useMemo(function () {
    if (exam.isScheduled) return {
      planned: exam.studentsPlanned,
      registered: exam.studentsRegistered,
      allocated: exam.studentsAllocated
    };
    if (groupingStatus === EXAM_GROUPING_STATUS_SINGLE) return {
      planned: 0,
      allocated: 0,
      registered: 0
    };
    return {
      planned: (examHierarchy.children || []).reduce(function (total, childExam) {
        if (childExam && childExam.isScheduled) {
          return total + childExam.studentsPlanned;
        }

        return total;
      }, 0),
      registered: exam.studentsRegistered,
      allocated: (examHierarchy.children || []).reduce(function (total, childExam) {
        if (childExam && childExam.isScheduled) {
          return total + childExam.studentsAllocated;
        }

        return total;
      }, 0)
    };
  }, [exam]),
      planned = _useMemo.planned;
      _useMemo.registered;
      _useMemo.allocated;

  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames('exam-scheduling-status-pane--wrapper', {
      'is-scheduled': isScheduled
    })
  }, /*#__PURE__*/React__default.createElement(ExamSchedulingStatusIndicator, {
    isScheduled: isScheduled
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: "exam-scheduling-exam-message"
  }, formatMessage(messages.component.examSchedulingStatusPane.studentsScheduledLabel), ":"), /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "".concat(planned, " scheduled/").concat(studentsPlanned, " planned"),
    mouseEnterDelay: TOOLTIP_DELAY,
    getPopupContainer: getPluginContainer
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(StatusLabel, {
    color: "default"
  }, "".concat(planned, "/").concat(studentsPlanned))))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: "exam-scheduling-exam-message"
  }, formatMessage(messages.component.examSchedulingStatusPane.numberOfChildExamsLabel), ":"), /*#__PURE__*/React__default.createElement(StatusLabel, {
    color: "default"
  }, childExams.length)));
};
ExamSchedulingStatusPane.propTypes = {
  exam: PropTypes.object.isRequired
};

var ExamGroupingStatus$2 = function ExamGroupingStatus(_ref) {
  var groupingStatus = _ref.groupingStatus;
  return groupingStatus ? /*#__PURE__*/React__default.createElement("div", {
    className: classnames('exam-grouping-status--wrapper', {
      'group-main': groupingStatus === EXAM_GROUPING_STATUS_MAIN,
      'group-single': groupingStatus === EXAM_GROUPING_STATUS_SINGLE,
      'group-child': groupingStatus === EXAM_GROUPING_STATUS_CHILD
    })
  }, EXAM_GROUPING_STATUS_LETTER[groupingStatus]) : null;
};

ExamGroupingStatus$2.propTypes = {
  groupingStatus: PropTypes.string
};
ExamGroupingStatus$2.defaultProps = {
  groupingStatus: undefined
};
var ExamGroupingStatus$3 = ExamGroupingStatus$2;

var ExamSchedulingDetails = function ExamSchedulingDetails(_ref6) {
  var exam = _ref6.exam;
  var isScheduled = exam.isScheduled,
      groupingStatus = exam.groupingStatus;
      exam.scheduledExamSlot;
      var scheduledExamDate = exam.scheduledExamDate,
      scheduledStartTime = exam.scheduledStartTime,
      scheduledEndTime = exam.scheduledEndTime;
      exam.scheduledRoom;
      var scheduledRoomBooking = exam.scheduledRoomBooking;
  useMemo(function () {
    return scheduledRoomBooking && scheduledRoomBooking.statistics && "".concat(scheduledRoomBooking.statistics.totalCapacityScheduled, " students scheduled / ").concat(scheduledRoomBooking.statistics.totalCapacity, " students capacity");
  }, [scheduledRoomBooking]);
  if (!isScheduled || groupingStatus === EXAM_GROUPING_STATUS_MAIN) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "exam-scheduling-details--wrapper"
  }, /*#__PURE__*/React__default.createElement(MdEvent, null), /*#__PURE__*/React__default.createElement("span", null, scheduledExamDate && scheduledExamDate.format(DATE_FORMAT_DEFAULT)), /*#__PURE__*/React__default.createElement(MdAccessTime, null), /*#__PURE__*/React__default.createElement("span", null, scheduledStartTime && scheduledEndTime && "\n            ".concat(moment.utc().startOf('day').add(scheduledStartTime, 'milliseconds').format('HH:mm'), " \n            - \n            ").concat(moment.utc().startOf('day').add(scheduledEndTime, 'milliseconds').format('HH:mm'), "\n        ")));
};
ExamSchedulingDetails.propTypes = {
  exam: PropTypes.object.isRequired
};

var ExamRow = function ExamRow(_ref) {
  var exam = _ref.exam;
  var examId = exam.examId,
      groupingStatus = exam.groupingStatus,
      name = exam.name,
      studentsPlanned = exam.studentsPlanned,
      isScheduled = exam.isScheduled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "exam-row--wrapper"
  }, /*#__PURE__*/React__default.createElement(ExamGroupingStatus$3, {
    groupingStatus: groupingStatus
  }), /*#__PURE__*/React__default.createElement("span", null, examId), /*#__PURE__*/React__default.createElement(Divider, {
    type: "vertical",
    className: "exam-row-divider"
  }), /*#__PURE__*/React__default.createElement("span", null, name), /*#__PURE__*/React__default.createElement(Divider, {
    type: "vertical",
    className: "exam-row-divider"
  }), formatMessage(messages.valueLabel.studentCount.planned, {
    number: studentsPlanned
  }), /*#__PURE__*/React__default.createElement(Divider, {
    type: "vertical",
    className: "exam-row-divider"
  }), /*#__PURE__*/React__default.createElement(ExamSchedulingStatusIndicator, {
    isScheduled: isScheduled
  }), /*#__PURE__*/React__default.createElement(Divider, {
    type: "vertical",
    className: "exam-row-divider"
  }), /*#__PURE__*/React__default.createElement(ExamSchedulingDetails, {
    exam: exam
  }));
};

var ExamHierarchyPane = function ExamHierarchyPane(_ref) {
  var exam = _ref.exam;
  var examMap = useSelector(function (state) {
    return state.exams.entities;
  });
  var getExamHierarchy = useCallback(function (exam) {
    if (!exam.parent) {
      return {
        parent: exam,
        children: exam.childExams
      };
    }

    return {
      parent: examMap[exam.parent],
      children: []
    };
  }, []);
  var examHierarchy = getExamHierarchy(exam);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "exam-hierarchy-pane--wrapper"
  }, /*#__PURE__*/React__default.createElement(Tree, {
    defaultExpandAll: true,
    switcherIcon: /*#__PURE__*/React__default.createElement(Icon, {
      type: "down"
    }),
    checkable: false,
    selectable: false
  }, /*#__PURE__*/React__default.createElement(Tree.TreeNode, {
    title: /*#__PURE__*/React__default.createElement(ExamRow, {
      exam: examHierarchy.parent
    }),
    key: examHierarchy.parent.id,
    selectable: false
  }, examHierarchy.children.map(function (e) {
    return /*#__PURE__*/React__default.createElement(Tree.TreeNode, {
      title: /*#__PURE__*/React__default.createElement(ExamRow, {
        exam: e
      }),
      key: e.id,
      selectable: false
    });
  }))));
};
ExamHierarchyPane.propTypes = {
  exam: PropTypes.object.isRequired
};

/* eslint-disable react/display-name */
var ExamRowWithLink = (function (_ref) {
  var exam = _ref.exam;
  var examId = exam.examId,
      groupingStatus = exam.groupingStatus,
      name = exam.name;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, groupingStatus === 'EXAM_GROUPING_STATUS_CHILD' ? /*#__PURE__*/React__default.createElement("div", {
    className: "exam-row--wrapper",
    key: examId
  }, /*#__PURE__*/React__default.createElement(ExamGroupingStatus$3, {
    groupingStatus: groupingStatus
  }), /*#__PURE__*/React__default.createElement("span", null, examId), /*#__PURE__*/React__default.createElement(Divider, {
    type: "vertical"
  }), /*#__PURE__*/React__default.createElement("span", null, name || 'N/A')) : /*#__PURE__*/React__default.createElement("div", {
    className: "exam-row--wrapper",
    key: examId
  }, /*#__PURE__*/React__default.createElement(ExamGroupingStatus$3, {
    groupingStatus: groupingStatus
  }), /*#__PURE__*/React__default.createElement("span", null, examId), /*#__PURE__*/React__default.createElement(Divider, {
    type: "vertical"
  }), /*#__PURE__*/React__default.createElement("span", null, name || 'N/A')));
});

var ExamLinking = function ExamLinking(_ref) {
  var linkedTo = _ref.linkedTo,
      linkedFrom = _ref.linkedFrom,
      _ref$propsStyle = _ref.propsStyle,
      propsStyle = _ref$propsStyle === void 0 ? {} : _ref$propsStyle,
      linkedExamId = _ref.linkedExamId;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "exam-linking-pane--wrapper",
    style: propsStyle.wrapper
  }, !isEmpty(linkedTo) ? /*#__PURE__*/React__default.createElement("div", {
    className: "linked-to",
    key: linkedExamId
  }, /*#__PURE__*/React__default.createElement("small", null, formatMessage(messages.label.thisExamIsLinkedTo), ":"), /*#__PURE__*/React__default.createElement(ExamRowWithLink, {
    exam: linkedTo
  })) : null, !isEmpty(linkedFrom) ? /*#__PURE__*/React__default.createElement("div", {
    className: "linked-from"
  }, /*#__PURE__*/React__default.createElement("small", null, formatMessage(messages.label.thisExamIsLinkedFrom), ":"), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, linkedFrom.map(function (exam) {
    return /*#__PURE__*/React__default.createElement(ExamRowWithLink, {
      exam: exam,
      key: exam.examId
    });
  }))) : null);
};

var ExamLinking$1 = ExamLinking;

var linkedProps = ['id', 'name', 'groupingStatus'];

/* eslint-disable react/display-name */
var ExamFoldout = /*#__PURE__*/React__default.memo(function (_ref) {
  var exam = _ref.exam,
      _ref$showSchedulingPa = _ref.showSchedulingPane,
      showSchedulingPane = _ref$showSchedulingPa === void 0 ? true : _ref$showSchedulingPa,
      _ref$showHierarchyPan = _ref.showHierarchyPane,
      showHierarchyPane = _ref$showHierarchyPan === void 0 ? true : _ref$showHierarchyPan;
      _ref.showPrioritiesPane;
  var isLinkedExamEnabled = useAppSelector(function (state) {
    return isExamObjectEnabled(state, 'linkedExam');
  });
  var examMapped = useAppSelector(function (state) {
    return state.exams.entities;
  });
  var linkedExamId = exam.linkedExamId,
      linkedFromExamIds = exam.linkedFromExamIds;
  var examLinkedTo = linkedExamId ? pick(examMapped[linkedExamId], linkedProps) : undefined;
  var examLinkedFrom = linkedFromExamIds ? linkedFromExamIds.map(function (id) {
    return pick(examMapped[id], linkedProps);
  }) : [];
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '4px',
      marginLeft: '34px'
    }
  }, /*#__PURE__*/React__default.createElement(Col, {
    span: 23
  }, /*#__PURE__*/React__default.createElement(ExamFoldoutWrapper, null, showSchedulingPane && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("small", {
    className: "exam-foldout_pane--title"
  }, formatMessage(messages.label.schedulingStatus), ":"), /*#__PURE__*/React__default.createElement(ExamSchedulingStatusPane, {
    exam: exam
  })), showHierarchyPane && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("small", {
    className: "exam-foldout_pane--title"
  }, formatMessage(messages.label.examHierarchy), ":"), /*#__PURE__*/React__default.createElement(ExamHierarchyPane, {
    exam: exam
  })), isLinkedExamEnabled && (!isEmpty(examLinkedTo) || !isEmpty(examLinkedFrom)) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("small", {
    className: "exam-foldout_pane--title"
  }, formatMessage(messages.label.linking), ":"), /*#__PURE__*/React__default.createElement(ExamLinking$1, {
    linkedTo: examLinkedTo,
    linkedFrom: examLinkedFrom
  })) : null)), /*#__PURE__*/React__default.createElement(Col, {
    span: 1
  }), /*#__PURE__*/React__default.createElement(Col, {
    span: 1,
    className: "fold-out-stick-column"
  }));
});
var ExamFoldoutWrapper = styled.div.withConfig({
  displayName: "ExamFoldout__ExamFoldoutWrapper",
  componentId: "sc-twh58d-0"
})(["& > div{margin-bottom:4px;}"]);
var ExamFoldout$1 = ExamFoldout;

var _excluded$2 = ["overlayClassName", "children"];

var Dropdown = function Dropdown(_ref) {
  var overlayClassName = _ref.overlayClassName,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$2);

  return /*#__PURE__*/React__default.createElement(Dropdown$2, _extends({
    overlayClassName: "exam-plugin-dropdown-overlay ".concat(overlayClassName)
  }, props), children);
};

var Dropdown$1 = Dropdown;

var ActionsCell = function ActionsCell(_ref) {
  var onSelectExam = _ref.onSelectExam,
      examId = _ref.examId,
      reservationId = _ref.reservationId;
      _ref.showInCalendar;
      var onSelectReservation = _ref.onSelectReservation;
  var isExamSelectable = !!(onSelectExam && examId);
  var isReservationSelectable = !!(onSelectReservation && reservationId);

  var createMenuItem = function createMenuItem(key, onClick, label, href) {
    return /*#__PURE__*/React__default.createElement(Menu.Item, {
      key: key
    }, href ? /*#__PURE__*/React__default.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: href,
      style: {
        padding: 0,
        margin: 0
      }
    }, label) : /*#__PURE__*/React__default.createElement("div", {
      onClick: onClick
    }, label));
  };

  var actions = [{
    condition: isExamSelectable,
    items: [{
      key: 'editRequest',
      onClick: function onClick() {
        if (isExamSelectable) {
          onSelectExam(examId);
        }
      },
      label: 'Edit request'
    }, {
      key: 'openInTEExam',
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onClick: function onClick() {},
      label: 'Open in TE Exam',
      href: "https://exam.timeedit.net/exams/".concat(examId)
    }]
  }, {
    condition: isReservationSelectable,
    items: [{
      key: 'editRequest',
      onClick: function onClick() {
        if (isReservationSelectable) {
          onSelectReservation(reservationId);
        }
      },
      label: 'Edit reservation request'
    }]
  }];
  var menu = /*#__PURE__*/React__default.createElement(Menu, null, actions.map(function (action, index) {
    return action.condition ? action.items.map(function (item) {
      return createMenuItem(item.key, item.onClick, item.label, item === null || item === void 0 ? void 0 : item.href);
    }) : null;
  }));
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
    getPopupContainer: getPluginContainer,
    overlay: menu,
    placement: "bottomLeft"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: "ellipsis",
    style: {
      fontSize: '2.0rem',
      margin: 'auto'
    }
  })));
};

var ActionsCell$1 = ActionsCell;

function useIsMounted() {
  var isMounted = useRef(false);
  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  return useCallback(function () {
    return isMounted.current;
  }, []);
}

var selectCurrentUser = function selectCurrentUser(state) {
  return state.auth.user;
};
createSelector(selectCurrentUser, selectCurrentOrganization, function (currentUser, currentOrganization) {
  return (// return true if user language is set to organization's primary language
    // in case of user language is not set to primary language nor secondary language, default using primary language
    currentUser.language === currentOrganization.primaryLanguage || currentUser.language !== currentOrganization.secondaryLanguage
  );
});

var selectUser = function selectUser(state) {
  return state.users.entities;
};
var userState = function userState(state) {
  return state.users;
};
var selectExam = function selectExam(state) {
  return state.exams.entities;
};
var selectUserFilter = createSelector(selectUser, selectCurrentUser, selectExam, function (user, curUser, exam) {
  var listUniqUser = _.uniq(Object.values(exam || {}).map(function (e) {
    return e.ownerId;
  }));

  return listUniqUser.map(function (e) {
    return {
      text: curUser && e === curUser.id ? 'Your Exam' : _.get(user, "".concat(e, ".name"), ''),
      value: _.get(user, "".concat(e, ".name"), '')
    };
  }).filter(function (e) {
    return !!e.value;
  });
});

var ExamGroupingStatus = function ExamGroupingStatus(_ref) {
  var groupingStatus = _ref.groupingStatus;
  return groupingStatus ? /*#__PURE__*/React__default.createElement("div", {
    className: classnames('exam-grouping-status--wrapper', {
      'group-main': groupingStatus === EXAM_GROUPING_STATUS_MAIN,
      'group-single': groupingStatus === EXAM_GROUPING_STATUS_SINGLE,
      'group-child': groupingStatus === EXAM_GROUPING_STATUS_CHILD
    })
  }, EXAM_GROUPING_STATUS_LETTER[groupingStatus]) : null;
};

ExamGroupingStatus.propTypes = {
  groupingStatus: PropTypes.string
};
ExamGroupingStatus.defaultProps = {
  groupingStatus: undefined
};
var ExamGroupingStatus$1 = ExamGroupingStatus;

var LongTextAndPopup = function LongTextAndPopup(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 500 : _ref$width,
      text = _ref.text;
  var displayText = Array.isArray(text) ? text.join(', ') : text;
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    title: displayText,
    getPopupContainer: getPluginContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxWidth: width,
      display: 'inline-block',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle'
    }
  }, displayText));
};

var PriorityItem = function PriorityItem(_ref) {
  var priority = _ref.priority;
  var room = priority ? priority.room : undefined;
  var priorityData = useMemo(function () {
    var data = [];

    if (priority && priority.targetDate) {
      var priorityDateValue = moment.utc(priority.targetDate).format(DATE_FORMAT_DEFAULT);
      data.push( /*#__PURE__*/React__default.createElement(Tooltip, {
        title: priorityDateValue,
        key: "date",
        getPopupContainer: getPluginContainer
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "priorities-column__priority--date"
      }, /*#__PURE__*/React__default.createElement("span", null, priorityDateValue))));
    }

    if (room && room.name) {
      var priorityRoomValue = room.name;
      data.push( /*#__PURE__*/React__default.createElement(Tooltip, {
        title: priorityRoomValue,
        key: "room",
        getPopupContainer: getPluginContainer
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "priorities-column__priority--room"
      }, /*#__PURE__*/React__default.createElement("span", null, priorityRoomValue))));
    }

    if (priority && priority.exactEndTime && priority.exactStartTime) {
      var priorityTimeValue = "".concat(unixTimestampToHourFormatter(priority.exactStartTime), " - ").concat(unixTimestampToHourFormatter(priority.exactEndTime));
      data.push( /*#__PURE__*/React__default.createElement(Tooltip, {
        title: priorityTimeValue,
        key: "timing",
        getPopupContainer: getPluginContainer
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "priorities-column__priority--timing"
      }, /*#__PURE__*/React__default.createElement("span", null, priorityTimeValue))));
    }

    return data.filter(function (value) {
      return value !== null && value !== undefined;
    }).reduce(function (prev, curr, index, array) {
      prev.push(curr);

      if (index !== array.length - 1 && array[index + 1] !== null && array[index + 1] !== undefined) {
        prev.push( /*#__PURE__*/React__default.createElement("span", {
          key: "delimiter-".concat(index),
          className: "delimiter"
        }, "\xA0\xA0/\xA0\xA0"));
      }

      return prev;
    }, []);
  }, [priority, room]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "priorities-column--wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "priorities-column__priority--wrapper"
  }, priorityData));
};

var PriorityItem$1 = PriorityItem;

var PriorityCell = function PriorityCell(_ref) {
  var _ref$priorities = _ref.priorities,
      priorities = _ref$priorities === void 0 ? [] : _ref$priorities;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIndex = _useState2[0],
      setSelectedIndex = _useState2[1];

  useEffect(function () {
    var newIndex = clamp(selectedIndex, 0, priorities.length - 1);

    if (selectedIndex != newIndex) {
      setSelectedIndex(newIndex);
    }
  }, [priorities, selectedIndex]);
  var priority = useMemo(function () {
    return priorities[selectedIndex];
  }, [priorities, selectedIndex]);
  var setNextPriority = useCallback(function () {
    // has next?
    if (priorities[selectedIndex + 1]) setSelectedIndex(selectedIndex + 1);
  }, [priorities, selectedIndex, setSelectedIndex]);
  var setPrevPriority = useCallback(function () {
    // has prev?
    if (priorities[selectedIndex - 1]) setSelectedIndex(selectedIndex - 1);
  }, [priorities, selectedIndex, setSelectedIndex]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "priorities-column--wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "priorities-column--toggler"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    icon: "caret-left",
    onClick: setPrevPriority,
    disabled: selectedIndex === 0
  }), /*#__PURE__*/React__default.createElement("span", null, "".concat(selectedIndex + 1, "/").concat(priorities.length)), /*#__PURE__*/React__default.createElement(Button$2, {
    icon: "caret-right",
    onClick: setNextPriority,
    disabled: selectedIndex + 1 >= priorities.length
  })), /*#__PURE__*/React__default.createElement(PriorityItem$1, {
    priority: priority
  }));
};

var PriorityCell$1 = PriorityCell;

var ExamSchedulingStatus = function ExamSchedulingStatus(_ref) {
  var status = _ref.status;
  if (!status) return null;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: classnames('exam-status-indicator', {
      'exam-pending': status === EXAM_STATUSES.PENDING,
      'exam-past': status === EXAM_STATUSES.PAST,
      'exam-scheduled': status === EXAM_STATUSES.SCHEDULED,
      'exam-cancel': status === EXAM_STATUSES.CANCELLED
    })
  }), formatMessage(messages.valueLabel.examSchedulingStatus[status]));
};

ExamSchedulingStatus.propTypes = {
  status: PropTypes.string.isRequired
};
var ExamSchedulingStatus$1 = ExamSchedulingStatus;

var UserCell = function UserCell(params) {
  var users = useAppSelector(userState);
  return users.loading ? /*#__PURE__*/React__default.createElement(LoadingOutlined, {
    style: {
      marginLeft: 10
    }
  }) : /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
    width: 130,
    text: get(params, 'name', '')
  });
};

var UserCell$1 = UserCell;

var ValidationTag = function ValidationTag(_ref) {
  var color = _ref.color,
      title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    title: title,
    getPopupContainer: getPluginContainer
  }, /*#__PURE__*/React__default.createElement(Tag, {
    color: color,
    style: {
      margin: '3px 0px'
    }
  }, children));
};

var ValidationStatus = function ValidationStatus(_ref2) {
  var status = _ref2.status;

  var _useMemo = useMemo(function () {
    return getValidationStatus(status);
  }, [status]),
      missingMandatory = _useMemo.missingMandatory,
      tooMany = _useMemo.tooMany,
      invalid = _useMemo.invalid;

  if (invalid.length) {
    return /*#__PURE__*/React__default.createElement(ValidationTag, {
      color: "red",
      title: invalid.join(', ')
    }, VALIDATION_STATUS.INVALID);
  } else if (missingMandatory.length) {
    return /*#__PURE__*/React__default.createElement(ValidationTag, {
      color: "red",
      title: 'Missing ' + missingMandatory.join(', ')
    }, VALIDATION_STATUS.MISSING_OBJECTS);
  } else if (tooMany.length) {
    return /*#__PURE__*/React__default.createElement(ValidationTag, {
      color: "red",
      title: 'Too many ' + tooMany.join(', ')
    }, VALIDATION_STATUS.TOO_MANY_OBJECTS);
  }

  return /*#__PURE__*/React__default.createElement(ValidationTag, {
    color: "green",
    title: ""
  }, VALIDATION_STATUS.READY_TO_SUBMIT);
};

var toName = function toName(obj) {
  var _ref, _obj$name;

  return (_ref = (_obj$name = obj.name) !== null && _obj$name !== void 0 ? _obj$name : obj.label) !== null && _ref !== void 0 ? _ref : '';
};

var toNames = function toNames(teObject) {
  return castArray(teObject !== null && teObject !== void 0 ? teObject : []).map(toName).join(', ');
};

var examIdColumn = {
  title: 'Exam ID',
  dataIndex: 'examId',
  key: 'id',
  width: 230,
  className: 'table-header-title',
  render: function render(id, exam) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        minHeight: '30px'
      }
    }, /*#__PURE__*/React__default.createElement(ExamGroupingStatus$1, {
      groupingStatus: exam.groupingStatus
    }), "\xA0", id);
  }
};

var ErrorMessage = function ErrorMessage(props) {
  if (!props.error) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "Failed to create exam: ".concat(props.error),
    getPopupContainer: getPluginContainer
  }, /*#__PURE__*/React__default.createElement(WarningTwoTone, {
    twoToneColor: "red"
  }));
};

var reservationIdColumn = {
  title: 'Reservation ID',
  dataIndex: 'reservationId',
  key: 'id',
  width: 120,
  className: 'table-header-title',
  sorter: function sorter(a, b) {
    return a.reservationId - b.reservationId;
  },
  render: function render(id, exam) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginRight: '1em'
      }
    }, /*#__PURE__*/React__default.createElement("span", null, id), /*#__PURE__*/React__default.createElement(ErrorMessage, {
      error: exam.error
    }));
  }
};
var nameColumn = {
  title: 'Name',
  dataIndex: 'name',
  key: 'name',
  width: 180,
  className: 'table-header-title',
  sorter: function sorter(a, b) {
    return a.name.localeCompare(b.name);
  },
  render: function render(name) {
    return /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
      text: name,
      width: 160
    });
  }
};
var campusColumn = {
  title: 'Campus',
  dataIndex: 'campus',
  key: 'campus',
  width: 120,
  className: 'table-header-title',
  render: function render(campus) {
    return /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
      text: campus,
      width: 100
    });
  }
};
var prioritiesColumn = {
  title: 'Priorities',
  dataIndex: 'priorities',
  key: 'priorities',
  width: 330,
  className: 'table-header-title',
  render: function render(priorities) {
    return /*#__PURE__*/React__default.createElement(PriorityCell$1, {
      priorities: priorities
    });
  }
};
var statusColumn = {
  title: 'Status',
  dataIndex: 'status',
  key: 'status',
  width: 110,
  className: 'table-header-title',
  render: function render(status) {
    return /*#__PURE__*/React__default.createElement(ExamSchedulingStatus$1, {
      status: status
    });
  }
};
var validationColumn = {
  title: 'Status',
  dataIndex: 'validation',
  key: 'validation',
  width: 110,
  className: 'table-header-title',
  filters: [{
    text: VALIDATION_STATUS.READY_TO_SUBMIT,
    value: 'valid'
  }, {
    text: VALIDATION_STATUS.TOO_MANY_OBJECTS,
    value: 'tooMany'
  }, {
    text: VALIDATION_STATUS.MISSING_OBJECTS,
    value: 'missing'
  }, {
    text: VALIDATION_STATUS.INVALID,
    value: 'invalid'
  }],
  onFilter: function onFilter(value, record) {
    switch (value) {
      case 'valid':
        return isValidationComplete(record.validation);

      case 'tooMany':
        return hasExcessObjects(record.validation);

      case 'missing':
        return hasMissingObjects(record.validation) && !hasInvalidValues(record.validation);

      case 'invalid':
        return hasInvalidValues(record.validation);

      default:
        return false;
    }
  },
  render: function render(status) {
    return /*#__PURE__*/React__default.createElement(ValidationStatus, {
      status: status
    });
  }
};
var coursesColumn = {
  title: 'Courses',
  dataIndex: 'courses',
  key: 'courses',
  width: 120,
  className: 'table-header-title',
  // sorter: (a: any, b: any) =>
  //   String(a.courseCode).localeCompare(String(b.courseCode)),
  render: function render(courses) {
    return /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
      text: toNames(courses),
      width: 100
    });
  }
};
var professorsColumn = {
  title: 'Professors',
  dataIndex: 'professors',
  key: 'professors',
  width: 220,
  className: 'table-header-title',
  onFilter: function onFilter(value, record) {
    var _record$professors$ma;

    return (_record$professors$ma = record.professors.map(function (p) {
      return p.teExtId;
    })) === null || _record$professors$ma === void 0 ? void 0 : _record$professors$ma.includes(value);
  },
  render: function render(professors) {
    return /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
      width: 200,
      text: toNames(professors)
    });
  }
};
var ownerColumn = {
  title: 'Owner',
  dataIndex: 'owner',
  key: 'owner',
  width: 150,
  className: 'table-header-title',
  render: function render(obj) {
    return /*#__PURE__*/React__default.createElement(UserCell$1, {
      name: _.get(obj, 'name', '')
    });
  }
};
var courseEventsColumn = {
  title: 'Course Events',
  dataIndex: 'courseEvents',
  key: 'courseEvents',
  width: 220,
  className: 'table-header-title',
  render: function render(courseEvents) {
    return /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
      width: 200,
      text: toNames(courseEvents)
    });
  }
};
var costCentersColumn = {
  title: 'Cost Centers',
  dataIndex: 'costCenters',
  key: 'costCenters',
  width: 200,
  className: 'table-header-title',
  render: function render(costCenters) {
    return /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
      width: 200,
      text: toNames(costCenters)
    });
  }
};
var coordinatorsColumn = {
  title: 'Coordinators',
  dataIndex: 'coordinators',
  key: 'coordinators',
  width: 220,
  className: 'table-header-title',
  render: function render(coordinators) {
    return /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
      width: 200,
      text: toNames(coordinators)
    });
  }
};
var studentsPlannedColumn = {
  title: 'Students Planned',
  dataIndex: 'studentsPlanned',
  key: 'studentsPlanned',
  width: 120,
  className: 'table-header-title',
  render: function render(studentsPlanned) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, studentsPlanned);
  }
};
var examTypesColumn = {
  title: 'Exam Types',
  dataIndex: 'examTypes',
  key: 'examType',
  width: 220,
  className: 'table-header-title',
  render: function render(examTypes) {
    return /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
      width: 200,
      text: toNames(examTypes)
    });
  }
};
var examLanguageColumn = {
  title: 'Exam Languages',
  dataIndex: 'examLanguages',
  key: 'examLanguage',
  width: 220,
  className: 'table-header-title',
  render: function render(examLanguages) {
    return /*#__PURE__*/React__default.createElement(LongTextAndPopup, {
      width: 200,
      text: toNames(examLanguages)
    });
  }
};

var StyledTable = styled(Table$2).withConfig({
  displayName: "StyledTable",
  componentId: "sc-apbqp0-0"
})([".ant-pagination-item-active{border-color:transparent;a{color:", ";}}.ant-pagination-item:not(.ant-pagination-disabled):focus a,.ant-pagination-item:not(.ant-pagination-disabled):hover a{color:", ";}.ant-pagination-prev:not(.ant-pagination-disabled):focus .ant-pagination-item-link,.ant-pagination-next:not(.ant-pagination-disabled):focus .ant-pagination-item-link,.ant-pagination-prev:not(.ant-pagination-disabled):hover .ant-pagination-item-link,.ant-pagination-next:not(.ant-pagination-disabled):hover .ant-pagination-item-link{color:", ";}.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon{color:", ";}.ant-table-pagination.ant-pagination{margin:8px 0;}.ant-pagination-item-link,.ant-pagination-item{border-color:transparent;}.ant-select-selection:hover,.ant-select-focused .ant-select-selection,.ant-select-selection:focus,.ant-select-selection:active{border-color:#29b68f;box-shadow:none;}"], jungleGreen, jungleGreen, jungleGreen, jungleGreen);

var ExamTableContainerWrapper = styled.div.withConfig({
  displayName: "ExamTableContainerWrapper",
  componentId: "sc-u1dpsh-0"
})(["&&&{.ant-table{.fold-out-stick-column{margin-top:-4px;width:40px;margin-right:-6px;background-color:#fafafa;right:0;position:sticky;z-index:10;border-left:0.5px solid #e8e8e8 !important;border-right:none !important;box-shadow:-5px 0px 7px -3px #e8e8e8;}&.ant-table-scroll-position-right{.fold-out-stick-column{width:41px;}}}.ant-table table{border-radius:0;}th.ant-table-row-cell-break-word.ant-table-row-cell-last{display:flex;span.ant-table-header-column{margin:auto;height:1.2rem;display:flex;div{margin:auto;}}}.ant-table-column-sorter-inner.ant-table-column-sorter-inner-full{margin-top:-0.5em !important;}.ant-table-row-expand-icon:focus,.ant-table-row-expand-icon:hover{color:#4cc29c;}.ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{background:#e6f5ee;}.ant-table-thead > tr > th{padding:0.2rem 0.2rem 0.2rem 0.4rem;}.ant-table-thead > tr > th:last-child{border-left:none;border-radius:0;}.ant-table-thead > tr > td:last-child{border-left:none;}.ant-table-thead > tr > th.ant-table-selection-column{padding:0 0.3rem;}.ant-table-tbody > tr > td{padding:0 0.3rem;min-height:30px;}}.action-column-sticky{background-color:#ffff;right:0;position:sticky;z-index:10;border-left:0.5px solid #e8e8e8 !important;box-shadow:-5px 0px 7px -3px #e8e8e8;}.ant-table-thead > tr > th.table-header-title{position:relative;}.ant-table-thead > tr > th.table-header-title:not(:nth-last-child(1)):after{content:' ';position:absolute;border-right:2px ", " solid;top:20%;left:0;height:60%;margin-top:auto;margin-bottom:auto;}.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on,.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on{color:", ";}"], lightGrey, jungleGreen);

var checkboxCommonStyles = css(["&&&{.ant-checkbox-checked .ant-checkbox-inner{background-color:", ";border-color:", ";}&.ant-checkbox-wrapper:hover .ant-checkbox-inner,.ant-checkbox:hover .ant-checkbox-inner,.ant-checkbox-input:focus + .ant-checkbox-inner{border-color:", ";}}"], jungleGreen, jungleGreen, jungleGreen);
var Checkbox = styled(Checkbox$1).withConfig({
  displayName: "Checkbox",
  componentId: "sc-2i283y-0"
})(["", ""], checkboxCommonStyles);

var ColumnSelector = function ColumnSelector(_ref) {
  var columns = _ref.columns,
      visibleColumns = _ref.visibleColumns,
      onColumnClick = _ref.onColumnClick;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(Dropdown$1, {
    getPopupContainer: getPluginContainer,
    overlay: function overlay() {
      return /*#__PURE__*/React.createElement(Menu, null, columns.filter(function (c) {
        return c.key !== 'modifyColumns';
      }).map(function (col) {
        return /*#__PURE__*/React.createElement(Menu.Item, {
          key: col.title
        }, /*#__PURE__*/React.createElement("div", {
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        }, /*#__PURE__*/React.createElement(Checkbox, {
          value: col.title,
          checked: visibleColumns.indexOf(col.title) > -1,
          onChange: function onChange(e) {
            return onColumnClick(e.target.value);
          }
        }, col.title)));
      }));
    },
    placement: "bottomLeft"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus-circle",
    theme: "filled",
    style: {
      fontSize: '1.2rem',
      margin: 'auto'
    }
  })));
};

var _excluded$1 = ["columns"];
var ExamTable = function ExamTable(_ref) {
  var columns = _ref.columns,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var _useState = useState(function () {
    return columns.filter(function (c) {
      return c.defaultVisible;
    }).map(function (c) {
      return c.title;
    });
  }),
      _useState2 = _slicedToArray(_useState, 2),
      visibleColumns = _useState2[0],
      setVisibleColumns = _useState2[1];

  function updateColumns(colName) {
    setVisibleColumns(function (prev) {
      var index = prev.indexOf(colName);

      if (index > -1) {
        return prev.filter(function (c) {
          return c !== colName;
        });
      }

      return [].concat(_toConsumableArray(prev), [colName]);
    });
  }

  var allColumns = useMemo(function () {
    return columns.filter(function (c) {
      return visibleColumns.includes(c.title);
    }).concat([{
      title: function title() {
        return /*#__PURE__*/React.createElement(ColumnSelector, {
          columns: columns,
          visibleColumns: visibleColumns,
          onColumnClick: updateColumns
        });
      },
      key: 'modifyColumns',
      width: 40,
      className: props.rowAction ? 'action-column-sticky' : 'table-header-title',
      render: props.rowAction ? function (_, exam) {
        return props.rowAction(exam);
      } : undefined
    }]);
  }, [columns, props.rowAction, visibleColumns]);
  return /*#__PURE__*/React.createElement(ExamTableContainerWrapper, null, /*#__PURE__*/React.createElement(StyledTable, _extends({
    bordered: false,
    columns: allColumns
  }, props)));
};

var Exams = function Exams(_ref) {
  var _ref$toLastPage = _ref.toLastPage,
      toLastPage = _ref$toLastPage === void 0 ? false : _ref$toLastPage,
      setToLastPage = _ref.setToLastPage,
      showInCalendar = _ref.showInCalendar,
      onSelectExam = _ref.onSelectExam,
      isReloadView = _ref.isReloadView;
  var dispatch = useDispatch();
  var examMap = useExams();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2);
      _useState2[0];
      var setCurrentPage = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      sortBy = _useState6[0],
      setSortBy = _useState6[1];

  var _useState7 = useState(_objectSpread2(_objectSpread2({}, DEFAULT_TABLE_CONFIG), {}, {
    populate: DEFAULT_POPULATE,
    sort_by: ''
  })),
      _useState8 = _slicedToArray(_useState7, 2),
      tableConfig = _useState8[0],
      setTableConfig = _useState8[1];

  var totalResults = useSelector(function (state) {
    return state.exams.totalResults;
  });
  var prevTableConfig = usePrevious$1(tableConfig);
  var campusFilters = useAppSelector(selectCampusFilters);
  var professorFilters = useAppSelector(selectProfessorFilters);
  var users = useAppSelector(selectUser);
  var userFilter = useAppSelector(selectUserFilter);
  var examLoadingStatus = useAppSelector(function (state) {
    return state.exams.apiStatus.searchExamsOfTeCoreType;
  });
  var isMounted = useIsMounted();
  useEffect(function () {
    if (toLastPage) {
      var lastPage = Math.floor(Object.keys(examMap).length / 10) + 1;
      setCurrentPage(lastPage);
      setToLastPage(false);
    }
  }, [toLastPage, examMap, setToLastPage]);
  useEffect(function () {
    if (!isMounted() && isReloadView) {
      setIsLoading(true);
    }
  }, [isReloadView, isMounted, dispatch, tableConfig]);
  useEffect(function () {
    if (isEmpty(examMap) && totalResults === 0) {
      setIsLoading(false);
    }
  }, [examMap, totalResults]);
  var prevSortBy = usePrevious$1(sortBy);
  var handleSort = useCallback(function (type, sortOrder) {
    if (type !== '' && sortOrder) {
      var sortTypeOrder = '';

      if (sortOrder) {
        sortTypeOrder = "".concat(type, ":").concat(sortOrder === 'descend' ? 'desc' : 'asc');
      }

      if (sortBy !== sortTypeOrder) {
        setSortBy(sortTypeOrder);
      }
    }
  }, [sortBy]);
  useEffect(function () {
    if (!isEqual(sortBy, prevSortBy)) {
      setTableConfig(_objectSpread2(_objectSpread2({}, tableConfig), {}, {
        sort_by: sortBy
      }));
    }
  }, [sortBy]);
  useEffect(function () {
    if (examLoadingStatus !== ApiStatus.LOADING) {
      setIsLoading(false);
    }
  }, [examLoadingStatus]);
  var columns = useMemo(function () {
    return [_objectSpread2(_objectSpread2({}, examIdColumn), {}, {
      sorter: function sorter(first, second, sortOrder) {
        return handleSort('examId', sortOrder);
      },
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, nameColumn), {}, {
      sorter: function sorter(first, second, sortOrder) {
        return handleSort('name', sortOrder);
      },
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, campusColumn), {}, {
      sorter: function sorter(first, second, sortOrder) {
        return handleSort('campus', sortOrder);
      },
      filters: campusFilters,
      onFilter: function onFilter(value, record) {
        var _record$campus;

        return (_record$campus = record.campus) === null || _record$campus === void 0 ? void 0 : _record$campus.includes(value || '');
      },
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, prioritiesColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, statusColumn), {}, {
      filters: [{
        text: 'Pending',
        value: 'pending'
      }, {
        text: 'Past',
        value: 'past'
      }, {
        text: 'Scheduled',
        value: 'scheduled'
      }],
      onFilter: function onFilter(value, record) {
        var _record$status;

        return (_record$status = record.status) === null || _record$status === void 0 ? void 0 : _record$status.includes(value || '');
      },
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, coursesColumn), {}, {
      defaultVisible: false
    }), _objectSpread2(_objectSpread2({}, professorsColumn), {}, {
      filters: professorFilters,
      onFilter: function onFilter(value, record) {
        var _record$professors$ma;

        return (_record$professors$ma = record.professors.map(function (p) {
          return p.teExtId;
        })) === null || _record$professors$ma === void 0 ? void 0 : _record$professors$ma.includes(value);
      },
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, ownerColumn), {}, {
      filters: userFilter,
      onFilter: function onFilter(value, record) {
        return _.get(record, 'owner.name', '').includes(value);
      },
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, courseEventsColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, costCentersColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, coordinatorsColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, examTypesColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, examLanguageColumn), {}, {
      defaultVisible: true
    })];
  }, [campusFilters, handleSort, professorFilters, userFilter]);
  var dataSource = useMemo(function () {
    return Object.values(examMap);
  }, [examMap]);
  var prevDataSource = usePrevious$1(dataSource);
  useEffect(function () {
    if (!isEmpty(dataSource) && !isEqual(prevDataSource, dataSource)) {
      var listExtraUser = [];
      dataSource.forEach(function (element) {
        if (!listExtraUser.includes(element.ownerId) && !_.get(users, element.ownerId)) {
          listExtraUser.push(element.ownerId);
        }
      });

      if (listExtraUser.length > 0) {
        // TODO: fix fetchExtraUser
        dispatch(fetchExtraUser(listExtraUser));
      }

      setIsLoading(false);
    }
  }, [dataSource]);

  var onPageChange = function onPageChange(pageNumber) {
    setIsLoading(true);
    setTableConfig(_objectSpread2(_objectSpread2({}, tableConfig), {}, {
      page: pageNumber
    }));
  };

  useEffect(function () {
    if (!isEmpty(prevTableConfig) && prevTableConfig !== tableConfig) {
      dispatch(searchExamsOfTeCoreType(tableConfig));
    }
  }, [tableConfig]);
  return /*#__PURE__*/React__default.createElement(ExamTable, {
    pagination: {
      current: tableConfig.page,
      onChange: onPageChange,
      size: 'small',
      total: totalResults
    },
    rowKey: "id",
    bordered: false,
    loading: isLoading,
    dataSource: dataSource,
    columns: columns,
    expandedRowRender: function expandedRowRender(exam) {
      return /*#__PURE__*/React__default.createElement(ExamFoldout$1, {
        exam: exam
      });
    },
    getPopupContainer: getPluginContainer,
    scroll: {
      x: '1200'
    },
    rowAction: function rowAction(exam) {
      return /*#__PURE__*/React__default.createElement(ActionsCell$1, {
        showInCalendar: showInCalendar,
        onSelectExam: onSelectExam,
        examId: exam.examId ? exam.examId : exam.id,
        reservationId: exam.reservationId
      });
    }
  });
};

var Exams$1 = Exams;

var appServiceApi = baseApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getReservationMapping: build.query({
        query: function query() {
          return 'app-service/reservation-mapping';
        }
      })
    };
  }
});
var useGetReservationMappingQuery = appServiceApi.useGetReservationMappingQuery;

var Integration = function Integration(_ref) {
  var children = _ref.children;
  var dispatch = useDispatch();
  var bulkEditIsLocked = useIsLockedFeature(FeatureFlag.EXAM_PLUGIN_BULK_EDIT);

  var tableConfig = _objectSpread2(_objectSpread2({}, DEFAULT_TABLE_CONFIG), {}, {
    populate: DEFAULT_POPULATE
  });

  var isMounted = useIsMounted();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      objectFetched = _useState2[0],
      setObjectFetched = _useState2[1];

  var mandatoryObjects = useAppSelector(function (state) {
    return state.organization.mandatoryObjects;
  });
  var mandatoryObjectsLoaded = useAppSelector(function (state) {
    return state.organization.apiStatus.fetchMandatoryObjects === ApiStatus.SUCCEEDED;
  });
  var teObjectTypes = useAppSelector(function (state) {
    return state.organization.teObjectTypes;
  });
  var featureFlagsLoaded = useAppSelector(function (state) {
    return [ApiStatus.SUCCEEDED, ApiStatus.FAILED].includes(state.organization.apiStatus.fetchFeatureFlags);
  });

  var _useGetReservationMap = useGetReservationMappingQuery(undefined, {
    skip: bulkEditIsLocked
  }),
      reservationMapping = _useGetReservationMap.data;

  useEffect(function () {
    if (reservationMapping && isMounted()) {
      dispatch(storeReservationSettings(reservationMapping));
    }
  }, [reservationMapping, dispatch, isMounted]);
  var teObjectTypeNames = useMemo(function () {
    if (!mandatoryObjectsLoaded) return [];
    return Object.keys(teObjectTypes).filter(function (teObjName) {
      return teObjectTypes[teObjName].objectTypeExtId && (!mandatoryObjects[teObjName] || !mandatoryObjects[teObjName].disabled);
    });
  }, [teObjectTypes, mandatoryObjects, mandatoryObjectsLoaded]);
  useEffect(function () {
    if (!objectFetched && teObjectTypeNames.length) {
      dispatch(initTeObjectLoadingState(teObjectTypeNames));
      teObjectTypeNames.forEach(function (type) {
        return dispatch(fetchObjectsOfType(type));
      });
      setObjectFetched(true);
    }
  }, [teObjectTypeNames, objectFetched, dispatch]);
  useEffect(function () {
    dispatch(searchExamsOfTeCoreType(tableConfig));
  }, []);
  useEffect(function () {
    dispatch(fetchFeatureFlags());
    dispatch(fetchExamTypes());
    dispatch(fetchLanguages());
    dispatch(fetchRooms());
    dispatch(fetchProfile());
    dispatch(fetchObjectTypeMapping());
    dispatch(fetchExamSettings());
    dispatch(fetchAppSettings());
  }, []);
  useEffect(function () {
    if (featureFlagsLoaded) {
      dispatch(fetchMandatoryObjects());
    }
  }, [featureFlagsLoaded, dispatch]);
  return /*#__PURE__*/React__default.createElement("div", null, children);
};

var IntegrationProvider = Integration;

var name = "@timeedit/te-exam-plugin";
var version = "0.5.50";
var description = "Teexam plugin";
var author = "TimeEdit";
var license = "UNLICENSED";
var repository = {
	type: "git",
	url: "git+https://github.com/TimeEdit/exam-plugin.git"
};
var sideEffects = false;
var main = "dist/index.js";
var module = "dist/index.es.js";
var engines = {
	node: ">=8",
	npm: ">=5"
};
var scripts = {
	test: "cross-env CI=1 react-scripts test --env=jsdom",
	"test:watch": "react-scripts test --env=jsdom",
	build: "npm run build:js",
	"build:both": "npm run build:js && npm run build:types",
	"build:js": "rollup -c rollup.config.js",
	"build:types": "tsc -p tsconfig.build.json",
	start: "npm run storybook",
	"start-rollup": "rollup -c -w",
	prepare: "yarn run build",
	predeploy: "cd example && yarn install && yarn run build",
	"i18n:extract": "react-intl-cra 'src/**/*.{js,jsx}' -o 'src/i18n/translations/extractedMessages.json'",
	"i18n:extracted2po": "gulp i18n:extracted2po --src 'src/i18n/translations/extractedMessages.json' --dest 'src/i18n/translations/messages/lang_en.json'",
	storybook: "start-storybook -p 6006",
	"build-storybook": "build-storybook",
	babel: "rimraf lib && babel ./src -d lib --source-maps --copy-files --extensions '.ts,.tsx'"
};
var peerDependencies = {
	antd: "^4.1.0",
	axios: "^0.19.0",
	"prop-types": "^15.5.4",
	"query-string": "^6.13.1"
};
var devDependencies = {
	"@babel/core": "^7.15.5",
	"@babel/preset-env": "^7.15.6",
	"@babel/preset-react": "^7.14.5",
	"@babel/preset-typescript": "^7.15.0",
	"@rollup/plugin-babel": "^5.3.0",
	"@rollup/plugin-commonjs": "^21.0.0",
	"@rollup/plugin-image": "^2.1.1",
	"@rollup/plugin-json": "^4.1.0",
	"@rollup/plugin-node-resolve": "^13.0.5",
	"@storybook/addon-actions": "^6.3.9",
	"@storybook/addon-essentials": "^6.3.9",
	"@storybook/addon-links": "^6.3.9",
	"@storybook/preset-create-react-app": "^3.1.7",
	"@storybook/react": "^6.3.9",
	"@svgr/rollup": "^2.4.1",
	"@types/classnames": "^2.3.1",
	"@types/history": "^4.7.9",
	"@types/jsonwebtoken": "^8.5.5",
	"@types/lodash": "^4.14.175",
	"@types/react": "^17.0.20",
	"@types/react-dom": "^17.0.9",
	"@types/react-redux": "^7.1.18",
	"@types/react-resizable": "^1.7.4",
	"@types/react-router-dom": "^5.3.2",
	"@types/styled-components": "^5.1.14",
	"@typescript-eslint/eslint-plugin": "^4.32.0",
	"@typescript-eslint/parser": "^4.32.0",
	"babel-loader": "^8.2.2",
	"babel-plugin-module-resolver": "^4.1.0",
	"babel-plugin-styled-components": "^1.13.2",
	"cross-env": "^5.1.4",
	"css-loader": "^3.4.2",
	eslint: "^7.32.0",
	"eslint-config-prettier": "^8.3.0",
	"eslint-plugin-react": "^7.26.1",
	"eslint-plugin-react-hooks": "^4.2.0",
	gulp: "^4.0.2",
	"gulp-json-transform": "^0.4.7",
	"gulp-rename": "^1.4.0",
	"http-proxy-middleware": "^2.0.1",
	less: "^4.1.2",
	"postcss-prefixwrap": "^1.24.0",
	prettier: "^2.4.1",
	"react-intl-cra": "^0.3.4",
	"react-scripts": "^4.0.1",
	rollup: "^2.56.3",
	"rollup-plugin-delete": "^2.0.0",
	"rollup-plugin-includepaths": "^0.2.4",
	"rollup-plugin-json": "^4.0.0",
	"rollup-plugin-node-externals": "^2.2.0",
	"rollup-plugin-peer-deps-external": "^2.2.4",
	"rollup-plugin-postcss": "^3",
	"rollup-plugin-typescript-paths": "^1.3.0",
	"rollup-plugin-typescript2": "^0.30.0",
	"rollup-plugin-url": "^1.4.0",
	sass: "^1.43.2",
	"sass-loader": "^12.2.0",
	typescript: "^4.4.4"
};
var files = [
	"dist"
];
var dependencies = {
	"@ant-design/icons": "4.6.3",
	"@reduxjs/toolkit": "^1.6.2",
	"@timeedit/te-auth-components": "^2.1.0",
	antd: "^3.25.0",
	axios: "^0.19.2",
	debug: "^4.1.1",
	jsonwebtoken: "^8.5.1",
	lodash: "^4.17.15",
	moment: "^2.24.0",
	normalizr: "^3.6.1",
	polished: "^4.1.3",
	"prop-types": "^15.5.4",
	qs: "^6.9.4",
	react: "^16.8.6",
	"react-dom": "^16.8.6",
	"react-hook-form": "^7.22.1",
	"react-icons": "^4.2.0",
	"react-intl": "^5.6.9",
	"react-redux": "^7.2.0",
	"react-resizable": "^3.0.4",
	"rollup-plugin-terser": "^7.0.2",
	"styled-components": "^5.3.1"
};
var bugs = {
	url: "https://github.com/TimeEdit/te-event-lib/issues"
};
var homepage = "https://github.com/TimeEdit/te-event-lib#readme";
var directories = {
	example: "example"
};
var browserify = {
	transform: [
		"babelify"
	]
};
var pkg = {
	name: name,
	version: version,
	description: description,
	author: author,
	license: license,
	repository: repository,
	sideEffects: sideEffects,
	main: main,
	module: module,
	engines: engines,
	scripts: scripts,
	peerDependencies: peerDependencies,
	devDependencies: devDependencies,
	files: files,
	dependencies: dependencies,
	bugs: bugs,
	homepage: homepage,
	directories: directories,
	browserify: browserify
};

var Tabs = styled(Tabs$2).withConfig({
  displayName: "Tabs",
  componentId: "sc-1oxcuyh-0"
})(["&&&{.ant-tabs-bar.ant-tabs-top-bar{padding-left:6px;padding-right:6px;}.ant-tabs-nav .ant-tabs-tab{padding:6px 0;color:rgba(191,191,191,1);font-weight:normal;}.ant-tabs-nav .ant-tabs-tab-active{color:", ";}.ant-tabs-ink-bar{background-color:", ";}.ant-tabs-bar{margin:0;}}"], jungleGreen, jungleGreen);
var Tabs$1 = Tabs;

var TabPane = styled(Tabs$2.TabPane).withConfig({
  displayName: "TabPane",
  componentId: "sc-7kmb8z-0"
})([""]);
var TabPane$1 = TabPane;

var EditExam = function EditExam(_ref) {
  var initialExam = _ref.exam,
      onCancel = _ref.onCancel,
      setMode = _ref.setMode,
      reservation = _ref.reservation;
  var isDisabled = useMemo(function () {
    return getExamStatus(initialExam) !== 'pending';
  }, [initialExam]);
  var isLockedExamTypeExamLanguage = useFeatureFlag(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE);
  var isMovedReservation = !isDisabled && (reservation === null || reservation === void 0 ? void 0 : reservation.mode) === 'move';

  var _useTeObjects = useTeObjects(),
      teObjects = _useTeObjects.teObjects,
      teObjectTypes = _useTeObjects.teObjectTypes,
      mandatoryObjects = _useTeObjects.mandatoryObjects;

  var _useReservationObject = useReservationObjectFields(isMovedReservation ? [reservation] : []),
      extraFields = _useReservationObject.data,
      isLoading = _useReservationObject.isLoading;

  var configurableFieldsGetter = useConfigurableFieldsGetter();

  var _useUpdateExamMutatio = useUpdateExamMutation(),
      _useUpdateExamMutatio2 = _slicedToArray(_useUpdateExamMutatio, 1),
      updateExam = _useUpdateExamMutatio2[0];

  var ownerId = useUserId();
  var dispatch = useAppDispatch();
  var currentPage = useAppSelector(function (state) {
    return state.exams.page;
  });

  var tableConfig = _objectSpread2(_objectSpread2({}, DEFAULT_TABLE_CONFIG), {}, {
    page: currentPage,
    populate: DEFAULT_POPULATE
  });

  var exam = useMemo(function () {
    if (!isMovedReservation || isLoading) {
      return initialExam;
    }

    var reservationExam = reservationToExamDraft(reservation, {
      teObjects: teObjects,
      extraFields: extraFields !== null && extraFields !== void 0 ? extraFields : {},
      teObjectTypes: teObjectTypes,
      configurableFieldsGetter: configurableFieldsGetter,
      mandatoryObjects: mandatoryObjects
    }, isLockedExamTypeExamLanguage);
    var fieldsFromReservation = ['durationHours', 'durationMinutes', 'studentsPlanned', 'priorities'].concat(_toConsumableArray(getExamPropertyObject(isLockedExamTypeExamLanguage).map(function (o) {
      return o.key;
    })));
    return _objectSpread2(_objectSpread2({}, initialExam), pick(reservationExam, fieldsFromReservation));
  }, [isMovedReservation, extraFields, isLoading, reservation, teObjects, teObjectTypes, configurableFieldsGetter, mandatoryObjects, initialExam, isLockedExamTypeExamLanguage]);

  var saveExam = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(exam) {
      var errors, result, _getErrorMessage;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              notification.destroy();
              errors = validateDraftExam(exam, mandatoryObjects, isLockedExamTypeExamLanguage);

              if (!notifyValidation(errors)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              _context.prev = 4;
              _context.next = 7;
              return updateExam({
                exam: exam,
                ownerId: ownerId
              });

            case 7:
              result = _context.sent;

              if (!('error' in result)) {
                _context.next = 10;
                break;
              }

              throw result.error;

            case 10:
              notification.success({
                getContainer: getPluginContainer,
                message: 'Success',
                description: 'Exam has been updated.'
              });
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", notification.error({
                getContainer: getPluginContainer,
                message: 'Exam update failed',
                description: (_getErrorMessage = getErrorMessage(_context.t0)) !== null && _getErrorMessage !== void 0 ? _getErrorMessage : 'Something went wrong'
              }));

            case 16:
              // Sync local data
              dispatch(searchExamsOfTeCoreType(tableConfig));
              setMode('ALL');

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 13]]);
    }));

    return function saveExam(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Spin, null);
  }

  return /*#__PURE__*/React__default.createElement(DraftExamDetail$1, {
    onCancel: onCancel,
    exam: exam,
    onSave: saveExam,
    isDisabled: isDisabled
  });
};

var EditExam$1 = EditExam;

var CoreAPIContext = /*#__PURE__*/React__default.createContext({});

var CoreAPIProvider = function CoreAPIProvider(_ref) {
  var children = _ref.children,
      methods = _ref.methods;
  return /*#__PURE__*/React__default.createElement(CoreAPIContext.Provider, {
    value: methods
  }, children);
};

var CoreAPIProvider$1 = CoreAPIProvider;

var NoReservationSelected = function NoReservationSelected() {
  return /*#__PURE__*/React__default.createElement(NoReservationSelectedWrapper, null, /*#__PURE__*/React__default.createElement("h1", null, "\u2205"), /*#__PURE__*/React__default.createElement("p", null, "No compatible reservation selected"));
};

var NoReservationSelectedWrapper = styled.div.withConfig({
  displayName: "NoReservationSelected__NoReservationSelectedWrapper",
  componentId: "sc-1szg4vq-0"
})(["&&&&&{width:100%;text-align:center;h1{font-size:2.5rem;margin-bottom:0;margin-top:2rem;}*{color:", ";}}"], darkGrey);
var NoReservationSelected$1 = NoReservationSelected;

var PendingExamsContainerWrapper = styled.div.withConfig({
  displayName: "PendingExamsContainerWrapper",
  componentId: "sc-pipkyc-0"
})(["&&&{.reservation-action{width:fit-content;position:relative;top:-2.5rem;left:0;margin:8px 0;> button{margin:0 10px;}}.ant-checkbox-indeterminate .ant-checkbox-inner::after{background-color:", ";border-color:", ";}", "}"], jungleGreen, jungleGreen, checkboxCommonStyles);

var _excluded = ["children"];

var EditDraftExamsTabContent = function EditDraftExamsTabContent(props) {
  var drafts = useAppSelector(function (state) {
    return state.draft.drafts;
  });
  var draft = drafts === null || drafts === void 0 ? void 0 : drafts.find(function (draft) {
    return draft.reservationId === props.reservationId;
  });

  if (!draft) {
    return /*#__PURE__*/React__default.createElement(NoReservationSelected$1, null);
  }

  return /*#__PURE__*/React__default.createElement(DraftExamDetail$1, {
    exam: draft,
    onSave: props.onSave
  });
};

var TabStub = function TabStub(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement(Tabs$1, {
    style: {
      width: '100%'
    },
    defaultActiveKey: 'stub',
    activeKey: 'stub'
  }, /*#__PURE__*/React__default.createElement(TabPane$1, {
    tab: /*#__PURE__*/React__default.createElement("div", {
      onClick: function onClick() {
        return props.onClick();
      }
    }, /*#__PURE__*/React__default.createElement(ArrowLeftOutlined, {
      style: {
        marginRight: 8
      }
    }), "Editing ".concat(props.reservationId)),
    key: 'stub'
  }, children));
};

var EditDraftExamsTab = function EditDraftExamsTab(props) {
  return /*#__PURE__*/React__default.createElement(TabStub, {
    reservationId: props.reservationId,
    onClick: props.onCancel
  }, /*#__PURE__*/React__default.createElement(EditDraftExamsTabContent, {
    reservationId: props.reservationId,
    onSave: props.onSave
  }));
};

var EditDraftExamsTab$1 = EditDraftExamsTab;

var PendingExams = function PendingExams(props) {
  var dispatch = useAppDispatch();
  var teObjects = useAppSelector(selectTeObjects);
  var oldExamTypes = useAppSelector(selectExamTypeMap);
  var oldExamLanguage = useAppSelector(selectLanguagesMap);
  var mandatoryObjects = useAppSelector(selectMandatoryObjects);
  var drafts = useAppSelector(function (state) {
    return state.draft.drafts;
  });
  var ownerId = useUserId();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      submitErrors = _useState2[0],
      setSubmitErrors = _useState2[1];

  var _useCreateExamsInBatc = useCreateExamsInBatchMutation(),
      _useCreateExamsInBatc2 = _slicedToArray(_useCreateExamsInBatc, 2),
      createExams = _useCreateExamsInBatc2[0],
      saveIsLoading = _useCreateExamsInBatc2[1].isLoading;

  var professorFilters = useAppSelector(selectProfessorFilters);
  var isLockExamTypeLanguage = useFeatureFlag(FeatureFlag.EXAM_TYPE_EXAM_LANGUAGE);

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedReservations = _useState4[0],
      setSelectedReservations = _useState4[1];

  var _useMemo = useMemo(function () {
    var _drafts$filter;

    var selectedDrafts = (_drafts$filter = drafts === null || drafts === void 0 ? void 0 : drafts.filter(function (d) {
      return selectedReservations.includes(d.reservationId);
    })) !== null && _drafts$filter !== void 0 ? _drafts$filter : [];
    var invalidSelectedCount = selectedDrafts.filter(function (d) {
      return !draftIsValid(d, mandatoryObjects, isLockExamTypeLanguage);
    }).length;
    return {
      selectedDrafts: selectedDrafts,
      invalidSelectedCount: invalidSelectedCount
    };
  }, [drafts, selectedReservations, mandatoryObjects]),
      selectedDrafts = _useMemo.selectedDrafts,
      invalidSelectedCount = _useMemo.invalidSelectedCount;

  var dataSource = useMemo(function () {
    var _drafts$map;

    return (_drafts$map = drafts === null || drafts === void 0 ? void 0 : drafts.map(draftToExam({
      teObjects: teObjects,
      isLockExamTypeLanguage: isLockExamTypeLanguage,
      oldDataSource: {
        examType: oldExamTypes,
        examLanguage: oldExamLanguage
      },
      mandatoryObjects: mandatoryObjects,
      errors: submitErrors
    }))) !== null && _drafts$map !== void 0 ? _drafts$map : [];
  }, [drafts, teObjects, mandatoryObjects, submitErrors, isLockExamTypeLanguage, oldExamTypes, oldExamLanguage]);
  var selectedReservation = useAppSelector(function (state) {
    return state.selection.selectedReservation;
  });
  useEffect(function () {
    props.onSetTabVisible(!selectedReservation);
  }, [selectedReservation, props]);

  var handleSendToExam = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$createExams$un, successful, failed, _dispatch, finishedAll, message;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(selectedDrafts.length === 0)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(invalidSelectedCount > 0)) {
                _context.next = 5;
                break;
              }

              notification.error({
                getContainer: getPluginContainer,
                message: "Can't send to exam because of ".concat(invalidSelectedCount, " invalid draft(s) in selection")
              });
              return _context.abrupt("return");

            case 5:
              _context.prev = 5;
              _context.next = 8;
              return createExams({
                exams: selectedDrafts,
                ownerId: ownerId
              }).unwrap();

            case 8:
              _yield$createExams$un = _context.sent;
              successful = _yield$createExams$un.successful;
              failed = _yield$createExams$un.failed;
              setSubmitErrors(failed);

              if (successful.length > 0) {
                _dispatch = dispatch(markReservationAsCompleted(successful.map(function (d) {
                  return d.reservationId;
                }))), finishedAll = _dispatch.finishedAll;

                if (finishedAll) {
                  props.onFinishedAll();
                }

                props.onCreateExams(successful);
                notification.success({
                  getContainer: getPluginContainer,
                  message: "Created ".concat(successful.length, " exam(s)")
                });
              }

              if (failed.length > 0) {
                notification.error({
                  getContainer: getPluginContainer,
                  message: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Failed to create ", failed.length, " exam(s)", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), failed.map(function (f) {
                    return f.reservationId;
                  }).join(', '))
                }); // Error could have been caused by an unknown mandatory configuration
                // Refetch the current configuration to make sure we have the latest

                dispatch(fetchMandatoryObjects());
              } // clear selection


              setSelectedReservations([]);
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](5);
              message = getErrorMessage(_context.t0);

              if (message) {
                notification.error({
                  getContainer: getPluginContainer,
                  message: "Failed to create exams: ".concat(message)
                });
              } else {
                console.error('Failed to create exams', _context.t0);
                notification.error({
                  getContainer: getPluginContainer,
                  message: 'Failed to create exams'
                });
              }

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 17]]);
    }));

    return function handleSendToExam() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleRemoveRequest = function handleRemoveRequest() {
    dispatch(removeDrafts(selectedReservations));
    setSelectedReservations([]);
  };

  var canSave = selectedDrafts.length > 0 && !props.loading;
  var canRemoveDrafts = selectedDrafts.length > 0 && !saveIsLoading && !props.loading;

  var handleSave = function handleSave(exam) {
    dispatch(saveExamDraft(exam));
    dispatch(setSelectedReservation(null));
    setSelectedReservations([]); // Clear error flag from last submit

    setSubmitErrors(function (errors) {
      return errors.filter(function (e) {
        return e.reservationId !== exam.reservationId;
      });
    });
  };

  var handleEditCancel = function handleEditCancel() {
    dispatch(setSelectedReservation(null));
    setSelectedReservations([]);
  };

  var columns = useMemo(function () {
    return [_objectSpread2(_objectSpread2({}, reservationIdColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, nameColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, validationColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, prioritiesColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, coursesColumn), {}, {
      defaultVisible: false
    }), _objectSpread2(_objectSpread2({}, studentsPlannedColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, professorsColumn), {}, {
      filters: professorFilters,
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, courseEventsColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, costCentersColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, coordinatorsColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, examTypesColumn), {}, {
      defaultVisible: true
    }), _objectSpread2(_objectSpread2({}, examLanguageColumn), {}, {
      defaultVisible: true
    })];
  }, [professorFilters]);

  if (!props.loading && (!drafts || drafts.length === 0)) {
    return /*#__PURE__*/React__default.createElement(NoReservationSelected$1, null);
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, selectedReservation && /*#__PURE__*/React__default.createElement(EditDraftExamsTab$1, {
    reservationId: selectedReservation,
    onSave: handleSave,
    setToLastPage: props.onSetToLastPage,
    onCancel: handleEditCancel
  }), /*#__PURE__*/React__default.createElement(PendingExamsContainerWrapper, {
    style: {
      display: selectedReservation ? 'none' : 'initial'
    }
  }, /*#__PURE__*/React__default.createElement(ExamTable, {
    pagination: {
      size: 'small',
      showSizeChanger: true,
      defaultPageSize: DEFAULT_PAGE_SIZE,
      pageSizeOptions: PAGE_SIZE_OPTIONS.map(function (size) {
        return String(size);
      })
    },
    bordered: false,
    loading: props.loading || saveIsLoading,
    rowSelection: {
      selectedRowKeys: selectedReservations,
      onChange: function onChange(ids) {
        return setSelectedReservations(ids);
      }
    },
    getPopupContainer: getPluginContainer,
    scroll: {
      x: '1200'
    },
    columns: columns,
    dataSource: dataSource,
    rowKey: "reservationId",
    rowAction: function rowAction(exam) {
      return /*#__PURE__*/React__default.createElement(ActionsCell$1, {
        showInCalendar: props.showInCalendar,
        onSelectReservation: function onSelectReservation(reservationId) {
          return dispatch(setSelectedReservation(reservationId));
        },
        reservationId: exam.reservationId
      });
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "reservation-action"
  }, /*#__PURE__*/React__default.createElement(Badge, {
    count: invalidSelectedCount > 0 ? '!' : undefined,
    title: "An invalid draft is selected"
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    size: "small",
    type: "primary",
    onClick: handleSendToExam,
    disabled: !canSave,
    loading: saveIsLoading
  }, "Send to Exam")), /*#__PURE__*/React__default.createElement(Button$1, {
    size: "small",
    type: "default",
    onClick: handleRemoveRequest,
    disabled: !canRemoveDrafts
  }, "Remove Request"), /*#__PURE__*/React__default.createElement("span", null, selectedReservations.length, " Selected reservations"))));
};

var ExamPluginWrapperStyle = styled.div.withConfig({
  displayName: "ExamPluginWrapperstyle__ExamPluginWrapperStyle",
  componentId: "sc-22vrl5-0"
})(["&&&&{width:100%;.ant-tabs *{font-size:", ";}.ant-tabs-nav .ant-tabs-tab{z-index:1;}.ant-tabs-tabpane{min-height:70vh;}.ant-spin-dot{font-size:20px;.ant-spin-dot-item{background-color:", " !important;}}*{::selection{background-color:", " !important;}}.ant-select-dropdown.exam-plugin-select-dropdown{.ant-select-dropdown-menu-item{font-size:", ";}.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled),.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled){background:", ";}}.ant-dropdown.exam-plugin-dropdown-overlay,.ant-table-filter-dropdown{.ant-dropdown-menu-item{font-size:", ";padding:0 6px;&:hover{background-color:#e6f5ee;}*{font-size:", ";}}}.ant-dropdown-menu-item.ant-dropdown-menu-item-selected{color:", ";}.ant-table-filter-dropdown{.ant-table-filter-dropdown-link{color:", ";font-size:", ";font-family:inherit;&.clear:before{content:none;}}.ant-checkbox{&:hover{.ant-checkbox-inner{border-color:", ";}}}.ant-checkbox-checked.ant-checkbox-inner:hover{background-color:", ";border-color:", ";}.ant-checkbox-checked .ant-checkbox-inner{background-color:", ";border-color:", ";}.ant-checkbox-checked::after{border-color:", ";}.ant-checkbox-wrapper:hover .ant-checkbox-inner,.ant-checkbox:hover .ant-checkbox-inner,.ant-checkbox-input:focus + .ant-checkbox-inner{border-color:", ";}}.ant-time-picker-panel.exam-plugin-time-picker-popup{.ant-time-picker-panel-input{font-size:", ";}.ant-time-picker-panel-select{li{font-size:", ";&:focus{color:", ";&:not(:hover){color:", ";}}&:hover{background:", ";}}}}.ant-calendar-picker-container.exam-plugin-date-picker-dropdown{.ant-calendar{font-size:", ";}.ant-calendar-header a:hover{color:", ";}.ant-calendar-footer-btn{.ant-calendar-today-btn{color:", ";}}.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year{background:", ";}.ant-calendar-year-panel-year:hover{background:transparent;}.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade{background:", ";}.ant-calendar-decade-panel-decade:hover{background:transparent;}.ant-calendar-cell:not(.ant-calendar-disabled-cell){.ant-calendar-date:hover{background:", ";}&.ant-calendar-selected-day .ant-calendar-date{background:", ";}&.ant-calendar-today .ant-calendar-date{color:", ";border-color:", ";}}}}"], defaultFontSize, jungleGreen, jungleGreen, defaultFontSize, lighten(0.5, jungleGreen), defaultFontSize, defaultFontSize, jungleGreen, jungleGreen, defaultFontSize, jungleGreen, jungleGreen, jungleGreen, jungleGreen, jungleGreen, jungleGreen, jungleGreen, defaultFontSize, defaultFontSize, jungleGreen, jungleGreen, lighten(0.5, jungleGreen), defaultFontSize, jungleGreen, jungleGreen, jungleGreen, jungleGreen, lighten(0.5, jungleGreen), lighten(0.3, jungleGreen), jungleGreen, jungleGreen);

var allowedOrgToEditExamWithRoom = ['5fe9ec9509761f00204daddb', '661792b376acfe002311c5e9', '675c55365593ba0022e0bb8c', '5c3e8d130000000000000001'];
var gotoEditExam = function gotoEditExam(examId) {
  return function (dispatch, getState) {
    var state = getState();
    var usedId = examId !== null && examId !== void 0 ? examId : state.selection.selectedExamId;
    var isIncrementId = /^[0-9]+$/.test("".concat(usedId)) && "".concat(usedId).length !== 24;
    dispatch(searchLinkedExams(_objectSpread2(_objectSpread2({}, DEFAULT_TABLE_CONFIG), {}, _defineProperty({
      populate: DEFAULT_POPULATE
    }, isIncrementId ? 'except_exam_id' : 'except_id', usedId))));
    dispatch(getExamDetail(usedId));
    dispatch(doGotoEditExam(usedId));
  };
};
var gotoPendingExams = function gotoPendingExams(reservations, reservationObjectFields) {
  var disableRedirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch, getState) {
    var state = getState();
    var redirected = false;

    if (reservations !== state.draft.reservations) {
      redirected = Boolean(dispatch(setReservationDrafts(reservations !== null && reservations !== void 0 ? reservations : [], // @ts-expect-error typed dispatch
      reservationObjectFields, disableRedirection)));
    }

    if (!redirected) {
      dispatch(setMode('CREATE_MULTI'));
    }
  };
};
var initializeNavigation = createAsyncThunk('navigation/initializeNavigation', /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref, _ref2) {
    var _reservationsWithExam, _reservationsWithExam2;

    var _ref$requestData, _mode, reservations, reservationObjectFields, dispatch, getState, state, mode, reservationsWithExamId, examId, _selectTeObjectTypes, _selectTeObjectTypes$, _state$auth, _state$auth$user, roomObjectType, reservation, organizationId, isAllowedEditExamWithRoom, hasRoom;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$requestData = _ref.requestData, _mode = _ref$requestData.mode, reservations = _ref$requestData.reservations, reservationObjectFields = _ref.reservationObjectFields;
            dispatch = _ref2.dispatch, getState = _ref2.getState;
            state = getState();
            mode = _mode.toUpperCase();
            reservationsWithExamId = reservations.filter(function (reservation) {
              return reservation.fields.find(findExamId);
            });
            examId = reservationsWithExamId.length === 1 ? (_reservationsWithExam = (_reservationsWithExam2 = reservationsWithExamId[0].fields.find(findExamId)) === null || _reservationsWithExam2 === void 0 ? void 0 : _reservationsWithExam2.values[0]) !== null && _reservationsWithExam !== void 0 ? _reservationsWithExam : null : null; // Choose one exam	Has	Has	Edit exam request	EDIT	Show all exam tabs with an error message. “Can not edit an exam containing a room“

            if (!(['EDIT', 'CREATE'].includes(mode) && reservations.length >= 1)) {
              _context.next = 17;
              break;
            }

            roomObjectType = (_selectTeObjectTypes = selectTeObjectTypes(state)) === null || _selectTeObjectTypes === void 0 ? void 0 : (_selectTeObjectTypes$ = _selectTeObjectTypes.room) === null || _selectTeObjectTypes$ === void 0 ? void 0 : _selectTeObjectTypes$.objectTypeExtId;
            reservation = reservations[0];
            organizationId = (_state$auth = state.auth) === null || _state$auth === void 0 ? void 0 : (_state$auth$user = _state$auth.user) === null || _state$auth$user === void 0 ? void 0 : _state$auth$user.organizationId;
            isAllowedEditExamWithRoom = allowedOrgToEditExamWithRoom.includes(organizationId) && mode === 'EDIT';
            hasRoom = reservation.objects.some(function (object) {
              return object.typeextid === roomObjectType && !!object.extid;
            });

            if (!(hasRoom && !isAllowedEditExamWithRoom)) {
              _context.next = 17;
              break;
            }

            notification.warn({
              getContainer: getPluginContainer,
              message: "Can not ".concat(mode.toLowerCase(), " an exam containing a room")
            });
            dispatch(clearCurReservations());
            dispatch(gotoAllExams());
            return _context.abrupt("return", {
              originalExamId: examId,
              selectedExamId: null
            });

          case 17:
            if (!(mode === 'CREATE')) {
              _context.next = 20;
              break;
            }

            dispatch(gotoCreateNewExam());
            return _context.abrupt("return", {
              originalExamId: examId
            });

          case 20:
            if (!(mode === 'EDIT' && examId)) {
              _context.next = 23;
              break;
            }

            // @ts-expect-error typed dispatch
            dispatch(gotoEditExam(examId));
            return _context.abrupt("return", {
              originalExamId: examId
            });

          case 23:
            if (!(mode === 'CREATE_MULTI')) {
              _context.next = 26;
              break;
            }

            // @ts-expect-error typed dispatch
            dispatch(gotoPendingExams(reservations, reservationObjectFields));
            return _context.abrupt("return", {
              originalExamId: null
            });

          case 26:
            return _context.abrupt("return", {
              originalExamId: examId,
              mode: 'ALL'
            });

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());

var findExamId = function findExamId(field) {
  var _field$values;

  return field.extid === 'tex.examid' && !!((_field$values = field.values) !== null && _field$values !== void 0 && _field$values.length);
};

console.log("** ExamPlugin version ".concat(pkg.version));

var Plugin = function Plugin(_ref) {
  var _requestData$reservat;

  var showInCalendar = _ref.showInCalendar,
      onCreateExam = _ref.onCreateExam,
      coreAPI = _ref.coreAPI,
      requestData = _ref.requestData;
  var dispatch = useDispatch();
  var bulkEditIsLocked = useIsLockedFeature(FeatureFlag.EXAM_PLUGIN_BULK_EDIT);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      toLastPage = _useState2[0],
      setToLastPage = _useState2[1];

  var mode = useAppSelector(function (state) {
    return state.selection.mode;
  });
  var originalExamId = useAppSelector(function (state) {
    return state.selection.originalExamId;
  });
  var selectedExamId = useAppSelector(function (state) {
    return state.selection.selectedExamId;
  });
  var curReservations = useAppSelector(function (state) {
    return state.selection.curReservations;
  });
  var previousMode = usePrevious$1(mode);
  var examDetail = useAppSelector(function (state) {
    return state.exams.examDetail;
  });
  var draftReservations = useAppSelector(function (state) {
    return state.draft.reservations;
  });

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showTabs = _useState4[0],
      setShowTabs = _useState4[1];

  var _useReservationObject = useReservationObjectFields(requestData.reservations),
      reservationObjectFields = _useReservationObject.data,
      isLoadingReservationObjectFields = _useReservationObject.isLoading;

  var objectFieldsLoading = useSelector(selectObjectFieldsLoading());
  var reservationSettingsLoading = useSelector(selectReservationSettingsLoading);
  var requestMode = useMemo(function () {
    return requestData.mode.toUpperCase();
  }, [requestData.mode]);
  useEffect(function () {
    // Land on correct tab
    dispatch(setInitialNavigation({
      mode: requestMode,
      reservations: requestData.reservations
    }));
  }, [requestData.reservations, dispatch, requestMode]);
  useEffect(function () {
    // Run initialization for CREATE_MULTI mode, once we've loaded all prerequisites
    if (mode === 'CREATE_MULTI' && !objectFieldsLoading && !isLoadingReservationObjectFields && !reservationSettingsLoading && requestData.reservations && requestData.reservations !== draftReservations) {
      dispatch(initializeNavigation({
        requestData: requestData,
        reservationObjectFields: reservationObjectFields
      }));
    }
  }, [dispatch, isLoadingReservationObjectFields, requestData, reservationSettingsLoading, objectFieldsLoading, reservationObjectFields, draftReservations, mode]);
  useEffect(function () {
    // Initialize once
    if (requestMode !== 'CREATE_MULTI' && !isLoadingReservationObjectFields) {
      dispatch(initializeNavigation({
        requestData: requestData,
        reservationObjectFields: undefined
      }));
    }
  }, [dispatch, requestData, requestMode, isLoadingReservationObjectFields]);
  useEffect(function () {
    // BUG: notifications stop working if exam plugin is unmounted and remounted
    return function () {
      return notification.destroy();
    };
  }, []);

  var selectExamHandler = function selectExamHandler(examId) {
    dispatch(gotoEditExam(examId));
  };

  var setModeCallback = useCallback(function (mode) {
    switch (mode) {
      case 'ALL':
        {
          dispatch(gotoAllExams());
          break;
        }

      case 'CREATE':
        {
          dispatch(gotoCreateNewExam());
          break;
        }

      case 'CREATE_MULTI':
        {
          dispatch(gotoPendingExams(requestData.reservations, reservationObjectFields, true));
          break;
        }

      case 'EDIT':
        {
          dispatch(gotoEditExam(null));
          break;
        }

      default:
        {
          dispatch(gotoAllExams());
        }
    }
  }, [dispatch, requestData.reservations, reservationObjectFields]);

  var renderSelectedReservationTab = function renderSelectedReservationTab() {
    if (mode === 'EDIT' && selectedExamId && examDetail[selectedExamId]) {
      var _curReservations$;

      return /*#__PURE__*/React__default.createElement(EditExam$1, {
        key: selectedExamId,
        onCancel: function onCancel() {
          dispatch(gotoAllExams());
        },
        exam: examDetail[selectedExamId],
        setMode: setModeCallback,
        reservation: (_curReservations$ = curReservations === null || curReservations === void 0 ? void 0 : curReservations[0]) !== null && _curReservations$ !== void 0 ? _curReservations$ : null
      });
    } else if (mode === 'CREATE' && curReservations !== null && curReservations !== void 0 && curReservations[0]) {
      var _curReservations$2;

      return /*#__PURE__*/React__default.createElement(NewExam$1, {
        key: curReservations === null || curReservations === void 0 ? void 0 : (_curReservations$2 = curReservations[0]) === null || _curReservations$2 === void 0 ? void 0 : _curReservations$2.id,
        reservation: curReservations === null || curReservations === void 0 ? void 0 : curReservations[0],
        onCreateExam: onCreateExam,
        setToLastPage: setToLastPage,
        setMode: setModeCallback
      });
    }

    return /*#__PURE__*/React__default.createElement(NoReservationSelected$1, null);
  };

  var onCreateExams = function onCreateExams(exams) {
    exams.forEach(function (_ref2) {
      var examId = _ref2.examId,
          reservationId = _ref2.reservationId;
      return onCreateExam(examId, reservationId);
    });
  };

  var onFinishedCreatingAll = function onFinishedCreatingAll() {
    setToLastPage(true);
    dispatch(gotoAllExams());
  };

  var draftIsLoading = !!((_requestData$reservat = requestData.reservations) !== null && _requestData$reservat !== void 0 && _requestData$reservat.length) && !(draftReservations !== null && draftReservations !== void 0 && draftReservations.length);
  return /*#__PURE__*/React__default.createElement(CoreAPIProvider$1, {
    methods: coreAPI
  }, /*#__PURE__*/React__default.createElement(IntegrationProvider, {
    examId: originalExamId
  }, /*#__PURE__*/React__default.createElement(Tabs$1, {
    tabBarStyle: {
      display: showTabs ? 'inherit' : 'none'
    },
    style: {
      width: '100%'
    },
    defaultActiveKey: mode,
    activeKey: mode === 'EDIT' ? 'CREATE' : mode,
    onChange: function onChange(mode) {
      if (mode === 'CREATE' && selectedExamId) {
        setModeCallback('EDIT');
      } else {
        setModeCallback(mode);
      }
    }
  }, /*#__PURE__*/React__default.createElement(TabPane$1, {
    tab: "Selected Reservation",
    key: 'CREATE'
  }, renderSelectedReservationTab()), /*#__PURE__*/React__default.createElement(TabPane$1, {
    tab: "All Exams",
    key: 'ALL'
  }, /*#__PURE__*/React__default.createElement(Exams$1, {
    setToLastPage: setToLastPage,
    toLastPage: toLastPage,
    showInCalendar: showInCalendar,
    onSelectExam: selectExamHandler,
    isReloadView: previousMode !== mode
  })), !bulkEditIsLocked && /*#__PURE__*/React__default.createElement(TabPane$1, {
    tab: "Pending Exams",
    key: 'CREATE_MULTI'
  }, /*#__PURE__*/React__default.createElement(PendingExams, {
    onSetTabVisible: setShowTabs,
    onSetToLastPage: function onSetToLastPage() {
      return setToLastPage(true);
    },
    loading: draftIsLoading,
    showInCalendar: showInCalendar,
    onCreateExams: onCreateExams,
    onFinishedAll: onFinishedCreatingAll
  })))));
};

var ExamPlugin = function ExamPlugin(props) {
  var env = props.env;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      ready = _useState6[0],
      setReady = _useState6[1];

  useEffect(function () {
    setEnv(env);
    setReady(true);
  }, [env]);

  if (!ready) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(ExamPluginWrapperStyle, {
    id: "exam-plugin",
    className: "exam-plugin",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React__default.createElement(Plugin, props)));
};

var ExamPlugin$1 = ExamPlugin;

export { ExamPlugin$1 as default };
